/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AcceptInvitationRouteImport } from './routes/accept-invitation'
import { Route as MfaSetupRouteImport } from './routes/mfa-setup'
import { Route as AppClearingCoreRouteImport } from './routes/_app/_clearing-core'
import { Route as AppLogoutRouteImport } from './routes/_app/logout'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthRegisterRouteImport } from './routes/_auth/register'
import { Route as AuthRequestAccessRouteImport } from './routes/_auth/request-access'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as DocsLayoutRouteImport } from './routes/docs/_layout'
import { Route as OauthConsentRouteImport } from './routes/oauth/consent'
import { Route as AppClearingCoreClearingRequiredRouteImport } from './routes/_app/_clearing-core/_clearing-required'
import { Route as AppO5O5RequiredRouteImport } from './routes/_app/_o5/_o5-required'
import { Route as AppPlatformContextRequiredRouteImport } from './routes/_app/_platform/_context-required'
import { Route as AppDeveloperIndexRouteImport } from './routes/_app/developer/index'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsPersonalRouteImport } from './routes/_app/settings/personal'
import { Route as AuthLoginLoginRouteImport } from './routes/_auth/login/_login'
import { Route as DocsLayoutIndexRouteImport } from './routes/docs/_layout/index'
import { Route as AppClearingCoreAssetAssetRouteImport } from './routes/_app/_clearing-core/asset/_asset'
import { Route as AppClearingCoreBillingIndexRouteImport } from './routes/_app/_clearing-core/billing/index'
import { Route as AppClearingCoreDashboardIndexRouteImport } from './routes/_app/_clearing-core/dashboard/index'
import { Route as AppClearingCoreFundingIndexRouteImport } from './routes/_app/_clearing-core/funding/index'
import { Route as AppClearingCoreHoursHoursRouteImport } from './routes/_app/_clearing-core/hours/_hours'
import { Route as AppClearingCoreOrderIndexRouteImport } from './routes/_app/_clearing-core/order/index'
import { Route as AppClearingCoreRegistrationIndexRouteImport } from './routes/_app/_clearing-core/registration/index'
import { Route as AppClearingCoreSweepIndexRouteImport } from './routes/_app/_clearing-core/sweep/index'
import { Route as AppDeveloperAgentKeyAgentKeyRouteImport } from './routes/_app/developer/agent-key/_agent-key'
import { Route as AppDeveloperApiKeyApiKeyRouteImport } from './routes/_app/developer/api-key/_api-key'
import { Route as AppDeveloperWebhookWebhookRouteImport } from './routes/_app/developer/webhook/_webhook'
import { Route as AuthLoginLoginIndexRouteImport } from './routes/_auth/login/_login/index'
import { Route as AuthLoginLoginMfaRouteImport } from './routes/_auth/login/_login/mfa'
import { Route as DocsLayoutApiReferenceProviderRouteImport } from './routes/docs/_layout/api-reference/_provider'
import { Route as DocsLayoutGuideProviderRouteImport } from './routes/docs/_layout/guide/_provider'
import { Route as AppClearingCoreClearingRequiredClearingIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/index'
import { Route as AppClearingCoreAssetAssetIndexRouteImport } from './routes/_app/_clearing-core/asset/_asset/index'
import { Route as AppClearingCoreBillingChargeChargeRouteImport } from './routes/_app/_clearing-core/billing/charge/_charge'
import { Route as AppClearingCoreFundingAccountNumberAccountNumberRouteImport } from './routes/_app/_clearing-core/funding/account-number/_account-number'
import { Route as AppClearingCoreFundingBatchTransferBatchTransferRouteImport } from './routes/_app/_clearing-core/funding/batch-transfer/_batch-transfer'
import { Route as AppClearingCoreFundingSourceSourceRouteImport } from './routes/_app/_clearing-core/funding/source/_source'
import { Route as AppClearingCoreFundingTransferTransferRouteImport } from './routes/_app/_clearing-core/funding/transfer/_transfer'
import { Route as AppClearingCoreHoursHoursIndexRouteImport } from './routes/_app/_clearing-core/hours/_hours/index'
import { Route as AppClearingCoreOrderEquitySingleRouteImport } from './routes/_app/_clearing-core/order/equity/_single'
import { Route as AppClearingCoreOrderMutualFundMutualFundRouteImport } from './routes/_app/_clearing-core/order/mutual-fund/_mutual-fund'
import { Route as AppClearingCoreRegistrationAccountIndexRouteImport } from './routes/_app/_clearing-core/registration/account/index'
import { Route as AppClearingCoreRegistrationProfileProfileRouteImport } from './routes/_app/_clearing-core/registration/profile/_profile'
import { Route as AppClearingCoreSweepCutoffCutoffRouteImport } from './routes/_app/_clearing-core/sweep/cutoff/_cutoff'
import { Route as AppClearingCoreSweepPlanPlanRouteImport } from './routes/_app/_clearing-core/sweep/plan/_plan'
import { Route as AppClearingCoreSweepTargetTargetRouteImport } from './routes/_app/_clearing-core/sweep/target/_target'
import { Route as AppPlatformContextRequiredOrganizationOrganizationRouteImport } from './routes/_app/_platform/_context-required/organization/_organization'
import { Route as AppPlatformContextRequiredProgramProgramRouteImport } from './routes/_app/_platform/_context-required/program/_program'
import { Route as AppPlatformContextRequiredRealmAccessRealmAccessRouteImport } from './routes/_app/_platform/_context-required/realm-access/_realm-access'
import { Route as AppPlatformContextRequiredRealmRealmRouteImport } from './routes/_app/_platform/_context-required/realm/_realm'
import { Route as AppPlatformContextRequiredRoleRoleRouteImport } from './routes/_app/_platform/_context-required/role/_role'
import { Route as AppPlatformContextRequiredTenantTenantRouteImport } from './routes/_app/_platform/_context-required/tenant/_tenant'
import { Route as AppPlatformContextRequiredUserIndexRouteImport } from './routes/_app/_platform/_context-required/user/index'
import { Route as AppPlatformContextRequiredUserInvitationRouteImport } from './routes/_app/_platform/_context-required/user/invitation'
import { Route as AppPlatformContextRequiredUserRequestRouteImport } from './routes/_app/_platform/_context-required/user/request'
import { Route as AppDeveloperAgentKeyAgentKeyIndexRouteImport } from './routes/_app/developer/agent-key/_agent-key/index'
import { Route as AppDeveloperApiKeyApiKeyIndexRouteImport } from './routes/_app/developer/api-key/_api-key/index'
import { Route as AppDeveloperWebhookWebhookIndexRouteImport } from './routes/_app/developer/webhook/_webhook/index'
import { Route as DocsLayoutApiReferenceProviderIndexRouteImport } from './routes/docs/_layout/api-reference/_provider/index'
import { Route as DocsLayoutApiReferenceProviderPackageRouteImport } from './routes/docs/_layout/api-reference/_provider/$package'
import { Route as DocsLayoutGuideProviderIndexRouteImport } from './routes/docs/_layout/guide/_provider/index'
import { Route as DocsLayoutGuideProviderArtifactNameRouteImport } from './routes/docs/_layout/guide/_provider/$artifactName'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor'
import { Route as AppClearingCoreClearingRequiredInboxInboxIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/inbox/_inbox/index'
import { Route as AppClearingCoreAssetAssetAssetIdDetailRouteImport } from './routes/_app/_clearing-core/asset/_asset/$assetId/_detail'
import { Route as AppClearingCoreBillingChargeChargeIndexRouteImport } from './routes/_app/_clearing-core/billing/charge/_charge/index'
import { Route as AppClearingCoreBillingChargeChargeChargeIdRouteImport } from './routes/_app/_clearing-core/billing/charge/_charge/$chargeId'
import { Route as AppClearingCoreFundingAccountNumberAccountNumberIndexRouteImport } from './routes/_app/_clearing-core/funding/account-number/_account-number/index'
import { Route as AppClearingCoreFundingAccountNumberAccountNumberAccountNumberIdRouteImport } from './routes/_app/_clearing-core/funding/account-number/_account-number/$accountNumberId'
import { Route as AppClearingCoreFundingBatchTransferBatchTransferIndexRouteImport } from './routes/_app/_clearing-core/funding/batch-transfer/_batch-transfer/index'
import { Route as AppClearingCoreFundingBatchTransferBatchTransferBatchTransferIdRouteImport } from './routes/_app/_clearing-core/funding/batch-transfer/_batch-transfer/$batchTransferId'
import { Route as AppClearingCoreFundingSourceSourceIndexRouteImport } from './routes/_app/_clearing-core/funding/source/_source/index'
import { Route as AppClearingCoreFundingSourceSourceSourceIdRouteImport } from './routes/_app/_clearing-core/funding/source/_source/$sourceId'
import { Route as AppClearingCoreFundingTransferTransferIndexRouteImport } from './routes/_app/_clearing-core/funding/transfer/_transfer/index'
import { Route as AppClearingCoreFundingTransferTransferTransferIdRouteImport } from './routes/_app/_clearing-core/funding/transfer/_transfer/$transferId'
import { Route as AppClearingCoreHoursHoursExceptionExceptionRouteImport } from './routes/_app/_clearing-core/hours/_hours/exception/_exception'
import { Route as AppClearingCoreHoursHoursScheduleChar123ScheduleNameChar125RouteImport } from './routes/_app/_clearing-core/hours/_hours/schedule/{-$scheduleName}'
import { Route as AppClearingCoreOrderEquitySingleIndexRouteImport } from './routes/_app/_clearing-core/order/equity/_single/index'
import { Route as AppClearingCoreOrderEquitySingleOrderIdRouteImport } from './routes/_app/_clearing-core/order/equity/_single/$orderId'
import { Route as AppClearingCoreOrderEquityBatchBatchRouteImport } from './routes/_app/_clearing-core/order/equity/batch/_batch'
import { Route as AppClearingCoreOrderMutualFundMutualFundIndexRouteImport } from './routes/_app/_clearing-core/order/mutual-fund/_mutual-fund/index'
import { Route as AppClearingCoreOrderMutualFundMutualFundFundOrderIdRouteImport } from './routes/_app/_clearing-core/order/mutual-fund/_mutual-fund/$fundOrderId'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account'
import { Route as AppClearingCoreRegistrationProfileProfileIndexRouteImport } from './routes/_app/_clearing-core/registration/profile/_profile/index'
import { Route as AppClearingCoreSweepCutoffCutoffIndexRouteImport } from './routes/_app/_clearing-core/sweep/cutoff/_cutoff/index'
import { Route as AppClearingCoreSweepPlanPlanIndexRouteImport } from './routes/_app/_clearing-core/sweep/plan/_plan/index'
import { Route as AppClearingCoreSweepPlanPlanSweepPlanIdRouteImport } from './routes/_app/_clearing-core/sweep/plan/_plan/$sweepPlanId'
import { Route as AppClearingCoreSweepTargetTargetIndexRouteImport } from './routes/_app/_clearing-core/sweep/target/_target/index'
import { Route as AppClearingCoreSweepTargetTargetSweepTargetIdRouteImport } from './routes/_app/_clearing-core/sweep/target/_target/$sweepTargetId'
import { Route as AppO5O5RequiredTechOpsBuildIndexRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/build/index'
import { Route as AppO5O5RequiredTechOpsClusterClusterRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/cluster/_cluster'
import { Route as AppO5O5RequiredTechOpsDeadMessageDeadMessageRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/dead-message/_dead-message'
import { Route as AppO5O5RequiredTechOpsDeploymentDeploymentRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/deployment/_deployment'
import { Route as AppO5O5RequiredTechOpsEnvironmentEnvironmentRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/environment/_environment'
import { Route as AppO5O5RequiredTechOpsStackStackRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/stack/_stack'
import { Route as AppO5O5RequiredTechOpsTestRunTestRunRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/test-run/_test-run'
import { Route as AppO5O5RequiredTechOpsTriggerTriggerRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/trigger/_trigger'
import { Route as AppPlatformContextRequiredOrganizationOrganizationIndexRouteImport } from './routes/_app/_platform/_context-required/organization/_organization/index'
import { Route as AppPlatformContextRequiredProgramProgramIndexRouteImport } from './routes/_app/_platform/_context-required/program/_program/index'
import { Route as AppPlatformContextRequiredRealmAccessRealmAccessIndexRouteImport } from './routes/_app/_platform/_context-required/realm-access/_realm-access/index'
import { Route as AppPlatformContextRequiredRealmAccessRealmAccessRealmAccessIdRouteImport } from './routes/_app/_platform/_context-required/realm-access/_realm-access/$realmAccessId'
import { Route as AppPlatformContextRequiredRealmRealmIndexRouteImport } from './routes/_app/_platform/_context-required/realm/_realm/index'
import { Route as AppPlatformContextRequiredRealmRealmRealmIdRouteImport } from './routes/_app/_platform/_context-required/realm/_realm/$realmId'
import { Route as AppPlatformContextRequiredRoleRoleIndexRouteImport } from './routes/_app/_platform/_context-required/role/_role/index'
import { Route as AppPlatformContextRequiredRoleRoleRoleIdRouteImport } from './routes/_app/_platform/_context-required/role/_role/$roleId'
import { Route as AppPlatformContextRequiredTenantTenantIndexRouteImport } from './routes/_app/_platform/_context-required/tenant/_tenant/index'
import { Route as AppPlatformContextRequiredTenantTenantTenantIdRouteImport } from './routes/_app/_platform/_context-required/tenant/_tenant/$tenantId'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/index'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/index'
import { Route as AppClearingCoreAssetAssetAssetIdDetailIndexRouteImport } from './routes/_app/_clearing-core/asset/_asset/$assetId/_detail/index'
import { Route as AppClearingCoreAssetAssetAssetIdDetailFilingsRouteImport } from './routes/_app/_clearing-core/asset/_asset/$assetId/_detail/filings'
import { Route as AppClearingCoreAssetAssetAssetIdDetailMarketDataRouteImport } from './routes/_app/_clearing-core/asset/_asset/$assetId/_detail/market-data'
import { Route as AppClearingCoreHoursHoursExceptionExceptionIndexRouteImport } from './routes/_app/_clearing-core/hours/_hours/exception/_exception/index'
import { Route as AppClearingCoreHoursHoursExceptionExceptionExceptionIdRouteImport } from './routes/_app/_clearing-core/hours/_hours/exception/_exception/$exceptionId'
import { Route as AppClearingCoreOrderEquityBatchBatchIndexRouteImport } from './routes/_app/_clearing-core/order/equity/batch/_batch/index'
import { Route as AppClearingCoreOrderEquityBatchBatchBatchOrderIdRouteImport } from './routes/_app/_clearing-core/order/equity/batch/_batch/$batchOrderId'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountIndexRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/index'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountOverviewRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_overview'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_summary-list'
import { Route as AppClearingCoreRegistrationProfileProfileProfileIdIndexRouteImport } from './routes/_app/_clearing-core/registration/profile/_profile/$profileId/index'
import { Route as AppO5O5RequiredTechOpsBuildRepoRepoRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/build/repo/_repo'
import { Route as AppO5O5RequiredTechOpsClusterClusterIndexRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/cluster/_cluster/index'
import { Route as AppO5O5RequiredTechOpsClusterClusterClusterIdRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/cluster/_cluster/$clusterId'
import { Route as AppO5O5RequiredTechOpsDeadMessageDeadMessageIndexRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/dead-message/_dead-message/index'
import { Route as AppO5O5RequiredTechOpsDeadMessageDeadMessageMessageIdRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/dead-message/_dead-message/$messageId'
import { Route as AppO5O5RequiredTechOpsDeploymentDeploymentIndexRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/deployment/_deployment/index'
import { Route as AppO5O5RequiredTechOpsDeploymentDeploymentDeploymentIdRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/deployment/_deployment/$deploymentId'
import { Route as AppO5O5RequiredTechOpsEnvironmentEnvironmentIndexRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/environment/_environment/index'
import { Route as AppO5O5RequiredTechOpsEnvironmentEnvironmentEnvironmentIdRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/environment/_environment/$environmentId'
import { Route as AppO5O5RequiredTechOpsStackStackIndexRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/stack/_stack/index'
import { Route as AppO5O5RequiredTechOpsStackStackStackIdRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/stack/_stack/$stackId'
import { Route as AppO5O5RequiredTechOpsTestRunTestRunIndexRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/test-run/_test-run/index'
import { Route as AppO5O5RequiredTechOpsTriggerTriggerIndexRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/trigger/_trigger/index'
import { Route as AppO5O5RequiredTechOpsTriggerTriggerTriggerIdRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/trigger/_trigger/$triggerId'
import { Route as AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRouteImport } from './routes/_app/_platform/_context-required/organization/_organization/$organizationId/_detail'
import { Route as AppPlatformContextRequiredProgramProgramProgramIdProgramRouteImport } from './routes/_app/_platform/_context-required/program/_program/$programId/_program'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceFincenIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/index'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceOfacIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/index'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceReportingIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/index'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/index'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/journal/_manual-entry'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/index'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsAccountIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/account/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsAccountCorrespondentRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/account/correspondent'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/balance/_balance'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-cash-balance/_customer-cash-balance'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-stock-record/_customer-stock-record'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-sweep-record/_customer-sweep-record'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsDtccIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/journal/_manual-entry'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsOmsIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsReportingIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsReportingCashBlotterRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/cash-blotter'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsReportingOrderBlotterRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/order-blotter'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsReportingStockBlotterRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/stock-blotter'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsSweepIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsTradeIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/transaction/_transaction'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trigger/_trigger'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jane-street/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorJpmIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorPlaidIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/plaid/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/index'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountSummaryListAssetRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/asset'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountSummaryListFundingRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/funding'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountSummaryListHoldRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/hold'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountSummaryListTransactionRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/transaction'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/dividends-receivable/_dividends-receivable'
import { Route as AppClearingCoreRegistrationProfileProfileProfileIdEditEditRouteImport } from './routes/_app/_clearing-core/registration/profile/_profile/$profileId/edit/_edit'
import { Route as AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateRouteImport } from './routes/_app/_clearing-core/registration/profile/_profile/create/$profileType/_create'
import { Route as AppO5O5RequiredTechOpsBuildRepoRepoIndexRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/build/repo/_repo/index'
import { Route as AppO5O5RequiredTechOpsTestRunTestRunEnvironmentIndexRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/test-run/_test-run/$environment/index'
import { Route as AppO5O5RequiredTechOpsTestRunTestRunEnvironmentTestRunIdRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/test-run/_test-run/$environment/$testRunId'
import { Route as AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailIndexRouteImport } from './routes/_app/_platform/_context-required/organization/_organization/$organizationId/_detail/index'
import { Route as AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailInvitationRouteImport } from './routes/_app/_platform/_context-required/organization/_organization/$organizationId/_detail/invitation'
import { Route as AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRealmAccessRouteImport } from './routes/_app/_platform/_context-required/organization/_organization/$organizationId/_detail/realm-access'
import { Route as AppPlatformContextRequiredProgramProgramProgramIdProgramIndexRouteImport } from './routes/_app/_platform/_context-required/program/_program/$programId/_program/index'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/entry/_entry'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/file/_file'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/match/_match'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/file/_file'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/match/_match'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/sdn/_sdn'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/blue-sheet/_blue-sheet'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cais/_cais'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cat/_cat'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606RouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/sec-606/_sec-606'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/balance-sheet/_balance-sheet'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/income-statement/_income-statement'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/transaction/_transaction'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/trial-balance/_trial-balance'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/journal/_manual-entry/index'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryEntryIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/journal/_manual-entry/$entryId'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryCreateRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/journal/_manual-entry/create'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyTafReportIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/taf-report/index'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/account-number/_account-number'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/ach/_ach'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-ach/_incoming-ach'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-wire/_incoming-wire'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/wire/_wire'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/balance/_balance/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceAccountCodeRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/balance/_balance/$accountCode'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/action/_action'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/payment/_payment'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-cash-balance/_customer-cash-balance/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-stock-record/_customer-stock-record/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-sweep-record/_customer-sweep-record/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset-day/_asset-day'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset/_asset'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/balance/_balance'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/books-order/_books-order'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/order/_order'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/sell-down/_sell-down'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/trading-day/_trading-day'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/journal/_manual-entry/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryEntryIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/journal/_manual-entry/$entryId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryCreateRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/journal/_manual-entry/create'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/dividend-accrual/_dividend-accrual'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/job/_job'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/task/_task'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/venue-order/_venue-order'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-order/_fix-order'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-session/_fix-session'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/routing-rule/_routing-rule'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/archive/_report'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/job/_job'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/order/_order'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/participant/_participant'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/task/_task'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-report/_trf-report'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-session/_trf-session'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc-fix-session/_utc-fix-session'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc/_utc'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/transaction/_transaction/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionTransactionIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/transaction/_transaction/$transactionId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trigger/_trigger/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerTriggerIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trigger/_trigger/$triggerId'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-job/_job'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-task/_task'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-task/_task'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/corporate-action/_action'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/instrument/_instrument'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/job/_job'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/task/_task'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/account-number/_account-number'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/ach/_ach'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/wire/_wire'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/destination/_destination'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorJpmEmulatorIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/emulator/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/job/_job'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/net-order/_net-order'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/order/_order'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/task/_task'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/plaid/processor-token/_processor-token'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/job/_job'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500RouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/sp-500/_sp-500'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/task/_task'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/document/_document'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/hold/_hold'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/transaction/_transaction'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailIndexRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/index'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailBeneficiariesRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/beneficiaries'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailClearingControlsRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/clearing-controls'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailControlsRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/controls'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailRiskRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/risk'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/order/_order'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableIndexRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/dividends-receivable/_dividends-receivable/index'
import { Route as AppClearingCoreRegistrationProfileProfileProfileIdEditEditIndexRouteImport } from './routes/_app/_clearing-core/registration/profile/_profile/$profileId/edit/_edit/index'
import { Route as AppClearingCoreRegistrationProfileProfileProfileIdEditEditReviewRouteImport } from './routes/_app/_clearing-core/registration/profile/_profile/$profileId/edit/_edit/review'
import { Route as AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateIndexRouteImport } from './routes/_app/_clearing-core/registration/profile/_profile/create/$profileType/_create/index'
import { Route as AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateReviewRouteImport } from './routes/_app/_clearing-core/registration/profile/_profile/create/$profileType/_create/review'
import { Route as AppO5O5RequiredTechOpsBuildRepoRepoOwnerNameRouteImport } from './routes/_app/_o5/_o5-required/tech-ops/build/repo/_repo/$owner/$name'
import { Route as AppPlatformContextRequiredProgramProgramProgramIdProgramBrandingIndexRouteImport } from './routes/_app/_platform/_context-required/program/_program/$programId/_program/branding/index'
import { Route as AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationIndexRouteImport } from './routes/_app/_platform/_context-required/program/_program/$programId/_program/configuration/index'
import { Route as AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationClearingRouteImport } from './routes/_app/_platform/_context-required/program/_program/$programId/_program/configuration/clearing'
import { Route as AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationContactsRouteImport } from './routes/_app/_platform/_context-required/program/_program/$programId/_program/configuration/contacts'
import { Route as AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationControlsRouteImport } from './routes/_app/_platform/_context-required/program/_program/$programId/_program/configuration/controls'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/entry/_entry/index'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryFincen314EntryIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/entry/_entry/$fincen314EntryId'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/file/_file/index'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileFincen314FileIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/file/_file/$fincen314FileId'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/match/_match/index'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchFincen314MatchIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/match/_match/$fincen314MatchId'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/file/_file/index'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileOfacFileIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/file/_file/$ofacFileId'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/match/_match/index'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchOfacMatchIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/match/_match/$ofacMatchId'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/sdn/_sdn/index'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnOfacSdnIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/sdn/_sdn/$ofacSdnId'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/blue-sheet/_blue-sheet/index'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetReportIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/blue-sheet/_blue-sheet/$reportId'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cais/_cais/index'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisReportIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cais/_cais/$reportId'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cat/_cat/index'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatReportIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cat/_cat/$reportId'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606IndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/sec-606/_sec-606/index'
import { Route as AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606ReportIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/sec-606/_sec-606/$reportId'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account/index'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/balance-sheet/_balance-sheet/index'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/income-statement/_income-statement/index'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/transaction/_transaction/index'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionTransactionIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/transaction/_transaction/$transactionId'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/trial-balance/_trial-balance/index'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate/index'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/account-number/_account-number/index'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberAccountNumberIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/account-number/_account-number/$accountNumberId'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/ach/_ach/index'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchAchIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/ach/_ach/$achId'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-ach/_incoming-ach/index'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchAchIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-ach/_incoming-ach/$achId'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-wire/_incoming-wire/index'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireWireIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-wire/_incoming-wire/$wireId'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/wire/_wire/index'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireWireIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/wire/_wire/$wireId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/action/_action/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionActionIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/action/_action/$actionId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/payment/_payment/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentPaymentIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/payment/_payment/$paymentId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset-day/_asset-day/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset/_asset/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/job/_job'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/task/_task'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/job/_job'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/task/_task'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/balance/_balance/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceAssetIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/balance/_balance/$assetId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/books-order/_books-order/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderBooksOrderIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/books-order/_books-order/$booksOrderId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/order/_order/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderFirmOrderIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/order/_order/$firmOrderId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/sell-down/_sell-down/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/trading-day/_trading-day/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/dividend-accrual/_dividend-accrual/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/job/_job/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobJobIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/job/_job/$jobId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/task/_task/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskTaskIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/task/_task/$taskId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/venue-order/_venue-order/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderVenueOrderIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/venue-order/_venue-order/$venueOrderId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-order/_fix-order/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderFixOrderIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-order/_fix-order/$fixOrderId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-session/_fix-session/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionSessionIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-session/_fix-session/$sessionId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/routing-rule/_routing-rule/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRuleIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/routing-rule/_routing-rule/$ruleId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/archive/_report/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportReportIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/archive/_report/$reportId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/asset/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/job/_job/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobJobIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/job/_job/$jobId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/order/_order/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderSweepOrderIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/order/_order/$sweepOrderId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/participant/_participant/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantAccountIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/participant/_participant/$accountId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/task/_task/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskTaskIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/task/_task/$taskId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-report/_trf-report/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportTrfReportIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-report/_trf-report/$trfReportId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-session/_trf-session/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionSessionIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-session/_trf-session/$sessionId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc-fix-session/_utc-fix-session/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionSessionIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc-fix-session/_utc-fix-session/$sessionId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc/_utc/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcTradeIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc/_utc/$tradeId'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-job/_job/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobJobIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-job/_job/$jobId'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-task/_task/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskTaskIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-task/_task/$taskId'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-task/_task/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskTaskIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-task/_task/$taskId'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file-request/_file-request'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file/_file'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/corporate-action/_action/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionEventIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/corporate-action/_action/$eventId'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/instrument/_instrument/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentInstrumentIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/instrument/_instrument/$instrumentId'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/job/_job/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobJobIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/job/_job/$jobId'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/task/_task/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskTaskIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/task/_task/$taskId'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/account-number/_account-number/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberAccountNumberIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/account-number/_account-number/$accountNumberId'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/ach/_ach/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchAchIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/ach/_ach/$achId'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/wire/_wire/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireWireIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/wire/_wire/$wireId'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jane-street/pfof/job/_job'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/destination/_destination/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationDestinationIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/destination/_destination/$destinationId'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/job/_job/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobJobIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/job/_job/$jobId'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/net-order/_net-order/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderNetOrderIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/net-order/_net-order/$netOrderId'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/order/_order/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderOrderIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/order/_order/$orderId'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/task/_task/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskTaskIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/task/_task/$taskId'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/plaid/processor-token/_processor-token/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenProcessorTokenIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/plaid/processor-token/_processor-token/$processorTokenId'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/job/_job/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobJobIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/job/_job/$jobId'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500IndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/sp-500/_sp-500/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500QuarterRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/sp-500/_sp-500/$quarter'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/task/_task/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskTaskIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/task/_task/$taskId'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashIndexRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/index'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentIndexRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/document/_document/index'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentTaxRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/document/_document/tax'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentTradeConfirmationRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/document/_document/trade-confirmation'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldHoldIdRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/hold/_hold/$holdId'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/order/equity/_equity'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/order/mutual-fund/_mutual-fund'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionTransactionIdRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/transaction/_transaction/$transactionId'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderIndexRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/order/_order/index'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderEquityRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/order/_order/equity'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderMutualFundRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/order/_order/mutual-fund'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account/$accountId/_layout'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate/$feeType/_$feeType'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayAssetIdIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset-day/_asset-day/$assetId/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayAssetIdDateRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset-day/_asset-day/$assetId/$date'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetAssetIdDateRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset/_asset/$assetId/$date'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/job/_job/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobJobIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/job/_job/$jobId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/task/_task/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskTaskIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/task/_task/$taskId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/job/_job/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobJobIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/job/_job/$jobId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/task/_task/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskTaskIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/task/_task/$taskId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/trading-day/_trading-day/$assetId/_$assetId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/asset/$assetId/_asset'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job/$jobId/_job'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file-request/_file-request/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestFileRequestIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file-request/_file-request/$fileRequestId'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file/_file/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileFileIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file/_file/$fileId'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jane-street/pfof/job/_job/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobJobIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jane-street/pfof/job/_job/$jobId'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountCostBasisAssetAssetIdRealizationRealizationIdRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_cost-basis/asset/$assetId/realization/$realizationId'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountCostBasisAssetAssetIdTaxLotTaxLotIdRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_cost-basis/asset/$assetId/tax-lot/$taxLotId'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashSweepAssetIdRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/sweep/$assetId'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/transaction/_transaction'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingSourceIndexRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding/source/index'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingSourceSourceIdRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding/source/$sourceId'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingTransferIndexRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding/transfer/index'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingTransferTransferIdRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding/transfer/$transferId'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityOrderIdRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/order/equity/_equity/$orderId'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundFundOrderIdRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/order/mutual-fund/_mutual-fund/$fundOrderId'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account/$accountId/_layout/index'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutSettingsRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account/$accountId/_layout/settings'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate/$feeType/_$feeType/index'
import { Route as AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeEffectiveDateRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate/$feeType/_$feeType/$effectiveDate'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdDateRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/trading-day/_trading-day/$assetId/_$assetId/$date'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day/$venue/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/asset/$assetId/_asset/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job/$jobId/_job/index'
import { Route as AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobTaskRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job/$jobId/_job/task'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceIndexRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/index'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceFundingRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/funding'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceHoldRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/hold'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionIndexRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/transaction/_transaction/index'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionTransactionIdRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/transaction/_transaction/$transactionId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualAccountIdAssetIdSourceFirstDayOfMonthRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/dividend-accrual/_dividend-accrual/$accountId/$assetId/$source/$firstDayOfMonth'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueDateIndexRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day/$venue/$date/index'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueDateAssetIdRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day/$venue/$date/$assetId'
import { Route as AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetAccountAccountCodeRouteImport } from './routes/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/asset/$assetId/_asset/account/$accountCode'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRealizationIndexRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/realization/index'
import { Route as AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceTaxLotIndexRouteImport } from './routes/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/tax-lot/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInvitationRoute = AcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const MfaSetupRoute = MfaSetupRouteImport.update({
  id: '/mfa-setup',
  path: '/mfa-setup',
  getParentRoute: () => rootRouteImport,
} as any)
const AppClearingCoreRoute = AppClearingCoreRouteImport.update({
  id: '/_clearing-core',
  getParentRoute: () => AppRoute,
} as any)
const AppLogoutRoute = AppLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AppRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRequestAccessRoute = AuthRequestAccessRouteImport.update({
  id: '/request-access',
  path: '/request-access',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const DocsLayoutRoute = DocsLayoutRouteImport.update({
  id: '/docs/_layout',
  path: '/docs',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const AppClearingCoreClearingRequiredRoute =
  AppClearingCoreClearingRequiredRouteImport.update({
    id: '/_clearing-required',
    getParentRoute: () => AppClearingCoreRoute,
  } as any)
const AppO5O5RequiredRoute = AppO5O5RequiredRouteImport.update({
  id: '/_o5/_o5-required',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformContextRequiredRoute =
  AppPlatformContextRequiredRouteImport.update({
    id: '/_platform/_context-required',
    getParentRoute: () => AppRoute,
  } as any)
const AppDeveloperIndexRoute = AppDeveloperIndexRouteImport.update({
  id: '/developer/',
  path: '/developer/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsPersonalRoute = AppSettingsPersonalRouteImport.update({
  id: '/settings/personal',
  path: '/settings/personal',
  getParentRoute: () => AppRoute,
} as any)
const AuthLoginLoginRoute = AuthLoginLoginRouteImport.update({
  id: '/login/_login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const DocsLayoutIndexRoute = DocsLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DocsLayoutRoute,
} as any)
const AppClearingCoreAssetAssetRoute =
  AppClearingCoreAssetAssetRouteImport.update({
    id: '/asset/_asset',
    path: '/asset',
    getParentRoute: () => AppClearingCoreRoute,
  } as any)
const AppClearingCoreBillingIndexRoute =
  AppClearingCoreBillingIndexRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => AppClearingCoreRoute,
  } as any)
const AppClearingCoreDashboardIndexRoute =
  AppClearingCoreDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AppClearingCoreRoute,
  } as any)
const AppClearingCoreFundingIndexRoute =
  AppClearingCoreFundingIndexRouteImport.update({
    id: '/funding/',
    path: '/funding/',
    getParentRoute: () => AppClearingCoreRoute,
  } as any)
const AppClearingCoreHoursHoursRoute =
  AppClearingCoreHoursHoursRouteImport.update({
    id: '/hours/_hours',
    path: '/hours',
    getParentRoute: () => AppClearingCoreRoute,
  } as any)
const AppClearingCoreOrderIndexRoute =
  AppClearingCoreOrderIndexRouteImport.update({
    id: '/order/',
    path: '/order/',
    getParentRoute: () => AppClearingCoreRoute,
  } as any)
const AppClearingCoreRegistrationIndexRoute =
  AppClearingCoreRegistrationIndexRouteImport.update({
    id: '/registration/',
    path: '/registration/',
    getParentRoute: () => AppClearingCoreRoute,
  } as any)
const AppClearingCoreSweepIndexRoute =
  AppClearingCoreSweepIndexRouteImport.update({
    id: '/sweep/',
    path: '/sweep/',
    getParentRoute: () => AppClearingCoreRoute,
  } as any)
const AppDeveloperAgentKeyAgentKeyRoute =
  AppDeveloperAgentKeyAgentKeyRouteImport.update({
    id: '/developer/agent-key/_agent-key',
    path: '/developer/agent-key',
    getParentRoute: () => AppRoute,
  } as any)
const AppDeveloperApiKeyApiKeyRoute =
  AppDeveloperApiKeyApiKeyRouteImport.update({
    id: '/developer/api-key/_api-key',
    path: '/developer/api-key',
    getParentRoute: () => AppRoute,
  } as any)
const AppDeveloperWebhookWebhookRoute =
  AppDeveloperWebhookWebhookRouteImport.update({
    id: '/developer/webhook/_webhook',
    path: '/developer/webhook',
    getParentRoute: () => AppRoute,
  } as any)
const AuthLoginLoginIndexRoute = AuthLoginLoginIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthLoginLoginRoute,
} as any)
const AuthLoginLoginMfaRoute = AuthLoginLoginMfaRouteImport.update({
  id: '/mfa',
  path: '/mfa',
  getParentRoute: () => AuthLoginLoginRoute,
} as any)
const DocsLayoutApiReferenceProviderRoute =
  DocsLayoutApiReferenceProviderRouteImport.update({
    id: '/api-reference/_provider',
    path: '/api-reference',
    getParentRoute: () => DocsLayoutRoute,
  } as any)
const DocsLayoutGuideProviderRoute = DocsLayoutGuideProviderRouteImport.update({
  id: '/guide/_provider',
  path: '/guide',
  getParentRoute: () => DocsLayoutRoute,
} as any)
const AppClearingCoreClearingRequiredClearingIndexRoute =
  AppClearingCoreClearingRequiredClearingIndexRouteImport.update({
    id: '/clearing/',
    path: '/clearing/',
    getParentRoute: () => AppClearingCoreClearingRequiredRoute,
  } as any)
const AppClearingCoreAssetAssetIndexRoute =
  AppClearingCoreAssetAssetIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppClearingCoreAssetAssetRoute,
  } as any)
const AppClearingCoreBillingChargeChargeRoute =
  AppClearingCoreBillingChargeChargeRouteImport.update({
    id: '/billing/charge/_charge',
    path: '/billing/charge',
    getParentRoute: () => AppClearingCoreRoute,
  } as any)
const AppClearingCoreFundingAccountNumberAccountNumberRoute =
  AppClearingCoreFundingAccountNumberAccountNumberRouteImport.update({
    id: '/funding/account-number/_account-number',
    path: '/funding/account-number',
    getParentRoute: () => AppClearingCoreRoute,
  } as any)
const AppClearingCoreFundingBatchTransferBatchTransferRoute =
  AppClearingCoreFundingBatchTransferBatchTransferRouteImport.update({
    id: '/funding/batch-transfer/_batch-transfer',
    path: '/funding/batch-transfer',
    getParentRoute: () => AppClearingCoreRoute,
  } as any)
const AppClearingCoreFundingSourceSourceRoute =
  AppClearingCoreFundingSourceSourceRouteImport.update({
    id: '/funding/source/_source',
    path: '/funding/source',
    getParentRoute: () => AppClearingCoreRoute,
  } as any)
const AppClearingCoreFundingTransferTransferRoute =
  AppClearingCoreFundingTransferTransferRouteImport.update({
    id: '/funding/transfer/_transfer',
    path: '/funding/transfer',
    getParentRoute: () => AppClearingCoreRoute,
  } as any)
const AppClearingCoreHoursHoursIndexRoute =
  AppClearingCoreHoursHoursIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppClearingCoreHoursHoursRoute,
  } as any)
const AppClearingCoreOrderEquitySingleRoute =
  AppClearingCoreOrderEquitySingleRouteImport.update({
    id: '/order/equity/_single',
    path: '/order/equity',
    getParentRoute: () => AppClearingCoreRoute,
  } as any)
const AppClearingCoreOrderMutualFundMutualFundRoute =
  AppClearingCoreOrderMutualFundMutualFundRouteImport.update({
    id: '/order/mutual-fund/_mutual-fund',
    path: '/order/mutual-fund',
    getParentRoute: () => AppClearingCoreRoute,
  } as any)
const AppClearingCoreRegistrationAccountIndexRoute =
  AppClearingCoreRegistrationAccountIndexRouteImport.update({
    id: '/registration/account/',
    path: '/registration/account/',
    getParentRoute: () => AppClearingCoreRoute,
  } as any)
const AppClearingCoreRegistrationProfileProfileRoute =
  AppClearingCoreRegistrationProfileProfileRouteImport.update({
    id: '/registration/profile/_profile',
    path: '/registration/profile',
    getParentRoute: () => AppClearingCoreRoute,
  } as any)
const AppClearingCoreSweepCutoffCutoffRoute =
  AppClearingCoreSweepCutoffCutoffRouteImport.update({
    id: '/sweep/cutoff/_cutoff',
    path: '/sweep/cutoff',
    getParentRoute: () => AppClearingCoreRoute,
  } as any)
const AppClearingCoreSweepPlanPlanRoute =
  AppClearingCoreSweepPlanPlanRouteImport.update({
    id: '/sweep/plan/_plan',
    path: '/sweep/plan',
    getParentRoute: () => AppClearingCoreRoute,
  } as any)
const AppClearingCoreSweepTargetTargetRoute =
  AppClearingCoreSweepTargetTargetRouteImport.update({
    id: '/sweep/target/_target',
    path: '/sweep/target',
    getParentRoute: () => AppClearingCoreRoute,
  } as any)
const AppPlatformContextRequiredOrganizationOrganizationRoute =
  AppPlatformContextRequiredOrganizationOrganizationRouteImport.update({
    id: '/organization/_organization',
    path: '/organization',
    getParentRoute: () => AppPlatformContextRequiredRoute,
  } as any)
const AppPlatformContextRequiredProgramProgramRoute =
  AppPlatformContextRequiredProgramProgramRouteImport.update({
    id: '/program/_program',
    path: '/program',
    getParentRoute: () => AppPlatformContextRequiredRoute,
  } as any)
const AppPlatformContextRequiredRealmAccessRealmAccessRoute =
  AppPlatformContextRequiredRealmAccessRealmAccessRouteImport.update({
    id: '/realm-access/_realm-access',
    path: '/realm-access',
    getParentRoute: () => AppPlatformContextRequiredRoute,
  } as any)
const AppPlatformContextRequiredRealmRealmRoute =
  AppPlatformContextRequiredRealmRealmRouteImport.update({
    id: '/realm/_realm',
    path: '/realm',
    getParentRoute: () => AppPlatformContextRequiredRoute,
  } as any)
const AppPlatformContextRequiredRoleRoleRoute =
  AppPlatformContextRequiredRoleRoleRouteImport.update({
    id: '/role/_role',
    path: '/role',
    getParentRoute: () => AppPlatformContextRequiredRoute,
  } as any)
const AppPlatformContextRequiredTenantTenantRoute =
  AppPlatformContextRequiredTenantTenantRouteImport.update({
    id: '/tenant/_tenant',
    path: '/tenant',
    getParentRoute: () => AppPlatformContextRequiredRoute,
  } as any)
const AppPlatformContextRequiredUserIndexRoute =
  AppPlatformContextRequiredUserIndexRouteImport.update({
    id: '/user/',
    path: '/user/',
    getParentRoute: () => AppPlatformContextRequiredRoute,
  } as any)
const AppPlatformContextRequiredUserInvitationRoute =
  AppPlatformContextRequiredUserInvitationRouteImport.update({
    id: '/user/invitation',
    path: '/user/invitation',
    getParentRoute: () => AppPlatformContextRequiredRoute,
  } as any)
const AppPlatformContextRequiredUserRequestRoute =
  AppPlatformContextRequiredUserRequestRouteImport.update({
    id: '/user/request',
    path: '/user/request',
    getParentRoute: () => AppPlatformContextRequiredRoute,
  } as any)
const AppDeveloperAgentKeyAgentKeyIndexRoute =
  AppDeveloperAgentKeyAgentKeyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDeveloperAgentKeyAgentKeyRoute,
  } as any)
const AppDeveloperApiKeyApiKeyIndexRoute =
  AppDeveloperApiKeyApiKeyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDeveloperApiKeyApiKeyRoute,
  } as any)
const AppDeveloperWebhookWebhookIndexRoute =
  AppDeveloperWebhookWebhookIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDeveloperWebhookWebhookRoute,
  } as any)
const DocsLayoutApiReferenceProviderIndexRoute =
  DocsLayoutApiReferenceProviderIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DocsLayoutApiReferenceProviderRoute,
  } as any)
const DocsLayoutApiReferenceProviderPackageRoute =
  DocsLayoutApiReferenceProviderPackageRouteImport.update({
    id: '/$package',
    path: '/$package',
    getParentRoute: () => DocsLayoutApiReferenceProviderRoute,
  } as any)
const DocsLayoutGuideProviderIndexRoute =
  DocsLayoutGuideProviderIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DocsLayoutGuideProviderRoute,
  } as any)
const DocsLayoutGuideProviderArtifactNameRoute =
  DocsLayoutGuideProviderArtifactNameRouteImport.update({
    id: '/$artifactName',
    path: '/$artifactName',
    getParentRoute: () => DocsLayoutGuideProviderRoute,
  } as any)
const AppClearingCoreClearingRequiredClearingComplianceComplianceRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceRouteImport.update(
    {
      id: '/clearing/compliance/_compliance',
      path: '/clearing/compliance',
      getParentRoute: () => AppClearingCoreClearingRequiredRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceRouteImport.update({
    id: '/clearing/finance/_finance',
    path: '/clearing/finance',
    getParentRoute: () => AppClearingCoreClearingRequiredRoute,
  } as any)
const AppClearingCoreClearingRequiredClearingOperationsOperationsRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsRouteImport.update(
    {
      id: '/clearing/operations/_operations',
      path: '/clearing/operations',
      getParentRoute: () => AppClearingCoreClearingRequiredRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorRouteImport.update({
    id: '/clearing/vendor/_vendor',
    path: '/clearing/vendor',
    getParentRoute: () => AppClearingCoreClearingRequiredRoute,
  } as any)
const AppClearingCoreClearingRequiredInboxInboxIndexRoute =
  AppClearingCoreClearingRequiredInboxInboxIndexRouteImport.update({
    id: '/inbox/_inbox/',
    path: '/inbox/',
    getParentRoute: () => AppClearingCoreClearingRequiredRoute,
  } as any)
const AppClearingCoreAssetAssetAssetIdDetailRoute =
  AppClearingCoreAssetAssetAssetIdDetailRouteImport.update({
    id: '/$assetId/_detail',
    path: '/$assetId',
    getParentRoute: () => AppClearingCoreAssetAssetRoute,
  } as any)
const AppClearingCoreBillingChargeChargeIndexRoute =
  AppClearingCoreBillingChargeChargeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppClearingCoreBillingChargeChargeRoute,
  } as any)
const AppClearingCoreBillingChargeChargeChargeIdRoute =
  AppClearingCoreBillingChargeChargeChargeIdRouteImport.update({
    id: '/$chargeId',
    path: '/$chargeId',
    getParentRoute: () => AppClearingCoreBillingChargeChargeRoute,
  } as any)
const AppClearingCoreFundingAccountNumberAccountNumberIndexRoute =
  AppClearingCoreFundingAccountNumberAccountNumberIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppClearingCoreFundingAccountNumberAccountNumberRoute,
  } as any)
const AppClearingCoreFundingAccountNumberAccountNumberAccountNumberIdRoute =
  AppClearingCoreFundingAccountNumberAccountNumberAccountNumberIdRouteImport.update(
    {
      id: '/$accountNumberId',
      path: '/$accountNumberId',
      getParentRoute: () =>
        AppClearingCoreFundingAccountNumberAccountNumberRoute,
    } as any,
  )
const AppClearingCoreFundingBatchTransferBatchTransferIndexRoute =
  AppClearingCoreFundingBatchTransferBatchTransferIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppClearingCoreFundingBatchTransferBatchTransferRoute,
  } as any)
const AppClearingCoreFundingBatchTransferBatchTransferBatchTransferIdRoute =
  AppClearingCoreFundingBatchTransferBatchTransferBatchTransferIdRouteImport.update(
    {
      id: '/$batchTransferId',
      path: '/$batchTransferId',
      getParentRoute: () =>
        AppClearingCoreFundingBatchTransferBatchTransferRoute,
    } as any,
  )
const AppClearingCoreFundingSourceSourceIndexRoute =
  AppClearingCoreFundingSourceSourceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppClearingCoreFundingSourceSourceRoute,
  } as any)
const AppClearingCoreFundingSourceSourceSourceIdRoute =
  AppClearingCoreFundingSourceSourceSourceIdRouteImport.update({
    id: '/$sourceId',
    path: '/$sourceId',
    getParentRoute: () => AppClearingCoreFundingSourceSourceRoute,
  } as any)
const AppClearingCoreFundingTransferTransferIndexRoute =
  AppClearingCoreFundingTransferTransferIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppClearingCoreFundingTransferTransferRoute,
  } as any)
const AppClearingCoreFundingTransferTransferTransferIdRoute =
  AppClearingCoreFundingTransferTransferTransferIdRouteImport.update({
    id: '/$transferId',
    path: '/$transferId',
    getParentRoute: () => AppClearingCoreFundingTransferTransferRoute,
  } as any)
const AppClearingCoreHoursHoursExceptionExceptionRoute =
  AppClearingCoreHoursHoursExceptionExceptionRouteImport.update({
    id: '/exception/_exception',
    path: '/exception',
    getParentRoute: () => AppClearingCoreHoursHoursRoute,
  } as any)
const AppClearingCoreHoursHoursScheduleChar123ScheduleNameChar125Route =
  AppClearingCoreHoursHoursScheduleChar123ScheduleNameChar125RouteImport.update(
    {
      id: '/schedule/{-$scheduleName}',
      path: '/schedule/{-$scheduleName}',
      getParentRoute: () => AppClearingCoreHoursHoursRoute,
    } as any,
  )
const AppClearingCoreOrderEquitySingleIndexRoute =
  AppClearingCoreOrderEquitySingleIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppClearingCoreOrderEquitySingleRoute,
  } as any)
const AppClearingCoreOrderEquitySingleOrderIdRoute =
  AppClearingCoreOrderEquitySingleOrderIdRouteImport.update({
    id: '/$orderId',
    path: '/$orderId',
    getParentRoute: () => AppClearingCoreOrderEquitySingleRoute,
  } as any)
const AppClearingCoreOrderEquityBatchBatchRoute =
  AppClearingCoreOrderEquityBatchBatchRouteImport.update({
    id: '/order/equity/batch/_batch',
    path: '/order/equity/batch',
    getParentRoute: () => AppClearingCoreRoute,
  } as any)
const AppClearingCoreOrderMutualFundMutualFundIndexRoute =
  AppClearingCoreOrderMutualFundMutualFundIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppClearingCoreOrderMutualFundMutualFundRoute,
  } as any)
const AppClearingCoreOrderMutualFundMutualFundFundOrderIdRoute =
  AppClearingCoreOrderMutualFundMutualFundFundOrderIdRouteImport.update({
    id: '/$fundOrderId',
    path: '/$fundOrderId',
    getParentRoute: () => AppClearingCoreOrderMutualFundMutualFundRoute,
  } as any)
const AppClearingCoreRegistrationAccountAccountIdAccountRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountRouteImport.update({
    id: '/registration/account/$accountId/_account',
    path: '/registration/account/$accountId',
    getParentRoute: () => AppClearingCoreRoute,
  } as any)
const AppClearingCoreRegistrationProfileProfileIndexRoute =
  AppClearingCoreRegistrationProfileProfileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppClearingCoreRegistrationProfileProfileRoute,
  } as any)
const AppClearingCoreSweepCutoffCutoffIndexRoute =
  AppClearingCoreSweepCutoffCutoffIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppClearingCoreSweepCutoffCutoffRoute,
  } as any)
const AppClearingCoreSweepPlanPlanIndexRoute =
  AppClearingCoreSweepPlanPlanIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppClearingCoreSweepPlanPlanRoute,
  } as any)
const AppClearingCoreSweepPlanPlanSweepPlanIdRoute =
  AppClearingCoreSweepPlanPlanSweepPlanIdRouteImport.update({
    id: '/$sweepPlanId',
    path: '/$sweepPlanId',
    getParentRoute: () => AppClearingCoreSweepPlanPlanRoute,
  } as any)
const AppClearingCoreSweepTargetTargetIndexRoute =
  AppClearingCoreSweepTargetTargetIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppClearingCoreSweepTargetTargetRoute,
  } as any)
const AppClearingCoreSweepTargetTargetSweepTargetIdRoute =
  AppClearingCoreSweepTargetTargetSweepTargetIdRouteImport.update({
    id: '/$sweepTargetId',
    path: '/$sweepTargetId',
    getParentRoute: () => AppClearingCoreSweepTargetTargetRoute,
  } as any)
const AppO5O5RequiredTechOpsBuildIndexRoute =
  AppO5O5RequiredTechOpsBuildIndexRouteImport.update({
    id: '/tech-ops/build/',
    path: '/tech-ops/build/',
    getParentRoute: () => AppO5O5RequiredRoute,
  } as any)
const AppO5O5RequiredTechOpsClusterClusterRoute =
  AppO5O5RequiredTechOpsClusterClusterRouteImport.update({
    id: '/tech-ops/cluster/_cluster',
    path: '/tech-ops/cluster',
    getParentRoute: () => AppO5O5RequiredRoute,
  } as any)
const AppO5O5RequiredTechOpsDeadMessageDeadMessageRoute =
  AppO5O5RequiredTechOpsDeadMessageDeadMessageRouteImport.update({
    id: '/tech-ops/dead-message/_dead-message',
    path: '/tech-ops/dead-message',
    getParentRoute: () => AppO5O5RequiredRoute,
  } as any)
const AppO5O5RequiredTechOpsDeploymentDeploymentRoute =
  AppO5O5RequiredTechOpsDeploymentDeploymentRouteImport.update({
    id: '/tech-ops/deployment/_deployment',
    path: '/tech-ops/deployment',
    getParentRoute: () => AppO5O5RequiredRoute,
  } as any)
const AppO5O5RequiredTechOpsEnvironmentEnvironmentRoute =
  AppO5O5RequiredTechOpsEnvironmentEnvironmentRouteImport.update({
    id: '/tech-ops/environment/_environment',
    path: '/tech-ops/environment',
    getParentRoute: () => AppO5O5RequiredRoute,
  } as any)
const AppO5O5RequiredTechOpsStackStackRoute =
  AppO5O5RequiredTechOpsStackStackRouteImport.update({
    id: '/tech-ops/stack/_stack',
    path: '/tech-ops/stack',
    getParentRoute: () => AppO5O5RequiredRoute,
  } as any)
const AppO5O5RequiredTechOpsTestRunTestRunRoute =
  AppO5O5RequiredTechOpsTestRunTestRunRouteImport.update({
    id: '/tech-ops/test-run/_test-run',
    path: '/tech-ops/test-run',
    getParentRoute: () => AppO5O5RequiredRoute,
  } as any)
const AppO5O5RequiredTechOpsTriggerTriggerRoute =
  AppO5O5RequiredTechOpsTriggerTriggerRouteImport.update({
    id: '/tech-ops/trigger/_trigger',
    path: '/tech-ops/trigger',
    getParentRoute: () => AppO5O5RequiredRoute,
  } as any)
const AppPlatformContextRequiredOrganizationOrganizationIndexRoute =
  AppPlatformContextRequiredOrganizationOrganizationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AppPlatformContextRequiredOrganizationOrganizationRoute,
  } as any)
const AppPlatformContextRequiredProgramProgramIndexRoute =
  AppPlatformContextRequiredProgramProgramIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppPlatformContextRequiredProgramProgramRoute,
  } as any)
const AppPlatformContextRequiredRealmAccessRealmAccessIndexRoute =
  AppPlatformContextRequiredRealmAccessRealmAccessIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppPlatformContextRequiredRealmAccessRealmAccessRoute,
  } as any)
const AppPlatformContextRequiredRealmAccessRealmAccessRealmAccessIdRoute =
  AppPlatformContextRequiredRealmAccessRealmAccessRealmAccessIdRouteImport.update(
    {
      id: '/$realmAccessId',
      path: '/$realmAccessId',
      getParentRoute: () =>
        AppPlatformContextRequiredRealmAccessRealmAccessRoute,
    } as any,
  )
const AppPlatformContextRequiredRealmRealmIndexRoute =
  AppPlatformContextRequiredRealmRealmIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppPlatformContextRequiredRealmRealmRoute,
  } as any)
const AppPlatformContextRequiredRealmRealmRealmIdRoute =
  AppPlatformContextRequiredRealmRealmRealmIdRouteImport.update({
    id: '/$realmId',
    path: '/$realmId',
    getParentRoute: () => AppPlatformContextRequiredRealmRealmRoute,
  } as any)
const AppPlatformContextRequiredRoleRoleIndexRoute =
  AppPlatformContextRequiredRoleRoleIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppPlatformContextRequiredRoleRoleRoute,
  } as any)
const AppPlatformContextRequiredRoleRoleRoleIdRoute =
  AppPlatformContextRequiredRoleRoleRoleIdRouteImport.update({
    id: '/$roleId',
    path: '/$roleId',
    getParentRoute: () => AppPlatformContextRequiredRoleRoleRoute,
  } as any)
const AppPlatformContextRequiredTenantTenantIndexRoute =
  AppPlatformContextRequiredTenantTenantIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppPlatformContextRequiredTenantTenantRoute,
  } as any)
const AppPlatformContextRequiredTenantTenantTenantIdRoute =
  AppPlatformContextRequiredTenantTenantTenantIdRouteImport.update({
    id: '/$tenantId',
    path: '/$tenantId',
    getParentRoute: () => AppPlatformContextRequiredTenantTenantRoute,
  } as any)
const AppClearingCoreClearingRequiredClearingComplianceComplianceIndexRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceIndexRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AppClearingCoreClearingRequiredClearingFinanceFinanceRoute,
  } as any)
const AppClearingCoreClearingRequiredClearingOperationsOperationsIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AppClearingCoreClearingRequiredClearingVendorVendorRoute,
  } as any)
const AppClearingCoreAssetAssetAssetIdDetailIndexRoute =
  AppClearingCoreAssetAssetAssetIdDetailIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppClearingCoreAssetAssetAssetIdDetailRoute,
  } as any)
const AppClearingCoreAssetAssetAssetIdDetailFilingsRoute =
  AppClearingCoreAssetAssetAssetIdDetailFilingsRouteImport.update({
    id: '/filings',
    path: '/filings',
    getParentRoute: () => AppClearingCoreAssetAssetAssetIdDetailRoute,
  } as any)
const AppClearingCoreAssetAssetAssetIdDetailMarketDataRoute =
  AppClearingCoreAssetAssetAssetIdDetailMarketDataRouteImport.update({
    id: '/market-data',
    path: '/market-data',
    getParentRoute: () => AppClearingCoreAssetAssetAssetIdDetailRoute,
  } as any)
const AppClearingCoreHoursHoursExceptionExceptionIndexRoute =
  AppClearingCoreHoursHoursExceptionExceptionIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppClearingCoreHoursHoursExceptionExceptionRoute,
  } as any)
const AppClearingCoreHoursHoursExceptionExceptionExceptionIdRoute =
  AppClearingCoreHoursHoursExceptionExceptionExceptionIdRouteImport.update({
    id: '/$exceptionId',
    path: '/$exceptionId',
    getParentRoute: () => AppClearingCoreHoursHoursExceptionExceptionRoute,
  } as any)
const AppClearingCoreOrderEquityBatchBatchIndexRoute =
  AppClearingCoreOrderEquityBatchBatchIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppClearingCoreOrderEquityBatchBatchRoute,
  } as any)
const AppClearingCoreOrderEquityBatchBatchBatchOrderIdRoute =
  AppClearingCoreOrderEquityBatchBatchBatchOrderIdRouteImport.update({
    id: '/$batchOrderId',
    path: '/$batchOrderId',
    getParentRoute: () => AppClearingCoreOrderEquityBatchBatchRoute,
  } as any)
const AppClearingCoreRegistrationAccountAccountIdAccountIndexRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AppClearingCoreRegistrationAccountAccountIdAccountRoute,
  } as any)
const AppClearingCoreRegistrationAccountAccountIdAccountOverviewRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountOverviewRouteImport.update({
    id: '/_overview',
    getParentRoute: () =>
      AppClearingCoreRegistrationAccountAccountIdAccountRoute,
  } as any)
const AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRouteImport.update(
    {
      id: '/_summary-list',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountRoute,
    } as any,
  )
const AppClearingCoreRegistrationProfileProfileProfileIdIndexRoute =
  AppClearingCoreRegistrationProfileProfileProfileIdIndexRouteImport.update({
    id: '/$profileId/',
    path: '/$profileId/',
    getParentRoute: () => AppClearingCoreRegistrationProfileProfileRoute,
  } as any)
const AppO5O5RequiredTechOpsBuildRepoRepoRoute =
  AppO5O5RequiredTechOpsBuildRepoRepoRouteImport.update({
    id: '/tech-ops/build/repo/_repo',
    path: '/tech-ops/build/repo',
    getParentRoute: () => AppO5O5RequiredRoute,
  } as any)
const AppO5O5RequiredTechOpsClusterClusterIndexRoute =
  AppO5O5RequiredTechOpsClusterClusterIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppO5O5RequiredTechOpsClusterClusterRoute,
  } as any)
const AppO5O5RequiredTechOpsClusterClusterClusterIdRoute =
  AppO5O5RequiredTechOpsClusterClusterClusterIdRouteImport.update({
    id: '/$clusterId',
    path: '/$clusterId',
    getParentRoute: () => AppO5O5RequiredTechOpsClusterClusterRoute,
  } as any)
const AppO5O5RequiredTechOpsDeadMessageDeadMessageIndexRoute =
  AppO5O5RequiredTechOpsDeadMessageDeadMessageIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppO5O5RequiredTechOpsDeadMessageDeadMessageRoute,
  } as any)
const AppO5O5RequiredTechOpsDeadMessageDeadMessageMessageIdRoute =
  AppO5O5RequiredTechOpsDeadMessageDeadMessageMessageIdRouteImport.update({
    id: '/$messageId',
    path: '/$messageId',
    getParentRoute: () => AppO5O5RequiredTechOpsDeadMessageDeadMessageRoute,
  } as any)
const AppO5O5RequiredTechOpsDeploymentDeploymentIndexRoute =
  AppO5O5RequiredTechOpsDeploymentDeploymentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppO5O5RequiredTechOpsDeploymentDeploymentRoute,
  } as any)
const AppO5O5RequiredTechOpsDeploymentDeploymentDeploymentIdRoute =
  AppO5O5RequiredTechOpsDeploymentDeploymentDeploymentIdRouteImport.update({
    id: '/$deploymentId',
    path: '/$deploymentId',
    getParentRoute: () => AppO5O5RequiredTechOpsDeploymentDeploymentRoute,
  } as any)
const AppO5O5RequiredTechOpsEnvironmentEnvironmentIndexRoute =
  AppO5O5RequiredTechOpsEnvironmentEnvironmentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppO5O5RequiredTechOpsEnvironmentEnvironmentRoute,
  } as any)
const AppO5O5RequiredTechOpsEnvironmentEnvironmentEnvironmentIdRoute =
  AppO5O5RequiredTechOpsEnvironmentEnvironmentEnvironmentIdRouteImport.update({
    id: '/$environmentId',
    path: '/$environmentId',
    getParentRoute: () => AppO5O5RequiredTechOpsEnvironmentEnvironmentRoute,
  } as any)
const AppO5O5RequiredTechOpsStackStackIndexRoute =
  AppO5O5RequiredTechOpsStackStackIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppO5O5RequiredTechOpsStackStackRoute,
  } as any)
const AppO5O5RequiredTechOpsStackStackStackIdRoute =
  AppO5O5RequiredTechOpsStackStackStackIdRouteImport.update({
    id: '/$stackId',
    path: '/$stackId',
    getParentRoute: () => AppO5O5RequiredTechOpsStackStackRoute,
  } as any)
const AppO5O5RequiredTechOpsTestRunTestRunIndexRoute =
  AppO5O5RequiredTechOpsTestRunTestRunIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppO5O5RequiredTechOpsTestRunTestRunRoute,
  } as any)
const AppO5O5RequiredTechOpsTriggerTriggerIndexRoute =
  AppO5O5RequiredTechOpsTriggerTriggerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppO5O5RequiredTechOpsTriggerTriggerRoute,
  } as any)
const AppO5O5RequiredTechOpsTriggerTriggerTriggerIdRoute =
  AppO5O5RequiredTechOpsTriggerTriggerTriggerIdRouteImport.update({
    id: '/$triggerId',
    path: '/$triggerId',
    getParentRoute: () => AppO5O5RequiredTechOpsTriggerTriggerRoute,
  } as any)
const AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRoute =
  AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRouteImport.update(
    {
      id: '/$organizationId/_detail',
      path: '/$organizationId',
      getParentRoute: () =>
        AppPlatformContextRequiredOrganizationOrganizationRoute,
    } as any,
  )
const AppPlatformContextRequiredProgramProgramProgramIdProgramRoute =
  AppPlatformContextRequiredProgramProgramProgramIdProgramRouteImport.update({
    id: '/$programId/_program',
    path: '/$programId',
    getParentRoute: () => AppPlatformContextRequiredProgramProgramRoute,
  } as any)
const AppClearingCoreClearingRequiredClearingComplianceComplianceFincenIndexRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceFincenIndexRouteImport.update(
    {
      id: '/fincen/',
      path: '/fincen/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceOfacIndexRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceOfacIndexRouteImport.update(
    {
      id: '/ofac/',
      path: '/ofac/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceReportingIndexRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingIndexRouteImport.update(
    {
      id: '/reporting/',
      path: '/reporting/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIndexRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIndexRouteImport.update(
    {
      id: '/accounting/',
      path: '/accounting/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryRouteImport.update(
    {
      id: '/journal/_manual-entry',
      path: '/journal',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyIndexRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyIndexRouteImport.update(
    {
      id: '/middle-money/',
      path: '/middle-money/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIndexRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIndexRouteImport.update(
    {
      id: '/payment/',
      path: '/payment/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsAccountIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsAccountIndexRouteImport.update(
    {
      id: '/account/',
      path: '/account/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsAccountCorrespondentRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsAccountCorrespondentRouteImport.update(
    {
      id: '/account/correspondent',
      path: '/account/correspondent',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceRouteImport.update(
    {
      id: '/balance/_balance',
      path: '/balance',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceRouteImport.update(
    {
      id: '/customer-cash-balance/_customer-cash-balance',
      path: '/customer-cash-balance',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordRouteImport.update(
    {
      id: '/customer-stock-record/_customer-stock-record',
      path: '/customer-stock-record',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordRouteImport.update(
    {
      id: '/customer-sweep-record/_customer-sweep-record',
      path: '/customer-sweep-record',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsDtccIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsDtccIndexRouteImport.update(
    {
      id: '/dtcc/',
      path: '/dtcc/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateIndexRouteImport.update(
    {
      id: '/generate/',
      path: '/generate/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryIndexRouteImport.update(
    {
      id: '/inventory/',
      path: '/inventory/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryRouteImport.update(
    {
      id: '/journal/_manual-entry',
      path: '/journal',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsIndexRouteImport.update(
    {
      id: '/mutualfunds/',
      path: '/mutualfunds/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsOmsIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsOmsIndexRouteImport.update(
    {
      id: '/oms/',
      path: '/oms/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsReportingIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsReportingIndexRouteImport.update(
    {
      id: '/reporting/',
      path: '/reporting/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsReportingCashBlotterRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsReportingCashBlotterRouteImport.update(
    {
      id: '/reporting/cash-blotter',
      path: '/reporting/cash-blotter',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsReportingOrderBlotterRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsReportingOrderBlotterRouteImport.update(
    {
      id: '/reporting/order-blotter',
      path: '/reporting/order-blotter',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsReportingStockBlotterRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsReportingStockBlotterRouteImport.update(
    {
      id: '/reporting/stock-blotter',
      path: '/reporting/stock-blotter',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordRouteImport.update(
    {
      id: '/stock-record/_stock-record',
      path: '/stock-record',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsSweepIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepIndexRouteImport.update(
    {
      id: '/sweep/',
      path: '/sweep/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsTradeIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeIndexRouteImport.update(
    {
      id: '/trade/',
      path: '/trade/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionRouteImport.update(
    {
      id: '/transaction/_transaction',
      path: '/transaction',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerRouteImport.update(
    {
      id: '/trigger/_trigger',
      path: '/trigger',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtIndexRouteImport.update(
    {
      id: '/beta-nxt/',
      path: '/beta-nxt/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccRouteImport.update(
    {
      id: '/dtcc/_dtcc',
      path: '/dtcc',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetIndexRouteImport.update(
    {
      id: '/jane-street/',
      path: '/jane-street/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorJpmIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorJpmIndexRouteImport.update(
    {
      id: '/jpm/',
      path: '/jpm/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorPlaidIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorPlaidIndexRouteImport.update(
    {
      id: '/plaid/',
      path: '/plaid/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaIndexRouteImport.update(
    {
      id: '/quote-media/',
      path: '/quote-media/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountSummaryListAssetRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountSummaryListAssetRouteImport.update(
    {
      id: '/asset',
      path: '/asset',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountSummaryListFundingRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountSummaryListFundingRouteImport.update(
    {
      id: '/funding',
      path: '/funding',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountSummaryListHoldRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountSummaryListHoldRouteImport.update(
    {
      id: '/hold',
      path: '/hold',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountSummaryListTransactionRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountSummaryListTransactionRouteImport.update(
    {
      id: '/transaction',
      path: '/transaction',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableRouteImport.update(
    {
      id: '/dividends-receivable/_dividends-receivable',
      path: '/dividends-receivable',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountRoute,
    } as any,
  )
const AppClearingCoreRegistrationProfileProfileProfileIdEditEditRoute =
  AppClearingCoreRegistrationProfileProfileProfileIdEditEditRouteImport.update({
    id: '/$profileId/edit/_edit',
    path: '/$profileId/edit',
    getParentRoute: () => AppClearingCoreRegistrationProfileProfileRoute,
  } as any)
const AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateRoute =
  AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateRouteImport.update(
    {
      id: '/create/$profileType/_create',
      path: '/create/$profileType',
      getParentRoute: () => AppClearingCoreRegistrationProfileProfileRoute,
    } as any,
  )
const AppO5O5RequiredTechOpsBuildRepoRepoIndexRoute =
  AppO5O5RequiredTechOpsBuildRepoRepoIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppO5O5RequiredTechOpsBuildRepoRepoRoute,
  } as any)
const AppO5O5RequiredTechOpsTestRunTestRunEnvironmentIndexRoute =
  AppO5O5RequiredTechOpsTestRunTestRunEnvironmentIndexRouteImport.update({
    id: '/$environment/',
    path: '/$environment/',
    getParentRoute: () => AppO5O5RequiredTechOpsTestRunTestRunRoute,
  } as any)
const AppO5O5RequiredTechOpsTestRunTestRunEnvironmentTestRunIdRoute =
  AppO5O5RequiredTechOpsTestRunTestRunEnvironmentTestRunIdRouteImport.update({
    id: '/$environment/$testRunId',
    path: '/$environment/$testRunId',
    getParentRoute: () => AppO5O5RequiredTechOpsTestRunTestRunRoute,
  } as any)
const AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailIndexRoute =
  AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRoute,
    } as any,
  )
const AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailInvitationRoute =
  AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailInvitationRouteImport.update(
    {
      id: '/invitation',
      path: '/invitation',
      getParentRoute: () =>
        AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRoute,
    } as any,
  )
const AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRealmAccessRoute =
  AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRealmAccessRouteImport.update(
    {
      id: '/realm-access',
      path: '/realm-access',
      getParentRoute: () =>
        AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRoute,
    } as any,
  )
const AppPlatformContextRequiredProgramProgramProgramIdProgramIndexRoute =
  AppPlatformContextRequiredProgramProgramProgramIdProgramIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppPlatformContextRequiredProgramProgramProgramIdProgramRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryRouteImport.update(
    {
      id: '/fincen/entry/_entry',
      path: '/fincen/entry',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileRouteImport.update(
    {
      id: '/fincen/file/_file',
      path: '/fincen/file',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchRouteImport.update(
    {
      id: '/fincen/match/_match',
      path: '/fincen/match',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileRouteImport.update(
    {
      id: '/ofac/file/_file',
      path: '/ofac/file',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchRouteImport.update(
    {
      id: '/ofac/match/_match',
      path: '/ofac/match',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnRouteImport.update(
    {
      id: '/ofac/sdn/_sdn',
      path: '/ofac/sdn',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetRouteImport.update(
    {
      id: '/reporting/blue-sheet/_blue-sheet',
      path: '/reporting/blue-sheet',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisRouteImport.update(
    {
      id: '/reporting/cais/_cais',
      path: '/reporting/cais',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatRouteImport.update(
    {
      id: '/reporting/cat/_cat',
      path: '/reporting/cat',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606Route =
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606RouteImport.update(
    {
      id: '/reporting/sec-606/_sec-606',
      path: '/reporting/sec-606',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountRouteImport.update(
    {
      id: '/accounting/account/_account',
      path: '/accounting/account',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetRouteImport.update(
    {
      id: '/accounting/balance-sheet/_balance-sheet',
      path: '/accounting/balance-sheet',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementRouteImport.update(
    {
      id: '/accounting/income-statement/_income-statement',
      path: '/accounting/income-statement',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionRouteImport.update(
    {
      id: '/accounting/transaction/_transaction',
      path: '/accounting/transaction',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceRouteImport.update(
    {
      id: '/accounting/trial-balance/_trial-balance',
      path: '/accounting/trial-balance',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryIndexRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryEntryIdRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryEntryIdRouteImport.update(
    {
      id: '/$entryId',
      path: '/$entryId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryCreateRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryCreateRouteImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateRouteImport.update(
    {
      id: '/middle-money/fee-rate/_fee-rate',
      path: '/middle-money/fee-rate',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyTafReportIndexRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyTafReportIndexRouteImport.update(
    {
      id: '/middle-money/taf-report/',
      path: '/middle-money/taf-report/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberRouteImport.update(
    {
      id: '/payment/account-number/_account-number',
      path: '/payment/account-number',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchRouteImport.update(
    {
      id: '/payment/ach/_ach',
      path: '/payment/ach',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchRouteImport.update(
    {
      id: '/payment/incoming-ach/_incoming-ach',
      path: '/payment/incoming-ach',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireRouteImport.update(
    {
      id: '/payment/incoming-wire/_incoming-wire',
      path: '/payment/incoming-wire',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireRouteImport.update(
    {
      id: '/payment/wire/_wire',
      path: '/payment/wire',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceAccountCodeRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceAccountCodeRouteImport.update(
    {
      id: '/$accountCode',
      path: '/$accountCode',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionRouteImport.update(
    {
      id: '/ca/action/_action',
      path: '/ca/action',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentRouteImport.update(
    {
      id: '/ca/payment/_payment',
      path: '/ca/payment',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayRouteImport.update(
    {
      id: '/dtcc/asset-day/_asset-day',
      path: '/dtcc/asset-day',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetRouteImport.update(
    {
      id: '/dtcc/asset/_asset',
      path: '/dtcc/asset',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementIndexRouteImport.update(
    {
      id: '/generate/monthly-statement/',
      path: '/generate/monthly-statement/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceRouteImport.update(
    {
      id: '/inventory/balance/_balance',
      path: '/inventory/balance',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderRouteImport.update(
    {
      id: '/inventory/books-order/_books-order',
      path: '/inventory/books-order',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderRouteImport.update(
    {
      id: '/inventory/order/_order',
      path: '/inventory/order',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownRouteImport.update(
    {
      id: '/inventory/sell-down/_sell-down',
      path: '/inventory/sell-down',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayRouteImport.update(
    {
      id: '/inventory/trading-day/_trading-day',
      path: '/inventory/trading-day',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryEntryIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryEntryIdRouteImport.update(
    {
      id: '/$entryId',
      path: '/$entryId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryCreateRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryCreateRouteImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualRouteImport.update(
    {
      id: '/mutualfunds/dividend-accrual/_dividend-accrual',
      path: '/mutualfunds/dividend-accrual',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobRouteImport.update(
    {
      id: '/mutualfunds/job/_job',
      path: '/mutualfunds/job',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationIndexRouteImport.update(
    {
      id: '/mutualfunds/reconciliation/',
      path: '/mutualfunds/reconciliation/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskRouteImport.update(
    {
      id: '/mutualfunds/task/_task',
      path: '/mutualfunds/task',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderRouteImport.update(
    {
      id: '/mutualfunds/venue-order/_venue-order',
      path: '/mutualfunds/venue-order',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderRouteImport.update(
    {
      id: '/oms/fix-order/_fix-order',
      path: '/oms/fix-order',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionRouteImport.update(
    {
      id: '/oms/fix-session/_fix-session',
      path: '/oms/fix-session',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRouteImport.update(
    {
      id: '/oms/routing-rule/_routing-rule',
      path: '/oms/routing-rule',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportRouteImport.update(
    {
      id: '/reporting/archive/_report',
      path: '/reporting/archive',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobRouteImport.update(
    {
      id: '/sweep/job/_job',
      path: '/sweep/job',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderRouteImport.update(
    {
      id: '/sweep/order/_order',
      path: '/sweep/order',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantRouteImport.update(
    {
      id: '/sweep/participant/_participant',
      path: '/sweep/participant',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskRouteImport.update(
    {
      id: '/sweep/task/_task',
      path: '/sweep/task',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportRouteImport.update(
    {
      id: '/trade/trf-report/_trf-report',
      path: '/trade/trf-report',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionRouteImport.update(
    {
      id: '/trade/trf-session/_trf-session',
      path: '/trade/trf-session',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionRouteImport.update(
    {
      id: '/trade/utc-fix-session/_utc-fix-session',
      path: '/trade/utc-fix-session',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcRouteImport.update(
    {
      id: '/trade/utc/_utc',
      path: '/trade/utc',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionTransactionIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionTransactionIdRouteImport.update(
    {
      id: '/$transactionId',
      path: '/$transactionId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerTriggerIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerTriggerIdRouteImport.update(
    {
      id: '/$triggerId',
      path: '/$triggerId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobRouteImport.update(
    {
      id: '/beta-nxt/prospectus-job/_job',
      path: '/beta-nxt/prospectus-job',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskRouteImport.update(
    {
      id: '/beta-nxt/prospectus-task/_task',
      path: '/beta-nxt/prospectus-task',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobRouteImport.update(
    {
      id: '/beta-nxt/proxy-vote-job/_job',
      path: '/beta-nxt/proxy-vote-job',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskRouteImport.update(
    {
      id: '/beta-nxt/proxy-vote-task/_task',
      path: '/beta-nxt/proxy-vote-task',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionRouteImport.update(
    {
      id: '/ice/corporate-action/_action',
      path: '/ice/corporate-action',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentRouteImport.update(
    {
      id: '/ice/instrument/_instrument',
      path: '/ice/instrument',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobRouteImport.update(
    {
      id: '/ice/job/_job',
      path: '/ice/job',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskRouteImport.update(
    {
      id: '/ice/task/_task',
      path: '/ice/task',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberRouteImport.update(
    {
      id: '/increase/account-number/_account-number',
      path: '/increase/account-number',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchRouteImport.update(
    {
      id: '/increase/ach/_ach',
      path: '/increase/ach',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireRouteImport.update(
    {
      id: '/increase/wire/_wire',
      path: '/increase/wire',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationRouteImport.update(
    {
      id: '/jpm/destination/_destination',
      path: '/jpm/destination',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorJpmEmulatorIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorJpmEmulatorIndexRouteImport.update(
    {
      id: '/jpm/emulator/',
      path: '/jpm/emulator/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobRouteImport.update(
    {
      id: '/jpm/job/_job',
      path: '/jpm/job',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderRouteImport.update(
    {
      id: '/jpm/net-order/_net-order',
      path: '/jpm/net-order',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderRouteImport.update(
    {
      id: '/jpm/order/_order',
      path: '/jpm/order',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskRouteImport.update(
    {
      id: '/jpm/task/_task',
      path: '/jpm/task',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenRouteImport.update(
    {
      id: '/plaid/processor-token/_processor-token',
      path: '/plaid/processor-token',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobRouteImport.update(
    {
      id: '/quote-media/job/_job',
      path: '/quote-media/job',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500Route =
  AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500RouteImport.update(
    {
      id: '/quote-media/sp-500/_sp-500',
      path: '/quote-media/sp-500',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskRouteImport.update(
    {
      id: '/quote-media/task/_task',
      path: '/quote-media/task',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetRouteImport.update(
    {
      id: '/_detail/asset/_asset',
      path: '/asset',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashRouteImport.update(
    {
      id: '/_detail/cash/_cash',
      path: '/cash',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentRouteImport.update(
    {
      id: '/_detail/document/_document',
      path: '/document',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingRouteImport.update(
    {
      id: '/_detail/funding/_funding',
      path: '/funding',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldRouteImport.update(
    {
      id: '/_detail/hold/_hold',
      path: '/hold',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionRouteImport.update(
    {
      id: '/_detail/transaction/_transaction',
      path: '/transaction',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailIndexRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailIndexRouteImport.update(
    {
      id: '/detail/',
      path: '/detail/',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountOverviewRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailBeneficiariesRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailBeneficiariesRouteImport.update(
    {
      id: '/detail/beneficiaries',
      path: '/detail/beneficiaries',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountOverviewRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailClearingControlsRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailClearingControlsRouteImport.update(
    {
      id: '/detail/clearing-controls',
      path: '/detail/clearing-controls',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountOverviewRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailControlsRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailControlsRouteImport.update(
    {
      id: '/detail/controls',
      path: '/detail/controls',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountOverviewRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailRiskRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailRiskRouteImport.update(
    {
      id: '/detail/risk',
      path: '/detail/risk',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountOverviewRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderRouteImport.update(
    {
      id: '/order/_order',
      path: '/order',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableIndexRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableRoute,
    } as any,
  )
const AppClearingCoreRegistrationProfileProfileProfileIdEditEditIndexRoute =
  AppClearingCoreRegistrationProfileProfileProfileIdEditEditIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreRegistrationProfileProfileProfileIdEditEditRoute,
    } as any,
  )
const AppClearingCoreRegistrationProfileProfileProfileIdEditEditReviewRoute =
  AppClearingCoreRegistrationProfileProfileProfileIdEditEditReviewRouteImport.update(
    {
      id: '/review',
      path: '/review',
      getParentRoute: () =>
        AppClearingCoreRegistrationProfileProfileProfileIdEditEditRoute,
    } as any,
  )
const AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateIndexRoute =
  AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateRoute,
    } as any,
  )
const AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateReviewRoute =
  AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateReviewRouteImport.update(
    {
      id: '/review',
      path: '/review',
      getParentRoute: () =>
        AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateRoute,
    } as any,
  )
const AppO5O5RequiredTechOpsBuildRepoRepoOwnerNameRoute =
  AppO5O5RequiredTechOpsBuildRepoRepoOwnerNameRouteImport.update({
    id: '/$owner/$name',
    path: '/$owner/$name',
    getParentRoute: () => AppO5O5RequiredTechOpsBuildRepoRepoRoute,
  } as any)
const AppPlatformContextRequiredProgramProgramProgramIdProgramBrandingIndexRoute =
  AppPlatformContextRequiredProgramProgramProgramIdProgramBrandingIndexRouteImport.update(
    {
      id: '/branding/',
      path: '/branding/',
      getParentRoute: () =>
        AppPlatformContextRequiredProgramProgramProgramIdProgramRoute,
    } as any,
  )
const AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationIndexRoute =
  AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationIndexRouteImport.update(
    {
      id: '/configuration/',
      path: '/configuration/',
      getParentRoute: () =>
        AppPlatformContextRequiredProgramProgramProgramIdProgramRoute,
    } as any,
  )
const AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationClearingRoute =
  AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationClearingRouteImport.update(
    {
      id: '/configuration/clearing',
      path: '/configuration/clearing',
      getParentRoute: () =>
        AppPlatformContextRequiredProgramProgramProgramIdProgramRoute,
    } as any,
  )
const AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationContactsRoute =
  AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationContactsRouteImport.update(
    {
      id: '/configuration/contacts',
      path: '/configuration/contacts',
      getParentRoute: () =>
        AppPlatformContextRequiredProgramProgramProgramIdProgramRoute,
    } as any,
  )
const AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationControlsRoute =
  AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationControlsRouteImport.update(
    {
      id: '/configuration/controls',
      path: '/configuration/controls',
      getParentRoute: () =>
        AppPlatformContextRequiredProgramProgramProgramIdProgramRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryIndexRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryFincen314EntryIdRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryFincen314EntryIdRouteImport.update(
    {
      id: '/$fincen314EntryId',
      path: '/$fincen314EntryId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileIndexRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileFincen314FileIdRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileFincen314FileIdRouteImport.update(
    {
      id: '/$fincen314FileId',
      path: '/$fincen314FileId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchIndexRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchFincen314MatchIdRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchFincen314MatchIdRouteImport.update(
    {
      id: '/$fincen314MatchId',
      path: '/$fincen314MatchId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileIndexRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileOfacFileIdRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileOfacFileIdRouteImport.update(
    {
      id: '/$ofacFileId',
      path: '/$ofacFileId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchIndexRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchOfacMatchIdRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchOfacMatchIdRouteImport.update(
    {
      id: '/$ofacMatchId',
      path: '/$ofacMatchId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnIndexRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnOfacSdnIdRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnOfacSdnIdRouteImport.update(
    {
      id: '/$ofacSdnId',
      path: '/$ofacSdnId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetIndexRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetReportIdRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetReportIdRouteImport.update(
    {
      id: '/$reportId',
      path: '/$reportId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisIndexRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisReportIdRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisReportIdRouteImport.update(
    {
      id: '/$reportId',
      path: '/$reportId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatIndexRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatReportIdRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatReportIdRouteImport.update(
    {
      id: '/$reportId',
      path: '/$reportId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606IndexRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606IndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606Route,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606ReportIdRoute =
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606ReportIdRouteImport.update(
    {
      id: '/$reportId',
      path: '/$reportId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606Route,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountIndexRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetIndexRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementIndexRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionIndexRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionTransactionIdRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionTransactionIdRouteImport.update(
    {
      id: '/$transactionId',
      path: '/$transactionId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceIndexRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateIndexRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberIndexRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberAccountNumberIdRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberAccountNumberIdRouteImport.update(
    {
      id: '/$accountNumberId',
      path: '/$accountNumberId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchIndexRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchAchIdRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchAchIdRouteImport.update(
    {
      id: '/$achId',
      path: '/$achId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchIndexRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchAchIdRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchAchIdRouteImport.update(
    {
      id: '/$achId',
      path: '/$achId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireIndexRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireWireIdRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireWireIdRouteImport.update(
    {
      id: '/$wireId',
      path: '/$wireId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireIndexRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireWireIdRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireWireIdRouteImport.update(
    {
      id: '/$wireId',
      path: '/$wireId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionActionIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionActionIdRouteImport.update(
    {
      id: '/$actionId',
      path: '/$actionId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentPaymentIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentPaymentIdRouteImport.update(
    {
      id: '/$paymentId',
      path: '/$paymentId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobRouteImport.update(
    {
      id: '/generate/monthly-statement/job/_job',
      path: '/generate/monthly-statement/job',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskRouteImport.update(
    {
      id: '/generate/monthly-statement/task/_task',
      path: '/generate/monthly-statement/task',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobRouteImport.update(
    {
      id: '/generate/trade-confirmation/job/_job',
      path: '/generate/trade-confirmation/job',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskRouteImport.update(
    {
      id: '/generate/trade-confirmation/task/_task',
      path: '/generate/trade-confirmation/task',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceAssetIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceAssetIdRouteImport.update(
    {
      id: '/$assetId',
      path: '/$assetId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderBooksOrderIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderBooksOrderIdRouteImport.update(
    {
      id: '/$booksOrderId',
      path: '/$booksOrderId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderFirmOrderIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderFirmOrderIdRouteImport.update(
    {
      id: '/$firmOrderId',
      path: '/$firmOrderId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobJobIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobJobIdRouteImport.update(
    {
      id: '/$jobId',
      path: '/$jobId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayRouteImport.update(
    {
      id: '/mutualfunds/reconciliation/position-day/_position-day',
      path: '/mutualfunds/reconciliation/position-day',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskTaskIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskTaskIdRouteImport.update(
    {
      id: '/$taskId',
      path: '/$taskId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderVenueOrderIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderVenueOrderIdRouteImport.update(
    {
      id: '/$venueOrderId',
      path: '/$venueOrderId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderFixOrderIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderFixOrderIdRouteImport.update(
    {
      id: '/$fixOrderId',
      path: '/$fixOrderId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionSessionIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionSessionIdRouteImport.update(
    {
      id: '/$sessionId',
      path: '/$sessionId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRuleIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRuleIdRouteImport.update(
    {
      id: '/$ruleId',
      path: '/$ruleId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportReportIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportReportIdRouteImport.update(
    {
      id: '/$reportId',
      path: '/$reportId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetIndexRouteImport.update(
    {
      id: '/asset/',
      path: '/asset/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobJobIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobJobIdRouteImport.update(
    {
      id: '/$jobId',
      path: '/$jobId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderSweepOrderIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderSweepOrderIdRouteImport.update(
    {
      id: '/$sweepOrderId',
      path: '/$sweepOrderId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantAccountIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantAccountIdRouteImport.update(
    {
      id: '/$accountId',
      path: '/$accountId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskTaskIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskTaskIdRouteImport.update(
    {
      id: '/$taskId',
      path: '/$taskId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportTrfReportIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportTrfReportIdRouteImport.update(
    {
      id: '/$trfReportId',
      path: '/$trfReportId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionSessionIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionSessionIdRouteImport.update(
    {
      id: '/$sessionId',
      path: '/$sessionId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionSessionIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionSessionIdRouteImport.update(
    {
      id: '/$sessionId',
      path: '/$sessionId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcTradeIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcTradeIdRouteImport.update(
    {
      id: '/$tradeId',
      path: '/$tradeId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobJobIdRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobJobIdRouteImport.update(
    {
      id: '/$jobId',
      path: '/$jobId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskTaskIdRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskTaskIdRouteImport.update(
    {
      id: '/$taskId',
      path: '/$taskId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskTaskIdRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskTaskIdRouteImport.update(
    {
      id: '/$taskId',
      path: '/$taskId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestRouteImport.update(
    {
      id: '/file-request/_file-request',
      path: '/file-request',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileRouteImport.update(
    {
      id: '/file/_file',
      path: '/file',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionEventIdRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionEventIdRouteImport.update(
    {
      id: '/$eventId',
      path: '/$eventId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentInstrumentIdRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentInstrumentIdRouteImport.update(
    {
      id: '/$instrumentId',
      path: '/$instrumentId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobJobIdRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobJobIdRouteImport.update(
    {
      id: '/$jobId',
      path: '/$jobId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskTaskIdRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskTaskIdRouteImport.update(
    {
      id: '/$taskId',
      path: '/$taskId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberAccountNumberIdRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberAccountNumberIdRouteImport.update(
    {
      id: '/$accountNumberId',
      path: '/$accountNumberId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchAchIdRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchAchIdRouteImport.update(
    {
      id: '/$achId',
      path: '/$achId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireWireIdRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireWireIdRouteImport.update(
    {
      id: '/$wireId',
      path: '/$wireId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobRouteImport.update(
    {
      id: '/jane-street/pfof/job/_job',
      path: '/jane-street/pfof/job',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationDestinationIdRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationDestinationIdRouteImport.update(
    {
      id: '/$destinationId',
      path: '/$destinationId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobJobIdRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobJobIdRouteImport.update(
    {
      id: '/$jobId',
      path: '/$jobId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderNetOrderIdRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderNetOrderIdRouteImport.update(
    {
      id: '/$netOrderId',
      path: '/$netOrderId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderOrderIdRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderOrderIdRouteImport.update(
    {
      id: '/$orderId',
      path: '/$orderId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskTaskIdRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskTaskIdRouteImport.update(
    {
      id: '/$taskId',
      path: '/$taskId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenProcessorTokenIdRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenProcessorTokenIdRouteImport.update(
    {
      id: '/$processorTokenId',
      path: '/$processorTokenId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobJobIdRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobJobIdRouteImport.update(
    {
      id: '/$jobId',
      path: '/$jobId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500IndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500IndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500Route,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500QuarterRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500QuarterRouteImport.update(
    {
      id: '/$quarter',
      path: '/$quarter',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500Route,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskTaskIdRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskTaskIdRouteImport.update(
    {
      id: '/$taskId',
      path: '/$taskId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashIndexRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentIndexRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentTaxRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentTaxRouteImport.update(
    {
      id: '/tax',
      path: '/tax',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentTradeConfirmationRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentTradeConfirmationRouteImport.update(
    {
      id: '/trade-confirmation',
      path: '/trade-confirmation',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldHoldIdRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldHoldIdRouteImport.update(
    {
      id: '/$holdId',
      path: '/$holdId',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityRouteImport.update(
    {
      id: '/_detail/order/equity/_equity',
      path: '/order/equity',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundRouteImport.update(
    {
      id: '/_detail/order/mutual-fund/_mutual-fund',
      path: '/order/mutual-fund',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionTransactionIdRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionTransactionIdRouteImport.update(
    {
      id: '/$transactionId',
      path: '/$transactionId',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderIndexRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderEquityRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderEquityRouteImport.update(
    {
      id: '/equity',
      path: '/equity',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderMutualFundRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderMutualFundRouteImport.update(
    {
      id: '/mutual-fund',
      path: '/mutual-fund',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutRouteImport.update(
    {
      id: '/$accountId/_layout',
      path: '/$accountId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeRouteImport.update(
    {
      id: '/$feeType/_$feeType',
      path: '/$feeType',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayAssetIdIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayAssetIdIndexRouteImport.update(
    {
      id: '/$assetId/',
      path: '/$assetId/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayAssetIdDateRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayAssetIdDateRouteImport.update(
    {
      id: '/$assetId/$date',
      path: '/$assetId/$date',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetAssetIdDateRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetAssetIdDateRouteImport.update(
    {
      id: '/$assetId/$date',
      path: '/$assetId/$date',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobJobIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobJobIdRouteImport.update(
    {
      id: '/$jobId',
      path: '/$jobId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskTaskIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskTaskIdRouteImport.update(
    {
      id: '/$taskId',
      path: '/$taskId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobJobIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobJobIdRouteImport.update(
    {
      id: '/$jobId',
      path: '/$jobId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskTaskIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskTaskIdRouteImport.update(
    {
      id: '/$taskId',
      path: '/$taskId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdRouteImport.update(
    {
      id: '/$assetId/_$assetId',
      path: '/$assetId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetRouteImport.update(
    {
      id: '/asset/$assetId/_asset',
      path: '/asset/$assetId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobRouteImport.update(
    {
      id: '/$jobId/_job',
      path: '/$jobId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestFileRequestIdRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestFileRequestIdRouteImport.update(
    {
      id: '/$fileRequestId',
      path: '/$fileRequestId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileFileIdRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileFileIdRouteImport.update(
    {
      id: '/$fileId',
      path: '/$fileId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobJobIdRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobJobIdRouteImport.update(
    {
      id: '/$jobId',
      path: '/$jobId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountCostBasisAssetAssetIdRealizationRealizationIdRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountCostBasisAssetAssetIdRealizationRealizationIdRouteImport.update(
    {
      id: '/_cost-basis/asset/$assetId/realization/$realizationId',
      path: '/asset/$assetId/realization/$realizationId',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountCostBasisAssetAssetIdTaxLotTaxLotIdRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountCostBasisAssetAssetIdTaxLotTaxLotIdRouteImport.update(
    {
      id: '/_cost-basis/asset/$assetId/tax-lot/$taxLotId',
      path: '/asset/$assetId/tax-lot/$taxLotId',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRouteImport.update(
    {
      id: '/$assetId/_asset-balance',
      path: '/$assetId',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashSweepAssetIdRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashSweepAssetIdRouteImport.update(
    {
      id: '/sweep/$assetId',
      path: '/sweep/$assetId',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionRouteImport.update(
    {
      id: '/transaction/_transaction',
      path: '/transaction',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingSourceIndexRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingSourceIndexRouteImport.update(
    {
      id: '/source/',
      path: '/source/',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingSourceSourceIdRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingSourceSourceIdRouteImport.update(
    {
      id: '/source/$sourceId',
      path: '/source/$sourceId',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingTransferIndexRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingTransferIndexRouteImport.update(
    {
      id: '/transfer/',
      path: '/transfer/',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingTransferTransferIdRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingTransferTransferIdRouteImport.update(
    {
      id: '/transfer/$transferId',
      path: '/transfer/$transferId',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityOrderIdRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityOrderIdRouteImport.update(
    {
      id: '/$orderId',
      path: '/$orderId',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundFundOrderIdRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundFundOrderIdRouteImport.update(
    {
      id: '/$fundOrderId',
      path: '/$fundOrderId',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutIndexRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutSettingsRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutSettingsRouteImport.update(
    {
      id: '/settings',
      path: '/settings',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeIndexRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeEffectiveDateRoute =
  AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeEffectiveDateRouteImport.update(
    {
      id: '/$effectiveDate',
      path: '/$effectiveDate',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdDateRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdDateRouteImport.update(
    {
      id: '/$date',
      path: '/$date',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueIndexRouteImport.update(
    {
      id: '/$venue/',
      path: '/$venue/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobIndexRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobTaskRoute =
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobTaskRouteImport.update(
    {
      id: '/task',
      path: '/task',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceIndexRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceFundingRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceFundingRouteImport.update(
    {
      id: '/funding',
      path: '/funding',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceHoldRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceHoldRouteImport.update(
    {
      id: '/hold',
      path: '/hold',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionIndexRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionTransactionIdRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionTransactionIdRouteImport.update(
    {
      id: '/$transactionId',
      path: '/$transactionId',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualAccountIdAssetIdSourceFirstDayOfMonthRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualAccountIdAssetIdSourceFirstDayOfMonthRouteImport.update(
    {
      id: '/$accountId/$assetId/$source/$firstDayOfMonth',
      path: '/$accountId/$assetId/$source/$firstDayOfMonth',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueDateIndexRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueDateIndexRouteImport.update(
    {
      id: '/$venue/$date/',
      path: '/$venue/$date/',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueDateAssetIdRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueDateAssetIdRouteImport.update(
    {
      id: '/$venue/$date/$assetId',
      path: '/$venue/$date/$assetId',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayRoute,
    } as any,
  )
const AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetAccountAccountCodeRoute =
  AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetAccountAccountCodeRouteImport.update(
    {
      id: '/account/$accountCode',
      path: '/account/$accountCode',
      getParentRoute: () =>
        AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRealizationIndexRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRealizationIndexRouteImport.update(
    {
      id: '/realization/',
      path: '/realization/',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRoute,
    } as any,
  )
const AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceTaxLotIndexRoute =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceTaxLotIndexRouteImport.update(
    {
      id: '/tax-lot/',
      path: '/tax-lot/',
      getParentRoute: () =>
        AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/mfa-setup': typeof MfaSetupRoute
  '/logout': typeof AppLogoutRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/register': typeof AuthRegisterRoute
  '/request-access': typeof AuthRequestAccessRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/docs': typeof DocsLayoutRouteWithChildren
  '/oauth/consent': typeof OauthConsentRoute
  '/settings/personal': typeof AppSettingsPersonalRoute
  '/login': typeof AuthLoginLoginRouteWithChildren
  '/developer/': typeof AppDeveloperIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/docs/': typeof DocsLayoutIndexRoute
  '/asset': typeof AppClearingCoreAssetAssetRouteWithChildren
  '/hours': typeof AppClearingCoreHoursHoursRouteWithChildren
  '/developer/agent-key': typeof AppDeveloperAgentKeyAgentKeyRouteWithChildren
  '/developer/api-key': typeof AppDeveloperApiKeyApiKeyRouteWithChildren
  '/developer/webhook': typeof AppDeveloperWebhookWebhookRouteWithChildren
  '/login/mfa': typeof AuthLoginLoginMfaRoute
  '/docs/api-reference': typeof DocsLayoutApiReferenceProviderRouteWithChildren
  '/docs/guide': typeof DocsLayoutGuideProviderRouteWithChildren
  '/billing/': typeof AppClearingCoreBillingIndexRoute
  '/dashboard/': typeof AppClearingCoreDashboardIndexRoute
  '/funding/': typeof AppClearingCoreFundingIndexRoute
  '/order/': typeof AppClearingCoreOrderIndexRoute
  '/registration/': typeof AppClearingCoreRegistrationIndexRoute
  '/sweep/': typeof AppClearingCoreSweepIndexRoute
  '/login/': typeof AuthLoginLoginIndexRoute
  '/billing/charge': typeof AppClearingCoreBillingChargeChargeRouteWithChildren
  '/funding/account-number': typeof AppClearingCoreFundingAccountNumberAccountNumberRouteWithChildren
  '/funding/batch-transfer': typeof AppClearingCoreFundingBatchTransferBatchTransferRouteWithChildren
  '/funding/source': typeof AppClearingCoreFundingSourceSourceRouteWithChildren
  '/funding/transfer': typeof AppClearingCoreFundingTransferTransferRouteWithChildren
  '/order/equity': typeof AppClearingCoreOrderEquitySingleRouteWithChildren
  '/order/mutual-fund': typeof AppClearingCoreOrderMutualFundMutualFundRouteWithChildren
  '/registration/profile': typeof AppClearingCoreRegistrationProfileProfileRouteWithChildren
  '/sweep/cutoff': typeof AppClearingCoreSweepCutoffCutoffRouteWithChildren
  '/sweep/plan': typeof AppClearingCoreSweepPlanPlanRouteWithChildren
  '/sweep/target': typeof AppClearingCoreSweepTargetTargetRouteWithChildren
  '/organization': typeof AppPlatformContextRequiredOrganizationOrganizationRouteWithChildren
  '/program': typeof AppPlatformContextRequiredProgramProgramRouteWithChildren
  '/realm-access': typeof AppPlatformContextRequiredRealmAccessRealmAccessRouteWithChildren
  '/realm': typeof AppPlatformContextRequiredRealmRealmRouteWithChildren
  '/role': typeof AppPlatformContextRequiredRoleRoleRouteWithChildren
  '/tenant': typeof AppPlatformContextRequiredTenantTenantRouteWithChildren
  '/user/invitation': typeof AppPlatformContextRequiredUserInvitationRoute
  '/user/request': typeof AppPlatformContextRequiredUserRequestRoute
  '/docs/api-reference/$package': typeof DocsLayoutApiReferenceProviderPackageRoute
  '/docs/guide/$artifactName': typeof DocsLayoutGuideProviderArtifactNameRoute
  '/clearing/': typeof AppClearingCoreClearingRequiredClearingIndexRoute
  '/asset/': typeof AppClearingCoreAssetAssetIndexRoute
  '/hours/': typeof AppClearingCoreHoursHoursIndexRoute
  '/registration/account/': typeof AppClearingCoreRegistrationAccountIndexRoute
  '/user/': typeof AppPlatformContextRequiredUserIndexRoute
  '/developer/agent-key/': typeof AppDeveloperAgentKeyAgentKeyIndexRoute
  '/developer/api-key/': typeof AppDeveloperApiKeyApiKeyIndexRoute
  '/developer/webhook/': typeof AppDeveloperWebhookWebhookIndexRoute
  '/docs/api-reference/': typeof DocsLayoutApiReferenceProviderIndexRoute
  '/docs/guide/': typeof DocsLayoutGuideProviderIndexRoute
  '/clearing/compliance': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceRouteWithChildren
  '/clearing/finance': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceRouteWithChildren
  '/clearing/operations': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRouteWithChildren
  '/clearing/vendor': typeof AppClearingCoreClearingRequiredClearingVendorVendorRouteWithChildren
  '/asset/$assetId': typeof AppClearingCoreAssetAssetAssetIdDetailRouteWithChildren
  '/billing/charge/$chargeId': typeof AppClearingCoreBillingChargeChargeChargeIdRoute
  '/funding/account-number/$accountNumberId': typeof AppClearingCoreFundingAccountNumberAccountNumberAccountNumberIdRoute
  '/funding/batch-transfer/$batchTransferId': typeof AppClearingCoreFundingBatchTransferBatchTransferBatchTransferIdRoute
  '/funding/source/$sourceId': typeof AppClearingCoreFundingSourceSourceSourceIdRoute
  '/funding/transfer/$transferId': typeof AppClearingCoreFundingTransferTransferTransferIdRoute
  '/hours/exception': typeof AppClearingCoreHoursHoursExceptionExceptionRouteWithChildren
  '/hours/schedule/{-$scheduleName}': typeof AppClearingCoreHoursHoursScheduleChar123ScheduleNameChar125Route
  '/order/equity/$orderId': typeof AppClearingCoreOrderEquitySingleOrderIdRoute
  '/order/equity/batch': typeof AppClearingCoreOrderEquityBatchBatchRouteWithChildren
  '/order/mutual-fund/$fundOrderId': typeof AppClearingCoreOrderMutualFundMutualFundFundOrderIdRoute
  '/registration/account/$accountId': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRouteWithChildren
  '/sweep/plan/$sweepPlanId': typeof AppClearingCoreSweepPlanPlanSweepPlanIdRoute
  '/sweep/target/$sweepTargetId': typeof AppClearingCoreSweepTargetTargetSweepTargetIdRoute
  '/tech-ops/cluster': typeof AppO5O5RequiredTechOpsClusterClusterRouteWithChildren
  '/tech-ops/dead-message': typeof AppO5O5RequiredTechOpsDeadMessageDeadMessageRouteWithChildren
  '/tech-ops/deployment': typeof AppO5O5RequiredTechOpsDeploymentDeploymentRouteWithChildren
  '/tech-ops/environment': typeof AppO5O5RequiredTechOpsEnvironmentEnvironmentRouteWithChildren
  '/tech-ops/stack': typeof AppO5O5RequiredTechOpsStackStackRouteWithChildren
  '/tech-ops/test-run': typeof AppO5O5RequiredTechOpsTestRunTestRunRouteWithChildren
  '/tech-ops/trigger': typeof AppO5O5RequiredTechOpsTriggerTriggerRouteWithChildren
  '/realm-access/$realmAccessId': typeof AppPlatformContextRequiredRealmAccessRealmAccessRealmAccessIdRoute
  '/realm/$realmId': typeof AppPlatformContextRequiredRealmRealmRealmIdRoute
  '/role/$roleId': typeof AppPlatformContextRequiredRoleRoleRoleIdRoute
  '/tenant/$tenantId': typeof AppPlatformContextRequiredTenantTenantTenantIdRoute
  '/inbox/': typeof AppClearingCoreClearingRequiredInboxInboxIndexRoute
  '/billing/charge/': typeof AppClearingCoreBillingChargeChargeIndexRoute
  '/funding/account-number/': typeof AppClearingCoreFundingAccountNumberAccountNumberIndexRoute
  '/funding/batch-transfer/': typeof AppClearingCoreFundingBatchTransferBatchTransferIndexRoute
  '/funding/source/': typeof AppClearingCoreFundingSourceSourceIndexRoute
  '/funding/transfer/': typeof AppClearingCoreFundingTransferTransferIndexRoute
  '/order/equity/': typeof AppClearingCoreOrderEquitySingleIndexRoute
  '/order/mutual-fund/': typeof AppClearingCoreOrderMutualFundMutualFundIndexRoute
  '/registration/profile/': typeof AppClearingCoreRegistrationProfileProfileIndexRoute
  '/sweep/cutoff/': typeof AppClearingCoreSweepCutoffCutoffIndexRoute
  '/sweep/plan/': typeof AppClearingCoreSweepPlanPlanIndexRoute
  '/sweep/target/': typeof AppClearingCoreSweepTargetTargetIndexRoute
  '/tech-ops/build/': typeof AppO5O5RequiredTechOpsBuildIndexRoute
  '/organization/': typeof AppPlatformContextRequiredOrganizationOrganizationIndexRoute
  '/program/': typeof AppPlatformContextRequiredProgramProgramIndexRoute
  '/realm-access/': typeof AppPlatformContextRequiredRealmAccessRealmAccessIndexRoute
  '/realm/': typeof AppPlatformContextRequiredRealmRealmIndexRoute
  '/role/': typeof AppPlatformContextRequiredRoleRoleIndexRoute
  '/tenant/': typeof AppPlatformContextRequiredTenantTenantIndexRoute
  '/asset/$assetId/filings': typeof AppClearingCoreAssetAssetAssetIdDetailFilingsRoute
  '/asset/$assetId/market-data': typeof AppClearingCoreAssetAssetAssetIdDetailMarketDataRoute
  '/hours/exception/$exceptionId': typeof AppClearingCoreHoursHoursExceptionExceptionExceptionIdRoute
  '/order/equity/batch/$batchOrderId': typeof AppClearingCoreOrderEquityBatchBatchBatchOrderIdRoute
  '/tech-ops/build/repo': typeof AppO5O5RequiredTechOpsBuildRepoRepoRouteWithChildren
  '/tech-ops/cluster/$clusterId': typeof AppO5O5RequiredTechOpsClusterClusterClusterIdRoute
  '/tech-ops/dead-message/$messageId': typeof AppO5O5RequiredTechOpsDeadMessageDeadMessageMessageIdRoute
  '/tech-ops/deployment/$deploymentId': typeof AppO5O5RequiredTechOpsDeploymentDeploymentDeploymentIdRoute
  '/tech-ops/environment/$environmentId': typeof AppO5O5RequiredTechOpsEnvironmentEnvironmentEnvironmentIdRoute
  '/tech-ops/stack/$stackId': typeof AppO5O5RequiredTechOpsStackStackStackIdRoute
  '/tech-ops/trigger/$triggerId': typeof AppO5O5RequiredTechOpsTriggerTriggerTriggerIdRoute
  '/organization/$organizationId': typeof AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRouteWithChildren
  '/program/$programId': typeof AppPlatformContextRequiredProgramProgramProgramIdProgramRouteWithChildren
  '/clearing/compliance/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceIndexRoute
  '/clearing/finance/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceIndexRoute
  '/clearing/operations/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsIndexRoute
  '/clearing/vendor/': typeof AppClearingCoreClearingRequiredClearingVendorVendorIndexRoute
  '/asset/$assetId/': typeof AppClearingCoreAssetAssetAssetIdDetailIndexRoute
  '/hours/exception/': typeof AppClearingCoreHoursHoursExceptionExceptionIndexRoute
  '/order/equity/batch/': typeof AppClearingCoreOrderEquityBatchBatchIndexRoute
  '/registration/account/$accountId/': typeof AppClearingCoreRegistrationAccountAccountIdAccountIndexRoute
  '/registration/profile/$profileId/': typeof AppClearingCoreRegistrationProfileProfileProfileIdIndexRoute
  '/tech-ops/cluster/': typeof AppO5O5RequiredTechOpsClusterClusterIndexRoute
  '/tech-ops/dead-message/': typeof AppO5O5RequiredTechOpsDeadMessageDeadMessageIndexRoute
  '/tech-ops/deployment/': typeof AppO5O5RequiredTechOpsDeploymentDeploymentIndexRoute
  '/tech-ops/environment/': typeof AppO5O5RequiredTechOpsEnvironmentEnvironmentIndexRoute
  '/tech-ops/stack/': typeof AppO5O5RequiredTechOpsStackStackIndexRoute
  '/tech-ops/test-run/': typeof AppO5O5RequiredTechOpsTestRunTestRunIndexRoute
  '/tech-ops/trigger/': typeof AppO5O5RequiredTechOpsTriggerTriggerIndexRoute
  '/clearing/finance/journal': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryRouteWithChildren
  '/clearing/operations/account/correspondent': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsAccountCorrespondentRoute
  '/clearing/operations/balance': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceRouteWithChildren
  '/clearing/operations/customer-cash-balance': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceRouteWithChildren
  '/clearing/operations/customer-stock-record': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordRouteWithChildren
  '/clearing/operations/customer-sweep-record': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordRouteWithChildren
  '/clearing/operations/journal': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryRouteWithChildren
  '/clearing/operations/reporting/cash-blotter': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingCashBlotterRoute
  '/clearing/operations/reporting/order-blotter': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingOrderBlotterRoute
  '/clearing/operations/reporting/stock-blotter': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingStockBlotterRoute
  '/clearing/operations/stock-record': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordRouteWithChildren
  '/clearing/operations/transaction': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionRouteWithChildren
  '/clearing/operations/trigger': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerRouteWithChildren
  '/clearing/vendor/dtcc': typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccRouteWithChildren
  '/registration/account/$accountId/asset': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListAssetRoute
  '/registration/account/$accountId/funding': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListFundingRoute
  '/registration/account/$accountId/hold': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListHoldRoute
  '/registration/account/$accountId/transaction': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListTransactionRoute
  '/registration/account/$accountId/dividends-receivable': typeof AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableRouteWithChildren
  '/registration/profile/$profileId/edit': typeof AppClearingCoreRegistrationProfileProfileProfileIdEditEditRouteWithChildren
  '/registration/profile/create/$profileType': typeof AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateRouteWithChildren
  '/tech-ops/test-run/$environment/$testRunId': typeof AppO5O5RequiredTechOpsTestRunTestRunEnvironmentTestRunIdRoute
  '/organization/$organizationId/invitation': typeof AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailInvitationRoute
  '/organization/$organizationId/realm-access': typeof AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRealmAccessRoute
  '/clearing/compliance/fincen/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenIndexRoute
  '/clearing/compliance/ofac/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacIndexRoute
  '/clearing/compliance/reporting/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingIndexRoute
  '/clearing/finance/accounting/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIndexRoute
  '/clearing/finance/middle-money/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyIndexRoute
  '/clearing/finance/payment/': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIndexRoute
  '/clearing/operations/account/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsAccountIndexRoute
  '/clearing/operations/dtcc/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccIndexRoute
  '/clearing/operations/generate/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateIndexRoute
  '/clearing/operations/inventory/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryIndexRoute
  '/clearing/operations/mutualfunds/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsIndexRoute
  '/clearing/operations/oms/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsIndexRoute
  '/clearing/operations/reporting/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingIndexRoute
  '/clearing/operations/sweep/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepIndexRoute
  '/clearing/operations/trade/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeIndexRoute
  '/clearing/vendor/beta-nxt/': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtIndexRoute
  '/clearing/vendor/jane-street/': typeof AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetIndexRoute
  '/clearing/vendor/jpm/': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmIndexRoute
  '/clearing/vendor/plaid/': typeof AppClearingCoreClearingRequiredClearingVendorVendorPlaidIndexRoute
  '/clearing/vendor/quote-media/': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaIndexRoute
  '/tech-ops/build/repo/': typeof AppO5O5RequiredTechOpsBuildRepoRepoIndexRoute
  '/tech-ops/test-run/$environment/': typeof AppO5O5RequiredTechOpsTestRunTestRunEnvironmentIndexRoute
  '/organization/$organizationId/': typeof AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailIndexRoute
  '/program/$programId/': typeof AppPlatformContextRequiredProgramProgramProgramIdProgramIndexRoute
  '/clearing/compliance/fincen/entry': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryRouteWithChildren
  '/clearing/compliance/fincen/file': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileRouteWithChildren
  '/clearing/compliance/fincen/match': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchRouteWithChildren
  '/clearing/compliance/ofac/file': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileRouteWithChildren
  '/clearing/compliance/ofac/match': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchRouteWithChildren
  '/clearing/compliance/ofac/sdn': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnRouteWithChildren
  '/clearing/compliance/reporting/blue-sheet': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetRouteWithChildren
  '/clearing/compliance/reporting/cais': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisRouteWithChildren
  '/clearing/compliance/reporting/cat': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatRouteWithChildren
  '/clearing/compliance/reporting/sec-606': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606RouteWithChildren
  '/clearing/finance/accounting/account': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountRouteWithChildren
  '/clearing/finance/accounting/balance-sheet': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetRouteWithChildren
  '/clearing/finance/accounting/income-statement': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementRouteWithChildren
  '/clearing/finance/accounting/transaction': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionRouteWithChildren
  '/clearing/finance/accounting/trial-balance': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceRouteWithChildren
  '/clearing/finance/journal/$entryId': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryEntryIdRoute
  '/clearing/finance/journal/create': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryCreateRoute
  '/clearing/finance/middle-money/fee-rate': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateRouteWithChildren
  '/clearing/finance/payment/account-number': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberRouteWithChildren
  '/clearing/finance/payment/ach': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchRouteWithChildren
  '/clearing/finance/payment/incoming-ach': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchRouteWithChildren
  '/clearing/finance/payment/incoming-wire': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireRouteWithChildren
  '/clearing/finance/payment/wire': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireRouteWithChildren
  '/clearing/operations/balance/$accountCode': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceAccountCodeRoute
  '/clearing/operations/ca/action': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionRouteWithChildren
  '/clearing/operations/ca/payment': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentRouteWithChildren
  '/clearing/operations/dtcc/asset-day': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayRouteWithChildren
  '/clearing/operations/dtcc/asset': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetRouteWithChildren
  '/clearing/operations/inventory/balance': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceRouteWithChildren
  '/clearing/operations/inventory/books-order': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderRouteWithChildren
  '/clearing/operations/inventory/order': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderRouteWithChildren
  '/clearing/operations/inventory/sell-down': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownRouteWithChildren
  '/clearing/operations/inventory/trading-day': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayRouteWithChildren
  '/clearing/operations/journal/$entryId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryEntryIdRoute
  '/clearing/operations/journal/create': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryCreateRoute
  '/clearing/operations/mutualfunds/dividend-accrual': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualRouteWithChildren
  '/clearing/operations/mutualfunds/job': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobRouteWithChildren
  '/clearing/operations/mutualfunds/task': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskRouteWithChildren
  '/clearing/operations/mutualfunds/venue-order': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderRouteWithChildren
  '/clearing/operations/oms/fix-order': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderRouteWithChildren
  '/clearing/operations/oms/fix-session': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionRouteWithChildren
  '/clearing/operations/oms/routing-rule': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRouteWithChildren
  '/clearing/operations/reporting/archive': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportRouteWithChildren
  '/clearing/operations/sweep/job': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobRouteWithChildren
  '/clearing/operations/sweep/order': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderRouteWithChildren
  '/clearing/operations/sweep/participant': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantRouteWithChildren
  '/clearing/operations/sweep/task': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskRouteWithChildren
  '/clearing/operations/trade/trf-report': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportRouteWithChildren
  '/clearing/operations/trade/trf-session': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionRouteWithChildren
  '/clearing/operations/trade/utc-fix-session': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionRouteWithChildren
  '/clearing/operations/trade/utc': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcRouteWithChildren
  '/clearing/operations/transaction/$transactionId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionTransactionIdRoute
  '/clearing/operations/trigger/$triggerId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerTriggerIdRoute
  '/clearing/vendor/beta-nxt/prospectus-job': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobRouteWithChildren
  '/clearing/vendor/beta-nxt/prospectus-task': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskRouteWithChildren
  '/clearing/vendor/beta-nxt/proxy-vote-job': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobRouteWithChildren
  '/clearing/vendor/beta-nxt/proxy-vote-task': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskRouteWithChildren
  '/clearing/vendor/ice/corporate-action': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionRouteWithChildren
  '/clearing/vendor/ice/instrument': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentRouteWithChildren
  '/clearing/vendor/ice/job': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobRouteWithChildren
  '/clearing/vendor/ice/task': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskRouteWithChildren
  '/clearing/vendor/increase/account-number': typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberRouteWithChildren
  '/clearing/vendor/increase/ach': typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchRouteWithChildren
  '/clearing/vendor/increase/wire': typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireRouteWithChildren
  '/clearing/vendor/jpm/destination': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationRouteWithChildren
  '/clearing/vendor/jpm/job': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobRouteWithChildren
  '/clearing/vendor/jpm/net-order': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderRouteWithChildren
  '/clearing/vendor/jpm/order': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderRouteWithChildren
  '/clearing/vendor/jpm/task': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskRouteWithChildren
  '/clearing/vendor/plaid/processor-token': typeof AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenRouteWithChildren
  '/clearing/vendor/quote-media/job': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobRouteWithChildren
  '/clearing/vendor/quote-media/sp-500': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500RouteWithChildren
  '/clearing/vendor/quote-media/task': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskRouteWithChildren
  '/registration/account/$accountId/cash': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashRouteWithChildren
  '/registration/account/$accountId/document': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentRouteWithChildren
  '/registration/account/$accountId/detail/beneficiaries': typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailBeneficiariesRoute
  '/registration/account/$accountId/detail/clearing-controls': typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailClearingControlsRoute
  '/registration/account/$accountId/detail/controls': typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailControlsRoute
  '/registration/account/$accountId/detail/risk': typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailRiskRoute
  '/registration/account/$accountId/order': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderRouteWithChildren
  '/registration/profile/$profileId/edit/review': typeof AppClearingCoreRegistrationProfileProfileProfileIdEditEditReviewRoute
  '/registration/profile/create/$profileType/review': typeof AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateReviewRoute
  '/tech-ops/build/repo/$owner/$name': typeof AppO5O5RequiredTechOpsBuildRepoRepoOwnerNameRoute
  '/program/$programId/configuration/clearing': typeof AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationClearingRoute
  '/program/$programId/configuration/contacts': typeof AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationContactsRoute
  '/program/$programId/configuration/controls': typeof AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationControlsRoute
  '/clearing/finance/journal/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryIndexRoute
  '/clearing/finance/middle-money/taf-report/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyTafReportIndexRoute
  '/clearing/operations/balance/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceIndexRoute
  '/clearing/operations/customer-cash-balance/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceIndexRoute
  '/clearing/operations/customer-stock-record/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordIndexRoute
  '/clearing/operations/customer-sweep-record/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordIndexRoute
  '/clearing/operations/generate/monthly-statement/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementIndexRoute
  '/clearing/operations/journal/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryIndexRoute
  '/clearing/operations/mutualfunds/reconciliation/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationIndexRoute
  '/clearing/operations/stock-record/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordIndexRoute
  '/clearing/operations/transaction/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionIndexRoute
  '/clearing/operations/trigger/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerIndexRoute
  '/clearing/vendor/dtcc/': typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccIndexRoute
  '/clearing/vendor/jpm/emulator/': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmEmulatorIndexRoute
  '/registration/account/$accountId/detail/': typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailIndexRoute
  '/registration/account/$accountId/dividends-receivable/': typeof AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableIndexRoute
  '/registration/profile/$profileId/edit/': typeof AppClearingCoreRegistrationProfileProfileProfileIdEditEditIndexRoute
  '/registration/profile/create/$profileType/': typeof AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateIndexRoute
  '/program/$programId/branding/': typeof AppPlatformContextRequiredProgramProgramProgramIdProgramBrandingIndexRoute
  '/program/$programId/configuration/': typeof AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationIndexRoute
  '/clearing/compliance/fincen/entry/$fincen314EntryId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryFincen314EntryIdRoute
  '/clearing/compliance/fincen/file/$fincen314FileId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileFincen314FileIdRoute
  '/clearing/compliance/fincen/match/$fincen314MatchId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchFincen314MatchIdRoute
  '/clearing/compliance/ofac/file/$ofacFileId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileOfacFileIdRoute
  '/clearing/compliance/ofac/match/$ofacMatchId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchOfacMatchIdRoute
  '/clearing/compliance/ofac/sdn/$ofacSdnId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnOfacSdnIdRoute
  '/clearing/compliance/reporting/blue-sheet/$reportId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetReportIdRoute
  '/clearing/compliance/reporting/cais/$reportId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisReportIdRoute
  '/clearing/compliance/reporting/cat/$reportId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatReportIdRoute
  '/clearing/compliance/reporting/sec-606/$reportId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606ReportIdRoute
  '/clearing/finance/accounting/transaction/$transactionId': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionTransactionIdRoute
  '/clearing/finance/payment/account-number/$accountNumberId': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberAccountNumberIdRoute
  '/clearing/finance/payment/ach/$achId': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchAchIdRoute
  '/clearing/finance/payment/incoming-ach/$achId': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchAchIdRoute
  '/clearing/finance/payment/incoming-wire/$wireId': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireWireIdRoute
  '/clearing/finance/payment/wire/$wireId': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireWireIdRoute
  '/clearing/operations/ca/action/$actionId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionActionIdRoute
  '/clearing/operations/ca/payment/$paymentId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentPaymentIdRoute
  '/clearing/operations/generate/monthly-statement/job': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobRouteWithChildren
  '/clearing/operations/generate/monthly-statement/task': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskRouteWithChildren
  '/clearing/operations/generate/trade-confirmation/job': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobRouteWithChildren
  '/clearing/operations/generate/trade-confirmation/task': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskRouteWithChildren
  '/clearing/operations/inventory/balance/$assetId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceAssetIdRoute
  '/clearing/operations/inventory/books-order/$booksOrderId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderBooksOrderIdRoute
  '/clearing/operations/inventory/order/$firmOrderId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderFirmOrderIdRoute
  '/clearing/operations/mutualfunds/job/$jobId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobJobIdRoute
  '/clearing/operations/mutualfunds/reconciliation/position-day': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayRouteWithChildren
  '/clearing/operations/mutualfunds/task/$taskId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskTaskIdRoute
  '/clearing/operations/mutualfunds/venue-order/$venueOrderId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderVenueOrderIdRoute
  '/clearing/operations/oms/fix-order/$fixOrderId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderFixOrderIdRoute
  '/clearing/operations/oms/fix-session/$sessionId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionSessionIdRoute
  '/clearing/operations/oms/routing-rule/$ruleId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRuleIdRoute
  '/clearing/operations/reporting/archive/$reportId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportReportIdRoute
  '/clearing/operations/sweep/job/$jobId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobJobIdRoute
  '/clearing/operations/sweep/order/$sweepOrderId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderSweepOrderIdRoute
  '/clearing/operations/sweep/participant/$accountId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantAccountIdRoute
  '/clearing/operations/sweep/task/$taskId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskTaskIdRoute
  '/clearing/operations/trade/trf-report/$trfReportId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportTrfReportIdRoute
  '/clearing/operations/trade/trf-session/$sessionId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionSessionIdRoute
  '/clearing/operations/trade/utc-fix-session/$sessionId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionSessionIdRoute
  '/clearing/operations/trade/utc/$tradeId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcTradeIdRoute
  '/clearing/vendor/beta-nxt/prospectus-job/$jobId': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobJobIdRoute
  '/clearing/vendor/beta-nxt/prospectus-task/$taskId': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskTaskIdRoute
  '/clearing/vendor/beta-nxt/proxy-vote-task/$taskId': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskTaskIdRoute
  '/clearing/vendor/dtcc/file-request': typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestRouteWithChildren
  '/clearing/vendor/dtcc/file': typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileRouteWithChildren
  '/clearing/vendor/ice/corporate-action/$eventId': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionEventIdRoute
  '/clearing/vendor/ice/instrument/$instrumentId': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentInstrumentIdRoute
  '/clearing/vendor/ice/job/$jobId': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobJobIdRoute
  '/clearing/vendor/ice/task/$taskId': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskTaskIdRoute
  '/clearing/vendor/increase/account-number/$accountNumberId': typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberAccountNumberIdRoute
  '/clearing/vendor/increase/ach/$achId': typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchAchIdRoute
  '/clearing/vendor/increase/wire/$wireId': typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireWireIdRoute
  '/clearing/vendor/jane-street/pfof/job': typeof AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobRouteWithChildren
  '/clearing/vendor/jpm/destination/$destinationId': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationDestinationIdRoute
  '/clearing/vendor/jpm/job/$jobId': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobJobIdRoute
  '/clearing/vendor/jpm/net-order/$netOrderId': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderNetOrderIdRoute
  '/clearing/vendor/jpm/order/$orderId': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderOrderIdRoute
  '/clearing/vendor/jpm/task/$taskId': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskTaskIdRoute
  '/clearing/vendor/plaid/processor-token/$processorTokenId': typeof AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenProcessorTokenIdRoute
  '/clearing/vendor/quote-media/job/$jobId': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobJobIdRoute
  '/clearing/vendor/quote-media/sp-500/$quarter': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500QuarterRoute
  '/clearing/vendor/quote-media/task/$taskId': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskTaskIdRoute
  '/registration/account/$accountId/document/tax': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentTaxRoute
  '/registration/account/$accountId/document/trade-confirmation': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentTradeConfirmationRoute
  '/registration/account/$accountId/hold/$holdId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldHoldIdRoute
  '/registration/account/$accountId/order/equity': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderEquityRoute
  '/registration/account/$accountId/order/mutual-fund': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderMutualFundRoute
  '/registration/account/$accountId/transaction/$transactionId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionTransactionIdRoute
  '/clearing/compliance/fincen/entry/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryIndexRoute
  '/clearing/compliance/fincen/file/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileIndexRoute
  '/clearing/compliance/fincen/match/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchIndexRoute
  '/clearing/compliance/ofac/file/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileIndexRoute
  '/clearing/compliance/ofac/match/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchIndexRoute
  '/clearing/compliance/ofac/sdn/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnIndexRoute
  '/clearing/compliance/reporting/blue-sheet/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetIndexRoute
  '/clearing/compliance/reporting/cais/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisIndexRoute
  '/clearing/compliance/reporting/cat/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatIndexRoute
  '/clearing/compliance/reporting/sec-606/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606IndexRoute
  '/clearing/finance/accounting/account/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountIndexRoute
  '/clearing/finance/accounting/balance-sheet/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetIndexRoute
  '/clearing/finance/accounting/income-statement/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementIndexRoute
  '/clearing/finance/accounting/transaction/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionIndexRoute
  '/clearing/finance/accounting/trial-balance/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceIndexRoute
  '/clearing/finance/middle-money/fee-rate/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateIndexRoute
  '/clearing/finance/payment/account-number/': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberIndexRoute
  '/clearing/finance/payment/ach/': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchIndexRoute
  '/clearing/finance/payment/incoming-ach/': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchIndexRoute
  '/clearing/finance/payment/incoming-wire/': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireIndexRoute
  '/clearing/finance/payment/wire/': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireIndexRoute
  '/clearing/operations/ca/action/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionIndexRoute
  '/clearing/operations/ca/payment/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentIndexRoute
  '/clearing/operations/dtcc/asset-day/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayIndexRoute
  '/clearing/operations/dtcc/asset/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetIndexRoute
  '/clearing/operations/inventory/balance/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceIndexRoute
  '/clearing/operations/inventory/books-order/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderIndexRoute
  '/clearing/operations/inventory/order/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderIndexRoute
  '/clearing/operations/inventory/sell-down/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownIndexRoute
  '/clearing/operations/inventory/trading-day/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayIndexRoute
  '/clearing/operations/mutualfunds/dividend-accrual/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualIndexRoute
  '/clearing/operations/mutualfunds/job/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobIndexRoute
  '/clearing/operations/mutualfunds/task/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskIndexRoute
  '/clearing/operations/mutualfunds/venue-order/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderIndexRoute
  '/clearing/operations/oms/fix-order/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderIndexRoute
  '/clearing/operations/oms/fix-session/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionIndexRoute
  '/clearing/operations/oms/routing-rule/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleIndexRoute
  '/clearing/operations/reporting/archive/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportIndexRoute
  '/clearing/operations/stock-record/asset/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetIndexRoute
  '/clearing/operations/sweep/job/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobIndexRoute
  '/clearing/operations/sweep/order/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderIndexRoute
  '/clearing/operations/sweep/participant/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantIndexRoute
  '/clearing/operations/sweep/task/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskIndexRoute
  '/clearing/operations/trade/trf-report/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportIndexRoute
  '/clearing/operations/trade/trf-session/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionIndexRoute
  '/clearing/operations/trade/utc-fix-session/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionIndexRoute
  '/clearing/operations/trade/utc/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcIndexRoute
  '/clearing/vendor/beta-nxt/prospectus-job/': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobIndexRoute
  '/clearing/vendor/beta-nxt/prospectus-task/': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskIndexRoute
  '/clearing/vendor/beta-nxt/proxy-vote-job/': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobIndexRoute
  '/clearing/vendor/beta-nxt/proxy-vote-task/': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskIndexRoute
  '/clearing/vendor/ice/corporate-action/': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionIndexRoute
  '/clearing/vendor/ice/instrument/': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentIndexRoute
  '/clearing/vendor/ice/job/': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobIndexRoute
  '/clearing/vendor/ice/task/': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskIndexRoute
  '/clearing/vendor/increase/account-number/': typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberIndexRoute
  '/clearing/vendor/increase/ach/': typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchIndexRoute
  '/clearing/vendor/increase/wire/': typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireIndexRoute
  '/clearing/vendor/jpm/destination/': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationIndexRoute
  '/clearing/vendor/jpm/job/': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobIndexRoute
  '/clearing/vendor/jpm/net-order/': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderIndexRoute
  '/clearing/vendor/jpm/order/': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderIndexRoute
  '/clearing/vendor/jpm/task/': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskIndexRoute
  '/clearing/vendor/plaid/processor-token/': typeof AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenIndexRoute
  '/clearing/vendor/quote-media/job/': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobIndexRoute
  '/clearing/vendor/quote-media/sp-500/': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500IndexRoute
  '/clearing/vendor/quote-media/task/': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskIndexRoute
  '/registration/account/$accountId/cash/': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashIndexRoute
  '/registration/account/$accountId/document/': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentIndexRoute
  '/registration/account/$accountId/order/': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderIndexRoute
  '/clearing/finance/accounting/account/$accountId': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutRouteWithChildren
  '/clearing/finance/middle-money/fee-rate/$feeType': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeRouteWithChildren
  '/clearing/operations/dtcc/asset-day/$assetId/$date': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayAssetIdDateRoute
  '/clearing/operations/dtcc/asset/$assetId/$date': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetAssetIdDateRoute
  '/clearing/operations/generate/monthly-statement/job/$jobId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobJobIdRoute
  '/clearing/operations/generate/monthly-statement/task/$taskId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskTaskIdRoute
  '/clearing/operations/generate/trade-confirmation/job/$jobId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobJobIdRoute
  '/clearing/operations/generate/trade-confirmation/task/$taskId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskTaskIdRoute
  '/clearing/operations/inventory/trading-day/$assetId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdRouteWithChildren
  '/clearing/operations/stock-record/asset/$assetId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetRouteWithChildren
  '/clearing/vendor/beta-nxt/proxy-vote-job/$jobId': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobRouteWithChildren
  '/clearing/vendor/dtcc/file-request/$fileRequestId': typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestFileRequestIdRoute
  '/clearing/vendor/dtcc/file/$fileId': typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileFileIdRoute
  '/clearing/vendor/jane-street/pfof/job/$jobId': typeof AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobJobIdRoute
  '/registration/account/$accountId/asset/$assetId/realization/$realizationId': typeof AppClearingCoreRegistrationAccountAccountIdAccountCostBasisAssetAssetIdRealizationRealizationIdRoute
  '/registration/account/$accountId/asset/$assetId/tax-lot/$taxLotId': typeof AppClearingCoreRegistrationAccountAccountIdAccountCostBasisAssetAssetIdTaxLotTaxLotIdRoute
  '/registration/account/$accountId/asset/$assetId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRouteWithChildren
  '/registration/account/$accountId/cash/sweep/$assetId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashSweepAssetIdRoute
  '/registration/account/$accountId/cash/transaction': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionRouteWithChildren
  '/registration/account/$accountId/funding/source/$sourceId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingSourceSourceIdRoute
  '/registration/account/$accountId/funding/transfer/$transferId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingTransferTransferIdRoute
  '/registration/account/$accountId/order/equity/$orderId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityOrderIdRoute
  '/registration/account/$accountId/order/mutual-fund/$fundOrderId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundFundOrderIdRoute
  '/clearing/operations/dtcc/asset-day/$assetId/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayAssetIdIndexRoute
  '/clearing/operations/generate/monthly-statement/job/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobIndexRoute
  '/clearing/operations/generate/monthly-statement/task/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskIndexRoute
  '/clearing/operations/generate/trade-confirmation/job/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobIndexRoute
  '/clearing/operations/generate/trade-confirmation/task/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskIndexRoute
  '/clearing/operations/mutualfunds/reconciliation/position-day/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayIndexRoute
  '/clearing/vendor/dtcc/file-request/': typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestIndexRoute
  '/clearing/vendor/dtcc/file/': typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileIndexRoute
  '/clearing/vendor/jane-street/pfof/job/': typeof AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobIndexRoute
  '/registration/account/$accountId/funding/source/': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingSourceIndexRoute
  '/registration/account/$accountId/funding/transfer/': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingTransferIndexRoute
  '/clearing/finance/accounting/account/$accountId/settings': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutSettingsRoute
  '/clearing/finance/middle-money/fee-rate/$feeType/$effectiveDate': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeEffectiveDateRoute
  '/clearing/operations/inventory/trading-day/$assetId/$date': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdDateRoute
  '/clearing/vendor/beta-nxt/proxy-vote-job/$jobId/task': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobTaskRoute
  '/registration/account/$accountId/asset/$assetId/funding': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceFundingRoute
  '/registration/account/$accountId/asset/$assetId/hold': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceHoldRoute
  '/registration/account/$accountId/cash/transaction/$transactionId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionTransactionIdRoute
  '/clearing/finance/accounting/account/$accountId/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutIndexRoute
  '/clearing/finance/middle-money/fee-rate/$feeType/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeIndexRoute
  '/clearing/operations/mutualfunds/reconciliation/position-day/$venue/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueIndexRoute
  '/clearing/operations/stock-record/asset/$assetId/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetIndexRoute
  '/clearing/vendor/beta-nxt/proxy-vote-job/$jobId/': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobIndexRoute
  '/registration/account/$accountId/asset/$assetId/': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceIndexRoute
  '/registration/account/$accountId/cash/transaction/': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionIndexRoute
  '/clearing/operations/mutualfunds/dividend-accrual/$accountId/$assetId/$source/$firstDayOfMonth': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualAccountIdAssetIdSourceFirstDayOfMonthRoute
  '/clearing/operations/mutualfunds/reconciliation/position-day/$venue/$date/$assetId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueDateAssetIdRoute
  '/clearing/operations/stock-record/asset/$assetId/account/$accountCode': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetAccountAccountCodeRoute
  '/clearing/operations/mutualfunds/reconciliation/position-day/$venue/$date/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueDateIndexRoute
  '/registration/account/$accountId/asset/$assetId/realization/': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRealizationIndexRoute
  '/registration/account/$accountId/asset/$assetId/tax-lot/': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceTaxLotIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/mfa-setup': typeof MfaSetupRoute
  '/logout': typeof AppLogoutRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/register': typeof AuthRegisterRoute
  '/request-access': typeof AuthRequestAccessRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/settings/personal': typeof AppSettingsPersonalRoute
  '/developer': typeof AppDeveloperIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/docs': typeof DocsLayoutIndexRoute
  '/login/mfa': typeof AuthLoginLoginMfaRoute
  '/billing': typeof AppClearingCoreBillingIndexRoute
  '/dashboard': typeof AppClearingCoreDashboardIndexRoute
  '/funding': typeof AppClearingCoreFundingIndexRoute
  '/order': typeof AppClearingCoreOrderIndexRoute
  '/registration': typeof AppClearingCoreRegistrationIndexRoute
  '/sweep': typeof AppClearingCoreSweepIndexRoute
  '/login': typeof AuthLoginLoginIndexRoute
  '/user/invitation': typeof AppPlatformContextRequiredUserInvitationRoute
  '/user/request': typeof AppPlatformContextRequiredUserRequestRoute
  '/docs/api-reference/$package': typeof DocsLayoutApiReferenceProviderPackageRoute
  '/docs/guide/$artifactName': typeof DocsLayoutGuideProviderArtifactNameRoute
  '/clearing': typeof AppClearingCoreClearingRequiredClearingIndexRoute
  '/asset': typeof AppClearingCoreAssetAssetIndexRoute
  '/hours': typeof AppClearingCoreHoursHoursIndexRoute
  '/registration/account': typeof AppClearingCoreRegistrationAccountIndexRoute
  '/user': typeof AppPlatformContextRequiredUserIndexRoute
  '/developer/agent-key': typeof AppDeveloperAgentKeyAgentKeyIndexRoute
  '/developer/api-key': typeof AppDeveloperApiKeyApiKeyIndexRoute
  '/developer/webhook': typeof AppDeveloperWebhookWebhookIndexRoute
  '/docs/api-reference': typeof DocsLayoutApiReferenceProviderIndexRoute
  '/docs/guide': typeof DocsLayoutGuideProviderIndexRoute
  '/billing/charge/$chargeId': typeof AppClearingCoreBillingChargeChargeChargeIdRoute
  '/funding/account-number/$accountNumberId': typeof AppClearingCoreFundingAccountNumberAccountNumberAccountNumberIdRoute
  '/funding/batch-transfer/$batchTransferId': typeof AppClearingCoreFundingBatchTransferBatchTransferBatchTransferIdRoute
  '/funding/source/$sourceId': typeof AppClearingCoreFundingSourceSourceSourceIdRoute
  '/funding/transfer/$transferId': typeof AppClearingCoreFundingTransferTransferTransferIdRoute
  '/hours/schedule/{-$scheduleName}': typeof AppClearingCoreHoursHoursScheduleChar123ScheduleNameChar125Route
  '/order/equity/$orderId': typeof AppClearingCoreOrderEquitySingleOrderIdRoute
  '/order/mutual-fund/$fundOrderId': typeof AppClearingCoreOrderMutualFundMutualFundFundOrderIdRoute
  '/sweep/plan/$sweepPlanId': typeof AppClearingCoreSweepPlanPlanSweepPlanIdRoute
  '/sweep/target/$sweepTargetId': typeof AppClearingCoreSweepTargetTargetSweepTargetIdRoute
  '/realm-access/$realmAccessId': typeof AppPlatformContextRequiredRealmAccessRealmAccessRealmAccessIdRoute
  '/realm/$realmId': typeof AppPlatformContextRequiredRealmRealmRealmIdRoute
  '/role/$roleId': typeof AppPlatformContextRequiredRoleRoleRoleIdRoute
  '/tenant/$tenantId': typeof AppPlatformContextRequiredTenantTenantTenantIdRoute
  '/inbox': typeof AppClearingCoreClearingRequiredInboxInboxIndexRoute
  '/billing/charge': typeof AppClearingCoreBillingChargeChargeIndexRoute
  '/funding/account-number': typeof AppClearingCoreFundingAccountNumberAccountNumberIndexRoute
  '/funding/batch-transfer': typeof AppClearingCoreFundingBatchTransferBatchTransferIndexRoute
  '/funding/source': typeof AppClearingCoreFundingSourceSourceIndexRoute
  '/funding/transfer': typeof AppClearingCoreFundingTransferTransferIndexRoute
  '/order/equity': typeof AppClearingCoreOrderEquitySingleIndexRoute
  '/order/mutual-fund': typeof AppClearingCoreOrderMutualFundMutualFundIndexRoute
  '/registration/profile': typeof AppClearingCoreRegistrationProfileProfileIndexRoute
  '/sweep/cutoff': typeof AppClearingCoreSweepCutoffCutoffIndexRoute
  '/sweep/plan': typeof AppClearingCoreSweepPlanPlanIndexRoute
  '/sweep/target': typeof AppClearingCoreSweepTargetTargetIndexRoute
  '/tech-ops/build': typeof AppO5O5RequiredTechOpsBuildIndexRoute
  '/organization': typeof AppPlatformContextRequiredOrganizationOrganizationIndexRoute
  '/program': typeof AppPlatformContextRequiredProgramProgramIndexRoute
  '/realm-access': typeof AppPlatformContextRequiredRealmAccessRealmAccessIndexRoute
  '/realm': typeof AppPlatformContextRequiredRealmRealmIndexRoute
  '/role': typeof AppPlatformContextRequiredRoleRoleIndexRoute
  '/tenant': typeof AppPlatformContextRequiredTenantTenantIndexRoute
  '/asset/$assetId/filings': typeof AppClearingCoreAssetAssetAssetIdDetailFilingsRoute
  '/asset/$assetId/market-data': typeof AppClearingCoreAssetAssetAssetIdDetailMarketDataRoute
  '/hours/exception/$exceptionId': typeof AppClearingCoreHoursHoursExceptionExceptionExceptionIdRoute
  '/order/equity/batch/$batchOrderId': typeof AppClearingCoreOrderEquityBatchBatchBatchOrderIdRoute
  '/registration/account/$accountId': typeof AppClearingCoreRegistrationAccountAccountIdAccountIndexRoute
  '/tech-ops/cluster/$clusterId': typeof AppO5O5RequiredTechOpsClusterClusterClusterIdRoute
  '/tech-ops/dead-message/$messageId': typeof AppO5O5RequiredTechOpsDeadMessageDeadMessageMessageIdRoute
  '/tech-ops/deployment/$deploymentId': typeof AppO5O5RequiredTechOpsDeploymentDeploymentDeploymentIdRoute
  '/tech-ops/environment/$environmentId': typeof AppO5O5RequiredTechOpsEnvironmentEnvironmentEnvironmentIdRoute
  '/tech-ops/stack/$stackId': typeof AppO5O5RequiredTechOpsStackStackStackIdRoute
  '/tech-ops/trigger/$triggerId': typeof AppO5O5RequiredTechOpsTriggerTriggerTriggerIdRoute
  '/clearing/compliance': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceIndexRoute
  '/clearing/finance': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceIndexRoute
  '/clearing/operations': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsIndexRoute
  '/clearing/vendor': typeof AppClearingCoreClearingRequiredClearingVendorVendorIndexRoute
  '/asset/$assetId': typeof AppClearingCoreAssetAssetAssetIdDetailIndexRoute
  '/hours/exception': typeof AppClearingCoreHoursHoursExceptionExceptionIndexRoute
  '/order/equity/batch': typeof AppClearingCoreOrderEquityBatchBatchIndexRoute
  '/registration/profile/$profileId': typeof AppClearingCoreRegistrationProfileProfileProfileIdIndexRoute
  '/tech-ops/cluster': typeof AppO5O5RequiredTechOpsClusterClusterIndexRoute
  '/tech-ops/dead-message': typeof AppO5O5RequiredTechOpsDeadMessageDeadMessageIndexRoute
  '/tech-ops/deployment': typeof AppO5O5RequiredTechOpsDeploymentDeploymentIndexRoute
  '/tech-ops/environment': typeof AppO5O5RequiredTechOpsEnvironmentEnvironmentIndexRoute
  '/tech-ops/stack': typeof AppO5O5RequiredTechOpsStackStackIndexRoute
  '/tech-ops/test-run': typeof AppO5O5RequiredTechOpsTestRunTestRunIndexRoute
  '/tech-ops/trigger': typeof AppO5O5RequiredTechOpsTriggerTriggerIndexRoute
  '/clearing/operations/account/correspondent': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsAccountCorrespondentRoute
  '/clearing/operations/reporting/cash-blotter': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingCashBlotterRoute
  '/clearing/operations/reporting/order-blotter': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingOrderBlotterRoute
  '/clearing/operations/reporting/stock-blotter': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingStockBlotterRoute
  '/registration/account/$accountId/asset': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListAssetRoute
  '/registration/account/$accountId/funding': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListFundingRoute
  '/registration/account/$accountId/hold': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListHoldRoute
  '/registration/account/$accountId/transaction': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListTransactionRoute
  '/tech-ops/test-run/$environment/$testRunId': typeof AppO5O5RequiredTechOpsTestRunTestRunEnvironmentTestRunIdRoute
  '/organization/$organizationId/invitation': typeof AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailInvitationRoute
  '/organization/$organizationId/realm-access': typeof AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRealmAccessRoute
  '/clearing/compliance/fincen': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenIndexRoute
  '/clearing/compliance/ofac': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacIndexRoute
  '/clearing/compliance/reporting': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingIndexRoute
  '/clearing/finance/accounting': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIndexRoute
  '/clearing/finance/middle-money': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyIndexRoute
  '/clearing/finance/payment': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIndexRoute
  '/clearing/operations/account': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsAccountIndexRoute
  '/clearing/operations/dtcc': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccIndexRoute
  '/clearing/operations/generate': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateIndexRoute
  '/clearing/operations/inventory': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryIndexRoute
  '/clearing/operations/mutualfunds': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsIndexRoute
  '/clearing/operations/oms': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsIndexRoute
  '/clearing/operations/reporting': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingIndexRoute
  '/clearing/operations/sweep': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepIndexRoute
  '/clearing/operations/trade': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeIndexRoute
  '/clearing/vendor/beta-nxt': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtIndexRoute
  '/clearing/vendor/jane-street': typeof AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetIndexRoute
  '/clearing/vendor/jpm': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmIndexRoute
  '/clearing/vendor/plaid': typeof AppClearingCoreClearingRequiredClearingVendorVendorPlaidIndexRoute
  '/clearing/vendor/quote-media': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaIndexRoute
  '/tech-ops/build/repo': typeof AppO5O5RequiredTechOpsBuildRepoRepoIndexRoute
  '/tech-ops/test-run/$environment': typeof AppO5O5RequiredTechOpsTestRunTestRunEnvironmentIndexRoute
  '/organization/$organizationId': typeof AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailIndexRoute
  '/program/$programId': typeof AppPlatformContextRequiredProgramProgramProgramIdProgramIndexRoute
  '/clearing/finance/journal/$entryId': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryEntryIdRoute
  '/clearing/finance/journal/create': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryCreateRoute
  '/clearing/operations/balance/$accountCode': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceAccountCodeRoute
  '/clearing/operations/journal/$entryId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryEntryIdRoute
  '/clearing/operations/journal/create': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryCreateRoute
  '/clearing/operations/transaction/$transactionId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionTransactionIdRoute
  '/clearing/operations/trigger/$triggerId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerTriggerIdRoute
  '/registration/account/$accountId/detail/beneficiaries': typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailBeneficiariesRoute
  '/registration/account/$accountId/detail/clearing-controls': typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailClearingControlsRoute
  '/registration/account/$accountId/detail/controls': typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailControlsRoute
  '/registration/account/$accountId/detail/risk': typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailRiskRoute
  '/registration/profile/$profileId/edit/review': typeof AppClearingCoreRegistrationProfileProfileProfileIdEditEditReviewRoute
  '/registration/profile/create/$profileType/review': typeof AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateReviewRoute
  '/tech-ops/build/repo/$owner/$name': typeof AppO5O5RequiredTechOpsBuildRepoRepoOwnerNameRoute
  '/program/$programId/configuration/clearing': typeof AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationClearingRoute
  '/program/$programId/configuration/contacts': typeof AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationContactsRoute
  '/program/$programId/configuration/controls': typeof AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationControlsRoute
  '/clearing/finance/journal': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryIndexRoute
  '/clearing/finance/middle-money/taf-report': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyTafReportIndexRoute
  '/clearing/operations/balance': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceIndexRoute
  '/clearing/operations/customer-cash-balance': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceIndexRoute
  '/clearing/operations/customer-stock-record': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordIndexRoute
  '/clearing/operations/customer-sweep-record': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordIndexRoute
  '/clearing/operations/generate/monthly-statement': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementIndexRoute
  '/clearing/operations/journal': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryIndexRoute
  '/clearing/operations/mutualfunds/reconciliation': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationIndexRoute
  '/clearing/operations/stock-record': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordIndexRoute
  '/clearing/operations/transaction': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionIndexRoute
  '/clearing/operations/trigger': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerIndexRoute
  '/clearing/vendor/dtcc': typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccIndexRoute
  '/clearing/vendor/jpm/emulator': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmEmulatorIndexRoute
  '/registration/account/$accountId/detail': typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailIndexRoute
  '/registration/account/$accountId/dividends-receivable': typeof AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableIndexRoute
  '/registration/profile/$profileId/edit': typeof AppClearingCoreRegistrationProfileProfileProfileIdEditEditIndexRoute
  '/registration/profile/create/$profileType': typeof AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateIndexRoute
  '/program/$programId/branding': typeof AppPlatformContextRequiredProgramProgramProgramIdProgramBrandingIndexRoute
  '/program/$programId/configuration': typeof AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationIndexRoute
  '/clearing/compliance/fincen/entry/$fincen314EntryId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryFincen314EntryIdRoute
  '/clearing/compliance/fincen/file/$fincen314FileId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileFincen314FileIdRoute
  '/clearing/compliance/fincen/match/$fincen314MatchId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchFincen314MatchIdRoute
  '/clearing/compliance/ofac/file/$ofacFileId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileOfacFileIdRoute
  '/clearing/compliance/ofac/match/$ofacMatchId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchOfacMatchIdRoute
  '/clearing/compliance/ofac/sdn/$ofacSdnId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnOfacSdnIdRoute
  '/clearing/compliance/reporting/blue-sheet/$reportId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetReportIdRoute
  '/clearing/compliance/reporting/cais/$reportId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisReportIdRoute
  '/clearing/compliance/reporting/cat/$reportId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatReportIdRoute
  '/clearing/compliance/reporting/sec-606/$reportId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606ReportIdRoute
  '/clearing/finance/accounting/transaction/$transactionId': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionTransactionIdRoute
  '/clearing/finance/payment/account-number/$accountNumberId': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberAccountNumberIdRoute
  '/clearing/finance/payment/ach/$achId': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchAchIdRoute
  '/clearing/finance/payment/incoming-ach/$achId': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchAchIdRoute
  '/clearing/finance/payment/incoming-wire/$wireId': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireWireIdRoute
  '/clearing/finance/payment/wire/$wireId': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireWireIdRoute
  '/clearing/operations/ca/action/$actionId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionActionIdRoute
  '/clearing/operations/ca/payment/$paymentId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentPaymentIdRoute
  '/clearing/operations/inventory/balance/$assetId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceAssetIdRoute
  '/clearing/operations/inventory/books-order/$booksOrderId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderBooksOrderIdRoute
  '/clearing/operations/inventory/order/$firmOrderId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderFirmOrderIdRoute
  '/clearing/operations/mutualfunds/job/$jobId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobJobIdRoute
  '/clearing/operations/mutualfunds/task/$taskId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskTaskIdRoute
  '/clearing/operations/mutualfunds/venue-order/$venueOrderId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderVenueOrderIdRoute
  '/clearing/operations/oms/fix-order/$fixOrderId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderFixOrderIdRoute
  '/clearing/operations/oms/fix-session/$sessionId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionSessionIdRoute
  '/clearing/operations/oms/routing-rule/$ruleId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRuleIdRoute
  '/clearing/operations/reporting/archive/$reportId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportReportIdRoute
  '/clearing/operations/sweep/job/$jobId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobJobIdRoute
  '/clearing/operations/sweep/order/$sweepOrderId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderSweepOrderIdRoute
  '/clearing/operations/sweep/participant/$accountId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantAccountIdRoute
  '/clearing/operations/sweep/task/$taskId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskTaskIdRoute
  '/clearing/operations/trade/trf-report/$trfReportId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportTrfReportIdRoute
  '/clearing/operations/trade/trf-session/$sessionId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionSessionIdRoute
  '/clearing/operations/trade/utc-fix-session/$sessionId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionSessionIdRoute
  '/clearing/operations/trade/utc/$tradeId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcTradeIdRoute
  '/clearing/vendor/beta-nxt/prospectus-job/$jobId': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobJobIdRoute
  '/clearing/vendor/beta-nxt/prospectus-task/$taskId': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskTaskIdRoute
  '/clearing/vendor/beta-nxt/proxy-vote-task/$taskId': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskTaskIdRoute
  '/clearing/vendor/ice/corporate-action/$eventId': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionEventIdRoute
  '/clearing/vendor/ice/instrument/$instrumentId': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentInstrumentIdRoute
  '/clearing/vendor/ice/job/$jobId': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobJobIdRoute
  '/clearing/vendor/ice/task/$taskId': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskTaskIdRoute
  '/clearing/vendor/increase/account-number/$accountNumberId': typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberAccountNumberIdRoute
  '/clearing/vendor/increase/ach/$achId': typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchAchIdRoute
  '/clearing/vendor/increase/wire/$wireId': typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireWireIdRoute
  '/clearing/vendor/jpm/destination/$destinationId': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationDestinationIdRoute
  '/clearing/vendor/jpm/job/$jobId': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobJobIdRoute
  '/clearing/vendor/jpm/net-order/$netOrderId': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderNetOrderIdRoute
  '/clearing/vendor/jpm/order/$orderId': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderOrderIdRoute
  '/clearing/vendor/jpm/task/$taskId': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskTaskIdRoute
  '/clearing/vendor/plaid/processor-token/$processorTokenId': typeof AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenProcessorTokenIdRoute
  '/clearing/vendor/quote-media/job/$jobId': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobJobIdRoute
  '/clearing/vendor/quote-media/sp-500/$quarter': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500QuarterRoute
  '/clearing/vendor/quote-media/task/$taskId': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskTaskIdRoute
  '/registration/account/$accountId/document/tax': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentTaxRoute
  '/registration/account/$accountId/document/trade-confirmation': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentTradeConfirmationRoute
  '/registration/account/$accountId/hold/$holdId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldHoldIdRoute
  '/registration/account/$accountId/order/equity': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderEquityRoute
  '/registration/account/$accountId/order/mutual-fund': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderMutualFundRoute
  '/registration/account/$accountId/transaction/$transactionId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionTransactionIdRoute
  '/clearing/compliance/fincen/entry': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryIndexRoute
  '/clearing/compliance/fincen/file': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileIndexRoute
  '/clearing/compliance/fincen/match': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchIndexRoute
  '/clearing/compliance/ofac/file': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileIndexRoute
  '/clearing/compliance/ofac/match': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchIndexRoute
  '/clearing/compliance/ofac/sdn': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnIndexRoute
  '/clearing/compliance/reporting/blue-sheet': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetIndexRoute
  '/clearing/compliance/reporting/cais': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisIndexRoute
  '/clearing/compliance/reporting/cat': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatIndexRoute
  '/clearing/compliance/reporting/sec-606': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606IndexRoute
  '/clearing/finance/accounting/account': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountIndexRoute
  '/clearing/finance/accounting/balance-sheet': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetIndexRoute
  '/clearing/finance/accounting/income-statement': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementIndexRoute
  '/clearing/finance/accounting/transaction': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionIndexRoute
  '/clearing/finance/accounting/trial-balance': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceIndexRoute
  '/clearing/finance/middle-money/fee-rate': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateIndexRoute
  '/clearing/finance/payment/account-number': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberIndexRoute
  '/clearing/finance/payment/ach': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchIndexRoute
  '/clearing/finance/payment/incoming-ach': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchIndexRoute
  '/clearing/finance/payment/incoming-wire': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireIndexRoute
  '/clearing/finance/payment/wire': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireIndexRoute
  '/clearing/operations/ca/action': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionIndexRoute
  '/clearing/operations/ca/payment': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentIndexRoute
  '/clearing/operations/dtcc/asset-day': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayIndexRoute
  '/clearing/operations/dtcc/asset': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetIndexRoute
  '/clearing/operations/inventory/balance': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceIndexRoute
  '/clearing/operations/inventory/books-order': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderIndexRoute
  '/clearing/operations/inventory/order': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderIndexRoute
  '/clearing/operations/inventory/sell-down': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownIndexRoute
  '/clearing/operations/inventory/trading-day': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayIndexRoute
  '/clearing/operations/mutualfunds/dividend-accrual': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualIndexRoute
  '/clearing/operations/mutualfunds/job': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobIndexRoute
  '/clearing/operations/mutualfunds/task': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskIndexRoute
  '/clearing/operations/mutualfunds/venue-order': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderIndexRoute
  '/clearing/operations/oms/fix-order': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderIndexRoute
  '/clearing/operations/oms/fix-session': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionIndexRoute
  '/clearing/operations/oms/routing-rule': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleIndexRoute
  '/clearing/operations/reporting/archive': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportIndexRoute
  '/clearing/operations/stock-record/asset': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetIndexRoute
  '/clearing/operations/sweep/job': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobIndexRoute
  '/clearing/operations/sweep/order': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderIndexRoute
  '/clearing/operations/sweep/participant': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantIndexRoute
  '/clearing/operations/sweep/task': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskIndexRoute
  '/clearing/operations/trade/trf-report': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportIndexRoute
  '/clearing/operations/trade/trf-session': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionIndexRoute
  '/clearing/operations/trade/utc-fix-session': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionIndexRoute
  '/clearing/operations/trade/utc': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcIndexRoute
  '/clearing/vendor/beta-nxt/prospectus-job': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobIndexRoute
  '/clearing/vendor/beta-nxt/prospectus-task': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskIndexRoute
  '/clearing/vendor/beta-nxt/proxy-vote-job': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobIndexRoute
  '/clearing/vendor/beta-nxt/proxy-vote-task': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskIndexRoute
  '/clearing/vendor/ice/corporate-action': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionIndexRoute
  '/clearing/vendor/ice/instrument': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentIndexRoute
  '/clearing/vendor/ice/job': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobIndexRoute
  '/clearing/vendor/ice/task': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskIndexRoute
  '/clearing/vendor/increase/account-number': typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberIndexRoute
  '/clearing/vendor/increase/ach': typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchIndexRoute
  '/clearing/vendor/increase/wire': typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireIndexRoute
  '/clearing/vendor/jpm/destination': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationIndexRoute
  '/clearing/vendor/jpm/job': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobIndexRoute
  '/clearing/vendor/jpm/net-order': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderIndexRoute
  '/clearing/vendor/jpm/order': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderIndexRoute
  '/clearing/vendor/jpm/task': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskIndexRoute
  '/clearing/vendor/plaid/processor-token': typeof AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenIndexRoute
  '/clearing/vendor/quote-media/job': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobIndexRoute
  '/clearing/vendor/quote-media/sp-500': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500IndexRoute
  '/clearing/vendor/quote-media/task': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskIndexRoute
  '/registration/account/$accountId/cash': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashIndexRoute
  '/registration/account/$accountId/document': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentIndexRoute
  '/registration/account/$accountId/order': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderIndexRoute
  '/clearing/operations/dtcc/asset-day/$assetId/$date': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayAssetIdDateRoute
  '/clearing/operations/dtcc/asset/$assetId/$date': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetAssetIdDateRoute
  '/clearing/operations/generate/monthly-statement/job/$jobId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobJobIdRoute
  '/clearing/operations/generate/monthly-statement/task/$taskId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskTaskIdRoute
  '/clearing/operations/generate/trade-confirmation/job/$jobId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobJobIdRoute
  '/clearing/operations/generate/trade-confirmation/task/$taskId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskTaskIdRoute
  '/clearing/operations/inventory/trading-day/$assetId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdRouteWithChildren
  '/clearing/vendor/dtcc/file-request/$fileRequestId': typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestFileRequestIdRoute
  '/clearing/vendor/dtcc/file/$fileId': typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileFileIdRoute
  '/clearing/vendor/jane-street/pfof/job/$jobId': typeof AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobJobIdRoute
  '/registration/account/$accountId/asset/$assetId/realization/$realizationId': typeof AppClearingCoreRegistrationAccountAccountIdAccountCostBasisAssetAssetIdRealizationRealizationIdRoute
  '/registration/account/$accountId/asset/$assetId/tax-lot/$taxLotId': typeof AppClearingCoreRegistrationAccountAccountIdAccountCostBasisAssetAssetIdTaxLotTaxLotIdRoute
  '/registration/account/$accountId/cash/sweep/$assetId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashSweepAssetIdRoute
  '/registration/account/$accountId/funding/source/$sourceId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingSourceSourceIdRoute
  '/registration/account/$accountId/funding/transfer/$transferId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingTransferTransferIdRoute
  '/registration/account/$accountId/order/equity/$orderId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityOrderIdRoute
  '/registration/account/$accountId/order/mutual-fund/$fundOrderId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundFundOrderIdRoute
  '/clearing/operations/dtcc/asset-day/$assetId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayAssetIdIndexRoute
  '/clearing/operations/generate/monthly-statement/job': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobIndexRoute
  '/clearing/operations/generate/monthly-statement/task': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskIndexRoute
  '/clearing/operations/generate/trade-confirmation/job': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobIndexRoute
  '/clearing/operations/generate/trade-confirmation/task': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskIndexRoute
  '/clearing/operations/mutualfunds/reconciliation/position-day': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayIndexRoute
  '/clearing/vendor/dtcc/file-request': typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestIndexRoute
  '/clearing/vendor/dtcc/file': typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileIndexRoute
  '/clearing/vendor/jane-street/pfof/job': typeof AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobIndexRoute
  '/registration/account/$accountId/funding/source': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingSourceIndexRoute
  '/registration/account/$accountId/funding/transfer': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingTransferIndexRoute
  '/clearing/finance/accounting/account/$accountId/settings': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutSettingsRoute
  '/clearing/finance/middle-money/fee-rate/$feeType/$effectiveDate': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeEffectiveDateRoute
  '/clearing/operations/inventory/trading-day/$assetId/$date': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdDateRoute
  '/clearing/vendor/beta-nxt/proxy-vote-job/$jobId/task': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobTaskRoute
  '/registration/account/$accountId/asset/$assetId/funding': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceFundingRoute
  '/registration/account/$accountId/asset/$assetId/hold': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceHoldRoute
  '/registration/account/$accountId/cash/transaction/$transactionId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionTransactionIdRoute
  '/clearing/finance/accounting/account/$accountId': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutIndexRoute
  '/clearing/finance/middle-money/fee-rate/$feeType': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeIndexRoute
  '/clearing/operations/mutualfunds/reconciliation/position-day/$venue': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueIndexRoute
  '/clearing/operations/stock-record/asset/$assetId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetIndexRoute
  '/clearing/vendor/beta-nxt/proxy-vote-job/$jobId': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobIndexRoute
  '/registration/account/$accountId/asset/$assetId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceIndexRoute
  '/registration/account/$accountId/cash/transaction': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionIndexRoute
  '/clearing/operations/mutualfunds/dividend-accrual/$accountId/$assetId/$source/$firstDayOfMonth': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualAccountIdAssetIdSourceFirstDayOfMonthRoute
  '/clearing/operations/mutualfunds/reconciliation/position-day/$venue/$date/$assetId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueDateAssetIdRoute
  '/clearing/operations/stock-record/asset/$assetId/account/$accountCode': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetAccountAccountCodeRoute
  '/clearing/operations/mutualfunds/reconciliation/position-day/$venue/$date': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueDateIndexRoute
  '/registration/account/$accountId/asset/$assetId/realization': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRealizationIndexRoute
  '/registration/account/$accountId/asset/$assetId/tax-lot': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceTaxLotIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/accept-invitation': typeof AcceptInvitationRoute
  '/mfa-setup': typeof MfaSetupRoute
  '/_app/_clearing-core': typeof AppClearingCoreRouteWithChildren
  '/_app/logout': typeof AppLogoutRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/register': typeof AuthRegisterRoute
  '/_auth/request-access': typeof AuthRequestAccessRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/docs/_layout': typeof DocsLayoutRouteWithChildren
  '/oauth/consent': typeof OauthConsentRoute
  '/_app/_clearing-core/_clearing-required': typeof AppClearingCoreClearingRequiredRouteWithChildren
  '/_app/_o5/_o5-required': typeof AppO5O5RequiredRouteWithChildren
  '/_app/_platform/_context-required': typeof AppPlatformContextRequiredRouteWithChildren
  '/_app/settings/personal': typeof AppSettingsPersonalRoute
  '/_auth/login/_login': typeof AuthLoginLoginRouteWithChildren
  '/_app/developer/': typeof AppDeveloperIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/docs/_layout/': typeof DocsLayoutIndexRoute
  '/_app/_clearing-core/asset/_asset': typeof AppClearingCoreAssetAssetRouteWithChildren
  '/_app/_clearing-core/hours/_hours': typeof AppClearingCoreHoursHoursRouteWithChildren
  '/_app/developer/agent-key/_agent-key': typeof AppDeveloperAgentKeyAgentKeyRouteWithChildren
  '/_app/developer/api-key/_api-key': typeof AppDeveloperApiKeyApiKeyRouteWithChildren
  '/_app/developer/webhook/_webhook': typeof AppDeveloperWebhookWebhookRouteWithChildren
  '/_auth/login/_login/mfa': typeof AuthLoginLoginMfaRoute
  '/docs/_layout/api-reference/_provider': typeof DocsLayoutApiReferenceProviderRouteWithChildren
  '/docs/_layout/guide/_provider': typeof DocsLayoutGuideProviderRouteWithChildren
  '/_app/_clearing-core/billing/': typeof AppClearingCoreBillingIndexRoute
  '/_app/_clearing-core/dashboard/': typeof AppClearingCoreDashboardIndexRoute
  '/_app/_clearing-core/funding/': typeof AppClearingCoreFundingIndexRoute
  '/_app/_clearing-core/order/': typeof AppClearingCoreOrderIndexRoute
  '/_app/_clearing-core/registration/': typeof AppClearingCoreRegistrationIndexRoute
  '/_app/_clearing-core/sweep/': typeof AppClearingCoreSweepIndexRoute
  '/_auth/login/_login/': typeof AuthLoginLoginIndexRoute
  '/_app/_clearing-core/billing/charge/_charge': typeof AppClearingCoreBillingChargeChargeRouteWithChildren
  '/_app/_clearing-core/funding/account-number/_account-number': typeof AppClearingCoreFundingAccountNumberAccountNumberRouteWithChildren
  '/_app/_clearing-core/funding/batch-transfer/_batch-transfer': typeof AppClearingCoreFundingBatchTransferBatchTransferRouteWithChildren
  '/_app/_clearing-core/funding/source/_source': typeof AppClearingCoreFundingSourceSourceRouteWithChildren
  '/_app/_clearing-core/funding/transfer/_transfer': typeof AppClearingCoreFundingTransferTransferRouteWithChildren
  '/_app/_clearing-core/order/equity/_single': typeof AppClearingCoreOrderEquitySingleRouteWithChildren
  '/_app/_clearing-core/order/mutual-fund/_mutual-fund': typeof AppClearingCoreOrderMutualFundMutualFundRouteWithChildren
  '/_app/_clearing-core/registration/profile/_profile': typeof AppClearingCoreRegistrationProfileProfileRouteWithChildren
  '/_app/_clearing-core/sweep/cutoff/_cutoff': typeof AppClearingCoreSweepCutoffCutoffRouteWithChildren
  '/_app/_clearing-core/sweep/plan/_plan': typeof AppClearingCoreSweepPlanPlanRouteWithChildren
  '/_app/_clearing-core/sweep/target/_target': typeof AppClearingCoreSweepTargetTargetRouteWithChildren
  '/_app/_platform/_context-required/organization/_organization': typeof AppPlatformContextRequiredOrganizationOrganizationRouteWithChildren
  '/_app/_platform/_context-required/program/_program': typeof AppPlatformContextRequiredProgramProgramRouteWithChildren
  '/_app/_platform/_context-required/realm-access/_realm-access': typeof AppPlatformContextRequiredRealmAccessRealmAccessRouteWithChildren
  '/_app/_platform/_context-required/realm/_realm': typeof AppPlatformContextRequiredRealmRealmRouteWithChildren
  '/_app/_platform/_context-required/role/_role': typeof AppPlatformContextRequiredRoleRoleRouteWithChildren
  '/_app/_platform/_context-required/tenant/_tenant': typeof AppPlatformContextRequiredTenantTenantRouteWithChildren
  '/_app/_platform/_context-required/user/invitation': typeof AppPlatformContextRequiredUserInvitationRoute
  '/_app/_platform/_context-required/user/request': typeof AppPlatformContextRequiredUserRequestRoute
  '/docs/_layout/api-reference/_provider/$package': typeof DocsLayoutApiReferenceProviderPackageRoute
  '/docs/_layout/guide/_provider/$artifactName': typeof DocsLayoutGuideProviderArtifactNameRoute
  '/_app/_clearing-core/_clearing-required/clearing/': typeof AppClearingCoreClearingRequiredClearingIndexRoute
  '/_app/_clearing-core/asset/_asset/': typeof AppClearingCoreAssetAssetIndexRoute
  '/_app/_clearing-core/hours/_hours/': typeof AppClearingCoreHoursHoursIndexRoute
  '/_app/_clearing-core/registration/account/': typeof AppClearingCoreRegistrationAccountIndexRoute
  '/_app/_platform/_context-required/user/': typeof AppPlatformContextRequiredUserIndexRoute
  '/_app/developer/agent-key/_agent-key/': typeof AppDeveloperAgentKeyAgentKeyIndexRoute
  '/_app/developer/api-key/_api-key/': typeof AppDeveloperApiKeyApiKeyIndexRoute
  '/_app/developer/webhook/_webhook/': typeof AppDeveloperWebhookWebhookIndexRoute
  '/docs/_layout/api-reference/_provider/': typeof DocsLayoutApiReferenceProviderIndexRoute
  '/docs/_layout/guide/_provider/': typeof DocsLayoutGuideProviderIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor': typeof AppClearingCoreClearingRequiredClearingVendorVendorRouteWithChildren
  '/_app/_clearing-core/asset/_asset/$assetId/_detail': typeof AppClearingCoreAssetAssetAssetIdDetailRouteWithChildren
  '/_app/_clearing-core/billing/charge/_charge/$chargeId': typeof AppClearingCoreBillingChargeChargeChargeIdRoute
  '/_app/_clearing-core/funding/account-number/_account-number/$accountNumberId': typeof AppClearingCoreFundingAccountNumberAccountNumberAccountNumberIdRoute
  '/_app/_clearing-core/funding/batch-transfer/_batch-transfer/$batchTransferId': typeof AppClearingCoreFundingBatchTransferBatchTransferBatchTransferIdRoute
  '/_app/_clearing-core/funding/source/_source/$sourceId': typeof AppClearingCoreFundingSourceSourceSourceIdRoute
  '/_app/_clearing-core/funding/transfer/_transfer/$transferId': typeof AppClearingCoreFundingTransferTransferTransferIdRoute
  '/_app/_clearing-core/hours/_hours/exception/_exception': typeof AppClearingCoreHoursHoursExceptionExceptionRouteWithChildren
  '/_app/_clearing-core/hours/_hours/schedule/{-$scheduleName}': typeof AppClearingCoreHoursHoursScheduleChar123ScheduleNameChar125Route
  '/_app/_clearing-core/order/equity/_single/$orderId': typeof AppClearingCoreOrderEquitySingleOrderIdRoute
  '/_app/_clearing-core/order/equity/batch/_batch': typeof AppClearingCoreOrderEquityBatchBatchRouteWithChildren
  '/_app/_clearing-core/order/mutual-fund/_mutual-fund/$fundOrderId': typeof AppClearingCoreOrderMutualFundMutualFundFundOrderIdRoute
  '/_app/_clearing-core/registration/account/$accountId/_account': typeof AppClearingCoreRegistrationAccountAccountIdAccountRouteWithChildren
  '/_app/_clearing-core/sweep/plan/_plan/$sweepPlanId': typeof AppClearingCoreSweepPlanPlanSweepPlanIdRoute
  '/_app/_clearing-core/sweep/target/_target/$sweepTargetId': typeof AppClearingCoreSweepTargetTargetSweepTargetIdRoute
  '/_app/_o5/_o5-required/tech-ops/cluster/_cluster': typeof AppO5O5RequiredTechOpsClusterClusterRouteWithChildren
  '/_app/_o5/_o5-required/tech-ops/dead-message/_dead-message': typeof AppO5O5RequiredTechOpsDeadMessageDeadMessageRouteWithChildren
  '/_app/_o5/_o5-required/tech-ops/deployment/_deployment': typeof AppO5O5RequiredTechOpsDeploymentDeploymentRouteWithChildren
  '/_app/_o5/_o5-required/tech-ops/environment/_environment': typeof AppO5O5RequiredTechOpsEnvironmentEnvironmentRouteWithChildren
  '/_app/_o5/_o5-required/tech-ops/stack/_stack': typeof AppO5O5RequiredTechOpsStackStackRouteWithChildren
  '/_app/_o5/_o5-required/tech-ops/test-run/_test-run': typeof AppO5O5RequiredTechOpsTestRunTestRunRouteWithChildren
  '/_app/_o5/_o5-required/tech-ops/trigger/_trigger': typeof AppO5O5RequiredTechOpsTriggerTriggerRouteWithChildren
  '/_app/_platform/_context-required/realm-access/_realm-access/$realmAccessId': typeof AppPlatformContextRequiredRealmAccessRealmAccessRealmAccessIdRoute
  '/_app/_platform/_context-required/realm/_realm/$realmId': typeof AppPlatformContextRequiredRealmRealmRealmIdRoute
  '/_app/_platform/_context-required/role/_role/$roleId': typeof AppPlatformContextRequiredRoleRoleRoleIdRoute
  '/_app/_platform/_context-required/tenant/_tenant/$tenantId': typeof AppPlatformContextRequiredTenantTenantTenantIdRoute
  '/_app/_clearing-core/_clearing-required/inbox/_inbox/': typeof AppClearingCoreClearingRequiredInboxInboxIndexRoute
  '/_app/_clearing-core/billing/charge/_charge/': typeof AppClearingCoreBillingChargeChargeIndexRoute
  '/_app/_clearing-core/funding/account-number/_account-number/': typeof AppClearingCoreFundingAccountNumberAccountNumberIndexRoute
  '/_app/_clearing-core/funding/batch-transfer/_batch-transfer/': typeof AppClearingCoreFundingBatchTransferBatchTransferIndexRoute
  '/_app/_clearing-core/funding/source/_source/': typeof AppClearingCoreFundingSourceSourceIndexRoute
  '/_app/_clearing-core/funding/transfer/_transfer/': typeof AppClearingCoreFundingTransferTransferIndexRoute
  '/_app/_clearing-core/order/equity/_single/': typeof AppClearingCoreOrderEquitySingleIndexRoute
  '/_app/_clearing-core/order/mutual-fund/_mutual-fund/': typeof AppClearingCoreOrderMutualFundMutualFundIndexRoute
  '/_app/_clearing-core/registration/profile/_profile/': typeof AppClearingCoreRegistrationProfileProfileIndexRoute
  '/_app/_clearing-core/sweep/cutoff/_cutoff/': typeof AppClearingCoreSweepCutoffCutoffIndexRoute
  '/_app/_clearing-core/sweep/plan/_plan/': typeof AppClearingCoreSweepPlanPlanIndexRoute
  '/_app/_clearing-core/sweep/target/_target/': typeof AppClearingCoreSweepTargetTargetIndexRoute
  '/_app/_o5/_o5-required/tech-ops/build/': typeof AppO5O5RequiredTechOpsBuildIndexRoute
  '/_app/_platform/_context-required/organization/_organization/': typeof AppPlatformContextRequiredOrganizationOrganizationIndexRoute
  '/_app/_platform/_context-required/program/_program/': typeof AppPlatformContextRequiredProgramProgramIndexRoute
  '/_app/_platform/_context-required/realm-access/_realm-access/': typeof AppPlatformContextRequiredRealmAccessRealmAccessIndexRoute
  '/_app/_platform/_context-required/realm/_realm/': typeof AppPlatformContextRequiredRealmRealmIndexRoute
  '/_app/_platform/_context-required/role/_role/': typeof AppPlatformContextRequiredRoleRoleIndexRoute
  '/_app/_platform/_context-required/tenant/_tenant/': typeof AppPlatformContextRequiredTenantTenantIndexRoute
  '/_app/_clearing-core/asset/_asset/$assetId/_detail/filings': typeof AppClearingCoreAssetAssetAssetIdDetailFilingsRoute
  '/_app/_clearing-core/asset/_asset/$assetId/_detail/market-data': typeof AppClearingCoreAssetAssetAssetIdDetailMarketDataRoute
  '/_app/_clearing-core/hours/_hours/exception/_exception/$exceptionId': typeof AppClearingCoreHoursHoursExceptionExceptionExceptionIdRoute
  '/_app/_clearing-core/order/equity/batch/_batch/$batchOrderId': typeof AppClearingCoreOrderEquityBatchBatchBatchOrderIdRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_overview': typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewRouteWithChildren
  '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRouteWithChildren
  '/_app/_o5/_o5-required/tech-ops/build/repo/_repo': typeof AppO5O5RequiredTechOpsBuildRepoRepoRouteWithChildren
  '/_app/_o5/_o5-required/tech-ops/cluster/_cluster/$clusterId': typeof AppO5O5RequiredTechOpsClusterClusterClusterIdRoute
  '/_app/_o5/_o5-required/tech-ops/dead-message/_dead-message/$messageId': typeof AppO5O5RequiredTechOpsDeadMessageDeadMessageMessageIdRoute
  '/_app/_o5/_o5-required/tech-ops/deployment/_deployment/$deploymentId': typeof AppO5O5RequiredTechOpsDeploymentDeploymentDeploymentIdRoute
  '/_app/_o5/_o5-required/tech-ops/environment/_environment/$environmentId': typeof AppO5O5RequiredTechOpsEnvironmentEnvironmentEnvironmentIdRoute
  '/_app/_o5/_o5-required/tech-ops/stack/_stack/$stackId': typeof AppO5O5RequiredTechOpsStackStackStackIdRoute
  '/_app/_o5/_o5-required/tech-ops/trigger/_trigger/$triggerId': typeof AppO5O5RequiredTechOpsTriggerTriggerTriggerIdRoute
  '/_app/_platform/_context-required/organization/_organization/$organizationId/_detail': typeof AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRouteWithChildren
  '/_app/_platform/_context-required/program/_program/$programId/_program': typeof AppPlatformContextRequiredProgramProgramProgramIdProgramRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/': typeof AppClearingCoreClearingRequiredClearingVendorVendorIndexRoute
  '/_app/_clearing-core/asset/_asset/$assetId/_detail/': typeof AppClearingCoreAssetAssetAssetIdDetailIndexRoute
  '/_app/_clearing-core/hours/_hours/exception/_exception/': typeof AppClearingCoreHoursHoursExceptionExceptionIndexRoute
  '/_app/_clearing-core/order/equity/batch/_batch/': typeof AppClearingCoreOrderEquityBatchBatchIndexRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/': typeof AppClearingCoreRegistrationAccountAccountIdAccountIndexRoute
  '/_app/_clearing-core/registration/profile/_profile/$profileId/': typeof AppClearingCoreRegistrationProfileProfileProfileIdIndexRoute
  '/_app/_o5/_o5-required/tech-ops/cluster/_cluster/': typeof AppO5O5RequiredTechOpsClusterClusterIndexRoute
  '/_app/_o5/_o5-required/tech-ops/dead-message/_dead-message/': typeof AppO5O5RequiredTechOpsDeadMessageDeadMessageIndexRoute
  '/_app/_o5/_o5-required/tech-ops/deployment/_deployment/': typeof AppO5O5RequiredTechOpsDeploymentDeploymentIndexRoute
  '/_app/_o5/_o5-required/tech-ops/environment/_environment/': typeof AppO5O5RequiredTechOpsEnvironmentEnvironmentIndexRoute
  '/_app/_o5/_o5-required/tech-ops/stack/_stack/': typeof AppO5O5RequiredTechOpsStackStackIndexRoute
  '/_app/_o5/_o5-required/tech-ops/test-run/_test-run/': typeof AppO5O5RequiredTechOpsTestRunTestRunIndexRoute
  '/_app/_o5/_o5-required/tech-ops/trigger/_trigger/': typeof AppO5O5RequiredTechOpsTriggerTriggerIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/journal/_manual-entry': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/account/correspondent': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsAccountCorrespondentRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/balance/_balance': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-cash-balance/_customer-cash-balance': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-stock-record/_customer-stock-record': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-sweep-record/_customer-sweep-record': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/journal/_manual-entry': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/cash-blotter': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingCashBlotterRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/order-blotter': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingOrderBlotterRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/stock-blotter': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingStockBlotterRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/transaction/_transaction': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trigger/_trigger': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc': typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccRouteWithChildren
  '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/asset': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListAssetRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/funding': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListFundingRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/hold': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListHoldRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/transaction': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListTransactionRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/dividends-receivable/_dividends-receivable': typeof AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableRouteWithChildren
  '/_app/_clearing-core/registration/profile/_profile/$profileId/edit/_edit': typeof AppClearingCoreRegistrationProfileProfileProfileIdEditEditRouteWithChildren
  '/_app/_clearing-core/registration/profile/_profile/create/$profileType/_create': typeof AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateRouteWithChildren
  '/_app/_o5/_o5-required/tech-ops/test-run/_test-run/$environment/$testRunId': typeof AppO5O5RequiredTechOpsTestRunTestRunEnvironmentTestRunIdRoute
  '/_app/_platform/_context-required/organization/_organization/$organizationId/_detail/invitation': typeof AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailInvitationRoute
  '/_app/_platform/_context-required/organization/_organization/$organizationId/_detail/realm-access': typeof AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRealmAccessRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/account/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsAccountIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jane-street/': typeof AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/plaid/': typeof AppClearingCoreClearingRequiredClearingVendorVendorPlaidIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaIndexRoute
  '/_app/_o5/_o5-required/tech-ops/build/repo/_repo/': typeof AppO5O5RequiredTechOpsBuildRepoRepoIndexRoute
  '/_app/_o5/_o5-required/tech-ops/test-run/_test-run/$environment/': typeof AppO5O5RequiredTechOpsTestRunTestRunEnvironmentIndexRoute
  '/_app/_platform/_context-required/organization/_organization/$organizationId/_detail/': typeof AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailIndexRoute
  '/_app/_platform/_context-required/program/_program/$programId/_program/': typeof AppPlatformContextRequiredProgramProgramProgramIdProgramIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/entry/_entry': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/file/_file': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/match/_match': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/file/_file': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/match/_match': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/sdn/_sdn': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/blue-sheet/_blue-sheet': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cais/_cais': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cat/_cat': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/sec-606/_sec-606': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606RouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/balance-sheet/_balance-sheet': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/income-statement/_income-statement': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/transaction/_transaction': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/trial-balance/_trial-balance': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/journal/_manual-entry/$entryId': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryEntryIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/journal/_manual-entry/create': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryCreateRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/account-number/_account-number': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/ach/_ach': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-ach/_incoming-ach': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-wire/_incoming-wire': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/wire/_wire': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/balance/_balance/$accountCode': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceAccountCodeRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/action/_action': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/payment/_payment': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset-day/_asset-day': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset/_asset': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/balance/_balance': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/books-order/_books-order': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/order/_order': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/sell-down/_sell-down': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/trading-day/_trading-day': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/journal/_manual-entry/$entryId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryEntryIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/journal/_manual-entry/create': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryCreateRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/dividend-accrual/_dividend-accrual': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/job/_job': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/task/_task': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/venue-order/_venue-order': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-order/_fix-order': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-session/_fix-session': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/routing-rule/_routing-rule': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/archive/_report': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/job/_job': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/order/_order': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/participant/_participant': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/task/_task': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-report/_trf-report': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-session/_trf-session': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc-fix-session/_utc-fix-session': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc/_utc': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/transaction/_transaction/$transactionId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionTransactionIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trigger/_trigger/$triggerId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerTriggerIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-job/_job': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-task/_task': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-task/_task': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/corporate-action/_action': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/instrument/_instrument': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/job/_job': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/task/_task': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/account-number/_account-number': typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/ach/_ach': typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/wire/_wire': typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/destination/_destination': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/job/_job': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/net-order/_net-order': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/order/_order': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/task/_task': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/plaid/processor-token/_processor-token': typeof AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/job/_job': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/sp-500/_sp-500': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500RouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/task/_task': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskRouteWithChildren
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetRouteWithChildren
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashRouteWithChildren
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/document/_document': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentRouteWithChildren
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingRouteWithChildren
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/hold/_hold': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldRouteWithChildren
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/transaction/_transaction': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionRouteWithChildren
  '/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/beneficiaries': typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailBeneficiariesRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/clearing-controls': typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailClearingControlsRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/controls': typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailControlsRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/risk': typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailRiskRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/order/_order': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderRouteWithChildren
  '/_app/_clearing-core/registration/profile/_profile/$profileId/edit/_edit/review': typeof AppClearingCoreRegistrationProfileProfileProfileIdEditEditReviewRoute
  '/_app/_clearing-core/registration/profile/_profile/create/$profileType/_create/review': typeof AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateReviewRoute
  '/_app/_o5/_o5-required/tech-ops/build/repo/_repo/$owner/$name': typeof AppO5O5RequiredTechOpsBuildRepoRepoOwnerNameRoute
  '/_app/_platform/_context-required/program/_program/$programId/_program/configuration/clearing': typeof AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationClearingRoute
  '/_app/_platform/_context-required/program/_program/$programId/_program/configuration/contacts': typeof AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationContactsRoute
  '/_app/_platform/_context-required/program/_program/$programId/_program/configuration/controls': typeof AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationControlsRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/journal/_manual-entry/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/taf-report/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyTafReportIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/balance/_balance/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-cash-balance/_customer-cash-balance/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-stock-record/_customer-stock-record/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-sweep-record/_customer-sweep-record/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/journal/_manual-entry/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/transaction/_transaction/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trigger/_trigger/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/': typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/emulator/': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmEmulatorIndexRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/': typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailIndexRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/dividends-receivable/_dividends-receivable/': typeof AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableIndexRoute
  '/_app/_clearing-core/registration/profile/_profile/$profileId/edit/_edit/': typeof AppClearingCoreRegistrationProfileProfileProfileIdEditEditIndexRoute
  '/_app/_clearing-core/registration/profile/_profile/create/$profileType/_create/': typeof AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateIndexRoute
  '/_app/_platform/_context-required/program/_program/$programId/_program/branding/': typeof AppPlatformContextRequiredProgramProgramProgramIdProgramBrandingIndexRoute
  '/_app/_platform/_context-required/program/_program/$programId/_program/configuration/': typeof AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/entry/_entry/$fincen314EntryId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryFincen314EntryIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/file/_file/$fincen314FileId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileFincen314FileIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/match/_match/$fincen314MatchId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchFincen314MatchIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/file/_file/$ofacFileId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileOfacFileIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/match/_match/$ofacMatchId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchOfacMatchIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/sdn/_sdn/$ofacSdnId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnOfacSdnIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/blue-sheet/_blue-sheet/$reportId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetReportIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cais/_cais/$reportId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisReportIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cat/_cat/$reportId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatReportIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/sec-606/_sec-606/$reportId': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606ReportIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/transaction/_transaction/$transactionId': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionTransactionIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/account-number/_account-number/$accountNumberId': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberAccountNumberIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/ach/_ach/$achId': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchAchIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-ach/_incoming-ach/$achId': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchAchIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-wire/_incoming-wire/$wireId': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireWireIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/wire/_wire/$wireId': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireWireIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/action/_action/$actionId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionActionIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/payment/_payment/$paymentId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentPaymentIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/job/_job': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/task/_task': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/job/_job': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/task/_task': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/balance/_balance/$assetId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceAssetIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/books-order/_books-order/$booksOrderId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderBooksOrderIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/order/_order/$firmOrderId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderFirmOrderIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/job/_job/$jobId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobJobIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/task/_task/$taskId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskTaskIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/venue-order/_venue-order/$venueOrderId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderVenueOrderIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-order/_fix-order/$fixOrderId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderFixOrderIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-session/_fix-session/$sessionId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionSessionIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/routing-rule/_routing-rule/$ruleId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRuleIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/archive/_report/$reportId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportReportIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/job/_job/$jobId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobJobIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/order/_order/$sweepOrderId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderSweepOrderIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/participant/_participant/$accountId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantAccountIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/task/_task/$taskId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskTaskIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-report/_trf-report/$trfReportId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportTrfReportIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-session/_trf-session/$sessionId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionSessionIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc-fix-session/_utc-fix-session/$sessionId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionSessionIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc/_utc/$tradeId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcTradeIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-job/_job/$jobId': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobJobIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-task/_task/$taskId': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskTaskIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-task/_task/$taskId': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskTaskIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file-request/_file-request': typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file/_file': typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/corporate-action/_action/$eventId': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionEventIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/instrument/_instrument/$instrumentId': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentInstrumentIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/job/_job/$jobId': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobJobIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/task/_task/$taskId': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskTaskIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/account-number/_account-number/$accountNumberId': typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberAccountNumberIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/ach/_ach/$achId': typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchAchIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/wire/_wire/$wireId': typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireWireIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jane-street/pfof/job/_job': typeof AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/destination/_destination/$destinationId': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationDestinationIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/job/_job/$jobId': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobJobIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/net-order/_net-order/$netOrderId': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderNetOrderIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/order/_order/$orderId': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderOrderIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/task/_task/$taskId': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskTaskIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/plaid/processor-token/_processor-token/$processorTokenId': typeof AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenProcessorTokenIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/job/_job/$jobId': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobJobIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/sp-500/_sp-500/$quarter': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500QuarterRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/task/_task/$taskId': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskTaskIdRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/document/_document/tax': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentTaxRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/document/_document/trade-confirmation': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentTradeConfirmationRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/hold/_hold/$holdId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldHoldIdRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/order/equity/_equity': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityRouteWithChildren
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/order/mutual-fund/_mutual-fund': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundRouteWithChildren
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/transaction/_transaction/$transactionId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionTransactionIdRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/order/_order/equity': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderEquityRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/order/_order/mutual-fund': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderMutualFundRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/entry/_entry/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/file/_file/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/match/_match/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/file/_file/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/match/_match/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/sdn/_sdn/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/blue-sheet/_blue-sheet/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cais/_cais/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cat/_cat/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/sec-606/_sec-606/': typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606IndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/balance-sheet/_balance-sheet/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/income-statement/_income-statement/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/transaction/_transaction/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/trial-balance/_trial-balance/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/account-number/_account-number/': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/ach/_ach/': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-ach/_incoming-ach/': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-wire/_incoming-wire/': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/wire/_wire/': typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/action/_action/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/payment/_payment/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset-day/_asset-day/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset/_asset/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/balance/_balance/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/books-order/_books-order/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/order/_order/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/sell-down/_sell-down/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/trading-day/_trading-day/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/dividend-accrual/_dividend-accrual/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/job/_job/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/task/_task/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/venue-order/_venue-order/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-order/_fix-order/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-session/_fix-session/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/routing-rule/_routing-rule/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/archive/_report/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/asset/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/job/_job/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/order/_order/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/participant/_participant/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/task/_task/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-report/_trf-report/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-session/_trf-session/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc-fix-session/_utc-fix-session/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc/_utc/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-job/_job/': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-task/_task/': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job/': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-task/_task/': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/corporate-action/_action/': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/instrument/_instrument/': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/job/_job/': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/task/_task/': typeof AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/account-number/_account-number/': typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/ach/_ach/': typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/wire/_wire/': typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/destination/_destination/': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/job/_job/': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/net-order/_net-order/': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/order/_order/': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/task/_task/': typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/plaid/processor-token/_processor-token/': typeof AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/job/_job/': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/sp-500/_sp-500/': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500IndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/task/_task/': typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskIndexRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashIndexRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/document/_document/': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentIndexRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/order/_order/': typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account/$accountId/_layout': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate/$feeType/_$feeType': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset-day/_asset-day/$assetId/$date': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayAssetIdDateRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset/_asset/$assetId/$date': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetAssetIdDateRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/job/_job/$jobId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobJobIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/task/_task/$taskId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskTaskIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/job/_job/$jobId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobJobIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/task/_task/$taskId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskTaskIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/trading-day/_trading-day/$assetId/_$assetId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/asset/$assetId/_asset': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job/$jobId/_job': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobRouteWithChildren
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file-request/_file-request/$fileRequestId': typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestFileRequestIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file/_file/$fileId': typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileFileIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jane-street/pfof/job/_job/$jobId': typeof AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobJobIdRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_cost-basis/asset/$assetId/realization/$realizationId': typeof AppClearingCoreRegistrationAccountAccountIdAccountCostBasisAssetAssetIdRealizationRealizationIdRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_cost-basis/asset/$assetId/tax-lot/$taxLotId': typeof AppClearingCoreRegistrationAccountAccountIdAccountCostBasisAssetAssetIdTaxLotTaxLotIdRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRouteWithChildren
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/sweep/$assetId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashSweepAssetIdRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/transaction/_transaction': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionRouteWithChildren
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding/source/$sourceId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingSourceSourceIdRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding/transfer/$transferId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingTransferTransferIdRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/order/equity/_equity/$orderId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityOrderIdRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/order/mutual-fund/_mutual-fund/$fundOrderId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundFundOrderIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset-day/_asset-day/$assetId/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayAssetIdIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/job/_job/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/task/_task/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/job/_job/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/task/_task/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file-request/_file-request/': typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file/_file/': typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jane-street/pfof/job/_job/': typeof AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobIndexRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding/source/': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingSourceIndexRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding/transfer/': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingTransferIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account/$accountId/_layout/settings': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutSettingsRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate/$feeType/_$feeType/$effectiveDate': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeEffectiveDateRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/trading-day/_trading-day/$assetId/_$assetId/$date': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdDateRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job/$jobId/_job/task': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobTaskRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/funding': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceFundingRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/hold': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceHoldRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/transaction/_transaction/$transactionId': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionTransactionIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account/$accountId/_layout/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate/$feeType/_$feeType/': typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day/$venue/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/asset/$assetId/_asset/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job/$jobId/_job/': typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobIndexRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceIndexRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/transaction/_transaction/': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionIndexRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/dividend-accrual/_dividend-accrual/$accountId/$assetId/$source/$firstDayOfMonth': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualAccountIdAssetIdSourceFirstDayOfMonthRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day/$venue/$date/$assetId': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueDateAssetIdRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/asset/$assetId/_asset/account/$accountCode': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetAccountAccountCodeRoute
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day/$venue/$date/': typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueDateIndexRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/realization/': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRealizationIndexRoute
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/tax-lot/': typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceTaxLotIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invitation'
    | '/mfa-setup'
    | '/logout'
    | '/forgot-password'
    | '/register'
    | '/request-access'
    | '/reset-password'
    | '/docs'
    | '/oauth/consent'
    | '/settings/personal'
    | '/login'
    | '/developer/'
    | '/settings/'
    | '/docs/'
    | '/asset'
    | '/hours'
    | '/developer/agent-key'
    | '/developer/api-key'
    | '/developer/webhook'
    | '/login/mfa'
    | '/docs/api-reference'
    | '/docs/guide'
    | '/billing/'
    | '/dashboard/'
    | '/funding/'
    | '/order/'
    | '/registration/'
    | '/sweep/'
    | '/login/'
    | '/billing/charge'
    | '/funding/account-number'
    | '/funding/batch-transfer'
    | '/funding/source'
    | '/funding/transfer'
    | '/order/equity'
    | '/order/mutual-fund'
    | '/registration/profile'
    | '/sweep/cutoff'
    | '/sweep/plan'
    | '/sweep/target'
    | '/organization'
    | '/program'
    | '/realm-access'
    | '/realm'
    | '/role'
    | '/tenant'
    | '/user/invitation'
    | '/user/request'
    | '/docs/api-reference/$package'
    | '/docs/guide/$artifactName'
    | '/clearing/'
    | '/asset/'
    | '/hours/'
    | '/registration/account/'
    | '/user/'
    | '/developer/agent-key/'
    | '/developer/api-key/'
    | '/developer/webhook/'
    | '/docs/api-reference/'
    | '/docs/guide/'
    | '/clearing/compliance'
    | '/clearing/finance'
    | '/clearing/operations'
    | '/clearing/vendor'
    | '/asset/$assetId'
    | '/billing/charge/$chargeId'
    | '/funding/account-number/$accountNumberId'
    | '/funding/batch-transfer/$batchTransferId'
    | '/funding/source/$sourceId'
    | '/funding/transfer/$transferId'
    | '/hours/exception'
    | '/hours/schedule/{-$scheduleName}'
    | '/order/equity/$orderId'
    | '/order/equity/batch'
    | '/order/mutual-fund/$fundOrderId'
    | '/registration/account/$accountId'
    | '/sweep/plan/$sweepPlanId'
    | '/sweep/target/$sweepTargetId'
    | '/tech-ops/cluster'
    | '/tech-ops/dead-message'
    | '/tech-ops/deployment'
    | '/tech-ops/environment'
    | '/tech-ops/stack'
    | '/tech-ops/test-run'
    | '/tech-ops/trigger'
    | '/realm-access/$realmAccessId'
    | '/realm/$realmId'
    | '/role/$roleId'
    | '/tenant/$tenantId'
    | '/inbox/'
    | '/billing/charge/'
    | '/funding/account-number/'
    | '/funding/batch-transfer/'
    | '/funding/source/'
    | '/funding/transfer/'
    | '/order/equity/'
    | '/order/mutual-fund/'
    | '/registration/profile/'
    | '/sweep/cutoff/'
    | '/sweep/plan/'
    | '/sweep/target/'
    | '/tech-ops/build/'
    | '/organization/'
    | '/program/'
    | '/realm-access/'
    | '/realm/'
    | '/role/'
    | '/tenant/'
    | '/asset/$assetId/filings'
    | '/asset/$assetId/market-data'
    | '/hours/exception/$exceptionId'
    | '/order/equity/batch/$batchOrderId'
    | '/tech-ops/build/repo'
    | '/tech-ops/cluster/$clusterId'
    | '/tech-ops/dead-message/$messageId'
    | '/tech-ops/deployment/$deploymentId'
    | '/tech-ops/environment/$environmentId'
    | '/tech-ops/stack/$stackId'
    | '/tech-ops/trigger/$triggerId'
    | '/organization/$organizationId'
    | '/program/$programId'
    | '/clearing/compliance/'
    | '/clearing/finance/'
    | '/clearing/operations/'
    | '/clearing/vendor/'
    | '/asset/$assetId/'
    | '/hours/exception/'
    | '/order/equity/batch/'
    | '/registration/account/$accountId/'
    | '/registration/profile/$profileId/'
    | '/tech-ops/cluster/'
    | '/tech-ops/dead-message/'
    | '/tech-ops/deployment/'
    | '/tech-ops/environment/'
    | '/tech-ops/stack/'
    | '/tech-ops/test-run/'
    | '/tech-ops/trigger/'
    | '/clearing/finance/journal'
    | '/clearing/operations/account/correspondent'
    | '/clearing/operations/balance'
    | '/clearing/operations/customer-cash-balance'
    | '/clearing/operations/customer-stock-record'
    | '/clearing/operations/customer-sweep-record'
    | '/clearing/operations/journal'
    | '/clearing/operations/reporting/cash-blotter'
    | '/clearing/operations/reporting/order-blotter'
    | '/clearing/operations/reporting/stock-blotter'
    | '/clearing/operations/stock-record'
    | '/clearing/operations/transaction'
    | '/clearing/operations/trigger'
    | '/clearing/vendor/dtcc'
    | '/registration/account/$accountId/asset'
    | '/registration/account/$accountId/funding'
    | '/registration/account/$accountId/hold'
    | '/registration/account/$accountId/transaction'
    | '/registration/account/$accountId/dividends-receivable'
    | '/registration/profile/$profileId/edit'
    | '/registration/profile/create/$profileType'
    | '/tech-ops/test-run/$environment/$testRunId'
    | '/organization/$organizationId/invitation'
    | '/organization/$organizationId/realm-access'
    | '/clearing/compliance/fincen/'
    | '/clearing/compliance/ofac/'
    | '/clearing/compliance/reporting/'
    | '/clearing/finance/accounting/'
    | '/clearing/finance/middle-money/'
    | '/clearing/finance/payment/'
    | '/clearing/operations/account/'
    | '/clearing/operations/dtcc/'
    | '/clearing/operations/generate/'
    | '/clearing/operations/inventory/'
    | '/clearing/operations/mutualfunds/'
    | '/clearing/operations/oms/'
    | '/clearing/operations/reporting/'
    | '/clearing/operations/sweep/'
    | '/clearing/operations/trade/'
    | '/clearing/vendor/beta-nxt/'
    | '/clearing/vendor/jane-street/'
    | '/clearing/vendor/jpm/'
    | '/clearing/vendor/plaid/'
    | '/clearing/vendor/quote-media/'
    | '/tech-ops/build/repo/'
    | '/tech-ops/test-run/$environment/'
    | '/organization/$organizationId/'
    | '/program/$programId/'
    | '/clearing/compliance/fincen/entry'
    | '/clearing/compliance/fincen/file'
    | '/clearing/compliance/fincen/match'
    | '/clearing/compliance/ofac/file'
    | '/clearing/compliance/ofac/match'
    | '/clearing/compliance/ofac/sdn'
    | '/clearing/compliance/reporting/blue-sheet'
    | '/clearing/compliance/reporting/cais'
    | '/clearing/compliance/reporting/cat'
    | '/clearing/compliance/reporting/sec-606'
    | '/clearing/finance/accounting/account'
    | '/clearing/finance/accounting/balance-sheet'
    | '/clearing/finance/accounting/income-statement'
    | '/clearing/finance/accounting/transaction'
    | '/clearing/finance/accounting/trial-balance'
    | '/clearing/finance/journal/$entryId'
    | '/clearing/finance/journal/create'
    | '/clearing/finance/middle-money/fee-rate'
    | '/clearing/finance/payment/account-number'
    | '/clearing/finance/payment/ach'
    | '/clearing/finance/payment/incoming-ach'
    | '/clearing/finance/payment/incoming-wire'
    | '/clearing/finance/payment/wire'
    | '/clearing/operations/balance/$accountCode'
    | '/clearing/operations/ca/action'
    | '/clearing/operations/ca/payment'
    | '/clearing/operations/dtcc/asset-day'
    | '/clearing/operations/dtcc/asset'
    | '/clearing/operations/inventory/balance'
    | '/clearing/operations/inventory/books-order'
    | '/clearing/operations/inventory/order'
    | '/clearing/operations/inventory/sell-down'
    | '/clearing/operations/inventory/trading-day'
    | '/clearing/operations/journal/$entryId'
    | '/clearing/operations/journal/create'
    | '/clearing/operations/mutualfunds/dividend-accrual'
    | '/clearing/operations/mutualfunds/job'
    | '/clearing/operations/mutualfunds/task'
    | '/clearing/operations/mutualfunds/venue-order'
    | '/clearing/operations/oms/fix-order'
    | '/clearing/operations/oms/fix-session'
    | '/clearing/operations/oms/routing-rule'
    | '/clearing/operations/reporting/archive'
    | '/clearing/operations/sweep/job'
    | '/clearing/operations/sweep/order'
    | '/clearing/operations/sweep/participant'
    | '/clearing/operations/sweep/task'
    | '/clearing/operations/trade/trf-report'
    | '/clearing/operations/trade/trf-session'
    | '/clearing/operations/trade/utc-fix-session'
    | '/clearing/operations/trade/utc'
    | '/clearing/operations/transaction/$transactionId'
    | '/clearing/operations/trigger/$triggerId'
    | '/clearing/vendor/beta-nxt/prospectus-job'
    | '/clearing/vendor/beta-nxt/prospectus-task'
    | '/clearing/vendor/beta-nxt/proxy-vote-job'
    | '/clearing/vendor/beta-nxt/proxy-vote-task'
    | '/clearing/vendor/ice/corporate-action'
    | '/clearing/vendor/ice/instrument'
    | '/clearing/vendor/ice/job'
    | '/clearing/vendor/ice/task'
    | '/clearing/vendor/increase/account-number'
    | '/clearing/vendor/increase/ach'
    | '/clearing/vendor/increase/wire'
    | '/clearing/vendor/jpm/destination'
    | '/clearing/vendor/jpm/job'
    | '/clearing/vendor/jpm/net-order'
    | '/clearing/vendor/jpm/order'
    | '/clearing/vendor/jpm/task'
    | '/clearing/vendor/plaid/processor-token'
    | '/clearing/vendor/quote-media/job'
    | '/clearing/vendor/quote-media/sp-500'
    | '/clearing/vendor/quote-media/task'
    | '/registration/account/$accountId/cash'
    | '/registration/account/$accountId/document'
    | '/registration/account/$accountId/detail/beneficiaries'
    | '/registration/account/$accountId/detail/clearing-controls'
    | '/registration/account/$accountId/detail/controls'
    | '/registration/account/$accountId/detail/risk'
    | '/registration/account/$accountId/order'
    | '/registration/profile/$profileId/edit/review'
    | '/registration/profile/create/$profileType/review'
    | '/tech-ops/build/repo/$owner/$name'
    | '/program/$programId/configuration/clearing'
    | '/program/$programId/configuration/contacts'
    | '/program/$programId/configuration/controls'
    | '/clearing/finance/journal/'
    | '/clearing/finance/middle-money/taf-report/'
    | '/clearing/operations/balance/'
    | '/clearing/operations/customer-cash-balance/'
    | '/clearing/operations/customer-stock-record/'
    | '/clearing/operations/customer-sweep-record/'
    | '/clearing/operations/generate/monthly-statement/'
    | '/clearing/operations/journal/'
    | '/clearing/operations/mutualfunds/reconciliation/'
    | '/clearing/operations/stock-record/'
    | '/clearing/operations/transaction/'
    | '/clearing/operations/trigger/'
    | '/clearing/vendor/dtcc/'
    | '/clearing/vendor/jpm/emulator/'
    | '/registration/account/$accountId/detail/'
    | '/registration/account/$accountId/dividends-receivable/'
    | '/registration/profile/$profileId/edit/'
    | '/registration/profile/create/$profileType/'
    | '/program/$programId/branding/'
    | '/program/$programId/configuration/'
    | '/clearing/compliance/fincen/entry/$fincen314EntryId'
    | '/clearing/compliance/fincen/file/$fincen314FileId'
    | '/clearing/compliance/fincen/match/$fincen314MatchId'
    | '/clearing/compliance/ofac/file/$ofacFileId'
    | '/clearing/compliance/ofac/match/$ofacMatchId'
    | '/clearing/compliance/ofac/sdn/$ofacSdnId'
    | '/clearing/compliance/reporting/blue-sheet/$reportId'
    | '/clearing/compliance/reporting/cais/$reportId'
    | '/clearing/compliance/reporting/cat/$reportId'
    | '/clearing/compliance/reporting/sec-606/$reportId'
    | '/clearing/finance/accounting/transaction/$transactionId'
    | '/clearing/finance/payment/account-number/$accountNumberId'
    | '/clearing/finance/payment/ach/$achId'
    | '/clearing/finance/payment/incoming-ach/$achId'
    | '/clearing/finance/payment/incoming-wire/$wireId'
    | '/clearing/finance/payment/wire/$wireId'
    | '/clearing/operations/ca/action/$actionId'
    | '/clearing/operations/ca/payment/$paymentId'
    | '/clearing/operations/generate/monthly-statement/job'
    | '/clearing/operations/generate/monthly-statement/task'
    | '/clearing/operations/generate/trade-confirmation/job'
    | '/clearing/operations/generate/trade-confirmation/task'
    | '/clearing/operations/inventory/balance/$assetId'
    | '/clearing/operations/inventory/books-order/$booksOrderId'
    | '/clearing/operations/inventory/order/$firmOrderId'
    | '/clearing/operations/mutualfunds/job/$jobId'
    | '/clearing/operations/mutualfunds/reconciliation/position-day'
    | '/clearing/operations/mutualfunds/task/$taskId'
    | '/clearing/operations/mutualfunds/venue-order/$venueOrderId'
    | '/clearing/operations/oms/fix-order/$fixOrderId'
    | '/clearing/operations/oms/fix-session/$sessionId'
    | '/clearing/operations/oms/routing-rule/$ruleId'
    | '/clearing/operations/reporting/archive/$reportId'
    | '/clearing/operations/sweep/job/$jobId'
    | '/clearing/operations/sweep/order/$sweepOrderId'
    | '/clearing/operations/sweep/participant/$accountId'
    | '/clearing/operations/sweep/task/$taskId'
    | '/clearing/operations/trade/trf-report/$trfReportId'
    | '/clearing/operations/trade/trf-session/$sessionId'
    | '/clearing/operations/trade/utc-fix-session/$sessionId'
    | '/clearing/operations/trade/utc/$tradeId'
    | '/clearing/vendor/beta-nxt/prospectus-job/$jobId'
    | '/clearing/vendor/beta-nxt/prospectus-task/$taskId'
    | '/clearing/vendor/beta-nxt/proxy-vote-task/$taskId'
    | '/clearing/vendor/dtcc/file-request'
    | '/clearing/vendor/dtcc/file'
    | '/clearing/vendor/ice/corporate-action/$eventId'
    | '/clearing/vendor/ice/instrument/$instrumentId'
    | '/clearing/vendor/ice/job/$jobId'
    | '/clearing/vendor/ice/task/$taskId'
    | '/clearing/vendor/increase/account-number/$accountNumberId'
    | '/clearing/vendor/increase/ach/$achId'
    | '/clearing/vendor/increase/wire/$wireId'
    | '/clearing/vendor/jane-street/pfof/job'
    | '/clearing/vendor/jpm/destination/$destinationId'
    | '/clearing/vendor/jpm/job/$jobId'
    | '/clearing/vendor/jpm/net-order/$netOrderId'
    | '/clearing/vendor/jpm/order/$orderId'
    | '/clearing/vendor/jpm/task/$taskId'
    | '/clearing/vendor/plaid/processor-token/$processorTokenId'
    | '/clearing/vendor/quote-media/job/$jobId'
    | '/clearing/vendor/quote-media/sp-500/$quarter'
    | '/clearing/vendor/quote-media/task/$taskId'
    | '/registration/account/$accountId/document/tax'
    | '/registration/account/$accountId/document/trade-confirmation'
    | '/registration/account/$accountId/hold/$holdId'
    | '/registration/account/$accountId/order/equity'
    | '/registration/account/$accountId/order/mutual-fund'
    | '/registration/account/$accountId/transaction/$transactionId'
    | '/clearing/compliance/fincen/entry/'
    | '/clearing/compliance/fincen/file/'
    | '/clearing/compliance/fincen/match/'
    | '/clearing/compliance/ofac/file/'
    | '/clearing/compliance/ofac/match/'
    | '/clearing/compliance/ofac/sdn/'
    | '/clearing/compliance/reporting/blue-sheet/'
    | '/clearing/compliance/reporting/cais/'
    | '/clearing/compliance/reporting/cat/'
    | '/clearing/compliance/reporting/sec-606/'
    | '/clearing/finance/accounting/account/'
    | '/clearing/finance/accounting/balance-sheet/'
    | '/clearing/finance/accounting/income-statement/'
    | '/clearing/finance/accounting/transaction/'
    | '/clearing/finance/accounting/trial-balance/'
    | '/clearing/finance/middle-money/fee-rate/'
    | '/clearing/finance/payment/account-number/'
    | '/clearing/finance/payment/ach/'
    | '/clearing/finance/payment/incoming-ach/'
    | '/clearing/finance/payment/incoming-wire/'
    | '/clearing/finance/payment/wire/'
    | '/clearing/operations/ca/action/'
    | '/clearing/operations/ca/payment/'
    | '/clearing/operations/dtcc/asset-day/'
    | '/clearing/operations/dtcc/asset/'
    | '/clearing/operations/inventory/balance/'
    | '/clearing/operations/inventory/books-order/'
    | '/clearing/operations/inventory/order/'
    | '/clearing/operations/inventory/sell-down/'
    | '/clearing/operations/inventory/trading-day/'
    | '/clearing/operations/mutualfunds/dividend-accrual/'
    | '/clearing/operations/mutualfunds/job/'
    | '/clearing/operations/mutualfunds/task/'
    | '/clearing/operations/mutualfunds/venue-order/'
    | '/clearing/operations/oms/fix-order/'
    | '/clearing/operations/oms/fix-session/'
    | '/clearing/operations/oms/routing-rule/'
    | '/clearing/operations/reporting/archive/'
    | '/clearing/operations/stock-record/asset/'
    | '/clearing/operations/sweep/job/'
    | '/clearing/operations/sweep/order/'
    | '/clearing/operations/sweep/participant/'
    | '/clearing/operations/sweep/task/'
    | '/clearing/operations/trade/trf-report/'
    | '/clearing/operations/trade/trf-session/'
    | '/clearing/operations/trade/utc-fix-session/'
    | '/clearing/operations/trade/utc/'
    | '/clearing/vendor/beta-nxt/prospectus-job/'
    | '/clearing/vendor/beta-nxt/prospectus-task/'
    | '/clearing/vendor/beta-nxt/proxy-vote-job/'
    | '/clearing/vendor/beta-nxt/proxy-vote-task/'
    | '/clearing/vendor/ice/corporate-action/'
    | '/clearing/vendor/ice/instrument/'
    | '/clearing/vendor/ice/job/'
    | '/clearing/vendor/ice/task/'
    | '/clearing/vendor/increase/account-number/'
    | '/clearing/vendor/increase/ach/'
    | '/clearing/vendor/increase/wire/'
    | '/clearing/vendor/jpm/destination/'
    | '/clearing/vendor/jpm/job/'
    | '/clearing/vendor/jpm/net-order/'
    | '/clearing/vendor/jpm/order/'
    | '/clearing/vendor/jpm/task/'
    | '/clearing/vendor/plaid/processor-token/'
    | '/clearing/vendor/quote-media/job/'
    | '/clearing/vendor/quote-media/sp-500/'
    | '/clearing/vendor/quote-media/task/'
    | '/registration/account/$accountId/cash/'
    | '/registration/account/$accountId/document/'
    | '/registration/account/$accountId/order/'
    | '/clearing/finance/accounting/account/$accountId'
    | '/clearing/finance/middle-money/fee-rate/$feeType'
    | '/clearing/operations/dtcc/asset-day/$assetId/$date'
    | '/clearing/operations/dtcc/asset/$assetId/$date'
    | '/clearing/operations/generate/monthly-statement/job/$jobId'
    | '/clearing/operations/generate/monthly-statement/task/$taskId'
    | '/clearing/operations/generate/trade-confirmation/job/$jobId'
    | '/clearing/operations/generate/trade-confirmation/task/$taskId'
    | '/clearing/operations/inventory/trading-day/$assetId'
    | '/clearing/operations/stock-record/asset/$assetId'
    | '/clearing/vendor/beta-nxt/proxy-vote-job/$jobId'
    | '/clearing/vendor/dtcc/file-request/$fileRequestId'
    | '/clearing/vendor/dtcc/file/$fileId'
    | '/clearing/vendor/jane-street/pfof/job/$jobId'
    | '/registration/account/$accountId/asset/$assetId/realization/$realizationId'
    | '/registration/account/$accountId/asset/$assetId/tax-lot/$taxLotId'
    | '/registration/account/$accountId/asset/$assetId'
    | '/registration/account/$accountId/cash/sweep/$assetId'
    | '/registration/account/$accountId/cash/transaction'
    | '/registration/account/$accountId/funding/source/$sourceId'
    | '/registration/account/$accountId/funding/transfer/$transferId'
    | '/registration/account/$accountId/order/equity/$orderId'
    | '/registration/account/$accountId/order/mutual-fund/$fundOrderId'
    | '/clearing/operations/dtcc/asset-day/$assetId/'
    | '/clearing/operations/generate/monthly-statement/job/'
    | '/clearing/operations/generate/monthly-statement/task/'
    | '/clearing/operations/generate/trade-confirmation/job/'
    | '/clearing/operations/generate/trade-confirmation/task/'
    | '/clearing/operations/mutualfunds/reconciliation/position-day/'
    | '/clearing/vendor/dtcc/file-request/'
    | '/clearing/vendor/dtcc/file/'
    | '/clearing/vendor/jane-street/pfof/job/'
    | '/registration/account/$accountId/funding/source/'
    | '/registration/account/$accountId/funding/transfer/'
    | '/clearing/finance/accounting/account/$accountId/settings'
    | '/clearing/finance/middle-money/fee-rate/$feeType/$effectiveDate'
    | '/clearing/operations/inventory/trading-day/$assetId/$date'
    | '/clearing/vendor/beta-nxt/proxy-vote-job/$jobId/task'
    | '/registration/account/$accountId/asset/$assetId/funding'
    | '/registration/account/$accountId/asset/$assetId/hold'
    | '/registration/account/$accountId/cash/transaction/$transactionId'
    | '/clearing/finance/accounting/account/$accountId/'
    | '/clearing/finance/middle-money/fee-rate/$feeType/'
    | '/clearing/operations/mutualfunds/reconciliation/position-day/$venue/'
    | '/clearing/operations/stock-record/asset/$assetId/'
    | '/clearing/vendor/beta-nxt/proxy-vote-job/$jobId/'
    | '/registration/account/$accountId/asset/$assetId/'
    | '/registration/account/$accountId/cash/transaction/'
    | '/clearing/operations/mutualfunds/dividend-accrual/$accountId/$assetId/$source/$firstDayOfMonth'
    | '/clearing/operations/mutualfunds/reconciliation/position-day/$venue/$date/$assetId'
    | '/clearing/operations/stock-record/asset/$assetId/account/$accountCode'
    | '/clearing/operations/mutualfunds/reconciliation/position-day/$venue/$date/'
    | '/registration/account/$accountId/asset/$assetId/realization/'
    | '/registration/account/$accountId/asset/$assetId/tax-lot/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-invitation'
    | '/mfa-setup'
    | '/logout'
    | '/forgot-password'
    | '/register'
    | '/request-access'
    | '/reset-password'
    | '/oauth/consent'
    | '/settings/personal'
    | '/developer'
    | '/settings'
    | '/docs'
    | '/login/mfa'
    | '/billing'
    | '/dashboard'
    | '/funding'
    | '/order'
    | '/registration'
    | '/sweep'
    | '/login'
    | '/user/invitation'
    | '/user/request'
    | '/docs/api-reference/$package'
    | '/docs/guide/$artifactName'
    | '/clearing'
    | '/asset'
    | '/hours'
    | '/registration/account'
    | '/user'
    | '/developer/agent-key'
    | '/developer/api-key'
    | '/developer/webhook'
    | '/docs/api-reference'
    | '/docs/guide'
    | '/billing/charge/$chargeId'
    | '/funding/account-number/$accountNumberId'
    | '/funding/batch-transfer/$batchTransferId'
    | '/funding/source/$sourceId'
    | '/funding/transfer/$transferId'
    | '/hours/schedule/{-$scheduleName}'
    | '/order/equity/$orderId'
    | '/order/mutual-fund/$fundOrderId'
    | '/sweep/plan/$sweepPlanId'
    | '/sweep/target/$sweepTargetId'
    | '/realm-access/$realmAccessId'
    | '/realm/$realmId'
    | '/role/$roleId'
    | '/tenant/$tenantId'
    | '/inbox'
    | '/billing/charge'
    | '/funding/account-number'
    | '/funding/batch-transfer'
    | '/funding/source'
    | '/funding/transfer'
    | '/order/equity'
    | '/order/mutual-fund'
    | '/registration/profile'
    | '/sweep/cutoff'
    | '/sweep/plan'
    | '/sweep/target'
    | '/tech-ops/build'
    | '/organization'
    | '/program'
    | '/realm-access'
    | '/realm'
    | '/role'
    | '/tenant'
    | '/asset/$assetId/filings'
    | '/asset/$assetId/market-data'
    | '/hours/exception/$exceptionId'
    | '/order/equity/batch/$batchOrderId'
    | '/registration/account/$accountId'
    | '/tech-ops/cluster/$clusterId'
    | '/tech-ops/dead-message/$messageId'
    | '/tech-ops/deployment/$deploymentId'
    | '/tech-ops/environment/$environmentId'
    | '/tech-ops/stack/$stackId'
    | '/tech-ops/trigger/$triggerId'
    | '/clearing/compliance'
    | '/clearing/finance'
    | '/clearing/operations'
    | '/clearing/vendor'
    | '/asset/$assetId'
    | '/hours/exception'
    | '/order/equity/batch'
    | '/registration/profile/$profileId'
    | '/tech-ops/cluster'
    | '/tech-ops/dead-message'
    | '/tech-ops/deployment'
    | '/tech-ops/environment'
    | '/tech-ops/stack'
    | '/tech-ops/test-run'
    | '/tech-ops/trigger'
    | '/clearing/operations/account/correspondent'
    | '/clearing/operations/reporting/cash-blotter'
    | '/clearing/operations/reporting/order-blotter'
    | '/clearing/operations/reporting/stock-blotter'
    | '/registration/account/$accountId/asset'
    | '/registration/account/$accountId/funding'
    | '/registration/account/$accountId/hold'
    | '/registration/account/$accountId/transaction'
    | '/tech-ops/test-run/$environment/$testRunId'
    | '/organization/$organizationId/invitation'
    | '/organization/$organizationId/realm-access'
    | '/clearing/compliance/fincen'
    | '/clearing/compliance/ofac'
    | '/clearing/compliance/reporting'
    | '/clearing/finance/accounting'
    | '/clearing/finance/middle-money'
    | '/clearing/finance/payment'
    | '/clearing/operations/account'
    | '/clearing/operations/dtcc'
    | '/clearing/operations/generate'
    | '/clearing/operations/inventory'
    | '/clearing/operations/mutualfunds'
    | '/clearing/operations/oms'
    | '/clearing/operations/reporting'
    | '/clearing/operations/sweep'
    | '/clearing/operations/trade'
    | '/clearing/vendor/beta-nxt'
    | '/clearing/vendor/jane-street'
    | '/clearing/vendor/jpm'
    | '/clearing/vendor/plaid'
    | '/clearing/vendor/quote-media'
    | '/tech-ops/build/repo'
    | '/tech-ops/test-run/$environment'
    | '/organization/$organizationId'
    | '/program/$programId'
    | '/clearing/finance/journal/$entryId'
    | '/clearing/finance/journal/create'
    | '/clearing/operations/balance/$accountCode'
    | '/clearing/operations/journal/$entryId'
    | '/clearing/operations/journal/create'
    | '/clearing/operations/transaction/$transactionId'
    | '/clearing/operations/trigger/$triggerId'
    | '/registration/account/$accountId/detail/beneficiaries'
    | '/registration/account/$accountId/detail/clearing-controls'
    | '/registration/account/$accountId/detail/controls'
    | '/registration/account/$accountId/detail/risk'
    | '/registration/profile/$profileId/edit/review'
    | '/registration/profile/create/$profileType/review'
    | '/tech-ops/build/repo/$owner/$name'
    | '/program/$programId/configuration/clearing'
    | '/program/$programId/configuration/contacts'
    | '/program/$programId/configuration/controls'
    | '/clearing/finance/journal'
    | '/clearing/finance/middle-money/taf-report'
    | '/clearing/operations/balance'
    | '/clearing/operations/customer-cash-balance'
    | '/clearing/operations/customer-stock-record'
    | '/clearing/operations/customer-sweep-record'
    | '/clearing/operations/generate/monthly-statement'
    | '/clearing/operations/journal'
    | '/clearing/operations/mutualfunds/reconciliation'
    | '/clearing/operations/stock-record'
    | '/clearing/operations/transaction'
    | '/clearing/operations/trigger'
    | '/clearing/vendor/dtcc'
    | '/clearing/vendor/jpm/emulator'
    | '/registration/account/$accountId/detail'
    | '/registration/account/$accountId/dividends-receivable'
    | '/registration/profile/$profileId/edit'
    | '/registration/profile/create/$profileType'
    | '/program/$programId/branding'
    | '/program/$programId/configuration'
    | '/clearing/compliance/fincen/entry/$fincen314EntryId'
    | '/clearing/compliance/fincen/file/$fincen314FileId'
    | '/clearing/compliance/fincen/match/$fincen314MatchId'
    | '/clearing/compliance/ofac/file/$ofacFileId'
    | '/clearing/compliance/ofac/match/$ofacMatchId'
    | '/clearing/compliance/ofac/sdn/$ofacSdnId'
    | '/clearing/compliance/reporting/blue-sheet/$reportId'
    | '/clearing/compliance/reporting/cais/$reportId'
    | '/clearing/compliance/reporting/cat/$reportId'
    | '/clearing/compliance/reporting/sec-606/$reportId'
    | '/clearing/finance/accounting/transaction/$transactionId'
    | '/clearing/finance/payment/account-number/$accountNumberId'
    | '/clearing/finance/payment/ach/$achId'
    | '/clearing/finance/payment/incoming-ach/$achId'
    | '/clearing/finance/payment/incoming-wire/$wireId'
    | '/clearing/finance/payment/wire/$wireId'
    | '/clearing/operations/ca/action/$actionId'
    | '/clearing/operations/ca/payment/$paymentId'
    | '/clearing/operations/inventory/balance/$assetId'
    | '/clearing/operations/inventory/books-order/$booksOrderId'
    | '/clearing/operations/inventory/order/$firmOrderId'
    | '/clearing/operations/mutualfunds/job/$jobId'
    | '/clearing/operations/mutualfunds/task/$taskId'
    | '/clearing/operations/mutualfunds/venue-order/$venueOrderId'
    | '/clearing/operations/oms/fix-order/$fixOrderId'
    | '/clearing/operations/oms/fix-session/$sessionId'
    | '/clearing/operations/oms/routing-rule/$ruleId'
    | '/clearing/operations/reporting/archive/$reportId'
    | '/clearing/operations/sweep/job/$jobId'
    | '/clearing/operations/sweep/order/$sweepOrderId'
    | '/clearing/operations/sweep/participant/$accountId'
    | '/clearing/operations/sweep/task/$taskId'
    | '/clearing/operations/trade/trf-report/$trfReportId'
    | '/clearing/operations/trade/trf-session/$sessionId'
    | '/clearing/operations/trade/utc-fix-session/$sessionId'
    | '/clearing/operations/trade/utc/$tradeId'
    | '/clearing/vendor/beta-nxt/prospectus-job/$jobId'
    | '/clearing/vendor/beta-nxt/prospectus-task/$taskId'
    | '/clearing/vendor/beta-nxt/proxy-vote-task/$taskId'
    | '/clearing/vendor/ice/corporate-action/$eventId'
    | '/clearing/vendor/ice/instrument/$instrumentId'
    | '/clearing/vendor/ice/job/$jobId'
    | '/clearing/vendor/ice/task/$taskId'
    | '/clearing/vendor/increase/account-number/$accountNumberId'
    | '/clearing/vendor/increase/ach/$achId'
    | '/clearing/vendor/increase/wire/$wireId'
    | '/clearing/vendor/jpm/destination/$destinationId'
    | '/clearing/vendor/jpm/job/$jobId'
    | '/clearing/vendor/jpm/net-order/$netOrderId'
    | '/clearing/vendor/jpm/order/$orderId'
    | '/clearing/vendor/jpm/task/$taskId'
    | '/clearing/vendor/plaid/processor-token/$processorTokenId'
    | '/clearing/vendor/quote-media/job/$jobId'
    | '/clearing/vendor/quote-media/sp-500/$quarter'
    | '/clearing/vendor/quote-media/task/$taskId'
    | '/registration/account/$accountId/document/tax'
    | '/registration/account/$accountId/document/trade-confirmation'
    | '/registration/account/$accountId/hold/$holdId'
    | '/registration/account/$accountId/order/equity'
    | '/registration/account/$accountId/order/mutual-fund'
    | '/registration/account/$accountId/transaction/$transactionId'
    | '/clearing/compliance/fincen/entry'
    | '/clearing/compliance/fincen/file'
    | '/clearing/compliance/fincen/match'
    | '/clearing/compliance/ofac/file'
    | '/clearing/compliance/ofac/match'
    | '/clearing/compliance/ofac/sdn'
    | '/clearing/compliance/reporting/blue-sheet'
    | '/clearing/compliance/reporting/cais'
    | '/clearing/compliance/reporting/cat'
    | '/clearing/compliance/reporting/sec-606'
    | '/clearing/finance/accounting/account'
    | '/clearing/finance/accounting/balance-sheet'
    | '/clearing/finance/accounting/income-statement'
    | '/clearing/finance/accounting/transaction'
    | '/clearing/finance/accounting/trial-balance'
    | '/clearing/finance/middle-money/fee-rate'
    | '/clearing/finance/payment/account-number'
    | '/clearing/finance/payment/ach'
    | '/clearing/finance/payment/incoming-ach'
    | '/clearing/finance/payment/incoming-wire'
    | '/clearing/finance/payment/wire'
    | '/clearing/operations/ca/action'
    | '/clearing/operations/ca/payment'
    | '/clearing/operations/dtcc/asset-day'
    | '/clearing/operations/dtcc/asset'
    | '/clearing/operations/inventory/balance'
    | '/clearing/operations/inventory/books-order'
    | '/clearing/operations/inventory/order'
    | '/clearing/operations/inventory/sell-down'
    | '/clearing/operations/inventory/trading-day'
    | '/clearing/operations/mutualfunds/dividend-accrual'
    | '/clearing/operations/mutualfunds/job'
    | '/clearing/operations/mutualfunds/task'
    | '/clearing/operations/mutualfunds/venue-order'
    | '/clearing/operations/oms/fix-order'
    | '/clearing/operations/oms/fix-session'
    | '/clearing/operations/oms/routing-rule'
    | '/clearing/operations/reporting/archive'
    | '/clearing/operations/stock-record/asset'
    | '/clearing/operations/sweep/job'
    | '/clearing/operations/sweep/order'
    | '/clearing/operations/sweep/participant'
    | '/clearing/operations/sweep/task'
    | '/clearing/operations/trade/trf-report'
    | '/clearing/operations/trade/trf-session'
    | '/clearing/operations/trade/utc-fix-session'
    | '/clearing/operations/trade/utc'
    | '/clearing/vendor/beta-nxt/prospectus-job'
    | '/clearing/vendor/beta-nxt/prospectus-task'
    | '/clearing/vendor/beta-nxt/proxy-vote-job'
    | '/clearing/vendor/beta-nxt/proxy-vote-task'
    | '/clearing/vendor/ice/corporate-action'
    | '/clearing/vendor/ice/instrument'
    | '/clearing/vendor/ice/job'
    | '/clearing/vendor/ice/task'
    | '/clearing/vendor/increase/account-number'
    | '/clearing/vendor/increase/ach'
    | '/clearing/vendor/increase/wire'
    | '/clearing/vendor/jpm/destination'
    | '/clearing/vendor/jpm/job'
    | '/clearing/vendor/jpm/net-order'
    | '/clearing/vendor/jpm/order'
    | '/clearing/vendor/jpm/task'
    | '/clearing/vendor/plaid/processor-token'
    | '/clearing/vendor/quote-media/job'
    | '/clearing/vendor/quote-media/sp-500'
    | '/clearing/vendor/quote-media/task'
    | '/registration/account/$accountId/cash'
    | '/registration/account/$accountId/document'
    | '/registration/account/$accountId/order'
    | '/clearing/operations/dtcc/asset-day/$assetId/$date'
    | '/clearing/operations/dtcc/asset/$assetId/$date'
    | '/clearing/operations/generate/monthly-statement/job/$jobId'
    | '/clearing/operations/generate/monthly-statement/task/$taskId'
    | '/clearing/operations/generate/trade-confirmation/job/$jobId'
    | '/clearing/operations/generate/trade-confirmation/task/$taskId'
    | '/clearing/operations/inventory/trading-day/$assetId'
    | '/clearing/vendor/dtcc/file-request/$fileRequestId'
    | '/clearing/vendor/dtcc/file/$fileId'
    | '/clearing/vendor/jane-street/pfof/job/$jobId'
    | '/registration/account/$accountId/asset/$assetId/realization/$realizationId'
    | '/registration/account/$accountId/asset/$assetId/tax-lot/$taxLotId'
    | '/registration/account/$accountId/cash/sweep/$assetId'
    | '/registration/account/$accountId/funding/source/$sourceId'
    | '/registration/account/$accountId/funding/transfer/$transferId'
    | '/registration/account/$accountId/order/equity/$orderId'
    | '/registration/account/$accountId/order/mutual-fund/$fundOrderId'
    | '/clearing/operations/dtcc/asset-day/$assetId'
    | '/clearing/operations/generate/monthly-statement/job'
    | '/clearing/operations/generate/monthly-statement/task'
    | '/clearing/operations/generate/trade-confirmation/job'
    | '/clearing/operations/generate/trade-confirmation/task'
    | '/clearing/operations/mutualfunds/reconciliation/position-day'
    | '/clearing/vendor/dtcc/file-request'
    | '/clearing/vendor/dtcc/file'
    | '/clearing/vendor/jane-street/pfof/job'
    | '/registration/account/$accountId/funding/source'
    | '/registration/account/$accountId/funding/transfer'
    | '/clearing/finance/accounting/account/$accountId/settings'
    | '/clearing/finance/middle-money/fee-rate/$feeType/$effectiveDate'
    | '/clearing/operations/inventory/trading-day/$assetId/$date'
    | '/clearing/vendor/beta-nxt/proxy-vote-job/$jobId/task'
    | '/registration/account/$accountId/asset/$assetId/funding'
    | '/registration/account/$accountId/asset/$assetId/hold'
    | '/registration/account/$accountId/cash/transaction/$transactionId'
    | '/clearing/finance/accounting/account/$accountId'
    | '/clearing/finance/middle-money/fee-rate/$feeType'
    | '/clearing/operations/mutualfunds/reconciliation/position-day/$venue'
    | '/clearing/operations/stock-record/asset/$assetId'
    | '/clearing/vendor/beta-nxt/proxy-vote-job/$jobId'
    | '/registration/account/$accountId/asset/$assetId'
    | '/registration/account/$accountId/cash/transaction'
    | '/clearing/operations/mutualfunds/dividend-accrual/$accountId/$assetId/$source/$firstDayOfMonth'
    | '/clearing/operations/mutualfunds/reconciliation/position-day/$venue/$date/$assetId'
    | '/clearing/operations/stock-record/asset/$assetId/account/$accountCode'
    | '/clearing/operations/mutualfunds/reconciliation/position-day/$venue/$date'
    | '/registration/account/$accountId/asset/$assetId/realization'
    | '/registration/account/$accountId/asset/$assetId/tax-lot'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_auth'
    | '/accept-invitation'
    | '/mfa-setup'
    | '/_app/_clearing-core'
    | '/_app/logout'
    | '/_auth/forgot-password'
    | '/_auth/register'
    | '/_auth/request-access'
    | '/_auth/reset-password'
    | '/docs/_layout'
    | '/oauth/consent'
    | '/_app/_clearing-core/_clearing-required'
    | '/_app/_o5/_o5-required'
    | '/_app/_platform/_context-required'
    | '/_app/settings/personal'
    | '/_auth/login/_login'
    | '/_app/developer/'
    | '/_app/settings/'
    | '/docs/_layout/'
    | '/_app/_clearing-core/asset/_asset'
    | '/_app/_clearing-core/hours/_hours'
    | '/_app/developer/agent-key/_agent-key'
    | '/_app/developer/api-key/_api-key'
    | '/_app/developer/webhook/_webhook'
    | '/_auth/login/_login/mfa'
    | '/docs/_layout/api-reference/_provider'
    | '/docs/_layout/guide/_provider'
    | '/_app/_clearing-core/billing/'
    | '/_app/_clearing-core/dashboard/'
    | '/_app/_clearing-core/funding/'
    | '/_app/_clearing-core/order/'
    | '/_app/_clearing-core/registration/'
    | '/_app/_clearing-core/sweep/'
    | '/_auth/login/_login/'
    | '/_app/_clearing-core/billing/charge/_charge'
    | '/_app/_clearing-core/funding/account-number/_account-number'
    | '/_app/_clearing-core/funding/batch-transfer/_batch-transfer'
    | '/_app/_clearing-core/funding/source/_source'
    | '/_app/_clearing-core/funding/transfer/_transfer'
    | '/_app/_clearing-core/order/equity/_single'
    | '/_app/_clearing-core/order/mutual-fund/_mutual-fund'
    | '/_app/_clearing-core/registration/profile/_profile'
    | '/_app/_clearing-core/sweep/cutoff/_cutoff'
    | '/_app/_clearing-core/sweep/plan/_plan'
    | '/_app/_clearing-core/sweep/target/_target'
    | '/_app/_platform/_context-required/organization/_organization'
    | '/_app/_platform/_context-required/program/_program'
    | '/_app/_platform/_context-required/realm-access/_realm-access'
    | '/_app/_platform/_context-required/realm/_realm'
    | '/_app/_platform/_context-required/role/_role'
    | '/_app/_platform/_context-required/tenant/_tenant'
    | '/_app/_platform/_context-required/user/invitation'
    | '/_app/_platform/_context-required/user/request'
    | '/docs/_layout/api-reference/_provider/$package'
    | '/docs/_layout/guide/_provider/$artifactName'
    | '/_app/_clearing-core/_clearing-required/clearing/'
    | '/_app/_clearing-core/asset/_asset/'
    | '/_app/_clearing-core/hours/_hours/'
    | '/_app/_clearing-core/registration/account/'
    | '/_app/_platform/_context-required/user/'
    | '/_app/developer/agent-key/_agent-key/'
    | '/_app/developer/api-key/_api-key/'
    | '/_app/developer/webhook/_webhook/'
    | '/docs/_layout/api-reference/_provider/'
    | '/docs/_layout/guide/_provider/'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor'
    | '/_app/_clearing-core/asset/_asset/$assetId/_detail'
    | '/_app/_clearing-core/billing/charge/_charge/$chargeId'
    | '/_app/_clearing-core/funding/account-number/_account-number/$accountNumberId'
    | '/_app/_clearing-core/funding/batch-transfer/_batch-transfer/$batchTransferId'
    | '/_app/_clearing-core/funding/source/_source/$sourceId'
    | '/_app/_clearing-core/funding/transfer/_transfer/$transferId'
    | '/_app/_clearing-core/hours/_hours/exception/_exception'
    | '/_app/_clearing-core/hours/_hours/schedule/{-$scheduleName}'
    | '/_app/_clearing-core/order/equity/_single/$orderId'
    | '/_app/_clearing-core/order/equity/batch/_batch'
    | '/_app/_clearing-core/order/mutual-fund/_mutual-fund/$fundOrderId'
    | '/_app/_clearing-core/registration/account/$accountId/_account'
    | '/_app/_clearing-core/sweep/plan/_plan/$sweepPlanId'
    | '/_app/_clearing-core/sweep/target/_target/$sweepTargetId'
    | '/_app/_o5/_o5-required/tech-ops/cluster/_cluster'
    | '/_app/_o5/_o5-required/tech-ops/dead-message/_dead-message'
    | '/_app/_o5/_o5-required/tech-ops/deployment/_deployment'
    | '/_app/_o5/_o5-required/tech-ops/environment/_environment'
    | '/_app/_o5/_o5-required/tech-ops/stack/_stack'
    | '/_app/_o5/_o5-required/tech-ops/test-run/_test-run'
    | '/_app/_o5/_o5-required/tech-ops/trigger/_trigger'
    | '/_app/_platform/_context-required/realm-access/_realm-access/$realmAccessId'
    | '/_app/_platform/_context-required/realm/_realm/$realmId'
    | '/_app/_platform/_context-required/role/_role/$roleId'
    | '/_app/_platform/_context-required/tenant/_tenant/$tenantId'
    | '/_app/_clearing-core/_clearing-required/inbox/_inbox/'
    | '/_app/_clearing-core/billing/charge/_charge/'
    | '/_app/_clearing-core/funding/account-number/_account-number/'
    | '/_app/_clearing-core/funding/batch-transfer/_batch-transfer/'
    | '/_app/_clearing-core/funding/source/_source/'
    | '/_app/_clearing-core/funding/transfer/_transfer/'
    | '/_app/_clearing-core/order/equity/_single/'
    | '/_app/_clearing-core/order/mutual-fund/_mutual-fund/'
    | '/_app/_clearing-core/registration/profile/_profile/'
    | '/_app/_clearing-core/sweep/cutoff/_cutoff/'
    | '/_app/_clearing-core/sweep/plan/_plan/'
    | '/_app/_clearing-core/sweep/target/_target/'
    | '/_app/_o5/_o5-required/tech-ops/build/'
    | '/_app/_platform/_context-required/organization/_organization/'
    | '/_app/_platform/_context-required/program/_program/'
    | '/_app/_platform/_context-required/realm-access/_realm-access/'
    | '/_app/_platform/_context-required/realm/_realm/'
    | '/_app/_platform/_context-required/role/_role/'
    | '/_app/_platform/_context-required/tenant/_tenant/'
    | '/_app/_clearing-core/asset/_asset/$assetId/_detail/filings'
    | '/_app/_clearing-core/asset/_asset/$assetId/_detail/market-data'
    | '/_app/_clearing-core/hours/_hours/exception/_exception/$exceptionId'
    | '/_app/_clearing-core/order/equity/batch/_batch/$batchOrderId'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_overview'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list'
    | '/_app/_o5/_o5-required/tech-ops/build/repo/_repo'
    | '/_app/_o5/_o5-required/tech-ops/cluster/_cluster/$clusterId'
    | '/_app/_o5/_o5-required/tech-ops/dead-message/_dead-message/$messageId'
    | '/_app/_o5/_o5-required/tech-ops/deployment/_deployment/$deploymentId'
    | '/_app/_o5/_o5-required/tech-ops/environment/_environment/$environmentId'
    | '/_app/_o5/_o5-required/tech-ops/stack/_stack/$stackId'
    | '/_app/_o5/_o5-required/tech-ops/trigger/_trigger/$triggerId'
    | '/_app/_platform/_context-required/organization/_organization/$organizationId/_detail'
    | '/_app/_platform/_context-required/program/_program/$programId/_program'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/'
    | '/_app/_clearing-core/asset/_asset/$assetId/_detail/'
    | '/_app/_clearing-core/hours/_hours/exception/_exception/'
    | '/_app/_clearing-core/order/equity/batch/_batch/'
    | '/_app/_clearing-core/registration/account/$accountId/_account/'
    | '/_app/_clearing-core/registration/profile/_profile/$profileId/'
    | '/_app/_o5/_o5-required/tech-ops/cluster/_cluster/'
    | '/_app/_o5/_o5-required/tech-ops/dead-message/_dead-message/'
    | '/_app/_o5/_o5-required/tech-ops/deployment/_deployment/'
    | '/_app/_o5/_o5-required/tech-ops/environment/_environment/'
    | '/_app/_o5/_o5-required/tech-ops/stack/_stack/'
    | '/_app/_o5/_o5-required/tech-ops/test-run/_test-run/'
    | '/_app/_o5/_o5-required/tech-ops/trigger/_trigger/'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/journal/_manual-entry'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/account/correspondent'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/balance/_balance'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-cash-balance/_customer-cash-balance'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-stock-record/_customer-stock-record'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-sweep-record/_customer-sweep-record'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/journal/_manual-entry'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/cash-blotter'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/order-blotter'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/stock-blotter'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/transaction/_transaction'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trigger/_trigger'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/asset'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/funding'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/hold'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/transaction'
    | '/_app/_clearing-core/registration/account/$accountId/_account/dividends-receivable/_dividends-receivable'
    | '/_app/_clearing-core/registration/profile/_profile/$profileId/edit/_edit'
    | '/_app/_clearing-core/registration/profile/_profile/create/$profileType/_create'
    | '/_app/_o5/_o5-required/tech-ops/test-run/_test-run/$environment/$testRunId'
    | '/_app/_platform/_context-required/organization/_organization/$organizationId/_detail/invitation'
    | '/_app/_platform/_context-required/organization/_organization/$organizationId/_detail/realm-access'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/account/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jane-street/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/plaid/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/'
    | '/_app/_o5/_o5-required/tech-ops/build/repo/_repo/'
    | '/_app/_o5/_o5-required/tech-ops/test-run/_test-run/$environment/'
    | '/_app/_platform/_context-required/organization/_organization/$organizationId/_detail/'
    | '/_app/_platform/_context-required/program/_program/$programId/_program/'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/entry/_entry'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/file/_file'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/match/_match'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/file/_file'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/match/_match'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/sdn/_sdn'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/blue-sheet/_blue-sheet'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cais/_cais'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cat/_cat'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/sec-606/_sec-606'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/balance-sheet/_balance-sheet'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/income-statement/_income-statement'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/transaction/_transaction'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/trial-balance/_trial-balance'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/journal/_manual-entry/$entryId'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/journal/_manual-entry/create'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/account-number/_account-number'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/ach/_ach'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-ach/_incoming-ach'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-wire/_incoming-wire'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/wire/_wire'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/balance/_balance/$accountCode'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/action/_action'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/payment/_payment'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset-day/_asset-day'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset/_asset'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/balance/_balance'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/books-order/_books-order'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/order/_order'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/sell-down/_sell-down'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/trading-day/_trading-day'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/journal/_manual-entry/$entryId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/journal/_manual-entry/create'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/dividend-accrual/_dividend-accrual'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/job/_job'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/task/_task'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/venue-order/_venue-order'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-order/_fix-order'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-session/_fix-session'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/routing-rule/_routing-rule'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/archive/_report'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/job/_job'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/order/_order'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/participant/_participant'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/task/_task'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-report/_trf-report'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-session/_trf-session'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc-fix-session/_utc-fix-session'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc/_utc'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/transaction/_transaction/$transactionId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trigger/_trigger/$triggerId'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-job/_job'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-task/_task'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-task/_task'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/corporate-action/_action'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/instrument/_instrument'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/job/_job'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/task/_task'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/account-number/_account-number'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/ach/_ach'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/wire/_wire'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/destination/_destination'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/job/_job'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/net-order/_net-order'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/order/_order'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/task/_task'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/plaid/processor-token/_processor-token'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/job/_job'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/sp-500/_sp-500'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/task/_task'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/document/_document'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/hold/_hold'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/transaction/_transaction'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/beneficiaries'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/clearing-controls'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/controls'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/risk'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/order/_order'
    | '/_app/_clearing-core/registration/profile/_profile/$profileId/edit/_edit/review'
    | '/_app/_clearing-core/registration/profile/_profile/create/$profileType/_create/review'
    | '/_app/_o5/_o5-required/tech-ops/build/repo/_repo/$owner/$name'
    | '/_app/_platform/_context-required/program/_program/$programId/_program/configuration/clearing'
    | '/_app/_platform/_context-required/program/_program/$programId/_program/configuration/contacts'
    | '/_app/_platform/_context-required/program/_program/$programId/_program/configuration/controls'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/journal/_manual-entry/'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/taf-report/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/balance/_balance/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-cash-balance/_customer-cash-balance/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-stock-record/_customer-stock-record/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-sweep-record/_customer-sweep-record/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/journal/_manual-entry/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/transaction/_transaction/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trigger/_trigger/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/emulator/'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/'
    | '/_app/_clearing-core/registration/account/$accountId/_account/dividends-receivable/_dividends-receivable/'
    | '/_app/_clearing-core/registration/profile/_profile/$profileId/edit/_edit/'
    | '/_app/_clearing-core/registration/profile/_profile/create/$profileType/_create/'
    | '/_app/_platform/_context-required/program/_program/$programId/_program/branding/'
    | '/_app/_platform/_context-required/program/_program/$programId/_program/configuration/'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/entry/_entry/$fincen314EntryId'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/file/_file/$fincen314FileId'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/match/_match/$fincen314MatchId'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/file/_file/$ofacFileId'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/match/_match/$ofacMatchId'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/sdn/_sdn/$ofacSdnId'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/blue-sheet/_blue-sheet/$reportId'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cais/_cais/$reportId'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cat/_cat/$reportId'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/sec-606/_sec-606/$reportId'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/transaction/_transaction/$transactionId'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/account-number/_account-number/$accountNumberId'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/ach/_ach/$achId'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-ach/_incoming-ach/$achId'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-wire/_incoming-wire/$wireId'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/wire/_wire/$wireId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/action/_action/$actionId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/payment/_payment/$paymentId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/job/_job'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/task/_task'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/job/_job'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/task/_task'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/balance/_balance/$assetId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/books-order/_books-order/$booksOrderId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/order/_order/$firmOrderId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/job/_job/$jobId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/task/_task/$taskId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/venue-order/_venue-order/$venueOrderId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-order/_fix-order/$fixOrderId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-session/_fix-session/$sessionId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/routing-rule/_routing-rule/$ruleId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/archive/_report/$reportId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/job/_job/$jobId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/order/_order/$sweepOrderId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/participant/_participant/$accountId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/task/_task/$taskId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-report/_trf-report/$trfReportId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-session/_trf-session/$sessionId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc-fix-session/_utc-fix-session/$sessionId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc/_utc/$tradeId'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-job/_job/$jobId'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-task/_task/$taskId'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-task/_task/$taskId'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file-request/_file-request'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file/_file'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/corporate-action/_action/$eventId'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/instrument/_instrument/$instrumentId'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/job/_job/$jobId'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/task/_task/$taskId'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/account-number/_account-number/$accountNumberId'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/ach/_ach/$achId'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/wire/_wire/$wireId'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jane-street/pfof/job/_job'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/destination/_destination/$destinationId'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/job/_job/$jobId'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/net-order/_net-order/$netOrderId'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/order/_order/$orderId'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/task/_task/$taskId'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/plaid/processor-token/_processor-token/$processorTokenId'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/job/_job/$jobId'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/sp-500/_sp-500/$quarter'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/task/_task/$taskId'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/document/_document/tax'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/document/_document/trade-confirmation'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/hold/_hold/$holdId'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/order/equity/_equity'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/order/mutual-fund/_mutual-fund'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/transaction/_transaction/$transactionId'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/order/_order/equity'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/order/_order/mutual-fund'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/entry/_entry/'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/file/_file/'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/match/_match/'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/file/_file/'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/match/_match/'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/sdn/_sdn/'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/blue-sheet/_blue-sheet/'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cais/_cais/'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cat/_cat/'
    | '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/sec-606/_sec-606/'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account/'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/balance-sheet/_balance-sheet/'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/income-statement/_income-statement/'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/transaction/_transaction/'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/trial-balance/_trial-balance/'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate/'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/account-number/_account-number/'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/ach/_ach/'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-ach/_incoming-ach/'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-wire/_incoming-wire/'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/wire/_wire/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/action/_action/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/payment/_payment/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset-day/_asset-day/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset/_asset/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/balance/_balance/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/books-order/_books-order/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/order/_order/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/sell-down/_sell-down/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/trading-day/_trading-day/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/dividend-accrual/_dividend-accrual/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/job/_job/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/task/_task/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/venue-order/_venue-order/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-order/_fix-order/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-session/_fix-session/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/routing-rule/_routing-rule/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/archive/_report/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/asset/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/job/_job/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/order/_order/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/participant/_participant/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/task/_task/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-report/_trf-report/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-session/_trf-session/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc-fix-session/_utc-fix-session/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc/_utc/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-job/_job/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-task/_task/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-task/_task/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/corporate-action/_action/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/instrument/_instrument/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/job/_job/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/task/_task/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/account-number/_account-number/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/ach/_ach/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/wire/_wire/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/destination/_destination/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/job/_job/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/net-order/_net-order/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/order/_order/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/task/_task/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/plaid/processor-token/_processor-token/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/job/_job/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/sp-500/_sp-500/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/task/_task/'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/document/_document/'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/order/_order/'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account/$accountId/_layout'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate/$feeType/_$feeType'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset-day/_asset-day/$assetId/$date'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset/_asset/$assetId/$date'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/job/_job/$jobId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/task/_task/$taskId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/job/_job/$jobId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/task/_task/$taskId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/trading-day/_trading-day/$assetId/_$assetId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/asset/$assetId/_asset'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job/$jobId/_job'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file-request/_file-request/$fileRequestId'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file/_file/$fileId'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jane-street/pfof/job/_job/$jobId'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_cost-basis/asset/$assetId/realization/$realizationId'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_cost-basis/asset/$assetId/tax-lot/$taxLotId'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/sweep/$assetId'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/transaction/_transaction'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding/source/$sourceId'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding/transfer/$transferId'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/order/equity/_equity/$orderId'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/order/mutual-fund/_mutual-fund/$fundOrderId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset-day/_asset-day/$assetId/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/job/_job/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/task/_task/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/job/_job/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/task/_task/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file-request/_file-request/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file/_file/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jane-street/pfof/job/_job/'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding/source/'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding/transfer/'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account/$accountId/_layout/settings'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate/$feeType/_$feeType/$effectiveDate'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/trading-day/_trading-day/$assetId/_$assetId/$date'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job/$jobId/_job/task'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/funding'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/hold'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/transaction/_transaction/$transactionId'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account/$accountId/_layout/'
    | '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate/$feeType/_$feeType/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day/$venue/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/asset/$assetId/_asset/'
    | '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job/$jobId/_job/'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/transaction/_transaction/'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/dividend-accrual/_dividend-accrual/$accountId/$assetId/$source/$firstDayOfMonth'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day/$venue/$date/$assetId'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/asset/$assetId/_asset/account/$accountCode'
    | '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day/$venue/$date/'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/realization/'
    | '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/tax-lot/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  AcceptInvitationRoute: typeof AcceptInvitationRoute
  MfaSetupRoute: typeof MfaSetupRoute
  DocsLayoutRoute: typeof DocsLayoutRouteWithChildren
  OauthConsentRoute: typeof OauthConsentRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invitation': {
      id: '/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof AcceptInvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mfa-setup': {
      id: '/mfa-setup'
      path: '/mfa-setup'
      fullPath: '/mfa-setup'
      preLoaderRoute: typeof MfaSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/_clearing-core': {
      id: '/_app/_clearing-core'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppClearingCoreRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/logout': {
      id: '/_app/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof AppLogoutRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/request-access': {
      id: '/_auth/request-access'
      path: '/request-access'
      fullPath: '/request-access'
      preLoaderRoute: typeof AuthRequestAccessRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/docs/_layout': {
      id: '/docs/_layout'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof DocsLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/_clearing-core/_clearing-required': {
      id: '/_app/_clearing-core/_clearing-required'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredRouteImport
      parentRoute: typeof AppClearingCoreRoute
    }
    '/_app/_o5/_o5-required': {
      id: '/_app/_o5/_o5-required'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppO5O5RequiredRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_platform/_context-required': {
      id: '/_app/_platform/_context-required'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppPlatformContextRequiredRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/developer/': {
      id: '/_app/developer/'
      path: '/developer'
      fullPath: '/developer/'
      preLoaderRoute: typeof AppDeveloperIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/personal': {
      id: '/_app/settings/personal'
      path: '/settings/personal'
      fullPath: '/settings/personal'
      preLoaderRoute: typeof AppSettingsPersonalRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/login/_login': {
      id: '/_auth/login/_login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/docs/_layout/': {
      id: '/docs/_layout/'
      path: '/'
      fullPath: '/docs/'
      preLoaderRoute: typeof DocsLayoutIndexRouteImport
      parentRoute: typeof DocsLayoutRoute
    }
    '/_app/_clearing-core/asset/_asset': {
      id: '/_app/_clearing-core/asset/_asset'
      path: '/asset'
      fullPath: '/asset'
      preLoaderRoute: typeof AppClearingCoreAssetAssetRouteImport
      parentRoute: typeof AppClearingCoreRoute
    }
    '/_app/_clearing-core/billing/': {
      id: '/_app/_clearing-core/billing/'
      path: '/billing'
      fullPath: '/billing/'
      preLoaderRoute: typeof AppClearingCoreBillingIndexRouteImport
      parentRoute: typeof AppClearingCoreRoute
    }
    '/_app/_clearing-core/dashboard/': {
      id: '/_app/_clearing-core/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AppClearingCoreDashboardIndexRouteImport
      parentRoute: typeof AppClearingCoreRoute
    }
    '/_app/_clearing-core/funding/': {
      id: '/_app/_clearing-core/funding/'
      path: '/funding'
      fullPath: '/funding/'
      preLoaderRoute: typeof AppClearingCoreFundingIndexRouteImport
      parentRoute: typeof AppClearingCoreRoute
    }
    '/_app/_clearing-core/hours/_hours': {
      id: '/_app/_clearing-core/hours/_hours'
      path: '/hours'
      fullPath: '/hours'
      preLoaderRoute: typeof AppClearingCoreHoursHoursRouteImport
      parentRoute: typeof AppClearingCoreRoute
    }
    '/_app/_clearing-core/order/': {
      id: '/_app/_clearing-core/order/'
      path: '/order'
      fullPath: '/order/'
      preLoaderRoute: typeof AppClearingCoreOrderIndexRouteImport
      parentRoute: typeof AppClearingCoreRoute
    }
    '/_app/_clearing-core/registration/': {
      id: '/_app/_clearing-core/registration/'
      path: '/registration'
      fullPath: '/registration/'
      preLoaderRoute: typeof AppClearingCoreRegistrationIndexRouteImport
      parentRoute: typeof AppClearingCoreRoute
    }
    '/_app/_clearing-core/sweep/': {
      id: '/_app/_clearing-core/sweep/'
      path: '/sweep'
      fullPath: '/sweep/'
      preLoaderRoute: typeof AppClearingCoreSweepIndexRouteImport
      parentRoute: typeof AppClearingCoreRoute
    }
    '/_app/developer/agent-key/_agent-key': {
      id: '/_app/developer/agent-key/_agent-key'
      path: '/developer/agent-key'
      fullPath: '/developer/agent-key'
      preLoaderRoute: typeof AppDeveloperAgentKeyAgentKeyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/developer/api-key/_api-key': {
      id: '/_app/developer/api-key/_api-key'
      path: '/developer/api-key'
      fullPath: '/developer/api-key'
      preLoaderRoute: typeof AppDeveloperApiKeyApiKeyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/developer/webhook/_webhook': {
      id: '/_app/developer/webhook/_webhook'
      path: '/developer/webhook'
      fullPath: '/developer/webhook'
      preLoaderRoute: typeof AppDeveloperWebhookWebhookRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/login/_login/': {
      id: '/_auth/login/_login/'
      path: '/'
      fullPath: '/login/'
      preLoaderRoute: typeof AuthLoginLoginIndexRouteImport
      parentRoute: typeof AuthLoginLoginRoute
    }
    '/_auth/login/_login/mfa': {
      id: '/_auth/login/_login/mfa'
      path: '/mfa'
      fullPath: '/login/mfa'
      preLoaderRoute: typeof AuthLoginLoginMfaRouteImport
      parentRoute: typeof AuthLoginLoginRoute
    }
    '/docs/_layout/api-reference/_provider': {
      id: '/docs/_layout/api-reference/_provider'
      path: '/api-reference'
      fullPath: '/docs/api-reference'
      preLoaderRoute: typeof DocsLayoutApiReferenceProviderRouteImport
      parentRoute: typeof DocsLayoutRoute
    }
    '/docs/_layout/guide/_provider': {
      id: '/docs/_layout/guide/_provider'
      path: '/guide'
      fullPath: '/docs/guide'
      preLoaderRoute: typeof DocsLayoutGuideProviderRouteImport
      parentRoute: typeof DocsLayoutRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/'
      path: '/clearing'
      fullPath: '/clearing/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredRoute
    }
    '/_app/_clearing-core/asset/_asset/': {
      id: '/_app/_clearing-core/asset/_asset/'
      path: '/'
      fullPath: '/asset/'
      preLoaderRoute: typeof AppClearingCoreAssetAssetIndexRouteImport
      parentRoute: typeof AppClearingCoreAssetAssetRoute
    }
    '/_app/_clearing-core/billing/charge/_charge': {
      id: '/_app/_clearing-core/billing/charge/_charge'
      path: '/billing/charge'
      fullPath: '/billing/charge'
      preLoaderRoute: typeof AppClearingCoreBillingChargeChargeRouteImport
      parentRoute: typeof AppClearingCoreRoute
    }
    '/_app/_clearing-core/funding/account-number/_account-number': {
      id: '/_app/_clearing-core/funding/account-number/_account-number'
      path: '/funding/account-number'
      fullPath: '/funding/account-number'
      preLoaderRoute: typeof AppClearingCoreFundingAccountNumberAccountNumberRouteImport
      parentRoute: typeof AppClearingCoreRoute
    }
    '/_app/_clearing-core/funding/batch-transfer/_batch-transfer': {
      id: '/_app/_clearing-core/funding/batch-transfer/_batch-transfer'
      path: '/funding/batch-transfer'
      fullPath: '/funding/batch-transfer'
      preLoaderRoute: typeof AppClearingCoreFundingBatchTransferBatchTransferRouteImport
      parentRoute: typeof AppClearingCoreRoute
    }
    '/_app/_clearing-core/funding/source/_source': {
      id: '/_app/_clearing-core/funding/source/_source'
      path: '/funding/source'
      fullPath: '/funding/source'
      preLoaderRoute: typeof AppClearingCoreFundingSourceSourceRouteImport
      parentRoute: typeof AppClearingCoreRoute
    }
    '/_app/_clearing-core/funding/transfer/_transfer': {
      id: '/_app/_clearing-core/funding/transfer/_transfer'
      path: '/funding/transfer'
      fullPath: '/funding/transfer'
      preLoaderRoute: typeof AppClearingCoreFundingTransferTransferRouteImport
      parentRoute: typeof AppClearingCoreRoute
    }
    '/_app/_clearing-core/hours/_hours/': {
      id: '/_app/_clearing-core/hours/_hours/'
      path: '/'
      fullPath: '/hours/'
      preLoaderRoute: typeof AppClearingCoreHoursHoursIndexRouteImport
      parentRoute: typeof AppClearingCoreHoursHoursRoute
    }
    '/_app/_clearing-core/order/equity/_single': {
      id: '/_app/_clearing-core/order/equity/_single'
      path: '/order/equity'
      fullPath: '/order/equity'
      preLoaderRoute: typeof AppClearingCoreOrderEquitySingleRouteImport
      parentRoute: typeof AppClearingCoreRoute
    }
    '/_app/_clearing-core/order/mutual-fund/_mutual-fund': {
      id: '/_app/_clearing-core/order/mutual-fund/_mutual-fund'
      path: '/order/mutual-fund'
      fullPath: '/order/mutual-fund'
      preLoaderRoute: typeof AppClearingCoreOrderMutualFundMutualFundRouteImport
      parentRoute: typeof AppClearingCoreRoute
    }
    '/_app/_clearing-core/registration/account/': {
      id: '/_app/_clearing-core/registration/account/'
      path: '/registration/account'
      fullPath: '/registration/account/'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountIndexRouteImport
      parentRoute: typeof AppClearingCoreRoute
    }
    '/_app/_clearing-core/registration/profile/_profile': {
      id: '/_app/_clearing-core/registration/profile/_profile'
      path: '/registration/profile'
      fullPath: '/registration/profile'
      preLoaderRoute: typeof AppClearingCoreRegistrationProfileProfileRouteImport
      parentRoute: typeof AppClearingCoreRoute
    }
    '/_app/_clearing-core/sweep/cutoff/_cutoff': {
      id: '/_app/_clearing-core/sweep/cutoff/_cutoff'
      path: '/sweep/cutoff'
      fullPath: '/sweep/cutoff'
      preLoaderRoute: typeof AppClearingCoreSweepCutoffCutoffRouteImport
      parentRoute: typeof AppClearingCoreRoute
    }
    '/_app/_clearing-core/sweep/plan/_plan': {
      id: '/_app/_clearing-core/sweep/plan/_plan'
      path: '/sweep/plan'
      fullPath: '/sweep/plan'
      preLoaderRoute: typeof AppClearingCoreSweepPlanPlanRouteImport
      parentRoute: typeof AppClearingCoreRoute
    }
    '/_app/_clearing-core/sweep/target/_target': {
      id: '/_app/_clearing-core/sweep/target/_target'
      path: '/sweep/target'
      fullPath: '/sweep/target'
      preLoaderRoute: typeof AppClearingCoreSweepTargetTargetRouteImport
      parentRoute: typeof AppClearingCoreRoute
    }
    '/_app/_platform/_context-required/organization/_organization': {
      id: '/_app/_platform/_context-required/organization/_organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof AppPlatformContextRequiredOrganizationOrganizationRouteImport
      parentRoute: typeof AppPlatformContextRequiredRoute
    }
    '/_app/_platform/_context-required/program/_program': {
      id: '/_app/_platform/_context-required/program/_program'
      path: '/program'
      fullPath: '/program'
      preLoaderRoute: typeof AppPlatformContextRequiredProgramProgramRouteImport
      parentRoute: typeof AppPlatformContextRequiredRoute
    }
    '/_app/_platform/_context-required/realm-access/_realm-access': {
      id: '/_app/_platform/_context-required/realm-access/_realm-access'
      path: '/realm-access'
      fullPath: '/realm-access'
      preLoaderRoute: typeof AppPlatformContextRequiredRealmAccessRealmAccessRouteImport
      parentRoute: typeof AppPlatformContextRequiredRoute
    }
    '/_app/_platform/_context-required/realm/_realm': {
      id: '/_app/_platform/_context-required/realm/_realm'
      path: '/realm'
      fullPath: '/realm'
      preLoaderRoute: typeof AppPlatformContextRequiredRealmRealmRouteImport
      parentRoute: typeof AppPlatformContextRequiredRoute
    }
    '/_app/_platform/_context-required/role/_role': {
      id: '/_app/_platform/_context-required/role/_role'
      path: '/role'
      fullPath: '/role'
      preLoaderRoute: typeof AppPlatformContextRequiredRoleRoleRouteImport
      parentRoute: typeof AppPlatformContextRequiredRoute
    }
    '/_app/_platform/_context-required/tenant/_tenant': {
      id: '/_app/_platform/_context-required/tenant/_tenant'
      path: '/tenant'
      fullPath: '/tenant'
      preLoaderRoute: typeof AppPlatformContextRequiredTenantTenantRouteImport
      parentRoute: typeof AppPlatformContextRequiredRoute
    }
    '/_app/_platform/_context-required/user/': {
      id: '/_app/_platform/_context-required/user/'
      path: '/user'
      fullPath: '/user/'
      preLoaderRoute: typeof AppPlatformContextRequiredUserIndexRouteImport
      parentRoute: typeof AppPlatformContextRequiredRoute
    }
    '/_app/_platform/_context-required/user/invitation': {
      id: '/_app/_platform/_context-required/user/invitation'
      path: '/user/invitation'
      fullPath: '/user/invitation'
      preLoaderRoute: typeof AppPlatformContextRequiredUserInvitationRouteImport
      parentRoute: typeof AppPlatformContextRequiredRoute
    }
    '/_app/_platform/_context-required/user/request': {
      id: '/_app/_platform/_context-required/user/request'
      path: '/user/request'
      fullPath: '/user/request'
      preLoaderRoute: typeof AppPlatformContextRequiredUserRequestRouteImport
      parentRoute: typeof AppPlatformContextRequiredRoute
    }
    '/_app/developer/agent-key/_agent-key/': {
      id: '/_app/developer/agent-key/_agent-key/'
      path: '/'
      fullPath: '/developer/agent-key/'
      preLoaderRoute: typeof AppDeveloperAgentKeyAgentKeyIndexRouteImport
      parentRoute: typeof AppDeveloperAgentKeyAgentKeyRoute
    }
    '/_app/developer/api-key/_api-key/': {
      id: '/_app/developer/api-key/_api-key/'
      path: '/'
      fullPath: '/developer/api-key/'
      preLoaderRoute: typeof AppDeveloperApiKeyApiKeyIndexRouteImport
      parentRoute: typeof AppDeveloperApiKeyApiKeyRoute
    }
    '/_app/developer/webhook/_webhook/': {
      id: '/_app/developer/webhook/_webhook/'
      path: '/'
      fullPath: '/developer/webhook/'
      preLoaderRoute: typeof AppDeveloperWebhookWebhookIndexRouteImport
      parentRoute: typeof AppDeveloperWebhookWebhookRoute
    }
    '/docs/_layout/api-reference/_provider/': {
      id: '/docs/_layout/api-reference/_provider/'
      path: '/'
      fullPath: '/docs/api-reference/'
      preLoaderRoute: typeof DocsLayoutApiReferenceProviderIndexRouteImport
      parentRoute: typeof DocsLayoutApiReferenceProviderRoute
    }
    '/docs/_layout/api-reference/_provider/$package': {
      id: '/docs/_layout/api-reference/_provider/$package'
      path: '/$package'
      fullPath: '/docs/api-reference/$package'
      preLoaderRoute: typeof DocsLayoutApiReferenceProviderPackageRouteImport
      parentRoute: typeof DocsLayoutApiReferenceProviderRoute
    }
    '/docs/_layout/guide/_provider/': {
      id: '/docs/_layout/guide/_provider/'
      path: '/'
      fullPath: '/docs/guide/'
      preLoaderRoute: typeof DocsLayoutGuideProviderIndexRouteImport
      parentRoute: typeof DocsLayoutGuideProviderRoute
    }
    '/docs/_layout/guide/_provider/$artifactName': {
      id: '/docs/_layout/guide/_provider/$artifactName'
      path: '/$artifactName'
      fullPath: '/docs/guide/$artifactName'
      preLoaderRoute: typeof DocsLayoutGuideProviderArtifactNameRouteImport
      parentRoute: typeof DocsLayoutGuideProviderRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance'
      path: '/clearing/compliance'
      fullPath: '/clearing/compliance'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance'
      path: '/clearing/finance'
      fullPath: '/clearing/finance'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations'
      path: '/clearing/operations'
      fullPath: '/clearing/operations'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor'
      path: '/clearing/vendor'
      fullPath: '/clearing/vendor'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredRoute
    }
    '/_app/_clearing-core/_clearing-required/inbox/_inbox/': {
      id: '/_app/_clearing-core/_clearing-required/inbox/_inbox/'
      path: '/inbox'
      fullPath: '/inbox/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredInboxInboxIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredRoute
    }
    '/_app/_clearing-core/asset/_asset/$assetId/_detail': {
      id: '/_app/_clearing-core/asset/_asset/$assetId/_detail'
      path: '/$assetId'
      fullPath: '/asset/$assetId'
      preLoaderRoute: typeof AppClearingCoreAssetAssetAssetIdDetailRouteImport
      parentRoute: typeof AppClearingCoreAssetAssetRoute
    }
    '/_app/_clearing-core/billing/charge/_charge/': {
      id: '/_app/_clearing-core/billing/charge/_charge/'
      path: '/'
      fullPath: '/billing/charge/'
      preLoaderRoute: typeof AppClearingCoreBillingChargeChargeIndexRouteImport
      parentRoute: typeof AppClearingCoreBillingChargeChargeRoute
    }
    '/_app/_clearing-core/billing/charge/_charge/$chargeId': {
      id: '/_app/_clearing-core/billing/charge/_charge/$chargeId'
      path: '/$chargeId'
      fullPath: '/billing/charge/$chargeId'
      preLoaderRoute: typeof AppClearingCoreBillingChargeChargeChargeIdRouteImport
      parentRoute: typeof AppClearingCoreBillingChargeChargeRoute
    }
    '/_app/_clearing-core/funding/account-number/_account-number/': {
      id: '/_app/_clearing-core/funding/account-number/_account-number/'
      path: '/'
      fullPath: '/funding/account-number/'
      preLoaderRoute: typeof AppClearingCoreFundingAccountNumberAccountNumberIndexRouteImport
      parentRoute: typeof AppClearingCoreFundingAccountNumberAccountNumberRoute
    }
    '/_app/_clearing-core/funding/account-number/_account-number/$accountNumberId': {
      id: '/_app/_clearing-core/funding/account-number/_account-number/$accountNumberId'
      path: '/$accountNumberId'
      fullPath: '/funding/account-number/$accountNumberId'
      preLoaderRoute: typeof AppClearingCoreFundingAccountNumberAccountNumberAccountNumberIdRouteImport
      parentRoute: typeof AppClearingCoreFundingAccountNumberAccountNumberRoute
    }
    '/_app/_clearing-core/funding/batch-transfer/_batch-transfer/': {
      id: '/_app/_clearing-core/funding/batch-transfer/_batch-transfer/'
      path: '/'
      fullPath: '/funding/batch-transfer/'
      preLoaderRoute: typeof AppClearingCoreFundingBatchTransferBatchTransferIndexRouteImport
      parentRoute: typeof AppClearingCoreFundingBatchTransferBatchTransferRoute
    }
    '/_app/_clearing-core/funding/batch-transfer/_batch-transfer/$batchTransferId': {
      id: '/_app/_clearing-core/funding/batch-transfer/_batch-transfer/$batchTransferId'
      path: '/$batchTransferId'
      fullPath: '/funding/batch-transfer/$batchTransferId'
      preLoaderRoute: typeof AppClearingCoreFundingBatchTransferBatchTransferBatchTransferIdRouteImport
      parentRoute: typeof AppClearingCoreFundingBatchTransferBatchTransferRoute
    }
    '/_app/_clearing-core/funding/source/_source/': {
      id: '/_app/_clearing-core/funding/source/_source/'
      path: '/'
      fullPath: '/funding/source/'
      preLoaderRoute: typeof AppClearingCoreFundingSourceSourceIndexRouteImport
      parentRoute: typeof AppClearingCoreFundingSourceSourceRoute
    }
    '/_app/_clearing-core/funding/source/_source/$sourceId': {
      id: '/_app/_clearing-core/funding/source/_source/$sourceId'
      path: '/$sourceId'
      fullPath: '/funding/source/$sourceId'
      preLoaderRoute: typeof AppClearingCoreFundingSourceSourceSourceIdRouteImport
      parentRoute: typeof AppClearingCoreFundingSourceSourceRoute
    }
    '/_app/_clearing-core/funding/transfer/_transfer/': {
      id: '/_app/_clearing-core/funding/transfer/_transfer/'
      path: '/'
      fullPath: '/funding/transfer/'
      preLoaderRoute: typeof AppClearingCoreFundingTransferTransferIndexRouteImport
      parentRoute: typeof AppClearingCoreFundingTransferTransferRoute
    }
    '/_app/_clearing-core/funding/transfer/_transfer/$transferId': {
      id: '/_app/_clearing-core/funding/transfer/_transfer/$transferId'
      path: '/$transferId'
      fullPath: '/funding/transfer/$transferId'
      preLoaderRoute: typeof AppClearingCoreFundingTransferTransferTransferIdRouteImport
      parentRoute: typeof AppClearingCoreFundingTransferTransferRoute
    }
    '/_app/_clearing-core/hours/_hours/exception/_exception': {
      id: '/_app/_clearing-core/hours/_hours/exception/_exception'
      path: '/exception'
      fullPath: '/hours/exception'
      preLoaderRoute: typeof AppClearingCoreHoursHoursExceptionExceptionRouteImport
      parentRoute: typeof AppClearingCoreHoursHoursRoute
    }
    '/_app/_clearing-core/hours/_hours/schedule/{-$scheduleName}': {
      id: '/_app/_clearing-core/hours/_hours/schedule/{-$scheduleName}'
      path: '/schedule/{-$scheduleName}'
      fullPath: '/hours/schedule/{-$scheduleName}'
      preLoaderRoute: typeof AppClearingCoreHoursHoursScheduleChar123ScheduleNameChar125RouteImport
      parentRoute: typeof AppClearingCoreHoursHoursRoute
    }
    '/_app/_clearing-core/order/equity/_single/': {
      id: '/_app/_clearing-core/order/equity/_single/'
      path: '/'
      fullPath: '/order/equity/'
      preLoaderRoute: typeof AppClearingCoreOrderEquitySingleIndexRouteImport
      parentRoute: typeof AppClearingCoreOrderEquitySingleRoute
    }
    '/_app/_clearing-core/order/equity/_single/$orderId': {
      id: '/_app/_clearing-core/order/equity/_single/$orderId'
      path: '/$orderId'
      fullPath: '/order/equity/$orderId'
      preLoaderRoute: typeof AppClearingCoreOrderEquitySingleOrderIdRouteImport
      parentRoute: typeof AppClearingCoreOrderEquitySingleRoute
    }
    '/_app/_clearing-core/order/equity/batch/_batch': {
      id: '/_app/_clearing-core/order/equity/batch/_batch'
      path: '/order/equity/batch'
      fullPath: '/order/equity/batch'
      preLoaderRoute: typeof AppClearingCoreOrderEquityBatchBatchRouteImport
      parentRoute: typeof AppClearingCoreRoute
    }
    '/_app/_clearing-core/order/mutual-fund/_mutual-fund/': {
      id: '/_app/_clearing-core/order/mutual-fund/_mutual-fund/'
      path: '/'
      fullPath: '/order/mutual-fund/'
      preLoaderRoute: typeof AppClearingCoreOrderMutualFundMutualFundIndexRouteImport
      parentRoute: typeof AppClearingCoreOrderMutualFundMutualFundRoute
    }
    '/_app/_clearing-core/order/mutual-fund/_mutual-fund/$fundOrderId': {
      id: '/_app/_clearing-core/order/mutual-fund/_mutual-fund/$fundOrderId'
      path: '/$fundOrderId'
      fullPath: '/order/mutual-fund/$fundOrderId'
      preLoaderRoute: typeof AppClearingCoreOrderMutualFundMutualFundFundOrderIdRouteImport
      parentRoute: typeof AppClearingCoreOrderMutualFundMutualFundRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account'
      path: '/registration/account/$accountId'
      fullPath: '/registration/account/$accountId'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountRouteImport
      parentRoute: typeof AppClearingCoreRoute
    }
    '/_app/_clearing-core/registration/profile/_profile/': {
      id: '/_app/_clearing-core/registration/profile/_profile/'
      path: '/'
      fullPath: '/registration/profile/'
      preLoaderRoute: typeof AppClearingCoreRegistrationProfileProfileIndexRouteImport
      parentRoute: typeof AppClearingCoreRegistrationProfileProfileRoute
    }
    '/_app/_clearing-core/sweep/cutoff/_cutoff/': {
      id: '/_app/_clearing-core/sweep/cutoff/_cutoff/'
      path: '/'
      fullPath: '/sweep/cutoff/'
      preLoaderRoute: typeof AppClearingCoreSweepCutoffCutoffIndexRouteImport
      parentRoute: typeof AppClearingCoreSweepCutoffCutoffRoute
    }
    '/_app/_clearing-core/sweep/plan/_plan/': {
      id: '/_app/_clearing-core/sweep/plan/_plan/'
      path: '/'
      fullPath: '/sweep/plan/'
      preLoaderRoute: typeof AppClearingCoreSweepPlanPlanIndexRouteImport
      parentRoute: typeof AppClearingCoreSweepPlanPlanRoute
    }
    '/_app/_clearing-core/sweep/plan/_plan/$sweepPlanId': {
      id: '/_app/_clearing-core/sweep/plan/_plan/$sweepPlanId'
      path: '/$sweepPlanId'
      fullPath: '/sweep/plan/$sweepPlanId'
      preLoaderRoute: typeof AppClearingCoreSweepPlanPlanSweepPlanIdRouteImport
      parentRoute: typeof AppClearingCoreSweepPlanPlanRoute
    }
    '/_app/_clearing-core/sweep/target/_target/': {
      id: '/_app/_clearing-core/sweep/target/_target/'
      path: '/'
      fullPath: '/sweep/target/'
      preLoaderRoute: typeof AppClearingCoreSweepTargetTargetIndexRouteImport
      parentRoute: typeof AppClearingCoreSweepTargetTargetRoute
    }
    '/_app/_clearing-core/sweep/target/_target/$sweepTargetId': {
      id: '/_app/_clearing-core/sweep/target/_target/$sweepTargetId'
      path: '/$sweepTargetId'
      fullPath: '/sweep/target/$sweepTargetId'
      preLoaderRoute: typeof AppClearingCoreSweepTargetTargetSweepTargetIdRouteImport
      parentRoute: typeof AppClearingCoreSweepTargetTargetRoute
    }
    '/_app/_o5/_o5-required/tech-ops/build/': {
      id: '/_app/_o5/_o5-required/tech-ops/build/'
      path: '/tech-ops/build'
      fullPath: '/tech-ops/build/'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsBuildIndexRouteImport
      parentRoute: typeof AppO5O5RequiredRoute
    }
    '/_app/_o5/_o5-required/tech-ops/cluster/_cluster': {
      id: '/_app/_o5/_o5-required/tech-ops/cluster/_cluster'
      path: '/tech-ops/cluster'
      fullPath: '/tech-ops/cluster'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsClusterClusterRouteImport
      parentRoute: typeof AppO5O5RequiredRoute
    }
    '/_app/_o5/_o5-required/tech-ops/dead-message/_dead-message': {
      id: '/_app/_o5/_o5-required/tech-ops/dead-message/_dead-message'
      path: '/tech-ops/dead-message'
      fullPath: '/tech-ops/dead-message'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsDeadMessageDeadMessageRouteImport
      parentRoute: typeof AppO5O5RequiredRoute
    }
    '/_app/_o5/_o5-required/tech-ops/deployment/_deployment': {
      id: '/_app/_o5/_o5-required/tech-ops/deployment/_deployment'
      path: '/tech-ops/deployment'
      fullPath: '/tech-ops/deployment'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsDeploymentDeploymentRouteImport
      parentRoute: typeof AppO5O5RequiredRoute
    }
    '/_app/_o5/_o5-required/tech-ops/environment/_environment': {
      id: '/_app/_o5/_o5-required/tech-ops/environment/_environment'
      path: '/tech-ops/environment'
      fullPath: '/tech-ops/environment'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsEnvironmentEnvironmentRouteImport
      parentRoute: typeof AppO5O5RequiredRoute
    }
    '/_app/_o5/_o5-required/tech-ops/stack/_stack': {
      id: '/_app/_o5/_o5-required/tech-ops/stack/_stack'
      path: '/tech-ops/stack'
      fullPath: '/tech-ops/stack'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsStackStackRouteImport
      parentRoute: typeof AppO5O5RequiredRoute
    }
    '/_app/_o5/_o5-required/tech-ops/test-run/_test-run': {
      id: '/_app/_o5/_o5-required/tech-ops/test-run/_test-run'
      path: '/tech-ops/test-run'
      fullPath: '/tech-ops/test-run'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsTestRunTestRunRouteImport
      parentRoute: typeof AppO5O5RequiredRoute
    }
    '/_app/_o5/_o5-required/tech-ops/trigger/_trigger': {
      id: '/_app/_o5/_o5-required/tech-ops/trigger/_trigger'
      path: '/tech-ops/trigger'
      fullPath: '/tech-ops/trigger'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsTriggerTriggerRouteImport
      parentRoute: typeof AppO5O5RequiredRoute
    }
    '/_app/_platform/_context-required/organization/_organization/': {
      id: '/_app/_platform/_context-required/organization/_organization/'
      path: '/'
      fullPath: '/organization/'
      preLoaderRoute: typeof AppPlatformContextRequiredOrganizationOrganizationIndexRouteImport
      parentRoute: typeof AppPlatformContextRequiredOrganizationOrganizationRoute
    }
    '/_app/_platform/_context-required/program/_program/': {
      id: '/_app/_platform/_context-required/program/_program/'
      path: '/'
      fullPath: '/program/'
      preLoaderRoute: typeof AppPlatformContextRequiredProgramProgramIndexRouteImport
      parentRoute: typeof AppPlatformContextRequiredProgramProgramRoute
    }
    '/_app/_platform/_context-required/realm-access/_realm-access/': {
      id: '/_app/_platform/_context-required/realm-access/_realm-access/'
      path: '/'
      fullPath: '/realm-access/'
      preLoaderRoute: typeof AppPlatformContextRequiredRealmAccessRealmAccessIndexRouteImport
      parentRoute: typeof AppPlatformContextRequiredRealmAccessRealmAccessRoute
    }
    '/_app/_platform/_context-required/realm-access/_realm-access/$realmAccessId': {
      id: '/_app/_platform/_context-required/realm-access/_realm-access/$realmAccessId'
      path: '/$realmAccessId'
      fullPath: '/realm-access/$realmAccessId'
      preLoaderRoute: typeof AppPlatformContextRequiredRealmAccessRealmAccessRealmAccessIdRouteImport
      parentRoute: typeof AppPlatformContextRequiredRealmAccessRealmAccessRoute
    }
    '/_app/_platform/_context-required/realm/_realm/': {
      id: '/_app/_platform/_context-required/realm/_realm/'
      path: '/'
      fullPath: '/realm/'
      preLoaderRoute: typeof AppPlatformContextRequiredRealmRealmIndexRouteImport
      parentRoute: typeof AppPlatformContextRequiredRealmRealmRoute
    }
    '/_app/_platform/_context-required/realm/_realm/$realmId': {
      id: '/_app/_platform/_context-required/realm/_realm/$realmId'
      path: '/$realmId'
      fullPath: '/realm/$realmId'
      preLoaderRoute: typeof AppPlatformContextRequiredRealmRealmRealmIdRouteImport
      parentRoute: typeof AppPlatformContextRequiredRealmRealmRoute
    }
    '/_app/_platform/_context-required/role/_role/': {
      id: '/_app/_platform/_context-required/role/_role/'
      path: '/'
      fullPath: '/role/'
      preLoaderRoute: typeof AppPlatformContextRequiredRoleRoleIndexRouteImport
      parentRoute: typeof AppPlatformContextRequiredRoleRoleRoute
    }
    '/_app/_platform/_context-required/role/_role/$roleId': {
      id: '/_app/_platform/_context-required/role/_role/$roleId'
      path: '/$roleId'
      fullPath: '/role/$roleId'
      preLoaderRoute: typeof AppPlatformContextRequiredRoleRoleRoleIdRouteImport
      parentRoute: typeof AppPlatformContextRequiredRoleRoleRoute
    }
    '/_app/_platform/_context-required/tenant/_tenant/': {
      id: '/_app/_platform/_context-required/tenant/_tenant/'
      path: '/'
      fullPath: '/tenant/'
      preLoaderRoute: typeof AppPlatformContextRequiredTenantTenantIndexRouteImport
      parentRoute: typeof AppPlatformContextRequiredTenantTenantRoute
    }
    '/_app/_platform/_context-required/tenant/_tenant/$tenantId': {
      id: '/_app/_platform/_context-required/tenant/_tenant/$tenantId'
      path: '/$tenantId'
      fullPath: '/tenant/$tenantId'
      preLoaderRoute: typeof AppPlatformContextRequiredTenantTenantTenantIdRouteImport
      parentRoute: typeof AppPlatformContextRequiredTenantTenantRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/'
      path: '/'
      fullPath: '/clearing/compliance/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/'
      path: '/'
      fullPath: '/clearing/finance/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/'
      path: '/'
      fullPath: '/clearing/operations/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/'
      path: '/'
      fullPath: '/clearing/vendor/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/asset/_asset/$assetId/_detail/': {
      id: '/_app/_clearing-core/asset/_asset/$assetId/_detail/'
      path: '/'
      fullPath: '/asset/$assetId/'
      preLoaderRoute: typeof AppClearingCoreAssetAssetAssetIdDetailIndexRouteImport
      parentRoute: typeof AppClearingCoreAssetAssetAssetIdDetailRoute
    }
    '/_app/_clearing-core/asset/_asset/$assetId/_detail/filings': {
      id: '/_app/_clearing-core/asset/_asset/$assetId/_detail/filings'
      path: '/filings'
      fullPath: '/asset/$assetId/filings'
      preLoaderRoute: typeof AppClearingCoreAssetAssetAssetIdDetailFilingsRouteImport
      parentRoute: typeof AppClearingCoreAssetAssetAssetIdDetailRoute
    }
    '/_app/_clearing-core/asset/_asset/$assetId/_detail/market-data': {
      id: '/_app/_clearing-core/asset/_asset/$assetId/_detail/market-data'
      path: '/market-data'
      fullPath: '/asset/$assetId/market-data'
      preLoaderRoute: typeof AppClearingCoreAssetAssetAssetIdDetailMarketDataRouteImport
      parentRoute: typeof AppClearingCoreAssetAssetAssetIdDetailRoute
    }
    '/_app/_clearing-core/hours/_hours/exception/_exception/': {
      id: '/_app/_clearing-core/hours/_hours/exception/_exception/'
      path: '/'
      fullPath: '/hours/exception/'
      preLoaderRoute: typeof AppClearingCoreHoursHoursExceptionExceptionIndexRouteImport
      parentRoute: typeof AppClearingCoreHoursHoursExceptionExceptionRoute
    }
    '/_app/_clearing-core/hours/_hours/exception/_exception/$exceptionId': {
      id: '/_app/_clearing-core/hours/_hours/exception/_exception/$exceptionId'
      path: '/$exceptionId'
      fullPath: '/hours/exception/$exceptionId'
      preLoaderRoute: typeof AppClearingCoreHoursHoursExceptionExceptionExceptionIdRouteImport
      parentRoute: typeof AppClearingCoreHoursHoursExceptionExceptionRoute
    }
    '/_app/_clearing-core/order/equity/batch/_batch/': {
      id: '/_app/_clearing-core/order/equity/batch/_batch/'
      path: '/'
      fullPath: '/order/equity/batch/'
      preLoaderRoute: typeof AppClearingCoreOrderEquityBatchBatchIndexRouteImport
      parentRoute: typeof AppClearingCoreOrderEquityBatchBatchRoute
    }
    '/_app/_clearing-core/order/equity/batch/_batch/$batchOrderId': {
      id: '/_app/_clearing-core/order/equity/batch/_batch/$batchOrderId'
      path: '/$batchOrderId'
      fullPath: '/order/equity/batch/$batchOrderId'
      preLoaderRoute: typeof AppClearingCoreOrderEquityBatchBatchBatchOrderIdRouteImport
      parentRoute: typeof AppClearingCoreOrderEquityBatchBatchRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/'
      path: '/'
      fullPath: '/registration/account/$accountId/'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountIndexRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_overview': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_overview'
      path: ''
      fullPath: '/registration/account/$accountId'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list'
      path: ''
      fullPath: '/registration/account/$accountId'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountRoute
    }
    '/_app/_clearing-core/registration/profile/_profile/$profileId/': {
      id: '/_app/_clearing-core/registration/profile/_profile/$profileId/'
      path: '/$profileId'
      fullPath: '/registration/profile/$profileId/'
      preLoaderRoute: typeof AppClearingCoreRegistrationProfileProfileProfileIdIndexRouteImport
      parentRoute: typeof AppClearingCoreRegistrationProfileProfileRoute
    }
    '/_app/_o5/_o5-required/tech-ops/build/repo/_repo': {
      id: '/_app/_o5/_o5-required/tech-ops/build/repo/_repo'
      path: '/tech-ops/build/repo'
      fullPath: '/tech-ops/build/repo'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsBuildRepoRepoRouteImport
      parentRoute: typeof AppO5O5RequiredRoute
    }
    '/_app/_o5/_o5-required/tech-ops/cluster/_cluster/': {
      id: '/_app/_o5/_o5-required/tech-ops/cluster/_cluster/'
      path: '/'
      fullPath: '/tech-ops/cluster/'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsClusterClusterIndexRouteImport
      parentRoute: typeof AppO5O5RequiredTechOpsClusterClusterRoute
    }
    '/_app/_o5/_o5-required/tech-ops/cluster/_cluster/$clusterId': {
      id: '/_app/_o5/_o5-required/tech-ops/cluster/_cluster/$clusterId'
      path: '/$clusterId'
      fullPath: '/tech-ops/cluster/$clusterId'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsClusterClusterClusterIdRouteImport
      parentRoute: typeof AppO5O5RequiredTechOpsClusterClusterRoute
    }
    '/_app/_o5/_o5-required/tech-ops/dead-message/_dead-message/': {
      id: '/_app/_o5/_o5-required/tech-ops/dead-message/_dead-message/'
      path: '/'
      fullPath: '/tech-ops/dead-message/'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsDeadMessageDeadMessageIndexRouteImport
      parentRoute: typeof AppO5O5RequiredTechOpsDeadMessageDeadMessageRoute
    }
    '/_app/_o5/_o5-required/tech-ops/dead-message/_dead-message/$messageId': {
      id: '/_app/_o5/_o5-required/tech-ops/dead-message/_dead-message/$messageId'
      path: '/$messageId'
      fullPath: '/tech-ops/dead-message/$messageId'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsDeadMessageDeadMessageMessageIdRouteImport
      parentRoute: typeof AppO5O5RequiredTechOpsDeadMessageDeadMessageRoute
    }
    '/_app/_o5/_o5-required/tech-ops/deployment/_deployment/': {
      id: '/_app/_o5/_o5-required/tech-ops/deployment/_deployment/'
      path: '/'
      fullPath: '/tech-ops/deployment/'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsDeploymentDeploymentIndexRouteImport
      parentRoute: typeof AppO5O5RequiredTechOpsDeploymentDeploymentRoute
    }
    '/_app/_o5/_o5-required/tech-ops/deployment/_deployment/$deploymentId': {
      id: '/_app/_o5/_o5-required/tech-ops/deployment/_deployment/$deploymentId'
      path: '/$deploymentId'
      fullPath: '/tech-ops/deployment/$deploymentId'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsDeploymentDeploymentDeploymentIdRouteImport
      parentRoute: typeof AppO5O5RequiredTechOpsDeploymentDeploymentRoute
    }
    '/_app/_o5/_o5-required/tech-ops/environment/_environment/': {
      id: '/_app/_o5/_o5-required/tech-ops/environment/_environment/'
      path: '/'
      fullPath: '/tech-ops/environment/'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsEnvironmentEnvironmentIndexRouteImport
      parentRoute: typeof AppO5O5RequiredTechOpsEnvironmentEnvironmentRoute
    }
    '/_app/_o5/_o5-required/tech-ops/environment/_environment/$environmentId': {
      id: '/_app/_o5/_o5-required/tech-ops/environment/_environment/$environmentId'
      path: '/$environmentId'
      fullPath: '/tech-ops/environment/$environmentId'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsEnvironmentEnvironmentEnvironmentIdRouteImport
      parentRoute: typeof AppO5O5RequiredTechOpsEnvironmentEnvironmentRoute
    }
    '/_app/_o5/_o5-required/tech-ops/stack/_stack/': {
      id: '/_app/_o5/_o5-required/tech-ops/stack/_stack/'
      path: '/'
      fullPath: '/tech-ops/stack/'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsStackStackIndexRouteImport
      parentRoute: typeof AppO5O5RequiredTechOpsStackStackRoute
    }
    '/_app/_o5/_o5-required/tech-ops/stack/_stack/$stackId': {
      id: '/_app/_o5/_o5-required/tech-ops/stack/_stack/$stackId'
      path: '/$stackId'
      fullPath: '/tech-ops/stack/$stackId'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsStackStackStackIdRouteImport
      parentRoute: typeof AppO5O5RequiredTechOpsStackStackRoute
    }
    '/_app/_o5/_o5-required/tech-ops/test-run/_test-run/': {
      id: '/_app/_o5/_o5-required/tech-ops/test-run/_test-run/'
      path: '/'
      fullPath: '/tech-ops/test-run/'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsTestRunTestRunIndexRouteImport
      parentRoute: typeof AppO5O5RequiredTechOpsTestRunTestRunRoute
    }
    '/_app/_o5/_o5-required/tech-ops/trigger/_trigger/': {
      id: '/_app/_o5/_o5-required/tech-ops/trigger/_trigger/'
      path: '/'
      fullPath: '/tech-ops/trigger/'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsTriggerTriggerIndexRouteImport
      parentRoute: typeof AppO5O5RequiredTechOpsTriggerTriggerRoute
    }
    '/_app/_o5/_o5-required/tech-ops/trigger/_trigger/$triggerId': {
      id: '/_app/_o5/_o5-required/tech-ops/trigger/_trigger/$triggerId'
      path: '/$triggerId'
      fullPath: '/tech-ops/trigger/$triggerId'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsTriggerTriggerTriggerIdRouteImport
      parentRoute: typeof AppO5O5RequiredTechOpsTriggerTriggerRoute
    }
    '/_app/_platform/_context-required/organization/_organization/$organizationId/_detail': {
      id: '/_app/_platform/_context-required/organization/_organization/$organizationId/_detail'
      path: '/$organizationId'
      fullPath: '/organization/$organizationId'
      preLoaderRoute: typeof AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRouteImport
      parentRoute: typeof AppPlatformContextRequiredOrganizationOrganizationRoute
    }
    '/_app/_platform/_context-required/program/_program/$programId/_program': {
      id: '/_app/_platform/_context-required/program/_program/$programId/_program'
      path: '/$programId'
      fullPath: '/program/$programId'
      preLoaderRoute: typeof AppPlatformContextRequiredProgramProgramProgramIdProgramRouteImport
      parentRoute: typeof AppPlatformContextRequiredProgramProgramRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/'
      path: '/fincen'
      fullPath: '/clearing/compliance/fincen/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/'
      path: '/ofac'
      fullPath: '/clearing/compliance/ofac/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/'
      path: '/reporting'
      fullPath: '/clearing/compliance/reporting/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/'
      path: '/accounting'
      fullPath: '/clearing/finance/accounting/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/journal/_manual-entry': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/journal/_manual-entry'
      path: '/journal'
      fullPath: '/clearing/finance/journal'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/'
      path: '/middle-money'
      fullPath: '/clearing/finance/middle-money/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/'
      path: '/payment'
      fullPath: '/clearing/finance/payment/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/account/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/account/'
      path: '/account'
      fullPath: '/clearing/operations/account/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsAccountIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/account/correspondent': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/account/correspondent'
      path: '/account/correspondent'
      fullPath: '/clearing/operations/account/correspondent'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsAccountCorrespondentRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/balance/_balance': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/balance/_balance'
      path: '/balance'
      fullPath: '/clearing/operations/balance'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-cash-balance/_customer-cash-balance': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-cash-balance/_customer-cash-balance'
      path: '/customer-cash-balance'
      fullPath: '/clearing/operations/customer-cash-balance'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-stock-record/_customer-stock-record': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-stock-record/_customer-stock-record'
      path: '/customer-stock-record'
      fullPath: '/clearing/operations/customer-stock-record'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-sweep-record/_customer-sweep-record': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-sweep-record/_customer-sweep-record'
      path: '/customer-sweep-record'
      fullPath: '/clearing/operations/customer-sweep-record'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/'
      path: '/dtcc'
      fullPath: '/clearing/operations/dtcc/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/'
      path: '/generate'
      fullPath: '/clearing/operations/generate/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/'
      path: '/inventory'
      fullPath: '/clearing/operations/inventory/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/journal/_manual-entry': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/journal/_manual-entry'
      path: '/journal'
      fullPath: '/clearing/operations/journal'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/'
      path: '/mutualfunds'
      fullPath: '/clearing/operations/mutualfunds/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/'
      path: '/oms'
      fullPath: '/clearing/operations/oms/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/'
      path: '/reporting'
      fullPath: '/clearing/operations/reporting/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/cash-blotter': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/cash-blotter'
      path: '/reporting/cash-blotter'
      fullPath: '/clearing/operations/reporting/cash-blotter'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingCashBlotterRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/order-blotter': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/order-blotter'
      path: '/reporting/order-blotter'
      fullPath: '/clearing/operations/reporting/order-blotter'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingOrderBlotterRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/stock-blotter': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/stock-blotter'
      path: '/reporting/stock-blotter'
      fullPath: '/clearing/operations/reporting/stock-blotter'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingStockBlotterRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record'
      path: '/stock-record'
      fullPath: '/clearing/operations/stock-record'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/'
      path: '/sweep'
      fullPath: '/clearing/operations/sweep/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/'
      path: '/trade'
      fullPath: '/clearing/operations/trade/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/transaction/_transaction': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/transaction/_transaction'
      path: '/transaction'
      fullPath: '/clearing/operations/transaction'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trigger/_trigger': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trigger/_trigger'
      path: '/trigger'
      fullPath: '/clearing/operations/trigger'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/'
      path: '/beta-nxt'
      fullPath: '/clearing/vendor/beta-nxt/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc'
      path: '/dtcc'
      fullPath: '/clearing/vendor/dtcc'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jane-street/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jane-street/'
      path: '/jane-street'
      fullPath: '/clearing/vendor/jane-street/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/'
      path: '/jpm'
      fullPath: '/clearing/vendor/jpm/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/plaid/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/plaid/'
      path: '/plaid'
      fullPath: '/clearing/vendor/plaid/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorPlaidIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/'
      path: '/quote-media'
      fullPath: '/clearing/vendor/quote-media/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/asset': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/asset'
      path: '/asset'
      fullPath: '/registration/account/$accountId/asset'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListAssetRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/funding': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/funding'
      path: '/funding'
      fullPath: '/registration/account/$accountId/funding'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListFundingRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/hold': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/hold'
      path: '/hold'
      fullPath: '/registration/account/$accountId/hold'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListHoldRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/transaction': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/transaction'
      path: '/transaction'
      fullPath: '/registration/account/$accountId/transaction'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListTransactionRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/dividends-receivable/_dividends-receivable': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/dividends-receivable/_dividends-receivable'
      path: '/dividends-receivable'
      fullPath: '/registration/account/$accountId/dividends-receivable'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountRoute
    }
    '/_app/_clearing-core/registration/profile/_profile/$profileId/edit/_edit': {
      id: '/_app/_clearing-core/registration/profile/_profile/$profileId/edit/_edit'
      path: '/$profileId/edit'
      fullPath: '/registration/profile/$profileId/edit'
      preLoaderRoute: typeof AppClearingCoreRegistrationProfileProfileProfileIdEditEditRouteImport
      parentRoute: typeof AppClearingCoreRegistrationProfileProfileRoute
    }
    '/_app/_clearing-core/registration/profile/_profile/create/$profileType/_create': {
      id: '/_app/_clearing-core/registration/profile/_profile/create/$profileType/_create'
      path: '/create/$profileType'
      fullPath: '/registration/profile/create/$profileType'
      preLoaderRoute: typeof AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateRouteImport
      parentRoute: typeof AppClearingCoreRegistrationProfileProfileRoute
    }
    '/_app/_o5/_o5-required/tech-ops/build/repo/_repo/': {
      id: '/_app/_o5/_o5-required/tech-ops/build/repo/_repo/'
      path: '/'
      fullPath: '/tech-ops/build/repo/'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsBuildRepoRepoIndexRouteImport
      parentRoute: typeof AppO5O5RequiredTechOpsBuildRepoRepoRoute
    }
    '/_app/_o5/_o5-required/tech-ops/test-run/_test-run/$environment/': {
      id: '/_app/_o5/_o5-required/tech-ops/test-run/_test-run/$environment/'
      path: '/$environment'
      fullPath: '/tech-ops/test-run/$environment/'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsTestRunTestRunEnvironmentIndexRouteImport
      parentRoute: typeof AppO5O5RequiredTechOpsTestRunTestRunRoute
    }
    '/_app/_o5/_o5-required/tech-ops/test-run/_test-run/$environment/$testRunId': {
      id: '/_app/_o5/_o5-required/tech-ops/test-run/_test-run/$environment/$testRunId'
      path: '/$environment/$testRunId'
      fullPath: '/tech-ops/test-run/$environment/$testRunId'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsTestRunTestRunEnvironmentTestRunIdRouteImport
      parentRoute: typeof AppO5O5RequiredTechOpsTestRunTestRunRoute
    }
    '/_app/_platform/_context-required/organization/_organization/$organizationId/_detail/': {
      id: '/_app/_platform/_context-required/organization/_organization/$organizationId/_detail/'
      path: '/'
      fullPath: '/organization/$organizationId/'
      preLoaderRoute: typeof AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailIndexRouteImport
      parentRoute: typeof AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRoute
    }
    '/_app/_platform/_context-required/organization/_organization/$organizationId/_detail/invitation': {
      id: '/_app/_platform/_context-required/organization/_organization/$organizationId/_detail/invitation'
      path: '/invitation'
      fullPath: '/organization/$organizationId/invitation'
      preLoaderRoute: typeof AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailInvitationRouteImport
      parentRoute: typeof AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRoute
    }
    '/_app/_platform/_context-required/organization/_organization/$organizationId/_detail/realm-access': {
      id: '/_app/_platform/_context-required/organization/_organization/$organizationId/_detail/realm-access'
      path: '/realm-access'
      fullPath: '/organization/$organizationId/realm-access'
      preLoaderRoute: typeof AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRealmAccessRouteImport
      parentRoute: typeof AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRoute
    }
    '/_app/_platform/_context-required/program/_program/$programId/_program/': {
      id: '/_app/_platform/_context-required/program/_program/$programId/_program/'
      path: '/'
      fullPath: '/program/$programId/'
      preLoaderRoute: typeof AppPlatformContextRequiredProgramProgramProgramIdProgramIndexRouteImport
      parentRoute: typeof AppPlatformContextRequiredProgramProgramProgramIdProgramRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/entry/_entry': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/entry/_entry'
      path: '/fincen/entry'
      fullPath: '/clearing/compliance/fincen/entry'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/file/_file': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/file/_file'
      path: '/fincen/file'
      fullPath: '/clearing/compliance/fincen/file'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/match/_match': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/match/_match'
      path: '/fincen/match'
      fullPath: '/clearing/compliance/fincen/match'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/file/_file': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/file/_file'
      path: '/ofac/file'
      fullPath: '/clearing/compliance/ofac/file'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/match/_match': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/match/_match'
      path: '/ofac/match'
      fullPath: '/clearing/compliance/ofac/match'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/sdn/_sdn': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/sdn/_sdn'
      path: '/ofac/sdn'
      fullPath: '/clearing/compliance/ofac/sdn'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/blue-sheet/_blue-sheet': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/blue-sheet/_blue-sheet'
      path: '/reporting/blue-sheet'
      fullPath: '/clearing/compliance/reporting/blue-sheet'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cais/_cais': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cais/_cais'
      path: '/reporting/cais'
      fullPath: '/clearing/compliance/reporting/cais'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cat/_cat': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cat/_cat'
      path: '/reporting/cat'
      fullPath: '/clearing/compliance/reporting/cat'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/sec-606/_sec-606': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/sec-606/_sec-606'
      path: '/reporting/sec-606'
      fullPath: '/clearing/compliance/reporting/sec-606'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606RouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account'
      path: '/accounting/account'
      fullPath: '/clearing/finance/accounting/account'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/balance-sheet/_balance-sheet': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/balance-sheet/_balance-sheet'
      path: '/accounting/balance-sheet'
      fullPath: '/clearing/finance/accounting/balance-sheet'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/income-statement/_income-statement': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/income-statement/_income-statement'
      path: '/accounting/income-statement'
      fullPath: '/clearing/finance/accounting/income-statement'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/transaction/_transaction': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/transaction/_transaction'
      path: '/accounting/transaction'
      fullPath: '/clearing/finance/accounting/transaction'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/trial-balance/_trial-balance': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/trial-balance/_trial-balance'
      path: '/accounting/trial-balance'
      fullPath: '/clearing/finance/accounting/trial-balance'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/journal/_manual-entry/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/journal/_manual-entry/'
      path: '/'
      fullPath: '/clearing/finance/journal/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/journal/_manual-entry/$entryId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/journal/_manual-entry/$entryId'
      path: '/$entryId'
      fullPath: '/clearing/finance/journal/$entryId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryEntryIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/journal/_manual-entry/create': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/journal/_manual-entry/create'
      path: '/create'
      fullPath: '/clearing/finance/journal/create'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryCreateRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate'
      path: '/middle-money/fee-rate'
      fullPath: '/clearing/finance/middle-money/fee-rate'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/taf-report/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/taf-report/'
      path: '/middle-money/taf-report'
      fullPath: '/clearing/finance/middle-money/taf-report/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyTafReportIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/account-number/_account-number': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/account-number/_account-number'
      path: '/payment/account-number'
      fullPath: '/clearing/finance/payment/account-number'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/ach/_ach': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/ach/_ach'
      path: '/payment/ach'
      fullPath: '/clearing/finance/payment/ach'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-ach/_incoming-ach': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-ach/_incoming-ach'
      path: '/payment/incoming-ach'
      fullPath: '/clearing/finance/payment/incoming-ach'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-wire/_incoming-wire': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-wire/_incoming-wire'
      path: '/payment/incoming-wire'
      fullPath: '/clearing/finance/payment/incoming-wire'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/wire/_wire': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/wire/_wire'
      path: '/payment/wire'
      fullPath: '/clearing/finance/payment/wire'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/balance/_balance/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/balance/_balance/'
      path: '/'
      fullPath: '/clearing/operations/balance/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/balance/_balance/$accountCode': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/balance/_balance/$accountCode'
      path: '/$accountCode'
      fullPath: '/clearing/operations/balance/$accountCode'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceAccountCodeRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/action/_action': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/action/_action'
      path: '/ca/action'
      fullPath: '/clearing/operations/ca/action'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/payment/_payment': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/payment/_payment'
      path: '/ca/payment'
      fullPath: '/clearing/operations/ca/payment'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-cash-balance/_customer-cash-balance/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-cash-balance/_customer-cash-balance/'
      path: '/'
      fullPath: '/clearing/operations/customer-cash-balance/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-stock-record/_customer-stock-record/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-stock-record/_customer-stock-record/'
      path: '/'
      fullPath: '/clearing/operations/customer-stock-record/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-sweep-record/_customer-sweep-record/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-sweep-record/_customer-sweep-record/'
      path: '/'
      fullPath: '/clearing/operations/customer-sweep-record/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset-day/_asset-day': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset-day/_asset-day'
      path: '/dtcc/asset-day'
      fullPath: '/clearing/operations/dtcc/asset-day'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset/_asset': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset/_asset'
      path: '/dtcc/asset'
      fullPath: '/clearing/operations/dtcc/asset'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/'
      path: '/generate/monthly-statement'
      fullPath: '/clearing/operations/generate/monthly-statement/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/balance/_balance': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/balance/_balance'
      path: '/inventory/balance'
      fullPath: '/clearing/operations/inventory/balance'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/books-order/_books-order': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/books-order/_books-order'
      path: '/inventory/books-order'
      fullPath: '/clearing/operations/inventory/books-order'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/order/_order': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/order/_order'
      path: '/inventory/order'
      fullPath: '/clearing/operations/inventory/order'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/sell-down/_sell-down': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/sell-down/_sell-down'
      path: '/inventory/sell-down'
      fullPath: '/clearing/operations/inventory/sell-down'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/trading-day/_trading-day': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/trading-day/_trading-day'
      path: '/inventory/trading-day'
      fullPath: '/clearing/operations/inventory/trading-day'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/journal/_manual-entry/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/journal/_manual-entry/'
      path: '/'
      fullPath: '/clearing/operations/journal/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/journal/_manual-entry/$entryId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/journal/_manual-entry/$entryId'
      path: '/$entryId'
      fullPath: '/clearing/operations/journal/$entryId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryEntryIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/journal/_manual-entry/create': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/journal/_manual-entry/create'
      path: '/create'
      fullPath: '/clearing/operations/journal/create'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryCreateRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/dividend-accrual/_dividend-accrual': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/dividend-accrual/_dividend-accrual'
      path: '/mutualfunds/dividend-accrual'
      fullPath: '/clearing/operations/mutualfunds/dividend-accrual'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/job/_job': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/job/_job'
      path: '/mutualfunds/job'
      fullPath: '/clearing/operations/mutualfunds/job'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/'
      path: '/mutualfunds/reconciliation'
      fullPath: '/clearing/operations/mutualfunds/reconciliation/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/task/_task': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/task/_task'
      path: '/mutualfunds/task'
      fullPath: '/clearing/operations/mutualfunds/task'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/venue-order/_venue-order': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/venue-order/_venue-order'
      path: '/mutualfunds/venue-order'
      fullPath: '/clearing/operations/mutualfunds/venue-order'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-order/_fix-order': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-order/_fix-order'
      path: '/oms/fix-order'
      fullPath: '/clearing/operations/oms/fix-order'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-session/_fix-session': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-session/_fix-session'
      path: '/oms/fix-session'
      fullPath: '/clearing/operations/oms/fix-session'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/routing-rule/_routing-rule': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/routing-rule/_routing-rule'
      path: '/oms/routing-rule'
      fullPath: '/clearing/operations/oms/routing-rule'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/archive/_report': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/archive/_report'
      path: '/reporting/archive'
      fullPath: '/clearing/operations/reporting/archive'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/'
      path: '/'
      fullPath: '/clearing/operations/stock-record/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/job/_job': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/job/_job'
      path: '/sweep/job'
      fullPath: '/clearing/operations/sweep/job'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/order/_order': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/order/_order'
      path: '/sweep/order'
      fullPath: '/clearing/operations/sweep/order'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/participant/_participant': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/participant/_participant'
      path: '/sweep/participant'
      fullPath: '/clearing/operations/sweep/participant'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/task/_task': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/task/_task'
      path: '/sweep/task'
      fullPath: '/clearing/operations/sweep/task'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-report/_trf-report': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-report/_trf-report'
      path: '/trade/trf-report'
      fullPath: '/clearing/operations/trade/trf-report'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-session/_trf-session': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-session/_trf-session'
      path: '/trade/trf-session'
      fullPath: '/clearing/operations/trade/trf-session'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc-fix-session/_utc-fix-session': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc-fix-session/_utc-fix-session'
      path: '/trade/utc-fix-session'
      fullPath: '/clearing/operations/trade/utc-fix-session'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc/_utc': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc/_utc'
      path: '/trade/utc'
      fullPath: '/clearing/operations/trade/utc'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/transaction/_transaction/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/transaction/_transaction/'
      path: '/'
      fullPath: '/clearing/operations/transaction/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/transaction/_transaction/$transactionId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/transaction/_transaction/$transactionId'
      path: '/$transactionId'
      fullPath: '/clearing/operations/transaction/$transactionId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionTransactionIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trigger/_trigger/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trigger/_trigger/'
      path: '/'
      fullPath: '/clearing/operations/trigger/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trigger/_trigger/$triggerId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trigger/_trigger/$triggerId'
      path: '/$triggerId'
      fullPath: '/clearing/operations/trigger/$triggerId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerTriggerIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-job/_job': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-job/_job'
      path: '/beta-nxt/prospectus-job'
      fullPath: '/clearing/vendor/beta-nxt/prospectus-job'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-task/_task': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-task/_task'
      path: '/beta-nxt/prospectus-task'
      fullPath: '/clearing/vendor/beta-nxt/prospectus-task'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job'
      path: '/beta-nxt/proxy-vote-job'
      fullPath: '/clearing/vendor/beta-nxt/proxy-vote-job'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-task/_task': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-task/_task'
      path: '/beta-nxt/proxy-vote-task'
      fullPath: '/clearing/vendor/beta-nxt/proxy-vote-task'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/'
      path: '/'
      fullPath: '/clearing/vendor/dtcc/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/corporate-action/_action': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/corporate-action/_action'
      path: '/ice/corporate-action'
      fullPath: '/clearing/vendor/ice/corporate-action'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/instrument/_instrument': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/instrument/_instrument'
      path: '/ice/instrument'
      fullPath: '/clearing/vendor/ice/instrument'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/job/_job': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/job/_job'
      path: '/ice/job'
      fullPath: '/clearing/vendor/ice/job'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/task/_task': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/task/_task'
      path: '/ice/task'
      fullPath: '/clearing/vendor/ice/task'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/account-number/_account-number': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/account-number/_account-number'
      path: '/increase/account-number'
      fullPath: '/clearing/vendor/increase/account-number'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/ach/_ach': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/ach/_ach'
      path: '/increase/ach'
      fullPath: '/clearing/vendor/increase/ach'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/wire/_wire': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/wire/_wire'
      path: '/increase/wire'
      fullPath: '/clearing/vendor/increase/wire'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/destination/_destination': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/destination/_destination'
      path: '/jpm/destination'
      fullPath: '/clearing/vendor/jpm/destination'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/emulator/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/emulator/'
      path: '/jpm/emulator'
      fullPath: '/clearing/vendor/jpm/emulator/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmEmulatorIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/job/_job': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/job/_job'
      path: '/jpm/job'
      fullPath: '/clearing/vendor/jpm/job'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/net-order/_net-order': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/net-order/_net-order'
      path: '/jpm/net-order'
      fullPath: '/clearing/vendor/jpm/net-order'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/order/_order': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/order/_order'
      path: '/jpm/order'
      fullPath: '/clearing/vendor/jpm/order'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/task/_task': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/task/_task'
      path: '/jpm/task'
      fullPath: '/clearing/vendor/jpm/task'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/plaid/processor-token/_processor-token': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/plaid/processor-token/_processor-token'
      path: '/plaid/processor-token'
      fullPath: '/clearing/vendor/plaid/processor-token'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/job/_job': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/job/_job'
      path: '/quote-media/job'
      fullPath: '/clearing/vendor/quote-media/job'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/sp-500/_sp-500': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/sp-500/_sp-500'
      path: '/quote-media/sp-500'
      fullPath: '/clearing/vendor/quote-media/sp-500'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500RouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/task/_task': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/task/_task'
      path: '/quote-media/task'
      fullPath: '/clearing/vendor/quote-media/task'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset'
      path: '/asset'
      fullPath: '/registration/account/$accountId/asset'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash'
      path: '/cash'
      fullPath: '/registration/account/$accountId/cash'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/document/_document': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/document/_document'
      path: '/document'
      fullPath: '/registration/account/$accountId/document'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding'
      path: '/funding'
      fullPath: '/registration/account/$accountId/funding'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/hold/_hold': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/hold/_hold'
      path: '/hold'
      fullPath: '/registration/account/$accountId/hold'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/transaction/_transaction': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/transaction/_transaction'
      path: '/transaction'
      fullPath: '/registration/account/$accountId/transaction'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/'
      path: '/detail'
      fullPath: '/registration/account/$accountId/detail/'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailIndexRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/beneficiaries': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/beneficiaries'
      path: '/detail/beneficiaries'
      fullPath: '/registration/account/$accountId/detail/beneficiaries'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailBeneficiariesRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/clearing-controls': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/clearing-controls'
      path: '/detail/clearing-controls'
      fullPath: '/registration/account/$accountId/detail/clearing-controls'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailClearingControlsRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/controls': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/controls'
      path: '/detail/controls'
      fullPath: '/registration/account/$accountId/detail/controls'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailControlsRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/risk': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_overview/detail/risk'
      path: '/detail/risk'
      fullPath: '/registration/account/$accountId/detail/risk'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailRiskRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/order/_order': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/order/_order'
      path: '/order'
      fullPath: '/registration/account/$accountId/order'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/dividends-receivable/_dividends-receivable/': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/dividends-receivable/_dividends-receivable/'
      path: '/'
      fullPath: '/registration/account/$accountId/dividends-receivable/'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableIndexRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableRoute
    }
    '/_app/_clearing-core/registration/profile/_profile/$profileId/edit/_edit/': {
      id: '/_app/_clearing-core/registration/profile/_profile/$profileId/edit/_edit/'
      path: '/'
      fullPath: '/registration/profile/$profileId/edit/'
      preLoaderRoute: typeof AppClearingCoreRegistrationProfileProfileProfileIdEditEditIndexRouteImport
      parentRoute: typeof AppClearingCoreRegistrationProfileProfileProfileIdEditEditRoute
    }
    '/_app/_clearing-core/registration/profile/_profile/$profileId/edit/_edit/review': {
      id: '/_app/_clearing-core/registration/profile/_profile/$profileId/edit/_edit/review'
      path: '/review'
      fullPath: '/registration/profile/$profileId/edit/review'
      preLoaderRoute: typeof AppClearingCoreRegistrationProfileProfileProfileIdEditEditReviewRouteImport
      parentRoute: typeof AppClearingCoreRegistrationProfileProfileProfileIdEditEditRoute
    }
    '/_app/_clearing-core/registration/profile/_profile/create/$profileType/_create/': {
      id: '/_app/_clearing-core/registration/profile/_profile/create/$profileType/_create/'
      path: '/'
      fullPath: '/registration/profile/create/$profileType/'
      preLoaderRoute: typeof AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateIndexRouteImport
      parentRoute: typeof AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateRoute
    }
    '/_app/_clearing-core/registration/profile/_profile/create/$profileType/_create/review': {
      id: '/_app/_clearing-core/registration/profile/_profile/create/$profileType/_create/review'
      path: '/review'
      fullPath: '/registration/profile/create/$profileType/review'
      preLoaderRoute: typeof AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateReviewRouteImport
      parentRoute: typeof AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateRoute
    }
    '/_app/_o5/_o5-required/tech-ops/build/repo/_repo/$owner/$name': {
      id: '/_app/_o5/_o5-required/tech-ops/build/repo/_repo/$owner/$name'
      path: '/$owner/$name'
      fullPath: '/tech-ops/build/repo/$owner/$name'
      preLoaderRoute: typeof AppO5O5RequiredTechOpsBuildRepoRepoOwnerNameRouteImport
      parentRoute: typeof AppO5O5RequiredTechOpsBuildRepoRepoRoute
    }
    '/_app/_platform/_context-required/program/_program/$programId/_program/branding/': {
      id: '/_app/_platform/_context-required/program/_program/$programId/_program/branding/'
      path: '/branding'
      fullPath: '/program/$programId/branding/'
      preLoaderRoute: typeof AppPlatformContextRequiredProgramProgramProgramIdProgramBrandingIndexRouteImport
      parentRoute: typeof AppPlatformContextRequiredProgramProgramProgramIdProgramRoute
    }
    '/_app/_platform/_context-required/program/_program/$programId/_program/configuration/': {
      id: '/_app/_platform/_context-required/program/_program/$programId/_program/configuration/'
      path: '/configuration'
      fullPath: '/program/$programId/configuration/'
      preLoaderRoute: typeof AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationIndexRouteImport
      parentRoute: typeof AppPlatformContextRequiredProgramProgramProgramIdProgramRoute
    }
    '/_app/_platform/_context-required/program/_program/$programId/_program/configuration/clearing': {
      id: '/_app/_platform/_context-required/program/_program/$programId/_program/configuration/clearing'
      path: '/configuration/clearing'
      fullPath: '/program/$programId/configuration/clearing'
      preLoaderRoute: typeof AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationClearingRouteImport
      parentRoute: typeof AppPlatformContextRequiredProgramProgramProgramIdProgramRoute
    }
    '/_app/_platform/_context-required/program/_program/$programId/_program/configuration/contacts': {
      id: '/_app/_platform/_context-required/program/_program/$programId/_program/configuration/contacts'
      path: '/configuration/contacts'
      fullPath: '/program/$programId/configuration/contacts'
      preLoaderRoute: typeof AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationContactsRouteImport
      parentRoute: typeof AppPlatformContextRequiredProgramProgramProgramIdProgramRoute
    }
    '/_app/_platform/_context-required/program/_program/$programId/_program/configuration/controls': {
      id: '/_app/_platform/_context-required/program/_program/$programId/_program/configuration/controls'
      path: '/configuration/controls'
      fullPath: '/program/$programId/configuration/controls'
      preLoaderRoute: typeof AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationControlsRouteImport
      parentRoute: typeof AppPlatformContextRequiredProgramProgramProgramIdProgramRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/entry/_entry/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/entry/_entry/'
      path: '/'
      fullPath: '/clearing/compliance/fincen/entry/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/entry/_entry/$fincen314EntryId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/entry/_entry/$fincen314EntryId'
      path: '/$fincen314EntryId'
      fullPath: '/clearing/compliance/fincen/entry/$fincen314EntryId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryFincen314EntryIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/file/_file/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/file/_file/'
      path: '/'
      fullPath: '/clearing/compliance/fincen/file/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/file/_file/$fincen314FileId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/file/_file/$fincen314FileId'
      path: '/$fincen314FileId'
      fullPath: '/clearing/compliance/fincen/file/$fincen314FileId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileFincen314FileIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/match/_match/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/match/_match/'
      path: '/'
      fullPath: '/clearing/compliance/fincen/match/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/match/_match/$fincen314MatchId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/match/_match/$fincen314MatchId'
      path: '/$fincen314MatchId'
      fullPath: '/clearing/compliance/fincen/match/$fincen314MatchId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchFincen314MatchIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/file/_file/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/file/_file/'
      path: '/'
      fullPath: '/clearing/compliance/ofac/file/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/file/_file/$ofacFileId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/file/_file/$ofacFileId'
      path: '/$ofacFileId'
      fullPath: '/clearing/compliance/ofac/file/$ofacFileId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileOfacFileIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/match/_match/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/match/_match/'
      path: '/'
      fullPath: '/clearing/compliance/ofac/match/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/match/_match/$ofacMatchId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/match/_match/$ofacMatchId'
      path: '/$ofacMatchId'
      fullPath: '/clearing/compliance/ofac/match/$ofacMatchId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchOfacMatchIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/sdn/_sdn/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/sdn/_sdn/'
      path: '/'
      fullPath: '/clearing/compliance/ofac/sdn/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/sdn/_sdn/$ofacSdnId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/sdn/_sdn/$ofacSdnId'
      path: '/$ofacSdnId'
      fullPath: '/clearing/compliance/ofac/sdn/$ofacSdnId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnOfacSdnIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/blue-sheet/_blue-sheet/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/blue-sheet/_blue-sheet/'
      path: '/'
      fullPath: '/clearing/compliance/reporting/blue-sheet/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/blue-sheet/_blue-sheet/$reportId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/blue-sheet/_blue-sheet/$reportId'
      path: '/$reportId'
      fullPath: '/clearing/compliance/reporting/blue-sheet/$reportId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetReportIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cais/_cais/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cais/_cais/'
      path: '/'
      fullPath: '/clearing/compliance/reporting/cais/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cais/_cais/$reportId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cais/_cais/$reportId'
      path: '/$reportId'
      fullPath: '/clearing/compliance/reporting/cais/$reportId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisReportIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cat/_cat/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cat/_cat/'
      path: '/'
      fullPath: '/clearing/compliance/reporting/cat/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cat/_cat/$reportId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cat/_cat/$reportId'
      path: '/$reportId'
      fullPath: '/clearing/compliance/reporting/cat/$reportId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatReportIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/sec-606/_sec-606/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/sec-606/_sec-606/'
      path: '/'
      fullPath: '/clearing/compliance/reporting/sec-606/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606IndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606Route
    }
    '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/sec-606/_sec-606/$reportId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/sec-606/_sec-606/$reportId'
      path: '/$reportId'
      fullPath: '/clearing/compliance/reporting/sec-606/$reportId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606ReportIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606Route
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account/'
      path: '/'
      fullPath: '/clearing/finance/accounting/account/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/balance-sheet/_balance-sheet/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/balance-sheet/_balance-sheet/'
      path: '/'
      fullPath: '/clearing/finance/accounting/balance-sheet/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/income-statement/_income-statement/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/income-statement/_income-statement/'
      path: '/'
      fullPath: '/clearing/finance/accounting/income-statement/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/transaction/_transaction/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/transaction/_transaction/'
      path: '/'
      fullPath: '/clearing/finance/accounting/transaction/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/transaction/_transaction/$transactionId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/transaction/_transaction/$transactionId'
      path: '/$transactionId'
      fullPath: '/clearing/finance/accounting/transaction/$transactionId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionTransactionIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/trial-balance/_trial-balance/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/trial-balance/_trial-balance/'
      path: '/'
      fullPath: '/clearing/finance/accounting/trial-balance/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate/'
      path: '/'
      fullPath: '/clearing/finance/middle-money/fee-rate/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/account-number/_account-number/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/account-number/_account-number/'
      path: '/'
      fullPath: '/clearing/finance/payment/account-number/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/account-number/_account-number/$accountNumberId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/account-number/_account-number/$accountNumberId'
      path: '/$accountNumberId'
      fullPath: '/clearing/finance/payment/account-number/$accountNumberId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberAccountNumberIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/ach/_ach/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/ach/_ach/'
      path: '/'
      fullPath: '/clearing/finance/payment/ach/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/ach/_ach/$achId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/ach/_ach/$achId'
      path: '/$achId'
      fullPath: '/clearing/finance/payment/ach/$achId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchAchIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-ach/_incoming-ach/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-ach/_incoming-ach/'
      path: '/'
      fullPath: '/clearing/finance/payment/incoming-ach/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-ach/_incoming-ach/$achId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-ach/_incoming-ach/$achId'
      path: '/$achId'
      fullPath: '/clearing/finance/payment/incoming-ach/$achId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchAchIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-wire/_incoming-wire/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-wire/_incoming-wire/'
      path: '/'
      fullPath: '/clearing/finance/payment/incoming-wire/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-wire/_incoming-wire/$wireId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-wire/_incoming-wire/$wireId'
      path: '/$wireId'
      fullPath: '/clearing/finance/payment/incoming-wire/$wireId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireWireIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/wire/_wire/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/wire/_wire/'
      path: '/'
      fullPath: '/clearing/finance/payment/wire/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/wire/_wire/$wireId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/wire/_wire/$wireId'
      path: '/$wireId'
      fullPath: '/clearing/finance/payment/wire/$wireId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireWireIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/action/_action/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/action/_action/'
      path: '/'
      fullPath: '/clearing/operations/ca/action/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/action/_action/$actionId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/action/_action/$actionId'
      path: '/$actionId'
      fullPath: '/clearing/operations/ca/action/$actionId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionActionIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/payment/_payment/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/payment/_payment/'
      path: '/'
      fullPath: '/clearing/operations/ca/payment/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/payment/_payment/$paymentId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/payment/_payment/$paymentId'
      path: '/$paymentId'
      fullPath: '/clearing/operations/ca/payment/$paymentId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentPaymentIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset-day/_asset-day/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset-day/_asset-day/'
      path: '/'
      fullPath: '/clearing/operations/dtcc/asset-day/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset/_asset/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset/_asset/'
      path: '/'
      fullPath: '/clearing/operations/dtcc/asset/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/job/_job': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/job/_job'
      path: '/generate/monthly-statement/job'
      fullPath: '/clearing/operations/generate/monthly-statement/job'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/task/_task': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/task/_task'
      path: '/generate/monthly-statement/task'
      fullPath: '/clearing/operations/generate/monthly-statement/task'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/job/_job': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/job/_job'
      path: '/generate/trade-confirmation/job'
      fullPath: '/clearing/operations/generate/trade-confirmation/job'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/task/_task': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/task/_task'
      path: '/generate/trade-confirmation/task'
      fullPath: '/clearing/operations/generate/trade-confirmation/task'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/balance/_balance/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/balance/_balance/'
      path: '/'
      fullPath: '/clearing/operations/inventory/balance/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/balance/_balance/$assetId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/balance/_balance/$assetId'
      path: '/$assetId'
      fullPath: '/clearing/operations/inventory/balance/$assetId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceAssetIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/books-order/_books-order/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/books-order/_books-order/'
      path: '/'
      fullPath: '/clearing/operations/inventory/books-order/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/books-order/_books-order/$booksOrderId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/books-order/_books-order/$booksOrderId'
      path: '/$booksOrderId'
      fullPath: '/clearing/operations/inventory/books-order/$booksOrderId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderBooksOrderIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/order/_order/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/order/_order/'
      path: '/'
      fullPath: '/clearing/operations/inventory/order/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/order/_order/$firmOrderId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/order/_order/$firmOrderId'
      path: '/$firmOrderId'
      fullPath: '/clearing/operations/inventory/order/$firmOrderId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderFirmOrderIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/sell-down/_sell-down/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/sell-down/_sell-down/'
      path: '/'
      fullPath: '/clearing/operations/inventory/sell-down/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/trading-day/_trading-day/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/trading-day/_trading-day/'
      path: '/'
      fullPath: '/clearing/operations/inventory/trading-day/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/dividend-accrual/_dividend-accrual/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/dividend-accrual/_dividend-accrual/'
      path: '/'
      fullPath: '/clearing/operations/mutualfunds/dividend-accrual/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/job/_job/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/job/_job/'
      path: '/'
      fullPath: '/clearing/operations/mutualfunds/job/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/job/_job/$jobId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/job/_job/$jobId'
      path: '/$jobId'
      fullPath: '/clearing/operations/mutualfunds/job/$jobId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobJobIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day'
      path: '/mutualfunds/reconciliation/position-day'
      fullPath: '/clearing/operations/mutualfunds/reconciliation/position-day'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/task/_task/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/task/_task/'
      path: '/'
      fullPath: '/clearing/operations/mutualfunds/task/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/task/_task/$taskId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/task/_task/$taskId'
      path: '/$taskId'
      fullPath: '/clearing/operations/mutualfunds/task/$taskId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskTaskIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/venue-order/_venue-order/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/venue-order/_venue-order/'
      path: '/'
      fullPath: '/clearing/operations/mutualfunds/venue-order/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/venue-order/_venue-order/$venueOrderId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/venue-order/_venue-order/$venueOrderId'
      path: '/$venueOrderId'
      fullPath: '/clearing/operations/mutualfunds/venue-order/$venueOrderId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderVenueOrderIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-order/_fix-order/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-order/_fix-order/'
      path: '/'
      fullPath: '/clearing/operations/oms/fix-order/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-order/_fix-order/$fixOrderId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-order/_fix-order/$fixOrderId'
      path: '/$fixOrderId'
      fullPath: '/clearing/operations/oms/fix-order/$fixOrderId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderFixOrderIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-session/_fix-session/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-session/_fix-session/'
      path: '/'
      fullPath: '/clearing/operations/oms/fix-session/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-session/_fix-session/$sessionId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-session/_fix-session/$sessionId'
      path: '/$sessionId'
      fullPath: '/clearing/operations/oms/fix-session/$sessionId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionSessionIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/routing-rule/_routing-rule/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/routing-rule/_routing-rule/'
      path: '/'
      fullPath: '/clearing/operations/oms/routing-rule/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/routing-rule/_routing-rule/$ruleId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/routing-rule/_routing-rule/$ruleId'
      path: '/$ruleId'
      fullPath: '/clearing/operations/oms/routing-rule/$ruleId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRuleIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/archive/_report/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/archive/_report/'
      path: '/'
      fullPath: '/clearing/operations/reporting/archive/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/archive/_report/$reportId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/archive/_report/$reportId'
      path: '/$reportId'
      fullPath: '/clearing/operations/reporting/archive/$reportId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportReportIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/asset/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/asset/'
      path: '/asset'
      fullPath: '/clearing/operations/stock-record/asset/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/job/_job/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/job/_job/'
      path: '/'
      fullPath: '/clearing/operations/sweep/job/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/job/_job/$jobId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/job/_job/$jobId'
      path: '/$jobId'
      fullPath: '/clearing/operations/sweep/job/$jobId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobJobIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/order/_order/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/order/_order/'
      path: '/'
      fullPath: '/clearing/operations/sweep/order/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/order/_order/$sweepOrderId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/order/_order/$sweepOrderId'
      path: '/$sweepOrderId'
      fullPath: '/clearing/operations/sweep/order/$sweepOrderId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderSweepOrderIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/participant/_participant/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/participant/_participant/'
      path: '/'
      fullPath: '/clearing/operations/sweep/participant/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/participant/_participant/$accountId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/participant/_participant/$accountId'
      path: '/$accountId'
      fullPath: '/clearing/operations/sweep/participant/$accountId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantAccountIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/task/_task/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/task/_task/'
      path: '/'
      fullPath: '/clearing/operations/sweep/task/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/task/_task/$taskId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/task/_task/$taskId'
      path: '/$taskId'
      fullPath: '/clearing/operations/sweep/task/$taskId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskTaskIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-report/_trf-report/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-report/_trf-report/'
      path: '/'
      fullPath: '/clearing/operations/trade/trf-report/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-report/_trf-report/$trfReportId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-report/_trf-report/$trfReportId'
      path: '/$trfReportId'
      fullPath: '/clearing/operations/trade/trf-report/$trfReportId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportTrfReportIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-session/_trf-session/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-session/_trf-session/'
      path: '/'
      fullPath: '/clearing/operations/trade/trf-session/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-session/_trf-session/$sessionId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-session/_trf-session/$sessionId'
      path: '/$sessionId'
      fullPath: '/clearing/operations/trade/trf-session/$sessionId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionSessionIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc-fix-session/_utc-fix-session/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc-fix-session/_utc-fix-session/'
      path: '/'
      fullPath: '/clearing/operations/trade/utc-fix-session/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc-fix-session/_utc-fix-session/$sessionId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc-fix-session/_utc-fix-session/$sessionId'
      path: '/$sessionId'
      fullPath: '/clearing/operations/trade/utc-fix-session/$sessionId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionSessionIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc/_utc/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc/_utc/'
      path: '/'
      fullPath: '/clearing/operations/trade/utc/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc/_utc/$tradeId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc/_utc/$tradeId'
      path: '/$tradeId'
      fullPath: '/clearing/operations/trade/utc/$tradeId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcTradeIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-job/_job/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-job/_job/'
      path: '/'
      fullPath: '/clearing/vendor/beta-nxt/prospectus-job/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-job/_job/$jobId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-job/_job/$jobId'
      path: '/$jobId'
      fullPath: '/clearing/vendor/beta-nxt/prospectus-job/$jobId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobJobIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-task/_task/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-task/_task/'
      path: '/'
      fullPath: '/clearing/vendor/beta-nxt/prospectus-task/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-task/_task/$taskId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-task/_task/$taskId'
      path: '/$taskId'
      fullPath: '/clearing/vendor/beta-nxt/prospectus-task/$taskId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskTaskIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job/'
      path: '/'
      fullPath: '/clearing/vendor/beta-nxt/proxy-vote-job/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-task/_task/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-task/_task/'
      path: '/'
      fullPath: '/clearing/vendor/beta-nxt/proxy-vote-task/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-task/_task/$taskId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-task/_task/$taskId'
      path: '/$taskId'
      fullPath: '/clearing/vendor/beta-nxt/proxy-vote-task/$taskId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskTaskIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file-request/_file-request': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file-request/_file-request'
      path: '/file-request'
      fullPath: '/clearing/vendor/dtcc/file-request'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file/_file': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file/_file'
      path: '/file'
      fullPath: '/clearing/vendor/dtcc/file'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/corporate-action/_action/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/corporate-action/_action/'
      path: '/'
      fullPath: '/clearing/vendor/ice/corporate-action/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/corporate-action/_action/$eventId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/corporate-action/_action/$eventId'
      path: '/$eventId'
      fullPath: '/clearing/vendor/ice/corporate-action/$eventId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionEventIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/instrument/_instrument/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/instrument/_instrument/'
      path: '/'
      fullPath: '/clearing/vendor/ice/instrument/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/instrument/_instrument/$instrumentId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/instrument/_instrument/$instrumentId'
      path: '/$instrumentId'
      fullPath: '/clearing/vendor/ice/instrument/$instrumentId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentInstrumentIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/job/_job/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/job/_job/'
      path: '/'
      fullPath: '/clearing/vendor/ice/job/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/job/_job/$jobId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/job/_job/$jobId'
      path: '/$jobId'
      fullPath: '/clearing/vendor/ice/job/$jobId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobJobIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/task/_task/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/task/_task/'
      path: '/'
      fullPath: '/clearing/vendor/ice/task/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/task/_task/$taskId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/task/_task/$taskId'
      path: '/$taskId'
      fullPath: '/clearing/vendor/ice/task/$taskId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskTaskIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/account-number/_account-number/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/account-number/_account-number/'
      path: '/'
      fullPath: '/clearing/vendor/increase/account-number/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/account-number/_account-number/$accountNumberId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/account-number/_account-number/$accountNumberId'
      path: '/$accountNumberId'
      fullPath: '/clearing/vendor/increase/account-number/$accountNumberId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberAccountNumberIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/ach/_ach/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/ach/_ach/'
      path: '/'
      fullPath: '/clearing/vendor/increase/ach/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/ach/_ach/$achId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/ach/_ach/$achId'
      path: '/$achId'
      fullPath: '/clearing/vendor/increase/ach/$achId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchAchIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/wire/_wire/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/wire/_wire/'
      path: '/'
      fullPath: '/clearing/vendor/increase/wire/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/wire/_wire/$wireId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/wire/_wire/$wireId'
      path: '/$wireId'
      fullPath: '/clearing/vendor/increase/wire/$wireId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireWireIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jane-street/pfof/job/_job': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jane-street/pfof/job/_job'
      path: '/jane-street/pfof/job'
      fullPath: '/clearing/vendor/jane-street/pfof/job'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/destination/_destination/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/destination/_destination/'
      path: '/'
      fullPath: '/clearing/vendor/jpm/destination/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/destination/_destination/$destinationId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/destination/_destination/$destinationId'
      path: '/$destinationId'
      fullPath: '/clearing/vendor/jpm/destination/$destinationId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationDestinationIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/job/_job/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/job/_job/'
      path: '/'
      fullPath: '/clearing/vendor/jpm/job/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/job/_job/$jobId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/job/_job/$jobId'
      path: '/$jobId'
      fullPath: '/clearing/vendor/jpm/job/$jobId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobJobIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/net-order/_net-order/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/net-order/_net-order/'
      path: '/'
      fullPath: '/clearing/vendor/jpm/net-order/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/net-order/_net-order/$netOrderId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/net-order/_net-order/$netOrderId'
      path: '/$netOrderId'
      fullPath: '/clearing/vendor/jpm/net-order/$netOrderId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderNetOrderIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/order/_order/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/order/_order/'
      path: '/'
      fullPath: '/clearing/vendor/jpm/order/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/order/_order/$orderId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/order/_order/$orderId'
      path: '/$orderId'
      fullPath: '/clearing/vendor/jpm/order/$orderId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderOrderIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/task/_task/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/task/_task/'
      path: '/'
      fullPath: '/clearing/vendor/jpm/task/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/task/_task/$taskId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/task/_task/$taskId'
      path: '/$taskId'
      fullPath: '/clearing/vendor/jpm/task/$taskId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskTaskIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/plaid/processor-token/_processor-token/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/plaid/processor-token/_processor-token/'
      path: '/'
      fullPath: '/clearing/vendor/plaid/processor-token/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/plaid/processor-token/_processor-token/$processorTokenId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/plaid/processor-token/_processor-token/$processorTokenId'
      path: '/$processorTokenId'
      fullPath: '/clearing/vendor/plaid/processor-token/$processorTokenId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenProcessorTokenIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/job/_job/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/job/_job/'
      path: '/'
      fullPath: '/clearing/vendor/quote-media/job/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/job/_job/$jobId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/job/_job/$jobId'
      path: '/$jobId'
      fullPath: '/clearing/vendor/quote-media/job/$jobId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobJobIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/sp-500/_sp-500/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/sp-500/_sp-500/'
      path: '/'
      fullPath: '/clearing/vendor/quote-media/sp-500/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500IndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500Route
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/sp-500/_sp-500/$quarter': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/sp-500/_sp-500/$quarter'
      path: '/$quarter'
      fullPath: '/clearing/vendor/quote-media/sp-500/$quarter'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500QuarterRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500Route
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/task/_task/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/task/_task/'
      path: '/'
      fullPath: '/clearing/vendor/quote-media/task/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/task/_task/$taskId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/task/_task/$taskId'
      path: '/$taskId'
      fullPath: '/clearing/vendor/quote-media/task/$taskId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskTaskIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/'
      path: '/'
      fullPath: '/registration/account/$accountId/cash/'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashIndexRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/document/_document/': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/document/_document/'
      path: '/'
      fullPath: '/registration/account/$accountId/document/'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentIndexRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/document/_document/tax': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/document/_document/tax'
      path: '/tax'
      fullPath: '/registration/account/$accountId/document/tax'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentTaxRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/document/_document/trade-confirmation': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/document/_document/trade-confirmation'
      path: '/trade-confirmation'
      fullPath: '/registration/account/$accountId/document/trade-confirmation'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentTradeConfirmationRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/hold/_hold/$holdId': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/hold/_hold/$holdId'
      path: '/$holdId'
      fullPath: '/registration/account/$accountId/hold/$holdId'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldHoldIdRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/order/equity/_equity': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/order/equity/_equity'
      path: '/order/equity'
      fullPath: '/registration/account/$accountId/order/equity'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/order/mutual-fund/_mutual-fund': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/order/mutual-fund/_mutual-fund'
      path: '/order/mutual-fund'
      fullPath: '/registration/account/$accountId/order/mutual-fund'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/transaction/_transaction/$transactionId': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/transaction/_transaction/$transactionId'
      path: '/$transactionId'
      fullPath: '/registration/account/$accountId/transaction/$transactionId'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionTransactionIdRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/order/_order/': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/order/_order/'
      path: '/'
      fullPath: '/registration/account/$accountId/order/'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderIndexRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/order/_order/equity': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/order/_order/equity'
      path: '/equity'
      fullPath: '/registration/account/$accountId/order/equity'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderEquityRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/order/_order/mutual-fund': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/order/_order/mutual-fund'
      path: '/mutual-fund'
      fullPath: '/registration/account/$accountId/order/mutual-fund'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderMutualFundRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account/$accountId/_layout': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account/$accountId/_layout'
      path: '/$accountId'
      fullPath: '/clearing/finance/accounting/account/$accountId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate/$feeType/_$feeType': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate/$feeType/_$feeType'
      path: '/$feeType'
      fullPath: '/clearing/finance/middle-money/fee-rate/$feeType'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset-day/_asset-day/$assetId/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset-day/_asset-day/$assetId/'
      path: '/$assetId'
      fullPath: '/clearing/operations/dtcc/asset-day/$assetId/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayAssetIdIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset-day/_asset-day/$assetId/$date': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset-day/_asset-day/$assetId/$date'
      path: '/$assetId/$date'
      fullPath: '/clearing/operations/dtcc/asset-day/$assetId/$date'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayAssetIdDateRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset/_asset/$assetId/$date': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset/_asset/$assetId/$date'
      path: '/$assetId/$date'
      fullPath: '/clearing/operations/dtcc/asset/$assetId/$date'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetAssetIdDateRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/job/_job/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/job/_job/'
      path: '/'
      fullPath: '/clearing/operations/generate/monthly-statement/job/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/job/_job/$jobId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/job/_job/$jobId'
      path: '/$jobId'
      fullPath: '/clearing/operations/generate/monthly-statement/job/$jobId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobJobIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/task/_task/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/task/_task/'
      path: '/'
      fullPath: '/clearing/operations/generate/monthly-statement/task/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/task/_task/$taskId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/task/_task/$taskId'
      path: '/$taskId'
      fullPath: '/clearing/operations/generate/monthly-statement/task/$taskId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskTaskIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/job/_job/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/job/_job/'
      path: '/'
      fullPath: '/clearing/operations/generate/trade-confirmation/job/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/job/_job/$jobId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/job/_job/$jobId'
      path: '/$jobId'
      fullPath: '/clearing/operations/generate/trade-confirmation/job/$jobId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobJobIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/task/_task/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/task/_task/'
      path: '/'
      fullPath: '/clearing/operations/generate/trade-confirmation/task/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/task/_task/$taskId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/task/_task/$taskId'
      path: '/$taskId'
      fullPath: '/clearing/operations/generate/trade-confirmation/task/$taskId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskTaskIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/trading-day/_trading-day/$assetId/_$assetId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/trading-day/_trading-day/$assetId/_$assetId'
      path: '/$assetId'
      fullPath: '/clearing/operations/inventory/trading-day/$assetId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day/'
      path: '/'
      fullPath: '/clearing/operations/mutualfunds/reconciliation/position-day/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/asset/$assetId/_asset': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/asset/$assetId/_asset'
      path: '/asset/$assetId'
      fullPath: '/clearing/operations/stock-record/asset/$assetId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job/$jobId/_job': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job/$jobId/_job'
      path: '/$jobId'
      fullPath: '/clearing/vendor/beta-nxt/proxy-vote-job/$jobId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file-request/_file-request/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file-request/_file-request/'
      path: '/'
      fullPath: '/clearing/vendor/dtcc/file-request/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file-request/_file-request/$fileRequestId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file-request/_file-request/$fileRequestId'
      path: '/$fileRequestId'
      fullPath: '/clearing/vendor/dtcc/file-request/$fileRequestId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestFileRequestIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file/_file/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file/_file/'
      path: '/'
      fullPath: '/clearing/vendor/dtcc/file/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file/_file/$fileId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file/_file/$fileId'
      path: '/$fileId'
      fullPath: '/clearing/vendor/dtcc/file/$fileId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileFileIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jane-street/pfof/job/_job/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jane-street/pfof/job/_job/'
      path: '/'
      fullPath: '/clearing/vendor/jane-street/pfof/job/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jane-street/pfof/job/_job/$jobId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jane-street/pfof/job/_job/$jobId'
      path: '/$jobId'
      fullPath: '/clearing/vendor/jane-street/pfof/job/$jobId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobJobIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_cost-basis/asset/$assetId/realization/$realizationId': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_cost-basis/asset/$assetId/realization/$realizationId'
      path: '/asset/$assetId/realization/$realizationId'
      fullPath: '/registration/account/$accountId/asset/$assetId/realization/$realizationId'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountCostBasisAssetAssetIdRealizationRealizationIdRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_cost-basis/asset/$assetId/tax-lot/$taxLotId': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_cost-basis/asset/$assetId/tax-lot/$taxLotId'
      path: '/asset/$assetId/tax-lot/$taxLotId'
      fullPath: '/registration/account/$accountId/asset/$assetId/tax-lot/$taxLotId'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountCostBasisAssetAssetIdTaxLotTaxLotIdRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance'
      path: '/$assetId'
      fullPath: '/registration/account/$accountId/asset/$assetId'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/sweep/$assetId': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/sweep/$assetId'
      path: '/sweep/$assetId'
      fullPath: '/registration/account/$accountId/cash/sweep/$assetId'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashSweepAssetIdRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/transaction/_transaction': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/transaction/_transaction'
      path: '/transaction'
      fullPath: '/registration/account/$accountId/cash/transaction'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding/source/': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding/source/'
      path: '/source'
      fullPath: '/registration/account/$accountId/funding/source/'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingSourceIndexRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding/source/$sourceId': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding/source/$sourceId'
      path: '/source/$sourceId'
      fullPath: '/registration/account/$accountId/funding/source/$sourceId'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingSourceSourceIdRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding/transfer/': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding/transfer/'
      path: '/transfer'
      fullPath: '/registration/account/$accountId/funding/transfer/'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingTransferIndexRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding/transfer/$transferId': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding/transfer/$transferId'
      path: '/transfer/$transferId'
      fullPath: '/registration/account/$accountId/funding/transfer/$transferId'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingTransferTransferIdRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/order/equity/_equity/$orderId': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/order/equity/_equity/$orderId'
      path: '/$orderId'
      fullPath: '/registration/account/$accountId/order/equity/$orderId'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityOrderIdRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/order/mutual-fund/_mutual-fund/$fundOrderId': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/order/mutual-fund/_mutual-fund/$fundOrderId'
      path: '/$fundOrderId'
      fullPath: '/registration/account/$accountId/order/mutual-fund/$fundOrderId'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundFundOrderIdRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account/$accountId/_layout/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account/$accountId/_layout/'
      path: '/'
      fullPath: '/clearing/finance/accounting/account/$accountId/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account/$accountId/_layout/settings': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account/$accountId/_layout/settings'
      path: '/settings'
      fullPath: '/clearing/finance/accounting/account/$accountId/settings'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutSettingsRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate/$feeType/_$feeType/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate/$feeType/_$feeType/'
      path: '/'
      fullPath: '/clearing/finance/middle-money/fee-rate/$feeType/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate/$feeType/_$feeType/$effectiveDate': {
      id: '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate/$feeType/_$feeType/$effectiveDate'
      path: '/$effectiveDate'
      fullPath: '/clearing/finance/middle-money/fee-rate/$feeType/$effectiveDate'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeEffectiveDateRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/trading-day/_trading-day/$assetId/_$assetId/$date': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/trading-day/_trading-day/$assetId/_$assetId/$date'
      path: '/$date'
      fullPath: '/clearing/operations/inventory/trading-day/$assetId/$date'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdDateRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day/$venue/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day/$venue/'
      path: '/$venue'
      fullPath: '/clearing/operations/mutualfunds/reconciliation/position-day/$venue/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/asset/$assetId/_asset/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/asset/$assetId/_asset/'
      path: '/'
      fullPath: '/clearing/operations/stock-record/asset/$assetId/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job/$jobId/_job/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job/$jobId/_job/'
      path: '/'
      fullPath: '/clearing/vendor/beta-nxt/proxy-vote-job/$jobId/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job/$jobId/_job/task': {
      id: '/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job/$jobId/_job/task'
      path: '/task'
      fullPath: '/clearing/vendor/beta-nxt/proxy-vote-job/$jobId/task'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobTaskRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/'
      path: '/'
      fullPath: '/registration/account/$accountId/asset/$assetId/'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceIndexRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/funding': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/funding'
      path: '/funding'
      fullPath: '/registration/account/$accountId/asset/$assetId/funding'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceFundingRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/hold': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/hold'
      path: '/hold'
      fullPath: '/registration/account/$accountId/asset/$assetId/hold'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceHoldRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/transaction/_transaction/': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/transaction/_transaction/'
      path: '/'
      fullPath: '/registration/account/$accountId/cash/transaction/'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionIndexRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/transaction/_transaction/$transactionId': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/transaction/_transaction/$transactionId'
      path: '/$transactionId'
      fullPath: '/registration/account/$accountId/cash/transaction/$transactionId'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionTransactionIdRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/dividend-accrual/_dividend-accrual/$accountId/$assetId/$source/$firstDayOfMonth': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/dividend-accrual/_dividend-accrual/$accountId/$assetId/$source/$firstDayOfMonth'
      path: '/$accountId/$assetId/$source/$firstDayOfMonth'
      fullPath: '/clearing/operations/mutualfunds/dividend-accrual/$accountId/$assetId/$source/$firstDayOfMonth'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualAccountIdAssetIdSourceFirstDayOfMonthRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day/$venue/$date/': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day/$venue/$date/'
      path: '/$venue/$date'
      fullPath: '/clearing/operations/mutualfunds/reconciliation/position-day/$venue/$date/'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueDateIndexRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day/$venue/$date/$assetId': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day/$venue/$date/$assetId'
      path: '/$venue/$date/$assetId'
      fullPath: '/clearing/operations/mutualfunds/reconciliation/position-day/$venue/$date/$assetId'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueDateAssetIdRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayRoute
    }
    '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/asset/$assetId/_asset/account/$accountCode': {
      id: '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/asset/$assetId/_asset/account/$accountCode'
      path: '/account/$accountCode'
      fullPath: '/clearing/operations/stock-record/asset/$assetId/account/$accountCode'
      preLoaderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetAccountAccountCodeRouteImport
      parentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/realization/': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/realization/'
      path: '/realization'
      fullPath: '/registration/account/$accountId/asset/$assetId/realization/'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRealizationIndexRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRoute
    }
    '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/tax-lot/': {
      id: '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/tax-lot/'
      path: '/tax-lot'
      fullPath: '/registration/account/$accountId/asset/$assetId/tax-lot/'
      preLoaderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceTaxLotIndexRouteImport
      parentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRoute
    }
  }
}

interface AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryRouteChildren {
  AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryFincen314EntryIdRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryFincen314EntryIdRoute
  AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryIndexRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryIndexRoute
}

const AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryRouteChildren: AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryFincen314EntryIdRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryFincen314EntryIdRoute,
    AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryIndexRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryRouteWithChildren =
  AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileRouteChildren {
  AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileFincen314FileIdRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileFincen314FileIdRoute
  AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileIndexRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileIndexRoute
}

const AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileRouteChildren: AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileFincen314FileIdRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileFincen314FileIdRoute,
    AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileIndexRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileRouteWithChildren =
  AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchRouteChildren {
  AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchFincen314MatchIdRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchFincen314MatchIdRoute
  AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchIndexRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchIndexRoute
}

const AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchRouteChildren: AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchFincen314MatchIdRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchFincen314MatchIdRoute,
    AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchIndexRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchRouteWithChildren =
  AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileRouteChildren {
  AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileOfacFileIdRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileOfacFileIdRoute
  AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileIndexRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileIndexRoute
}

const AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileRouteChildren: AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileOfacFileIdRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileOfacFileIdRoute,
    AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileIndexRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileRouteWithChildren =
  AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchRouteChildren {
  AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchOfacMatchIdRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchOfacMatchIdRoute
  AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchIndexRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchIndexRoute
}

const AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchRouteChildren: AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchOfacMatchIdRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchOfacMatchIdRoute,
    AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchIndexRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchRouteWithChildren =
  AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnRouteChildren {
  AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnOfacSdnIdRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnOfacSdnIdRoute
  AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnIndexRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnIndexRoute
}

const AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnRouteChildren: AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnOfacSdnIdRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnOfacSdnIdRoute,
    AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnIndexRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnRouteWithChildren =
  AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetRouteChildren {
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetReportIdRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetReportIdRoute
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetIndexRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetIndexRoute
}

const AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetRouteChildren: AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetReportIdRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetReportIdRoute,
    AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetIndexRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetRouteWithChildren =
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisRouteChildren {
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisReportIdRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisReportIdRoute
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisIndexRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisIndexRoute
}

const AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisRouteChildren: AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisReportIdRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisReportIdRoute,
    AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisIndexRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisRouteWithChildren =
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatRouteChildren {
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatReportIdRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatReportIdRoute
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatIndexRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatIndexRoute
}

const AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatRouteChildren: AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatReportIdRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatReportIdRoute,
    AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatIndexRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatRouteWithChildren =
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606RouteChildren {
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606ReportIdRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606ReportIdRoute
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606IndexRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606IndexRoute
}

const AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606RouteChildren: AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606RouteChildren =
  {
    AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606ReportIdRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606ReportIdRoute,
    AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606IndexRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606IndexRoute,
  }

const AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606RouteWithChildren =
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606Route._addFileChildren(
    AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606RouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingComplianceComplianceRouteChildren {
  AppClearingCoreClearingRequiredClearingComplianceComplianceIndexRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceIndexRoute
  AppClearingCoreClearingRequiredClearingComplianceComplianceFincenIndexRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenIndexRoute
  AppClearingCoreClearingRequiredClearingComplianceComplianceOfacIndexRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacIndexRoute
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingIndexRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingIndexRoute
  AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryRouteWithChildren
  AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileRouteWithChildren
  AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchRouteWithChildren
  AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileRouteWithChildren
  AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchRouteWithChildren
  AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnRouteWithChildren
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetRouteWithChildren
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisRouteWithChildren
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatRouteWithChildren
  AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606Route: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606RouteWithChildren
}

const AppClearingCoreClearingRequiredClearingComplianceComplianceRouteChildren: AppClearingCoreClearingRequiredClearingComplianceComplianceRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingComplianceComplianceIndexRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceIndexRoute,
    AppClearingCoreClearingRequiredClearingComplianceComplianceFincenIndexRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceFincenIndexRoute,
    AppClearingCoreClearingRequiredClearingComplianceComplianceOfacIndexRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceOfacIndexRoute,
    AppClearingCoreClearingRequiredClearingComplianceComplianceReportingIndexRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceReportingIndexRoute,
    AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceFincenEntryEntryRouteWithChildren,
    AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceFincenFileFileRouteWithChildren,
    AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceFincenMatchMatchRouteWithChildren,
    AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceOfacFileFileRouteWithChildren,
    AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceOfacMatchMatchRouteWithChildren,
    AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceOfacSdnSdnRouteWithChildren,
    AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceReportingBlueSheetBlueSheetRouteWithChildren,
    AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCaisCaisRouteWithChildren,
    AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceReportingCatCatRouteWithChildren,
    AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606Route:
      AppClearingCoreClearingRequiredClearingComplianceComplianceReportingSec606Sec606RouteWithChildren,
  }

const AppClearingCoreClearingRequiredClearingComplianceComplianceRouteWithChildren =
  AppClearingCoreClearingRequiredClearingComplianceComplianceRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingComplianceComplianceRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryRouteChildren {
  AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryEntryIdRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryEntryIdRoute
  AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryCreateRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryCreateRoute
  AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryIndexRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryIndexRoute
}

const AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryRouteChildren: AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryEntryIdRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryEntryIdRoute,
    AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryCreateRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryCreateRoute,
    AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryIndexRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryRouteWithChildren =
  AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutRouteChildren {
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutSettingsRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutSettingsRoute
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutIndexRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutIndexRoute
}

const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutRouteChildren: AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutSettingsRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutSettingsRoute,
    AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutIndexRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutRouteWithChildren =
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountRouteChildren {
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountIndexRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountIndexRoute
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutRouteWithChildren
}

const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountRouteChildren: AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountIndexRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountIndexRoute,
    AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountAccountIdLayoutRouteWithChildren,
  }

const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountRouteWithChildren =
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetRouteChildren {
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetIndexRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetIndexRoute
}

const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetRouteChildren: AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetIndexRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetRouteWithChildren =
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementRouteChildren {
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementIndexRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementIndexRoute
}

const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementRouteChildren: AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementIndexRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementRouteWithChildren =
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionRouteChildren {
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionTransactionIdRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionTransactionIdRoute
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionIndexRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionIndexRoute
}

const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionRouteChildren: AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionTransactionIdRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionTransactionIdRoute,
    AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionIndexRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionRouteWithChildren =
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceRouteChildren {
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceIndexRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceIndexRoute
}

const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceRouteChildren: AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceIndexRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceRouteWithChildren =
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeRouteChildren {
  AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeEffectiveDateRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeEffectiveDateRoute
  AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeIndexRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeIndexRoute
}

const AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeRouteChildren: AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeEffectiveDateRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeEffectiveDateRoute,
    AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeIndexRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeRouteWithChildren =
  AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateRouteChildren {
  AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateIndexRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateIndexRoute
  AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeRouteWithChildren
}

const AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateRouteChildren: AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateIndexRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateIndexRoute,
    AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateFeeTypeFeeTypeRouteWithChildren,
  }

const AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateRouteWithChildren =
  AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberRouteChildren {
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberAccountNumberIdRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberAccountNumberIdRoute
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberIndexRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberIndexRoute
}

const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberRouteChildren: AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberAccountNumberIdRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberAccountNumberIdRoute,
    AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberIndexRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberRouteWithChildren =
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchRouteChildren {
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchAchIdRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchAchIdRoute
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchIndexRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchIndexRoute
}

const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchRouteChildren: AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchAchIdRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchAchIdRoute,
    AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchIndexRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchRouteWithChildren =
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchRouteChildren {
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchAchIdRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchAchIdRoute
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchIndexRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchIndexRoute
}

const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchRouteChildren: AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchAchIdRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchAchIdRoute,
    AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchIndexRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchRouteWithChildren =
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireRouteChildren {
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireWireIdRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireWireIdRoute
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireIndexRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireIndexRoute
}

const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireRouteChildren: AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireWireIdRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireWireIdRoute,
    AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireIndexRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireRouteWithChildren =
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireRouteChildren {
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireWireIdRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireWireIdRoute
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireIndexRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireIndexRoute
}

const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireRouteChildren: AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireWireIdRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireWireIdRoute,
    AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireIndexRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireRouteWithChildren =
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingFinanceFinanceRouteChildren {
  AppClearingCoreClearingRequiredClearingFinanceFinanceIndexRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceIndexRoute
  AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryRouteWithChildren
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIndexRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIndexRoute
  AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyIndexRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyIndexRoute
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIndexRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIndexRoute
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountRouteWithChildren
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetRouteWithChildren
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementRouteWithChildren
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionRouteWithChildren
  AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceRouteWithChildren
  AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateRouteWithChildren
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberRouteWithChildren
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchRouteWithChildren
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchRouteWithChildren
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireRouteWithChildren
  AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireRouteWithChildren
  AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyTafReportIndexRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyTafReportIndexRoute
}

const AppClearingCoreClearingRequiredClearingFinanceFinanceRouteChildren: AppClearingCoreClearingRequiredClearingFinanceFinanceRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingFinanceFinanceIndexRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceIndexRoute,
    AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceJournalManualEntryRouteWithChildren,
    AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIndexRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIndexRoute,
    AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyIndexRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyIndexRoute,
    AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIndexRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIndexRoute,
    AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingAccountAccountRouteWithChildren,
    AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingBalanceSheetBalanceSheetRouteWithChildren,
    AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingIncomeStatementIncomeStatementRouteWithChildren,
    AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTransactionTransactionRouteWithChildren,
    AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceAccountingTrialBalanceTrialBalanceRouteWithChildren,
    AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyFeeRateFeeRateRouteWithChildren,
    AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAccountNumberAccountNumberRouteWithChildren,
    AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinancePaymentAchAchRouteWithChildren,
    AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingAchIncomingAchRouteWithChildren,
    AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinancePaymentIncomingWireIncomingWireRouteWithChildren,
    AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinancePaymentWireWireRouteWithChildren,
    AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyTafReportIndexRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceMiddleMoneyTafReportIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingFinanceFinanceRouteWithChildren =
  AppClearingCoreClearingRequiredClearingFinanceFinanceRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingFinanceFinanceRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceAccountCodeRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceAccountCodeRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceAccountCodeRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceAccountCodeRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryEntryIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryEntryIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryCreateRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryCreateRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryEntryIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryEntryIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryCreateRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryCreateRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetIndexRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetAccountAccountCodeRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetAccountAccountCodeRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetIndexRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetAccountAccountCodeRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetAccountAccountCodeRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordIndexRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetIndexRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetRouteWithChildren
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordIndexRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetIndexRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordAssetAssetIdAssetRouteWithChildren,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionTransactionIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionTransactionIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionTransactionIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionTransactionIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerTriggerIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerTriggerIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerTriggerIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerTriggerIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionActionIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionActionIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionActionIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionActionIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentPaymentIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentPaymentIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentPaymentIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentPaymentIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayIndexRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayAssetIdDateRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayAssetIdDateRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayAssetIdIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayAssetIdIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayIndexRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayAssetIdDateRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayAssetIdDateRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayAssetIdIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayAssetIdIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetIndexRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetAssetIdDateRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetAssetIdDateRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetIndexRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetAssetIdDateRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetAssetIdDateRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceAssetIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceAssetIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceAssetIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceAssetIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderBooksOrderIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderBooksOrderIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderBooksOrderIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderBooksOrderIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderFirmOrderIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderFirmOrderIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderFirmOrderIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderFirmOrderIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdDateRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdDateRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdDateRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdDateRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayIndexRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdRouteWithChildren
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayIndexRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayAssetIdAssetIdRouteWithChildren,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualIndexRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualAccountIdAssetIdSourceFirstDayOfMonthRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualAccountIdAssetIdSourceFirstDayOfMonthRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualIndexRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualAccountIdAssetIdSourceFirstDayOfMonthRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualAccountIdAssetIdSourceFirstDayOfMonthRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobJobIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobJobIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobJobIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobJobIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskTaskIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskTaskIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskTaskIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskTaskIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderVenueOrderIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderVenueOrderIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderVenueOrderIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderVenueOrderIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderFixOrderIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderFixOrderIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderFixOrderIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderFixOrderIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionSessionIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionSessionIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionSessionIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionSessionIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRuleIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRuleIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRuleIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRuleIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportReportIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportReportIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportReportIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportReportIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobJobIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobJobIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobJobIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobJobIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderSweepOrderIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderSweepOrderIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderSweepOrderIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderSweepOrderIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantAccountIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantAccountIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantAccountIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantAccountIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskTaskIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskTaskIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskTaskIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskTaskIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportTrfReportIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportTrfReportIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportTrfReportIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportTrfReportIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionSessionIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionSessionIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionSessionIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionSessionIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionSessionIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionSessionIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionSessionIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionSessionIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcTradeIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcTradeIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcTradeIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcTradeIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobJobIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobJobIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobJobIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobJobIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskTaskIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskTaskIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskTaskIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskTaskIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobJobIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobJobIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobJobIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobJobIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskTaskIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskTaskIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskTaskIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskTaskIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayIndexRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueIndexRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueDateAssetIdRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueDateAssetIdRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueDateIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueDateIndexRoute
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayIndexRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueIndexRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueDateAssetIdRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueDateAssetIdRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueDateIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayVenueDateIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingOperationsOperationsRouteChildren {
  AppClearingCoreClearingRequiredClearingOperationsOperationsIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsIndexRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsAccountCorrespondentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsAccountCorrespondentRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsReportingCashBlotterRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingCashBlotterRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsReportingOrderBlotterRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingOrderBlotterRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsReportingStockBlotterRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingStockBlotterRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsAccountIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsAccountIndexRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsDtccIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccIndexRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateIndexRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryIndexRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsIndexRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsOmsIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsIndexRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsReportingIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingIndexRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepIndexRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeIndexRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementIndexRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationIndexRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationIndexRoute
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayRouteWithChildren
}

const AppClearingCoreClearingRequiredClearingOperationsOperationsRouteChildren: AppClearingCoreClearingRequiredClearingOperationsOperationsRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingOperationsOperationsIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsIndexRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsAccountCorrespondentRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsAccountCorrespondentRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsBalanceBalanceRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerCashBalanceCustomerCashBalanceRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerStockRecordCustomerStockRecordRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsCustomerSweepRecordCustomerSweepRecordRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsJournalManualEntryRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsReportingCashBlotterRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsReportingCashBlotterRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsReportingOrderBlotterRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsReportingOrderBlotterRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsReportingStockBlotterRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsReportingStockBlotterRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsStockRecordStockRecordRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsTransactionTransactionRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsTriggerTriggerRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsAccountIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsAccountIndexRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsDtccIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsDtccIndexRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateIndexRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryIndexRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsIndexRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsOmsIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsOmsIndexRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsReportingIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsReportingIndexRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsSweepIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsSweepIndexRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsTradeIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsTradeIndexRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsCaActionActionRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsCaPaymentPaymentRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetDayAssetDayRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsDtccAssetAssetRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBalanceBalanceRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryBooksOrderBooksOrderRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryOrderOrderRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsInventorySellDownSellDownRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsInventoryTradingDayTradingDayRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsDividendAccrualDividendAccrualRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsJobJobRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsTaskTaskRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsVenueOrderVenueOrderRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixOrderFixOrderRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsOmsFixSessionFixSessionRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsOmsRoutingRuleRoutingRuleRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsReportingArchiveReportRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsSweepJobJobRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsSweepOrderOrderRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsSweepParticipantParticipantRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsSweepTaskTaskRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfReportTrfReportRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsTradeTrfSessionTrfSessionRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcFixSessionUtcFixSessionRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsTradeUtcUtcRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementIndexRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationIndexRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationIndexRoute,
    AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementJobJobRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateMonthlyStatementTaskTaskRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationJobJobRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsGenerateTradeConfirmationTaskTaskRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsMutualfundsReconciliationPositionDayPositionDayRouteWithChildren,
  }

const AppClearingCoreClearingRequiredClearingOperationsOperationsRouteWithChildren =
  AppClearingCoreClearingRequiredClearingOperationsOperationsRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingOperationsOperationsRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestFileRequestIdRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestFileRequestIdRoute
  AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestIndexRoute
}

const AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestFileRequestIdRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestFileRequestIdRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileFileIdRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileFileIdRoute
  AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileIndexRoute
}

const AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileFileIdRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileFileIdRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccIndexRoute
  AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestRouteWithChildren
  AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileRouteWithChildren
}

const AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccIndexRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileRequestFileRequestRouteWithChildren,
    AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccFileFileRouteWithChildren,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobJobIdRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobJobIdRoute
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobIndexRoute
}

const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobJobIdRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobJobIdRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskTaskIdRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskTaskIdRoute
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskIndexRoute
}

const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskTaskIdRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskTaskIdRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobTaskRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobTaskRoute
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobIndexRoute
}

const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobTaskRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobTaskRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobIndexRoute
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobRouteWithChildren
}

const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobIndexRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobJobIdJobRouteWithChildren,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskTaskIdRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskTaskIdRoute
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskIndexRoute
}

const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskTaskIdRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskTaskIdRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionEventIdRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionEventIdRoute
  AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionIndexRoute
}

const AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionEventIdRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionEventIdRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentInstrumentIdRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentInstrumentIdRoute
  AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentIndexRoute
}

const AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentInstrumentIdRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentInstrumentIdRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobJobIdRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobJobIdRoute
  AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobIndexRoute
}

const AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobJobIdRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobJobIdRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskTaskIdRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskTaskIdRoute
  AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskIndexRoute
}

const AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskTaskIdRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskTaskIdRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberAccountNumberIdRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberAccountNumberIdRoute
  AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberIndexRoute
}

const AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberAccountNumberIdRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberAccountNumberIdRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchAchIdRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchAchIdRoute
  AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchIndexRoute
}

const AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchAchIdRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchAchIdRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireWireIdRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireWireIdRoute
  AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireIndexRoute
}

const AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireWireIdRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireWireIdRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationDestinationIdRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationDestinationIdRoute
  AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationIndexRoute
}

const AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationDestinationIdRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationDestinationIdRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobJobIdRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobJobIdRoute
  AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobIndexRoute
}

const AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobJobIdRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobJobIdRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderNetOrderIdRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderNetOrderIdRoute
  AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderIndexRoute
}

const AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderNetOrderIdRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderNetOrderIdRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderOrderIdRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderOrderIdRoute
  AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderIndexRoute
}

const AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderOrderIdRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderOrderIdRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskTaskIdRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskTaskIdRoute
  AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskIndexRoute
}

const AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskTaskIdRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskTaskIdRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenProcessorTokenIdRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenProcessorTokenIdRoute
  AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenIndexRoute
}

const AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenProcessorTokenIdRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenProcessorTokenIdRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobJobIdRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobJobIdRoute
  AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobIndexRoute
}

const AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobJobIdRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobJobIdRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500RouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500QuarterRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500QuarterRoute
  AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500IndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500IndexRoute
}

const AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500RouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500RouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500QuarterRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500QuarterRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500IndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500IndexRoute,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500RouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500Route._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500RouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskTaskIdRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskTaskIdRoute
  AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskIndexRoute
}

const AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskTaskIdRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskTaskIdRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobJobIdRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobJobIdRoute
  AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobIndexRoute
}

const AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobJobIdRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobJobIdRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobIndexRoute,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobRouteChildren,
  )

interface AppClearingCoreClearingRequiredClearingVendorVendorRouteChildren {
  AppClearingCoreClearingRequiredClearingVendorVendorIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIndexRoute
  AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccRouteWithChildren
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtIndexRoute
  AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetIndexRoute
  AppClearingCoreClearingRequiredClearingVendorVendorJpmIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmIndexRoute
  AppClearingCoreClearingRequiredClearingVendorVendorPlaidIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorPlaidIndexRoute
  AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaIndexRoute
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobRouteWithChildren
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskRouteWithChildren
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobRouteWithChildren
  AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskRouteWithChildren
  AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionRouteWithChildren
  AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentRouteWithChildren
  AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobRouteWithChildren
  AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskRouteWithChildren
  AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberRouteWithChildren
  AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchRouteWithChildren
  AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireRouteWithChildren
  AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationRouteWithChildren
  AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobRouteWithChildren
  AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderRouteWithChildren
  AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderRouteWithChildren
  AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskRouteWithChildren
  AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenRouteWithChildren
  AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobRouteWithChildren
  AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500Route: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500RouteWithChildren
  AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskRouteWithChildren
  AppClearingCoreClearingRequiredClearingVendorVendorJpmEmulatorIndexRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJpmEmulatorIndexRoute
  AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobRouteWithChildren
}

const AppClearingCoreClearingRequiredClearingVendorVendorRouteChildren: AppClearingCoreClearingRequiredClearingVendorVendorRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingVendorVendorIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorIndexRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorDtccDtccRouteWithChildren,
    AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtIndexRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetIndexRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorJpmIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorJpmIndexRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorPlaidIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorPlaidIndexRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaIndexRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusJobJobRouteWithChildren,
    AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProspectusTaskTaskRouteWithChildren,
    AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteJobJobRouteWithChildren,
    AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorBetaNxtProxyVoteTaskTaskRouteWithChildren,
    AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorIceCorporateActionActionRouteWithChildren,
    AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorIceInstrumentInstrumentRouteWithChildren,
    AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorIceJobJobRouteWithChildren,
    AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorIceTaskTaskRouteWithChildren,
    AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAccountNumberAccountNumberRouteWithChildren,
    AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorIncreaseAchAchRouteWithChildren,
    AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorIncreaseWireWireRouteWithChildren,
    AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorJpmDestinationDestinationRouteWithChildren,
    AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorJpmJobJobRouteWithChildren,
    AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorJpmNetOrderNetOrderRouteWithChildren,
    AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorJpmOrderOrderRouteWithChildren,
    AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorJpmTaskTaskRouteWithChildren,
    AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorPlaidProcessorTokenProcessorTokenRouteWithChildren,
    AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaJobJobRouteWithChildren,
    AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500Route:
      AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaSp500Sp500RouteWithChildren,
    AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorQuoteMediaTaskTaskRouteWithChildren,
    AppClearingCoreClearingRequiredClearingVendorVendorJpmEmulatorIndexRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorJpmEmulatorIndexRoute,
    AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorJaneStreetPfofJobJobRouteWithChildren,
  }

const AppClearingCoreClearingRequiredClearingVendorVendorRouteWithChildren =
  AppClearingCoreClearingRequiredClearingVendorVendorRoute._addFileChildren(
    AppClearingCoreClearingRequiredClearingVendorVendorRouteChildren,
  )

interface AppClearingCoreClearingRequiredRouteChildren {
  AppClearingCoreClearingRequiredClearingIndexRoute: typeof AppClearingCoreClearingRequiredClearingIndexRoute
  AppClearingCoreClearingRequiredClearingComplianceComplianceRoute: typeof AppClearingCoreClearingRequiredClearingComplianceComplianceRouteWithChildren
  AppClearingCoreClearingRequiredClearingFinanceFinanceRoute: typeof AppClearingCoreClearingRequiredClearingFinanceFinanceRouteWithChildren
  AppClearingCoreClearingRequiredClearingOperationsOperationsRoute: typeof AppClearingCoreClearingRequiredClearingOperationsOperationsRouteWithChildren
  AppClearingCoreClearingRequiredClearingVendorVendorRoute: typeof AppClearingCoreClearingRequiredClearingVendorVendorRouteWithChildren
  AppClearingCoreClearingRequiredInboxInboxIndexRoute: typeof AppClearingCoreClearingRequiredInboxInboxIndexRoute
}

const AppClearingCoreClearingRequiredRouteChildren: AppClearingCoreClearingRequiredRouteChildren =
  {
    AppClearingCoreClearingRequiredClearingIndexRoute:
      AppClearingCoreClearingRequiredClearingIndexRoute,
    AppClearingCoreClearingRequiredClearingComplianceComplianceRoute:
      AppClearingCoreClearingRequiredClearingComplianceComplianceRouteWithChildren,
    AppClearingCoreClearingRequiredClearingFinanceFinanceRoute:
      AppClearingCoreClearingRequiredClearingFinanceFinanceRouteWithChildren,
    AppClearingCoreClearingRequiredClearingOperationsOperationsRoute:
      AppClearingCoreClearingRequiredClearingOperationsOperationsRouteWithChildren,
    AppClearingCoreClearingRequiredClearingVendorVendorRoute:
      AppClearingCoreClearingRequiredClearingVendorVendorRouteWithChildren,
    AppClearingCoreClearingRequiredInboxInboxIndexRoute:
      AppClearingCoreClearingRequiredInboxInboxIndexRoute,
  }

const AppClearingCoreClearingRequiredRouteWithChildren =
  AppClearingCoreClearingRequiredRoute._addFileChildren(
    AppClearingCoreClearingRequiredRouteChildren,
  )

interface AppClearingCoreAssetAssetAssetIdDetailRouteChildren {
  AppClearingCoreAssetAssetAssetIdDetailFilingsRoute: typeof AppClearingCoreAssetAssetAssetIdDetailFilingsRoute
  AppClearingCoreAssetAssetAssetIdDetailMarketDataRoute: typeof AppClearingCoreAssetAssetAssetIdDetailMarketDataRoute
  AppClearingCoreAssetAssetAssetIdDetailIndexRoute: typeof AppClearingCoreAssetAssetAssetIdDetailIndexRoute
}

const AppClearingCoreAssetAssetAssetIdDetailRouteChildren: AppClearingCoreAssetAssetAssetIdDetailRouteChildren =
  {
    AppClearingCoreAssetAssetAssetIdDetailFilingsRoute:
      AppClearingCoreAssetAssetAssetIdDetailFilingsRoute,
    AppClearingCoreAssetAssetAssetIdDetailMarketDataRoute:
      AppClearingCoreAssetAssetAssetIdDetailMarketDataRoute,
    AppClearingCoreAssetAssetAssetIdDetailIndexRoute:
      AppClearingCoreAssetAssetAssetIdDetailIndexRoute,
  }

const AppClearingCoreAssetAssetAssetIdDetailRouteWithChildren =
  AppClearingCoreAssetAssetAssetIdDetailRoute._addFileChildren(
    AppClearingCoreAssetAssetAssetIdDetailRouteChildren,
  )

interface AppClearingCoreAssetAssetRouteChildren {
  AppClearingCoreAssetAssetIndexRoute: typeof AppClearingCoreAssetAssetIndexRoute
  AppClearingCoreAssetAssetAssetIdDetailRoute: typeof AppClearingCoreAssetAssetAssetIdDetailRouteWithChildren
}

const AppClearingCoreAssetAssetRouteChildren: AppClearingCoreAssetAssetRouteChildren =
  {
    AppClearingCoreAssetAssetIndexRoute: AppClearingCoreAssetAssetIndexRoute,
    AppClearingCoreAssetAssetAssetIdDetailRoute:
      AppClearingCoreAssetAssetAssetIdDetailRouteWithChildren,
  }

const AppClearingCoreAssetAssetRouteWithChildren =
  AppClearingCoreAssetAssetRoute._addFileChildren(
    AppClearingCoreAssetAssetRouteChildren,
  )

interface AppClearingCoreHoursHoursExceptionExceptionRouteChildren {
  AppClearingCoreHoursHoursExceptionExceptionExceptionIdRoute: typeof AppClearingCoreHoursHoursExceptionExceptionExceptionIdRoute
  AppClearingCoreHoursHoursExceptionExceptionIndexRoute: typeof AppClearingCoreHoursHoursExceptionExceptionIndexRoute
}

const AppClearingCoreHoursHoursExceptionExceptionRouteChildren: AppClearingCoreHoursHoursExceptionExceptionRouteChildren =
  {
    AppClearingCoreHoursHoursExceptionExceptionExceptionIdRoute:
      AppClearingCoreHoursHoursExceptionExceptionExceptionIdRoute,
    AppClearingCoreHoursHoursExceptionExceptionIndexRoute:
      AppClearingCoreHoursHoursExceptionExceptionIndexRoute,
  }

const AppClearingCoreHoursHoursExceptionExceptionRouteWithChildren =
  AppClearingCoreHoursHoursExceptionExceptionRoute._addFileChildren(
    AppClearingCoreHoursHoursExceptionExceptionRouteChildren,
  )

interface AppClearingCoreHoursHoursRouteChildren {
  AppClearingCoreHoursHoursIndexRoute: typeof AppClearingCoreHoursHoursIndexRoute
  AppClearingCoreHoursHoursExceptionExceptionRoute: typeof AppClearingCoreHoursHoursExceptionExceptionRouteWithChildren
  AppClearingCoreHoursHoursScheduleChar123ScheduleNameChar125Route: typeof AppClearingCoreHoursHoursScheduleChar123ScheduleNameChar125Route
}

const AppClearingCoreHoursHoursRouteChildren: AppClearingCoreHoursHoursRouteChildren =
  {
    AppClearingCoreHoursHoursIndexRoute: AppClearingCoreHoursHoursIndexRoute,
    AppClearingCoreHoursHoursExceptionExceptionRoute:
      AppClearingCoreHoursHoursExceptionExceptionRouteWithChildren,
    AppClearingCoreHoursHoursScheduleChar123ScheduleNameChar125Route:
      AppClearingCoreHoursHoursScheduleChar123ScheduleNameChar125Route,
  }

const AppClearingCoreHoursHoursRouteWithChildren =
  AppClearingCoreHoursHoursRoute._addFileChildren(
    AppClearingCoreHoursHoursRouteChildren,
  )

interface AppClearingCoreBillingChargeChargeRouteChildren {
  AppClearingCoreBillingChargeChargeChargeIdRoute: typeof AppClearingCoreBillingChargeChargeChargeIdRoute
  AppClearingCoreBillingChargeChargeIndexRoute: typeof AppClearingCoreBillingChargeChargeIndexRoute
}

const AppClearingCoreBillingChargeChargeRouteChildren: AppClearingCoreBillingChargeChargeRouteChildren =
  {
    AppClearingCoreBillingChargeChargeChargeIdRoute:
      AppClearingCoreBillingChargeChargeChargeIdRoute,
    AppClearingCoreBillingChargeChargeIndexRoute:
      AppClearingCoreBillingChargeChargeIndexRoute,
  }

const AppClearingCoreBillingChargeChargeRouteWithChildren =
  AppClearingCoreBillingChargeChargeRoute._addFileChildren(
    AppClearingCoreBillingChargeChargeRouteChildren,
  )

interface AppClearingCoreFundingAccountNumberAccountNumberRouteChildren {
  AppClearingCoreFundingAccountNumberAccountNumberAccountNumberIdRoute: typeof AppClearingCoreFundingAccountNumberAccountNumberAccountNumberIdRoute
  AppClearingCoreFundingAccountNumberAccountNumberIndexRoute: typeof AppClearingCoreFundingAccountNumberAccountNumberIndexRoute
}

const AppClearingCoreFundingAccountNumberAccountNumberRouteChildren: AppClearingCoreFundingAccountNumberAccountNumberRouteChildren =
  {
    AppClearingCoreFundingAccountNumberAccountNumberAccountNumberIdRoute:
      AppClearingCoreFundingAccountNumberAccountNumberAccountNumberIdRoute,
    AppClearingCoreFundingAccountNumberAccountNumberIndexRoute:
      AppClearingCoreFundingAccountNumberAccountNumberIndexRoute,
  }

const AppClearingCoreFundingAccountNumberAccountNumberRouteWithChildren =
  AppClearingCoreFundingAccountNumberAccountNumberRoute._addFileChildren(
    AppClearingCoreFundingAccountNumberAccountNumberRouteChildren,
  )

interface AppClearingCoreFundingBatchTransferBatchTransferRouteChildren {
  AppClearingCoreFundingBatchTransferBatchTransferBatchTransferIdRoute: typeof AppClearingCoreFundingBatchTransferBatchTransferBatchTransferIdRoute
  AppClearingCoreFundingBatchTransferBatchTransferIndexRoute: typeof AppClearingCoreFundingBatchTransferBatchTransferIndexRoute
}

const AppClearingCoreFundingBatchTransferBatchTransferRouteChildren: AppClearingCoreFundingBatchTransferBatchTransferRouteChildren =
  {
    AppClearingCoreFundingBatchTransferBatchTransferBatchTransferIdRoute:
      AppClearingCoreFundingBatchTransferBatchTransferBatchTransferIdRoute,
    AppClearingCoreFundingBatchTransferBatchTransferIndexRoute:
      AppClearingCoreFundingBatchTransferBatchTransferIndexRoute,
  }

const AppClearingCoreFundingBatchTransferBatchTransferRouteWithChildren =
  AppClearingCoreFundingBatchTransferBatchTransferRoute._addFileChildren(
    AppClearingCoreFundingBatchTransferBatchTransferRouteChildren,
  )

interface AppClearingCoreFundingSourceSourceRouteChildren {
  AppClearingCoreFundingSourceSourceSourceIdRoute: typeof AppClearingCoreFundingSourceSourceSourceIdRoute
  AppClearingCoreFundingSourceSourceIndexRoute: typeof AppClearingCoreFundingSourceSourceIndexRoute
}

const AppClearingCoreFundingSourceSourceRouteChildren: AppClearingCoreFundingSourceSourceRouteChildren =
  {
    AppClearingCoreFundingSourceSourceSourceIdRoute:
      AppClearingCoreFundingSourceSourceSourceIdRoute,
    AppClearingCoreFundingSourceSourceIndexRoute:
      AppClearingCoreFundingSourceSourceIndexRoute,
  }

const AppClearingCoreFundingSourceSourceRouteWithChildren =
  AppClearingCoreFundingSourceSourceRoute._addFileChildren(
    AppClearingCoreFundingSourceSourceRouteChildren,
  )

interface AppClearingCoreFundingTransferTransferRouteChildren {
  AppClearingCoreFundingTransferTransferTransferIdRoute: typeof AppClearingCoreFundingTransferTransferTransferIdRoute
  AppClearingCoreFundingTransferTransferIndexRoute: typeof AppClearingCoreFundingTransferTransferIndexRoute
}

const AppClearingCoreFundingTransferTransferRouteChildren: AppClearingCoreFundingTransferTransferRouteChildren =
  {
    AppClearingCoreFundingTransferTransferTransferIdRoute:
      AppClearingCoreFundingTransferTransferTransferIdRoute,
    AppClearingCoreFundingTransferTransferIndexRoute:
      AppClearingCoreFundingTransferTransferIndexRoute,
  }

const AppClearingCoreFundingTransferTransferRouteWithChildren =
  AppClearingCoreFundingTransferTransferRoute._addFileChildren(
    AppClearingCoreFundingTransferTransferRouteChildren,
  )

interface AppClearingCoreOrderEquitySingleRouteChildren {
  AppClearingCoreOrderEquitySingleOrderIdRoute: typeof AppClearingCoreOrderEquitySingleOrderIdRoute
  AppClearingCoreOrderEquitySingleIndexRoute: typeof AppClearingCoreOrderEquitySingleIndexRoute
}

const AppClearingCoreOrderEquitySingleRouteChildren: AppClearingCoreOrderEquitySingleRouteChildren =
  {
    AppClearingCoreOrderEquitySingleOrderIdRoute:
      AppClearingCoreOrderEquitySingleOrderIdRoute,
    AppClearingCoreOrderEquitySingleIndexRoute:
      AppClearingCoreOrderEquitySingleIndexRoute,
  }

const AppClearingCoreOrderEquitySingleRouteWithChildren =
  AppClearingCoreOrderEquitySingleRoute._addFileChildren(
    AppClearingCoreOrderEquitySingleRouteChildren,
  )

interface AppClearingCoreOrderMutualFundMutualFundRouteChildren {
  AppClearingCoreOrderMutualFundMutualFundFundOrderIdRoute: typeof AppClearingCoreOrderMutualFundMutualFundFundOrderIdRoute
  AppClearingCoreOrderMutualFundMutualFundIndexRoute: typeof AppClearingCoreOrderMutualFundMutualFundIndexRoute
}

const AppClearingCoreOrderMutualFundMutualFundRouteChildren: AppClearingCoreOrderMutualFundMutualFundRouteChildren =
  {
    AppClearingCoreOrderMutualFundMutualFundFundOrderIdRoute:
      AppClearingCoreOrderMutualFundMutualFundFundOrderIdRoute,
    AppClearingCoreOrderMutualFundMutualFundIndexRoute:
      AppClearingCoreOrderMutualFundMutualFundIndexRoute,
  }

const AppClearingCoreOrderMutualFundMutualFundRouteWithChildren =
  AppClearingCoreOrderMutualFundMutualFundRoute._addFileChildren(
    AppClearingCoreOrderMutualFundMutualFundRouteChildren,
  )

interface AppClearingCoreRegistrationProfileProfileProfileIdEditEditRouteChildren {
  AppClearingCoreRegistrationProfileProfileProfileIdEditEditReviewRoute: typeof AppClearingCoreRegistrationProfileProfileProfileIdEditEditReviewRoute
  AppClearingCoreRegistrationProfileProfileProfileIdEditEditIndexRoute: typeof AppClearingCoreRegistrationProfileProfileProfileIdEditEditIndexRoute
}

const AppClearingCoreRegistrationProfileProfileProfileIdEditEditRouteChildren: AppClearingCoreRegistrationProfileProfileProfileIdEditEditRouteChildren =
  {
    AppClearingCoreRegistrationProfileProfileProfileIdEditEditReviewRoute:
      AppClearingCoreRegistrationProfileProfileProfileIdEditEditReviewRoute,
    AppClearingCoreRegistrationProfileProfileProfileIdEditEditIndexRoute:
      AppClearingCoreRegistrationProfileProfileProfileIdEditEditIndexRoute,
  }

const AppClearingCoreRegistrationProfileProfileProfileIdEditEditRouteWithChildren =
  AppClearingCoreRegistrationProfileProfileProfileIdEditEditRoute._addFileChildren(
    AppClearingCoreRegistrationProfileProfileProfileIdEditEditRouteChildren,
  )

interface AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateRouteChildren {
  AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateReviewRoute: typeof AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateReviewRoute
  AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateIndexRoute: typeof AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateIndexRoute
}

const AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateRouteChildren: AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateRouteChildren =
  {
    AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateReviewRoute:
      AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateReviewRoute,
    AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateIndexRoute:
      AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateIndexRoute,
  }

const AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateRouteWithChildren =
  AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateRoute._addFileChildren(
    AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateRouteChildren,
  )

interface AppClearingCoreRegistrationProfileProfileRouteChildren {
  AppClearingCoreRegistrationProfileProfileIndexRoute: typeof AppClearingCoreRegistrationProfileProfileIndexRoute
  AppClearingCoreRegistrationProfileProfileProfileIdIndexRoute: typeof AppClearingCoreRegistrationProfileProfileProfileIdIndexRoute
  AppClearingCoreRegistrationProfileProfileProfileIdEditEditRoute: typeof AppClearingCoreRegistrationProfileProfileProfileIdEditEditRouteWithChildren
  AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateRoute: typeof AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateRouteWithChildren
}

const AppClearingCoreRegistrationProfileProfileRouteChildren: AppClearingCoreRegistrationProfileProfileRouteChildren =
  {
    AppClearingCoreRegistrationProfileProfileIndexRoute:
      AppClearingCoreRegistrationProfileProfileIndexRoute,
    AppClearingCoreRegistrationProfileProfileProfileIdIndexRoute:
      AppClearingCoreRegistrationProfileProfileProfileIdIndexRoute,
    AppClearingCoreRegistrationProfileProfileProfileIdEditEditRoute:
      AppClearingCoreRegistrationProfileProfileProfileIdEditEditRouteWithChildren,
    AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateRoute:
      AppClearingCoreRegistrationProfileProfileCreateProfileTypeCreateRouteWithChildren,
  }

const AppClearingCoreRegistrationProfileProfileRouteWithChildren =
  AppClearingCoreRegistrationProfileProfileRoute._addFileChildren(
    AppClearingCoreRegistrationProfileProfileRouteChildren,
  )

interface AppClearingCoreSweepCutoffCutoffRouteChildren {
  AppClearingCoreSweepCutoffCutoffIndexRoute: typeof AppClearingCoreSweepCutoffCutoffIndexRoute
}

const AppClearingCoreSweepCutoffCutoffRouteChildren: AppClearingCoreSweepCutoffCutoffRouteChildren =
  {
    AppClearingCoreSweepCutoffCutoffIndexRoute:
      AppClearingCoreSweepCutoffCutoffIndexRoute,
  }

const AppClearingCoreSweepCutoffCutoffRouteWithChildren =
  AppClearingCoreSweepCutoffCutoffRoute._addFileChildren(
    AppClearingCoreSweepCutoffCutoffRouteChildren,
  )

interface AppClearingCoreSweepPlanPlanRouteChildren {
  AppClearingCoreSweepPlanPlanSweepPlanIdRoute: typeof AppClearingCoreSweepPlanPlanSweepPlanIdRoute
  AppClearingCoreSweepPlanPlanIndexRoute: typeof AppClearingCoreSweepPlanPlanIndexRoute
}

const AppClearingCoreSweepPlanPlanRouteChildren: AppClearingCoreSweepPlanPlanRouteChildren =
  {
    AppClearingCoreSweepPlanPlanSweepPlanIdRoute:
      AppClearingCoreSweepPlanPlanSweepPlanIdRoute,
    AppClearingCoreSweepPlanPlanIndexRoute:
      AppClearingCoreSweepPlanPlanIndexRoute,
  }

const AppClearingCoreSweepPlanPlanRouteWithChildren =
  AppClearingCoreSweepPlanPlanRoute._addFileChildren(
    AppClearingCoreSweepPlanPlanRouteChildren,
  )

interface AppClearingCoreSweepTargetTargetRouteChildren {
  AppClearingCoreSweepTargetTargetSweepTargetIdRoute: typeof AppClearingCoreSweepTargetTargetSweepTargetIdRoute
  AppClearingCoreSweepTargetTargetIndexRoute: typeof AppClearingCoreSweepTargetTargetIndexRoute
}

const AppClearingCoreSweepTargetTargetRouteChildren: AppClearingCoreSweepTargetTargetRouteChildren =
  {
    AppClearingCoreSweepTargetTargetSweepTargetIdRoute:
      AppClearingCoreSweepTargetTargetSweepTargetIdRoute,
    AppClearingCoreSweepTargetTargetIndexRoute:
      AppClearingCoreSweepTargetTargetIndexRoute,
  }

const AppClearingCoreSweepTargetTargetRouteWithChildren =
  AppClearingCoreSweepTargetTargetRoute._addFileChildren(
    AppClearingCoreSweepTargetTargetRouteChildren,
  )

interface AppClearingCoreOrderEquityBatchBatchRouteChildren {
  AppClearingCoreOrderEquityBatchBatchBatchOrderIdRoute: typeof AppClearingCoreOrderEquityBatchBatchBatchOrderIdRoute
  AppClearingCoreOrderEquityBatchBatchIndexRoute: typeof AppClearingCoreOrderEquityBatchBatchIndexRoute
}

const AppClearingCoreOrderEquityBatchBatchRouteChildren: AppClearingCoreOrderEquityBatchBatchRouteChildren =
  {
    AppClearingCoreOrderEquityBatchBatchBatchOrderIdRoute:
      AppClearingCoreOrderEquityBatchBatchBatchOrderIdRoute,
    AppClearingCoreOrderEquityBatchBatchIndexRoute:
      AppClearingCoreOrderEquityBatchBatchIndexRoute,
  }

const AppClearingCoreOrderEquityBatchBatchRouteWithChildren =
  AppClearingCoreOrderEquityBatchBatchRoute._addFileChildren(
    AppClearingCoreOrderEquityBatchBatchRouteChildren,
  )

interface AppClearingCoreRegistrationAccountAccountIdAccountOverviewRouteChildren {
  AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailBeneficiariesRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailBeneficiariesRoute
  AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailClearingControlsRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailClearingControlsRoute
  AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailControlsRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailControlsRoute
  AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailRiskRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailRiskRoute
  AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailIndexRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailIndexRoute
}

const AppClearingCoreRegistrationAccountAccountIdAccountOverviewRouteChildren: AppClearingCoreRegistrationAccountAccountIdAccountOverviewRouteChildren =
  {
    AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailBeneficiariesRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailBeneficiariesRoute,
    AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailClearingControlsRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailClearingControlsRoute,
    AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailControlsRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailControlsRoute,
    AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailRiskRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailRiskRoute,
    AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailIndexRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountOverviewDetailIndexRoute,
  }

const AppClearingCoreRegistrationAccountAccountIdAccountOverviewRouteWithChildren =
  AppClearingCoreRegistrationAccountAccountIdAccountOverviewRoute._addFileChildren(
    AppClearingCoreRegistrationAccountAccountIdAccountOverviewRouteChildren,
  )

interface AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderRouteChildren {
  AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderEquityRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderEquityRoute
  AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderMutualFundRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderMutualFundRoute
  AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderIndexRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderIndexRoute
}

const AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderRouteChildren: AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderRouteChildren =
  {
    AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderEquityRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderEquityRoute,
    AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderMutualFundRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderMutualFundRoute,
    AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderIndexRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderIndexRoute,
  }

const AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderRouteWithChildren =
  AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderRoute._addFileChildren(
    AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderRouteChildren,
  )

interface AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRouteChildren {
  AppClearingCoreRegistrationAccountAccountIdAccountSummaryListAssetRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListAssetRoute
  AppClearingCoreRegistrationAccountAccountIdAccountSummaryListFundingRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListFundingRoute
  AppClearingCoreRegistrationAccountAccountIdAccountSummaryListHoldRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListHoldRoute
  AppClearingCoreRegistrationAccountAccountIdAccountSummaryListTransactionRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListTransactionRoute
  AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderRouteWithChildren
}

const AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRouteChildren: AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRouteChildren =
  {
    AppClearingCoreRegistrationAccountAccountIdAccountSummaryListAssetRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountSummaryListAssetRoute,
    AppClearingCoreRegistrationAccountAccountIdAccountSummaryListFundingRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountSummaryListFundingRoute,
    AppClearingCoreRegistrationAccountAccountIdAccountSummaryListHoldRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountSummaryListHoldRoute,
    AppClearingCoreRegistrationAccountAccountIdAccountSummaryListTransactionRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountSummaryListTransactionRoute,
    AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountSummaryListOrderOrderRouteWithChildren,
  }

const AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRouteWithChildren =
  AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRoute._addFileChildren(
    AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRouteChildren,
  )

interface AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableRouteChildren {
  AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableIndexRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableIndexRoute
}

const AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableRouteChildren: AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableRouteChildren =
  {
    AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableIndexRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableIndexRoute,
  }

const AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableRouteWithChildren =
  AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableRoute._addFileChildren(
    AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableRouteChildren,
  )

interface AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRouteChildren {
  AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceFundingRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceFundingRoute
  AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceHoldRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceHoldRoute
  AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceIndexRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceIndexRoute
  AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRealizationIndexRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRealizationIndexRoute
  AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceTaxLotIndexRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceTaxLotIndexRoute
}

const AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRouteChildren: AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRouteChildren =
  {
    AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceFundingRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceFundingRoute,
    AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceHoldRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceHoldRoute,
    AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceIndexRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceIndexRoute,
    AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRealizationIndexRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRealizationIndexRoute,
    AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceTaxLotIndexRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceTaxLotIndexRoute,
  }

const AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRouteWithChildren =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRoute._addFileChildren(
    AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRouteChildren,
  )

interface AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetRouteChildren {
  AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRouteWithChildren
}

const AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetRouteChildren: AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetRouteChildren =
  {
    AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetAssetIdAssetBalanceRouteWithChildren,
  }

const AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetRouteWithChildren =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetRoute._addFileChildren(
    AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetRouteChildren,
  )

interface AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionRouteChildren {
  AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionTransactionIdRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionTransactionIdRoute
  AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionIndexRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionIndexRoute
}

const AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionRouteChildren: AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionRouteChildren =
  {
    AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionTransactionIdRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionTransactionIdRoute,
    AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionIndexRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionIndexRoute,
  }

const AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionRouteWithChildren =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionRoute._addFileChildren(
    AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionRouteChildren,
  )

interface AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashRouteChildren {
  AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashIndexRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashIndexRoute
  AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashSweepAssetIdRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashSweepAssetIdRoute
  AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionRouteWithChildren
}

const AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashRouteChildren: AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashRouteChildren =
  {
    AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashIndexRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashIndexRoute,
    AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashSweepAssetIdRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashSweepAssetIdRoute,
    AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashTransactionTransactionRouteWithChildren,
  }

const AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashRouteWithChildren =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashRoute._addFileChildren(
    AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashRouteChildren,
  )

interface AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentRouteChildren {
  AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentTaxRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentTaxRoute
  AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentTradeConfirmationRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentTradeConfirmationRoute
  AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentIndexRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentIndexRoute
}

const AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentRouteChildren: AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentRouteChildren =
  {
    AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentTaxRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentTaxRoute,
    AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentTradeConfirmationRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentTradeConfirmationRoute,
    AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentIndexRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentIndexRoute,
  }

const AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentRouteWithChildren =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentRoute._addFileChildren(
    AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentRouteChildren,
  )

interface AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingRouteChildren {
  AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingSourceSourceIdRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingSourceSourceIdRoute
  AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingTransferTransferIdRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingTransferTransferIdRoute
  AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingSourceIndexRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingSourceIndexRoute
  AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingTransferIndexRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingTransferIndexRoute
}

const AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingRouteChildren: AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingRouteChildren =
  {
    AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingSourceSourceIdRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingSourceSourceIdRoute,
    AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingTransferTransferIdRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingTransferTransferIdRoute,
    AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingSourceIndexRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingSourceIndexRoute,
    AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingTransferIndexRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingTransferIndexRoute,
  }

const AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingRouteWithChildren =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingRoute._addFileChildren(
    AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingRouteChildren,
  )

interface AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldRouteChildren {
  AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldHoldIdRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldHoldIdRoute
}

const AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldRouteChildren: AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldRouteChildren =
  {
    AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldHoldIdRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldHoldIdRoute,
  }

const AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldRouteWithChildren =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldRoute._addFileChildren(
    AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldRouteChildren,
  )

interface AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionRouteChildren {
  AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionTransactionIdRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionTransactionIdRoute
}

const AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionRouteChildren: AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionRouteChildren =
  {
    AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionTransactionIdRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionTransactionIdRoute,
  }

const AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionRouteWithChildren =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionRoute._addFileChildren(
    AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionRouteChildren,
  )

interface AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityRouteChildren {
  AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityOrderIdRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityOrderIdRoute
}

const AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityRouteChildren: AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityRouteChildren =
  {
    AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityOrderIdRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityOrderIdRoute,
  }

const AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityRouteWithChildren =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityRoute._addFileChildren(
    AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityRouteChildren,
  )

interface AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundRouteChildren {
  AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundFundOrderIdRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundFundOrderIdRoute
}

const AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundRouteChildren: AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundRouteChildren =
  {
    AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundFundOrderIdRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundFundOrderIdRoute,
  }

const AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundRouteWithChildren =
  AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundRoute._addFileChildren(
    AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundRouteChildren,
  )

interface AppClearingCoreRegistrationAccountAccountIdAccountRouteChildren {
  AppClearingCoreRegistrationAccountAccountIdAccountOverviewRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountOverviewRouteWithChildren
  AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRouteWithChildren
  AppClearingCoreRegistrationAccountAccountIdAccountIndexRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountIndexRoute
  AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableRouteWithChildren
  AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetRouteWithChildren
  AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashRouteWithChildren
  AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentRouteWithChildren
  AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingRouteWithChildren
  AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldRouteWithChildren
  AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionRouteWithChildren
  AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityRouteWithChildren
  AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundRouteWithChildren
  AppClearingCoreRegistrationAccountAccountIdAccountCostBasisAssetAssetIdRealizationRealizationIdRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountCostBasisAssetAssetIdRealizationRealizationIdRoute
  AppClearingCoreRegistrationAccountAccountIdAccountCostBasisAssetAssetIdTaxLotTaxLotIdRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountCostBasisAssetAssetIdTaxLotTaxLotIdRoute
}

const AppClearingCoreRegistrationAccountAccountIdAccountRouteChildren: AppClearingCoreRegistrationAccountAccountIdAccountRouteChildren =
  {
    AppClearingCoreRegistrationAccountAccountIdAccountOverviewRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountOverviewRouteWithChildren,
    AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountSummaryListRouteWithChildren,
    AppClearingCoreRegistrationAccountAccountIdAccountIndexRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountIndexRoute,
    AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDividendsReceivableDividendsReceivableRouteWithChildren,
    AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailAssetAssetRouteWithChildren,
    AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailCashCashRouteWithChildren,
    AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailDocumentDocumentRouteWithChildren,
    AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailFundingFundingRouteWithChildren,
    AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailHoldHoldRouteWithChildren,
    AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailTransactionTransactionRouteWithChildren,
    AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderEquityEquityRouteWithChildren,
    AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountDetailOrderMutualFundMutualFundRouteWithChildren,
    AppClearingCoreRegistrationAccountAccountIdAccountCostBasisAssetAssetIdRealizationRealizationIdRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountCostBasisAssetAssetIdRealizationRealizationIdRoute,
    AppClearingCoreRegistrationAccountAccountIdAccountCostBasisAssetAssetIdTaxLotTaxLotIdRoute:
      AppClearingCoreRegistrationAccountAccountIdAccountCostBasisAssetAssetIdTaxLotTaxLotIdRoute,
  }

const AppClearingCoreRegistrationAccountAccountIdAccountRouteWithChildren =
  AppClearingCoreRegistrationAccountAccountIdAccountRoute._addFileChildren(
    AppClearingCoreRegistrationAccountAccountIdAccountRouteChildren,
  )

interface AppClearingCoreRouteChildren {
  AppClearingCoreClearingRequiredRoute: typeof AppClearingCoreClearingRequiredRouteWithChildren
  AppClearingCoreAssetAssetRoute: typeof AppClearingCoreAssetAssetRouteWithChildren
  AppClearingCoreHoursHoursRoute: typeof AppClearingCoreHoursHoursRouteWithChildren
  AppClearingCoreBillingIndexRoute: typeof AppClearingCoreBillingIndexRoute
  AppClearingCoreDashboardIndexRoute: typeof AppClearingCoreDashboardIndexRoute
  AppClearingCoreFundingIndexRoute: typeof AppClearingCoreFundingIndexRoute
  AppClearingCoreOrderIndexRoute: typeof AppClearingCoreOrderIndexRoute
  AppClearingCoreRegistrationIndexRoute: typeof AppClearingCoreRegistrationIndexRoute
  AppClearingCoreSweepIndexRoute: typeof AppClearingCoreSweepIndexRoute
  AppClearingCoreBillingChargeChargeRoute: typeof AppClearingCoreBillingChargeChargeRouteWithChildren
  AppClearingCoreFundingAccountNumberAccountNumberRoute: typeof AppClearingCoreFundingAccountNumberAccountNumberRouteWithChildren
  AppClearingCoreFundingBatchTransferBatchTransferRoute: typeof AppClearingCoreFundingBatchTransferBatchTransferRouteWithChildren
  AppClearingCoreFundingSourceSourceRoute: typeof AppClearingCoreFundingSourceSourceRouteWithChildren
  AppClearingCoreFundingTransferTransferRoute: typeof AppClearingCoreFundingTransferTransferRouteWithChildren
  AppClearingCoreOrderEquitySingleRoute: typeof AppClearingCoreOrderEquitySingleRouteWithChildren
  AppClearingCoreOrderMutualFundMutualFundRoute: typeof AppClearingCoreOrderMutualFundMutualFundRouteWithChildren
  AppClearingCoreRegistrationProfileProfileRoute: typeof AppClearingCoreRegistrationProfileProfileRouteWithChildren
  AppClearingCoreSweepCutoffCutoffRoute: typeof AppClearingCoreSweepCutoffCutoffRouteWithChildren
  AppClearingCoreSweepPlanPlanRoute: typeof AppClearingCoreSweepPlanPlanRouteWithChildren
  AppClearingCoreSweepTargetTargetRoute: typeof AppClearingCoreSweepTargetTargetRouteWithChildren
  AppClearingCoreRegistrationAccountIndexRoute: typeof AppClearingCoreRegistrationAccountIndexRoute
  AppClearingCoreOrderEquityBatchBatchRoute: typeof AppClearingCoreOrderEquityBatchBatchRouteWithChildren
  AppClearingCoreRegistrationAccountAccountIdAccountRoute: typeof AppClearingCoreRegistrationAccountAccountIdAccountRouteWithChildren
}

const AppClearingCoreRouteChildren: AppClearingCoreRouteChildren = {
  AppClearingCoreClearingRequiredRoute:
    AppClearingCoreClearingRequiredRouteWithChildren,
  AppClearingCoreAssetAssetRoute: AppClearingCoreAssetAssetRouteWithChildren,
  AppClearingCoreHoursHoursRoute: AppClearingCoreHoursHoursRouteWithChildren,
  AppClearingCoreBillingIndexRoute: AppClearingCoreBillingIndexRoute,
  AppClearingCoreDashboardIndexRoute: AppClearingCoreDashboardIndexRoute,
  AppClearingCoreFundingIndexRoute: AppClearingCoreFundingIndexRoute,
  AppClearingCoreOrderIndexRoute: AppClearingCoreOrderIndexRoute,
  AppClearingCoreRegistrationIndexRoute: AppClearingCoreRegistrationIndexRoute,
  AppClearingCoreSweepIndexRoute: AppClearingCoreSweepIndexRoute,
  AppClearingCoreBillingChargeChargeRoute:
    AppClearingCoreBillingChargeChargeRouteWithChildren,
  AppClearingCoreFundingAccountNumberAccountNumberRoute:
    AppClearingCoreFundingAccountNumberAccountNumberRouteWithChildren,
  AppClearingCoreFundingBatchTransferBatchTransferRoute:
    AppClearingCoreFundingBatchTransferBatchTransferRouteWithChildren,
  AppClearingCoreFundingSourceSourceRoute:
    AppClearingCoreFundingSourceSourceRouteWithChildren,
  AppClearingCoreFundingTransferTransferRoute:
    AppClearingCoreFundingTransferTransferRouteWithChildren,
  AppClearingCoreOrderEquitySingleRoute:
    AppClearingCoreOrderEquitySingleRouteWithChildren,
  AppClearingCoreOrderMutualFundMutualFundRoute:
    AppClearingCoreOrderMutualFundMutualFundRouteWithChildren,
  AppClearingCoreRegistrationProfileProfileRoute:
    AppClearingCoreRegistrationProfileProfileRouteWithChildren,
  AppClearingCoreSweepCutoffCutoffRoute:
    AppClearingCoreSweepCutoffCutoffRouteWithChildren,
  AppClearingCoreSweepPlanPlanRoute:
    AppClearingCoreSweepPlanPlanRouteWithChildren,
  AppClearingCoreSweepTargetTargetRoute:
    AppClearingCoreSweepTargetTargetRouteWithChildren,
  AppClearingCoreRegistrationAccountIndexRoute:
    AppClearingCoreRegistrationAccountIndexRoute,
  AppClearingCoreOrderEquityBatchBatchRoute:
    AppClearingCoreOrderEquityBatchBatchRouteWithChildren,
  AppClearingCoreRegistrationAccountAccountIdAccountRoute:
    AppClearingCoreRegistrationAccountAccountIdAccountRouteWithChildren,
}

const AppClearingCoreRouteWithChildren = AppClearingCoreRoute._addFileChildren(
  AppClearingCoreRouteChildren,
)

interface AppO5O5RequiredTechOpsClusterClusterRouteChildren {
  AppO5O5RequiredTechOpsClusterClusterClusterIdRoute: typeof AppO5O5RequiredTechOpsClusterClusterClusterIdRoute
  AppO5O5RequiredTechOpsClusterClusterIndexRoute: typeof AppO5O5RequiredTechOpsClusterClusterIndexRoute
}

const AppO5O5RequiredTechOpsClusterClusterRouteChildren: AppO5O5RequiredTechOpsClusterClusterRouteChildren =
  {
    AppO5O5RequiredTechOpsClusterClusterClusterIdRoute:
      AppO5O5RequiredTechOpsClusterClusterClusterIdRoute,
    AppO5O5RequiredTechOpsClusterClusterIndexRoute:
      AppO5O5RequiredTechOpsClusterClusterIndexRoute,
  }

const AppO5O5RequiredTechOpsClusterClusterRouteWithChildren =
  AppO5O5RequiredTechOpsClusterClusterRoute._addFileChildren(
    AppO5O5RequiredTechOpsClusterClusterRouteChildren,
  )

interface AppO5O5RequiredTechOpsDeadMessageDeadMessageRouteChildren {
  AppO5O5RequiredTechOpsDeadMessageDeadMessageMessageIdRoute: typeof AppO5O5RequiredTechOpsDeadMessageDeadMessageMessageIdRoute
  AppO5O5RequiredTechOpsDeadMessageDeadMessageIndexRoute: typeof AppO5O5RequiredTechOpsDeadMessageDeadMessageIndexRoute
}

const AppO5O5RequiredTechOpsDeadMessageDeadMessageRouteChildren: AppO5O5RequiredTechOpsDeadMessageDeadMessageRouteChildren =
  {
    AppO5O5RequiredTechOpsDeadMessageDeadMessageMessageIdRoute:
      AppO5O5RequiredTechOpsDeadMessageDeadMessageMessageIdRoute,
    AppO5O5RequiredTechOpsDeadMessageDeadMessageIndexRoute:
      AppO5O5RequiredTechOpsDeadMessageDeadMessageIndexRoute,
  }

const AppO5O5RequiredTechOpsDeadMessageDeadMessageRouteWithChildren =
  AppO5O5RequiredTechOpsDeadMessageDeadMessageRoute._addFileChildren(
    AppO5O5RequiredTechOpsDeadMessageDeadMessageRouteChildren,
  )

interface AppO5O5RequiredTechOpsDeploymentDeploymentRouteChildren {
  AppO5O5RequiredTechOpsDeploymentDeploymentDeploymentIdRoute: typeof AppO5O5RequiredTechOpsDeploymentDeploymentDeploymentIdRoute
  AppO5O5RequiredTechOpsDeploymentDeploymentIndexRoute: typeof AppO5O5RequiredTechOpsDeploymentDeploymentIndexRoute
}

const AppO5O5RequiredTechOpsDeploymentDeploymentRouteChildren: AppO5O5RequiredTechOpsDeploymentDeploymentRouteChildren =
  {
    AppO5O5RequiredTechOpsDeploymentDeploymentDeploymentIdRoute:
      AppO5O5RequiredTechOpsDeploymentDeploymentDeploymentIdRoute,
    AppO5O5RequiredTechOpsDeploymentDeploymentIndexRoute:
      AppO5O5RequiredTechOpsDeploymentDeploymentIndexRoute,
  }

const AppO5O5RequiredTechOpsDeploymentDeploymentRouteWithChildren =
  AppO5O5RequiredTechOpsDeploymentDeploymentRoute._addFileChildren(
    AppO5O5RequiredTechOpsDeploymentDeploymentRouteChildren,
  )

interface AppO5O5RequiredTechOpsEnvironmentEnvironmentRouteChildren {
  AppO5O5RequiredTechOpsEnvironmentEnvironmentEnvironmentIdRoute: typeof AppO5O5RequiredTechOpsEnvironmentEnvironmentEnvironmentIdRoute
  AppO5O5RequiredTechOpsEnvironmentEnvironmentIndexRoute: typeof AppO5O5RequiredTechOpsEnvironmentEnvironmentIndexRoute
}

const AppO5O5RequiredTechOpsEnvironmentEnvironmentRouteChildren: AppO5O5RequiredTechOpsEnvironmentEnvironmentRouteChildren =
  {
    AppO5O5RequiredTechOpsEnvironmentEnvironmentEnvironmentIdRoute:
      AppO5O5RequiredTechOpsEnvironmentEnvironmentEnvironmentIdRoute,
    AppO5O5RequiredTechOpsEnvironmentEnvironmentIndexRoute:
      AppO5O5RequiredTechOpsEnvironmentEnvironmentIndexRoute,
  }

const AppO5O5RequiredTechOpsEnvironmentEnvironmentRouteWithChildren =
  AppO5O5RequiredTechOpsEnvironmentEnvironmentRoute._addFileChildren(
    AppO5O5RequiredTechOpsEnvironmentEnvironmentRouteChildren,
  )

interface AppO5O5RequiredTechOpsStackStackRouteChildren {
  AppO5O5RequiredTechOpsStackStackStackIdRoute: typeof AppO5O5RequiredTechOpsStackStackStackIdRoute
  AppO5O5RequiredTechOpsStackStackIndexRoute: typeof AppO5O5RequiredTechOpsStackStackIndexRoute
}

const AppO5O5RequiredTechOpsStackStackRouteChildren: AppO5O5RequiredTechOpsStackStackRouteChildren =
  {
    AppO5O5RequiredTechOpsStackStackStackIdRoute:
      AppO5O5RequiredTechOpsStackStackStackIdRoute,
    AppO5O5RequiredTechOpsStackStackIndexRoute:
      AppO5O5RequiredTechOpsStackStackIndexRoute,
  }

const AppO5O5RequiredTechOpsStackStackRouteWithChildren =
  AppO5O5RequiredTechOpsStackStackRoute._addFileChildren(
    AppO5O5RequiredTechOpsStackStackRouteChildren,
  )

interface AppO5O5RequiredTechOpsTestRunTestRunRouteChildren {
  AppO5O5RequiredTechOpsTestRunTestRunIndexRoute: typeof AppO5O5RequiredTechOpsTestRunTestRunIndexRoute
  AppO5O5RequiredTechOpsTestRunTestRunEnvironmentTestRunIdRoute: typeof AppO5O5RequiredTechOpsTestRunTestRunEnvironmentTestRunIdRoute
  AppO5O5RequiredTechOpsTestRunTestRunEnvironmentIndexRoute: typeof AppO5O5RequiredTechOpsTestRunTestRunEnvironmentIndexRoute
}

const AppO5O5RequiredTechOpsTestRunTestRunRouteChildren: AppO5O5RequiredTechOpsTestRunTestRunRouteChildren =
  {
    AppO5O5RequiredTechOpsTestRunTestRunIndexRoute:
      AppO5O5RequiredTechOpsTestRunTestRunIndexRoute,
    AppO5O5RequiredTechOpsTestRunTestRunEnvironmentTestRunIdRoute:
      AppO5O5RequiredTechOpsTestRunTestRunEnvironmentTestRunIdRoute,
    AppO5O5RequiredTechOpsTestRunTestRunEnvironmentIndexRoute:
      AppO5O5RequiredTechOpsTestRunTestRunEnvironmentIndexRoute,
  }

const AppO5O5RequiredTechOpsTestRunTestRunRouteWithChildren =
  AppO5O5RequiredTechOpsTestRunTestRunRoute._addFileChildren(
    AppO5O5RequiredTechOpsTestRunTestRunRouteChildren,
  )

interface AppO5O5RequiredTechOpsTriggerTriggerRouteChildren {
  AppO5O5RequiredTechOpsTriggerTriggerTriggerIdRoute: typeof AppO5O5RequiredTechOpsTriggerTriggerTriggerIdRoute
  AppO5O5RequiredTechOpsTriggerTriggerIndexRoute: typeof AppO5O5RequiredTechOpsTriggerTriggerIndexRoute
}

const AppO5O5RequiredTechOpsTriggerTriggerRouteChildren: AppO5O5RequiredTechOpsTriggerTriggerRouteChildren =
  {
    AppO5O5RequiredTechOpsTriggerTriggerTriggerIdRoute:
      AppO5O5RequiredTechOpsTriggerTriggerTriggerIdRoute,
    AppO5O5RequiredTechOpsTriggerTriggerIndexRoute:
      AppO5O5RequiredTechOpsTriggerTriggerIndexRoute,
  }

const AppO5O5RequiredTechOpsTriggerTriggerRouteWithChildren =
  AppO5O5RequiredTechOpsTriggerTriggerRoute._addFileChildren(
    AppO5O5RequiredTechOpsTriggerTriggerRouteChildren,
  )

interface AppO5O5RequiredTechOpsBuildRepoRepoRouteChildren {
  AppO5O5RequiredTechOpsBuildRepoRepoIndexRoute: typeof AppO5O5RequiredTechOpsBuildRepoRepoIndexRoute
  AppO5O5RequiredTechOpsBuildRepoRepoOwnerNameRoute: typeof AppO5O5RequiredTechOpsBuildRepoRepoOwnerNameRoute
}

const AppO5O5RequiredTechOpsBuildRepoRepoRouteChildren: AppO5O5RequiredTechOpsBuildRepoRepoRouteChildren =
  {
    AppO5O5RequiredTechOpsBuildRepoRepoIndexRoute:
      AppO5O5RequiredTechOpsBuildRepoRepoIndexRoute,
    AppO5O5RequiredTechOpsBuildRepoRepoOwnerNameRoute:
      AppO5O5RequiredTechOpsBuildRepoRepoOwnerNameRoute,
  }

const AppO5O5RequiredTechOpsBuildRepoRepoRouteWithChildren =
  AppO5O5RequiredTechOpsBuildRepoRepoRoute._addFileChildren(
    AppO5O5RequiredTechOpsBuildRepoRepoRouteChildren,
  )

interface AppO5O5RequiredRouteChildren {
  AppO5O5RequiredTechOpsClusterClusterRoute: typeof AppO5O5RequiredTechOpsClusterClusterRouteWithChildren
  AppO5O5RequiredTechOpsDeadMessageDeadMessageRoute: typeof AppO5O5RequiredTechOpsDeadMessageDeadMessageRouteWithChildren
  AppO5O5RequiredTechOpsDeploymentDeploymentRoute: typeof AppO5O5RequiredTechOpsDeploymentDeploymentRouteWithChildren
  AppO5O5RequiredTechOpsEnvironmentEnvironmentRoute: typeof AppO5O5RequiredTechOpsEnvironmentEnvironmentRouteWithChildren
  AppO5O5RequiredTechOpsStackStackRoute: typeof AppO5O5RequiredTechOpsStackStackRouteWithChildren
  AppO5O5RequiredTechOpsTestRunTestRunRoute: typeof AppO5O5RequiredTechOpsTestRunTestRunRouteWithChildren
  AppO5O5RequiredTechOpsTriggerTriggerRoute: typeof AppO5O5RequiredTechOpsTriggerTriggerRouteWithChildren
  AppO5O5RequiredTechOpsBuildIndexRoute: typeof AppO5O5RequiredTechOpsBuildIndexRoute
  AppO5O5RequiredTechOpsBuildRepoRepoRoute: typeof AppO5O5RequiredTechOpsBuildRepoRepoRouteWithChildren
}

const AppO5O5RequiredRouteChildren: AppO5O5RequiredRouteChildren = {
  AppO5O5RequiredTechOpsClusterClusterRoute:
    AppO5O5RequiredTechOpsClusterClusterRouteWithChildren,
  AppO5O5RequiredTechOpsDeadMessageDeadMessageRoute:
    AppO5O5RequiredTechOpsDeadMessageDeadMessageRouteWithChildren,
  AppO5O5RequiredTechOpsDeploymentDeploymentRoute:
    AppO5O5RequiredTechOpsDeploymentDeploymentRouteWithChildren,
  AppO5O5RequiredTechOpsEnvironmentEnvironmentRoute:
    AppO5O5RequiredTechOpsEnvironmentEnvironmentRouteWithChildren,
  AppO5O5RequiredTechOpsStackStackRoute:
    AppO5O5RequiredTechOpsStackStackRouteWithChildren,
  AppO5O5RequiredTechOpsTestRunTestRunRoute:
    AppO5O5RequiredTechOpsTestRunTestRunRouteWithChildren,
  AppO5O5RequiredTechOpsTriggerTriggerRoute:
    AppO5O5RequiredTechOpsTriggerTriggerRouteWithChildren,
  AppO5O5RequiredTechOpsBuildIndexRoute: AppO5O5RequiredTechOpsBuildIndexRoute,
  AppO5O5RequiredTechOpsBuildRepoRepoRoute:
    AppO5O5RequiredTechOpsBuildRepoRepoRouteWithChildren,
}

const AppO5O5RequiredRouteWithChildren = AppO5O5RequiredRoute._addFileChildren(
  AppO5O5RequiredRouteChildren,
)

interface AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRouteChildren {
  AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailInvitationRoute: typeof AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailInvitationRoute
  AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRealmAccessRoute: typeof AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRealmAccessRoute
  AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailIndexRoute: typeof AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailIndexRoute
}

const AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRouteChildren: AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRouteChildren =
  {
    AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailInvitationRoute:
      AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailInvitationRoute,
    AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRealmAccessRoute:
      AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRealmAccessRoute,
    AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailIndexRoute:
      AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailIndexRoute,
  }

const AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRouteWithChildren =
  AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRoute._addFileChildren(
    AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRouteChildren,
  )

interface AppPlatformContextRequiredOrganizationOrganizationRouteChildren {
  AppPlatformContextRequiredOrganizationOrganizationIndexRoute: typeof AppPlatformContextRequiredOrganizationOrganizationIndexRoute
  AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRoute: typeof AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRouteWithChildren
}

const AppPlatformContextRequiredOrganizationOrganizationRouteChildren: AppPlatformContextRequiredOrganizationOrganizationRouteChildren =
  {
    AppPlatformContextRequiredOrganizationOrganizationIndexRoute:
      AppPlatformContextRequiredOrganizationOrganizationIndexRoute,
    AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRoute:
      AppPlatformContextRequiredOrganizationOrganizationOrganizationIdDetailRouteWithChildren,
  }

const AppPlatformContextRequiredOrganizationOrganizationRouteWithChildren =
  AppPlatformContextRequiredOrganizationOrganizationRoute._addFileChildren(
    AppPlatformContextRequiredOrganizationOrganizationRouteChildren,
  )

interface AppPlatformContextRequiredProgramProgramProgramIdProgramRouteChildren {
  AppPlatformContextRequiredProgramProgramProgramIdProgramIndexRoute: typeof AppPlatformContextRequiredProgramProgramProgramIdProgramIndexRoute
  AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationClearingRoute: typeof AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationClearingRoute
  AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationContactsRoute: typeof AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationContactsRoute
  AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationControlsRoute: typeof AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationControlsRoute
  AppPlatformContextRequiredProgramProgramProgramIdProgramBrandingIndexRoute: typeof AppPlatformContextRequiredProgramProgramProgramIdProgramBrandingIndexRoute
  AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationIndexRoute: typeof AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationIndexRoute
}

const AppPlatformContextRequiredProgramProgramProgramIdProgramRouteChildren: AppPlatformContextRequiredProgramProgramProgramIdProgramRouteChildren =
  {
    AppPlatformContextRequiredProgramProgramProgramIdProgramIndexRoute:
      AppPlatformContextRequiredProgramProgramProgramIdProgramIndexRoute,
    AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationClearingRoute:
      AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationClearingRoute,
    AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationContactsRoute:
      AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationContactsRoute,
    AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationControlsRoute:
      AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationControlsRoute,
    AppPlatformContextRequiredProgramProgramProgramIdProgramBrandingIndexRoute:
      AppPlatformContextRequiredProgramProgramProgramIdProgramBrandingIndexRoute,
    AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationIndexRoute:
      AppPlatformContextRequiredProgramProgramProgramIdProgramConfigurationIndexRoute,
  }

const AppPlatformContextRequiredProgramProgramProgramIdProgramRouteWithChildren =
  AppPlatformContextRequiredProgramProgramProgramIdProgramRoute._addFileChildren(
    AppPlatformContextRequiredProgramProgramProgramIdProgramRouteChildren,
  )

interface AppPlatformContextRequiredProgramProgramRouteChildren {
  AppPlatformContextRequiredProgramProgramIndexRoute: typeof AppPlatformContextRequiredProgramProgramIndexRoute
  AppPlatformContextRequiredProgramProgramProgramIdProgramRoute: typeof AppPlatformContextRequiredProgramProgramProgramIdProgramRouteWithChildren
}

const AppPlatformContextRequiredProgramProgramRouteChildren: AppPlatformContextRequiredProgramProgramRouteChildren =
  {
    AppPlatformContextRequiredProgramProgramIndexRoute:
      AppPlatformContextRequiredProgramProgramIndexRoute,
    AppPlatformContextRequiredProgramProgramProgramIdProgramRoute:
      AppPlatformContextRequiredProgramProgramProgramIdProgramRouteWithChildren,
  }

const AppPlatformContextRequiredProgramProgramRouteWithChildren =
  AppPlatformContextRequiredProgramProgramRoute._addFileChildren(
    AppPlatformContextRequiredProgramProgramRouteChildren,
  )

interface AppPlatformContextRequiredRealmAccessRealmAccessRouteChildren {
  AppPlatformContextRequiredRealmAccessRealmAccessRealmAccessIdRoute: typeof AppPlatformContextRequiredRealmAccessRealmAccessRealmAccessIdRoute
  AppPlatformContextRequiredRealmAccessRealmAccessIndexRoute: typeof AppPlatformContextRequiredRealmAccessRealmAccessIndexRoute
}

const AppPlatformContextRequiredRealmAccessRealmAccessRouteChildren: AppPlatformContextRequiredRealmAccessRealmAccessRouteChildren =
  {
    AppPlatformContextRequiredRealmAccessRealmAccessRealmAccessIdRoute:
      AppPlatformContextRequiredRealmAccessRealmAccessRealmAccessIdRoute,
    AppPlatformContextRequiredRealmAccessRealmAccessIndexRoute:
      AppPlatformContextRequiredRealmAccessRealmAccessIndexRoute,
  }

const AppPlatformContextRequiredRealmAccessRealmAccessRouteWithChildren =
  AppPlatformContextRequiredRealmAccessRealmAccessRoute._addFileChildren(
    AppPlatformContextRequiredRealmAccessRealmAccessRouteChildren,
  )

interface AppPlatformContextRequiredRealmRealmRouteChildren {
  AppPlatformContextRequiredRealmRealmRealmIdRoute: typeof AppPlatformContextRequiredRealmRealmRealmIdRoute
  AppPlatformContextRequiredRealmRealmIndexRoute: typeof AppPlatformContextRequiredRealmRealmIndexRoute
}

const AppPlatformContextRequiredRealmRealmRouteChildren: AppPlatformContextRequiredRealmRealmRouteChildren =
  {
    AppPlatformContextRequiredRealmRealmRealmIdRoute:
      AppPlatformContextRequiredRealmRealmRealmIdRoute,
    AppPlatformContextRequiredRealmRealmIndexRoute:
      AppPlatformContextRequiredRealmRealmIndexRoute,
  }

const AppPlatformContextRequiredRealmRealmRouteWithChildren =
  AppPlatformContextRequiredRealmRealmRoute._addFileChildren(
    AppPlatformContextRequiredRealmRealmRouteChildren,
  )

interface AppPlatformContextRequiredRoleRoleRouteChildren {
  AppPlatformContextRequiredRoleRoleRoleIdRoute: typeof AppPlatformContextRequiredRoleRoleRoleIdRoute
  AppPlatformContextRequiredRoleRoleIndexRoute: typeof AppPlatformContextRequiredRoleRoleIndexRoute
}

const AppPlatformContextRequiredRoleRoleRouteChildren: AppPlatformContextRequiredRoleRoleRouteChildren =
  {
    AppPlatformContextRequiredRoleRoleRoleIdRoute:
      AppPlatformContextRequiredRoleRoleRoleIdRoute,
    AppPlatformContextRequiredRoleRoleIndexRoute:
      AppPlatformContextRequiredRoleRoleIndexRoute,
  }

const AppPlatformContextRequiredRoleRoleRouteWithChildren =
  AppPlatformContextRequiredRoleRoleRoute._addFileChildren(
    AppPlatformContextRequiredRoleRoleRouteChildren,
  )

interface AppPlatformContextRequiredTenantTenantRouteChildren {
  AppPlatformContextRequiredTenantTenantTenantIdRoute: typeof AppPlatformContextRequiredTenantTenantTenantIdRoute
  AppPlatformContextRequiredTenantTenantIndexRoute: typeof AppPlatformContextRequiredTenantTenantIndexRoute
}

const AppPlatformContextRequiredTenantTenantRouteChildren: AppPlatformContextRequiredTenantTenantRouteChildren =
  {
    AppPlatformContextRequiredTenantTenantTenantIdRoute:
      AppPlatformContextRequiredTenantTenantTenantIdRoute,
    AppPlatformContextRequiredTenantTenantIndexRoute:
      AppPlatformContextRequiredTenantTenantIndexRoute,
  }

const AppPlatformContextRequiredTenantTenantRouteWithChildren =
  AppPlatformContextRequiredTenantTenantRoute._addFileChildren(
    AppPlatformContextRequiredTenantTenantRouteChildren,
  )

interface AppPlatformContextRequiredRouteChildren {
  AppPlatformContextRequiredOrganizationOrganizationRoute: typeof AppPlatformContextRequiredOrganizationOrganizationRouteWithChildren
  AppPlatformContextRequiredProgramProgramRoute: typeof AppPlatformContextRequiredProgramProgramRouteWithChildren
  AppPlatformContextRequiredRealmAccessRealmAccessRoute: typeof AppPlatformContextRequiredRealmAccessRealmAccessRouteWithChildren
  AppPlatformContextRequiredRealmRealmRoute: typeof AppPlatformContextRequiredRealmRealmRouteWithChildren
  AppPlatformContextRequiredRoleRoleRoute: typeof AppPlatformContextRequiredRoleRoleRouteWithChildren
  AppPlatformContextRequiredTenantTenantRoute: typeof AppPlatformContextRequiredTenantTenantRouteWithChildren
  AppPlatformContextRequiredUserInvitationRoute: typeof AppPlatformContextRequiredUserInvitationRoute
  AppPlatformContextRequiredUserRequestRoute: typeof AppPlatformContextRequiredUserRequestRoute
  AppPlatformContextRequiredUserIndexRoute: typeof AppPlatformContextRequiredUserIndexRoute
}

const AppPlatformContextRequiredRouteChildren: AppPlatformContextRequiredRouteChildren =
  {
    AppPlatformContextRequiredOrganizationOrganizationRoute:
      AppPlatformContextRequiredOrganizationOrganizationRouteWithChildren,
    AppPlatformContextRequiredProgramProgramRoute:
      AppPlatformContextRequiredProgramProgramRouteWithChildren,
    AppPlatformContextRequiredRealmAccessRealmAccessRoute:
      AppPlatformContextRequiredRealmAccessRealmAccessRouteWithChildren,
    AppPlatformContextRequiredRealmRealmRoute:
      AppPlatformContextRequiredRealmRealmRouteWithChildren,
    AppPlatformContextRequiredRoleRoleRoute:
      AppPlatformContextRequiredRoleRoleRouteWithChildren,
    AppPlatformContextRequiredTenantTenantRoute:
      AppPlatformContextRequiredTenantTenantRouteWithChildren,
    AppPlatformContextRequiredUserInvitationRoute:
      AppPlatformContextRequiredUserInvitationRoute,
    AppPlatformContextRequiredUserRequestRoute:
      AppPlatformContextRequiredUserRequestRoute,
    AppPlatformContextRequiredUserIndexRoute:
      AppPlatformContextRequiredUserIndexRoute,
  }

const AppPlatformContextRequiredRouteWithChildren =
  AppPlatformContextRequiredRoute._addFileChildren(
    AppPlatformContextRequiredRouteChildren,
  )

interface AppDeveloperAgentKeyAgentKeyRouteChildren {
  AppDeveloperAgentKeyAgentKeyIndexRoute: typeof AppDeveloperAgentKeyAgentKeyIndexRoute
}

const AppDeveloperAgentKeyAgentKeyRouteChildren: AppDeveloperAgentKeyAgentKeyRouteChildren =
  {
    AppDeveloperAgentKeyAgentKeyIndexRoute:
      AppDeveloperAgentKeyAgentKeyIndexRoute,
  }

const AppDeveloperAgentKeyAgentKeyRouteWithChildren =
  AppDeveloperAgentKeyAgentKeyRoute._addFileChildren(
    AppDeveloperAgentKeyAgentKeyRouteChildren,
  )

interface AppDeveloperApiKeyApiKeyRouteChildren {
  AppDeveloperApiKeyApiKeyIndexRoute: typeof AppDeveloperApiKeyApiKeyIndexRoute
}

const AppDeveloperApiKeyApiKeyRouteChildren: AppDeveloperApiKeyApiKeyRouteChildren =
  {
    AppDeveloperApiKeyApiKeyIndexRoute: AppDeveloperApiKeyApiKeyIndexRoute,
  }

const AppDeveloperApiKeyApiKeyRouteWithChildren =
  AppDeveloperApiKeyApiKeyRoute._addFileChildren(
    AppDeveloperApiKeyApiKeyRouteChildren,
  )

interface AppDeveloperWebhookWebhookRouteChildren {
  AppDeveloperWebhookWebhookIndexRoute: typeof AppDeveloperWebhookWebhookIndexRoute
}

const AppDeveloperWebhookWebhookRouteChildren: AppDeveloperWebhookWebhookRouteChildren =
  {
    AppDeveloperWebhookWebhookIndexRoute: AppDeveloperWebhookWebhookIndexRoute,
  }

const AppDeveloperWebhookWebhookRouteWithChildren =
  AppDeveloperWebhookWebhookRoute._addFileChildren(
    AppDeveloperWebhookWebhookRouteChildren,
  )

interface AppRouteChildren {
  AppClearingCoreRoute: typeof AppClearingCoreRouteWithChildren
  AppLogoutRoute: typeof AppLogoutRoute
  AppO5O5RequiredRoute: typeof AppO5O5RequiredRouteWithChildren
  AppPlatformContextRequiredRoute: typeof AppPlatformContextRequiredRouteWithChildren
  AppSettingsPersonalRoute: typeof AppSettingsPersonalRoute
  AppDeveloperIndexRoute: typeof AppDeveloperIndexRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppDeveloperAgentKeyAgentKeyRoute: typeof AppDeveloperAgentKeyAgentKeyRouteWithChildren
  AppDeveloperApiKeyApiKeyRoute: typeof AppDeveloperApiKeyApiKeyRouteWithChildren
  AppDeveloperWebhookWebhookRoute: typeof AppDeveloperWebhookWebhookRouteWithChildren
}

const AppRouteChildren: AppRouteChildren = {
  AppClearingCoreRoute: AppClearingCoreRouteWithChildren,
  AppLogoutRoute: AppLogoutRoute,
  AppO5O5RequiredRoute: AppO5O5RequiredRouteWithChildren,
  AppPlatformContextRequiredRoute: AppPlatformContextRequiredRouteWithChildren,
  AppSettingsPersonalRoute: AppSettingsPersonalRoute,
  AppDeveloperIndexRoute: AppDeveloperIndexRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppDeveloperAgentKeyAgentKeyRoute:
    AppDeveloperAgentKeyAgentKeyRouteWithChildren,
  AppDeveloperApiKeyApiKeyRoute: AppDeveloperApiKeyApiKeyRouteWithChildren,
  AppDeveloperWebhookWebhookRoute: AppDeveloperWebhookWebhookRouteWithChildren,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthLoginLoginRouteChildren {
  AuthLoginLoginMfaRoute: typeof AuthLoginLoginMfaRoute
  AuthLoginLoginIndexRoute: typeof AuthLoginLoginIndexRoute
}

const AuthLoginLoginRouteChildren: AuthLoginLoginRouteChildren = {
  AuthLoginLoginMfaRoute: AuthLoginLoginMfaRoute,
  AuthLoginLoginIndexRoute: AuthLoginLoginIndexRoute,
}

const AuthLoginLoginRouteWithChildren = AuthLoginLoginRoute._addFileChildren(
  AuthLoginLoginRouteChildren,
)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthRequestAccessRoute: typeof AuthRequestAccessRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthLoginLoginRoute: typeof AuthLoginLoginRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthRequestAccessRoute: AuthRequestAccessRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthLoginLoginRoute: AuthLoginLoginRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface DocsLayoutApiReferenceProviderRouteChildren {
  DocsLayoutApiReferenceProviderPackageRoute: typeof DocsLayoutApiReferenceProviderPackageRoute
  DocsLayoutApiReferenceProviderIndexRoute: typeof DocsLayoutApiReferenceProviderIndexRoute
}

const DocsLayoutApiReferenceProviderRouteChildren: DocsLayoutApiReferenceProviderRouteChildren =
  {
    DocsLayoutApiReferenceProviderPackageRoute:
      DocsLayoutApiReferenceProviderPackageRoute,
    DocsLayoutApiReferenceProviderIndexRoute:
      DocsLayoutApiReferenceProviderIndexRoute,
  }

const DocsLayoutApiReferenceProviderRouteWithChildren =
  DocsLayoutApiReferenceProviderRoute._addFileChildren(
    DocsLayoutApiReferenceProviderRouteChildren,
  )

interface DocsLayoutGuideProviderRouteChildren {
  DocsLayoutGuideProviderArtifactNameRoute: typeof DocsLayoutGuideProviderArtifactNameRoute
  DocsLayoutGuideProviderIndexRoute: typeof DocsLayoutGuideProviderIndexRoute
}

const DocsLayoutGuideProviderRouteChildren: DocsLayoutGuideProviderRouteChildren =
  {
    DocsLayoutGuideProviderArtifactNameRoute:
      DocsLayoutGuideProviderArtifactNameRoute,
    DocsLayoutGuideProviderIndexRoute: DocsLayoutGuideProviderIndexRoute,
  }

const DocsLayoutGuideProviderRouteWithChildren =
  DocsLayoutGuideProviderRoute._addFileChildren(
    DocsLayoutGuideProviderRouteChildren,
  )

interface DocsLayoutRouteChildren {
  DocsLayoutIndexRoute: typeof DocsLayoutIndexRoute
  DocsLayoutApiReferenceProviderRoute: typeof DocsLayoutApiReferenceProviderRouteWithChildren
  DocsLayoutGuideProviderRoute: typeof DocsLayoutGuideProviderRouteWithChildren
}

const DocsLayoutRouteChildren: DocsLayoutRouteChildren = {
  DocsLayoutIndexRoute: DocsLayoutIndexRoute,
  DocsLayoutApiReferenceProviderRoute:
    DocsLayoutApiReferenceProviderRouteWithChildren,
  DocsLayoutGuideProviderRoute: DocsLayoutGuideProviderRouteWithChildren,
}

const DocsLayoutRouteWithChildren = DocsLayoutRoute._addFileChildren(
  DocsLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  AcceptInvitationRoute: AcceptInvitationRoute,
  MfaSetupRoute: MfaSetupRoute,
  DocsLayoutRoute: DocsLayoutRouteWithChildren,
  OauthConsentRoute: OauthConsentRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
